(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo
   * @description
   *
   */
  angular
    .module('neo', [
      'ngAria',
      'ngMaterial',
      'ngMessages',
      'ui.router',
      'ngResource',
      'md.data.table',
      'angular-jwt',
      'pascalprecht.translate',
      'uiGmapgoogle-maps',
      'googlechart',
      'neo.config',
      'neo.home',
      'neo.services',
      'neo.components',
      'neo.authentication',
      'neo.security',
      'neo.public',
      'neo.serverNotFound','neo.home.refereeNewInvoice','neo.home.resultats','neo.home.informes','neo.home.informestecnic'
      ,'neo.home.informestg','neo.home.informespublic'
    ]);
}());

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/informacio/people/people.tpl.html',
    '<div class="md-whiteframe-2dp" flex layout-padding>\n' +
    '  <h2 class="md-title">{{\'PERSONAL\' | translate}}</h2>\n' +
    '  <md-divider></md-divider>\n' +
    '  <md-list flex>\n' +
    '    <md-list-item ng-repeat="person in vm.people">\n' +
    '      <div layout="row">\n' +
    '        <p class="md-body-1">{{ person.email }}</p>\n' +
    '      </div>\n' +
    '      <md-divider ng-if="!$last"></md-divider>\n' +
    '    </md-list-item>\n' +
    '  </md-list>\n' +
    '</div>\n' +
    '\n' +
    '<div class="md-whiteframe-2dp" flex layout-padding>\n' +
    '  <h2 class="md-title">{{\'USERS_ACCESS\' | translate}}</h2>\n' +
    '  <md-divider></md-divider>\n' +
    '  <md-list flex>\n' +
    '    <md-list-item ng-repeat="user in vm.users" ui-sref="home.userProfile({userId: user.id})">\n' +
    '      <div layout="row">\n' +
    '        <p class="md-body-1">{{ user.username }}</p>\n' +
    '      </div>\n' +
    '      <md-divider ng-if="!$last"></md-divider>\n' +
    '    </md-list-item>\n' +
    '  </md-list>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/informacio/image/image.tpl.html',
    '<div layout="row" layout-align="center" layout-padding flex>\n' +
    '  <img\n' +
    '    src="http://www.motorolasolutions.com/content/dam/msi/images/business/products/accessories/_images/_staticfiles/b2b_product_placeholder_lg_us-en.jpg"\n' +
    '    style="width: 168px; height: 168px">\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntament/informacio/people/people.tpl.html',
    '<div class="md-whiteframe-2dp" flex layout-padding>\n' +
    '  <h1 class="md-title">{{\'PERSONAL\' | translate }}</h1>\n' +
    '  <md-divider></md-divider>\n' +
    '  <md-list class="md-dense" flex>\n' +
    '    <md-list-item ng-repeat="person in vm.people">\n' +
    '      <span class="md-body-1">{{ person.email }}</span>\n' +
    '      <md-divider ng-if="!$last"></md-divider>\n' +
    '    </md-list-item>\n' +
    '  </md-list>\n' +
    '</div>\n' +
    '\n' +
    '<div class="md-whiteframe-2dp" flex layout-padding>\n' +
    '  <h1 class="md-title">{{\'USERS_ACCESS\' | translate}}</h1>\n' +
    '  <md-divider></md-divider>\n' +
    '  <md-list flex>\n' +
    '    <md-list-item ng-repeat="user in vm.users" ui-sref="home.userProfile({userId: user.id})">\n' +
    '      <span class="md-body-1">{{ user.username }}</span>\n' +
    '      <md-divider ng-if="!$last"></md-divider>\n' +
    '    </md-list-item>\n' +
    '  </md-list>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntament/informacio/image/image.tpl.html',
    '<div layout="row" layout-align="center" layout-padding flex>\n' +
    '  <img\n' +
    '    src="http://www.motorolasolutions.com/content/dam/msi/images/business/products/accessories/_images/_staticfiles/b2b_product_placeholder_lg_us-en.jpg"\n' +
    '    style="width: 168px; height: 168px">\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/phases/phase/inscribed-teams/inscribed-teams.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/person/information/text.tpl.html',
    '<div layout="row" layout-align="space-around center" style="padding-top: 1%;">\n' +
    '    <style type="text/css">\n' +
    '        .fileUpload {\n' +
    '    position: relative;\n' +
    '    overflow: hidden;\n' +
    '    margin: 10px;\n' +
    '}\n' +
    '.fileUpload input.upload {\n' +
    '    position: absolute;\n' +
    '    top: 0;\n' +
    '    right: 0;\n' +
    '    margin: 0;\n' +
    '    padding: 0;\n' +
    '    font-size: 20px;\n' +
    '    cursor: pointer;\n' +
    '    opacity: 0;\n' +
    '    filter: alpha(opacity=0);\n' +
    '}\n' +
    '        </style>\n' +
    '\n' +
    ' \n' +
    ' \n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline" ng-if="!vm.edit">{{\'PEOPLE.VINCULED_TO_TEAM_PERSON_DATA\' | translate}}</span>\n' +
    '          <span class="md-headline" ng-if="vm.edit">{{\'PEOPLE.MODIFY_VINCULED_TO_TEAM_PERSON_DATA\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '         <div   width="200" height="200"  class="dropzone" file-dropzone="[image/png, image/jpeg, image/gif, image/jpg]"\n' +
    '                  file="image" file-name="imageFileName" data-max-file-size="3"   ng_show="vm.edit">\n' +
    '   \n' +
    '      <img id="im" ng-src={{image}} width="200" height="200" alt="Arrossegar aqui foto" style="width: 200px;height: 200px;line-height: 200px;text-align: center;padding:1px;border:1px solid #021a40;" />\n' +
    '       <form action>\n' +
    '       <div class="fileUpload btn btn-primary" >\n' +
    '      \n' +
    '    <input type="file" fileread="image" >\n' +
    '    </div>\n' +
    '  </form>\n' +
    '    </div>\n' +
    '  <div  width="200" height="200"  ng_show="!vm.edit">\n' +
    '  <img ng-src="{{image}}" width="200" height="200" alt="Falta fotografia&nbsp;&nbsp;&nbsp;&nbsp;" style="width: 200px;height: 200px;line-height: 200px;text-align: center;padding:1px;border:1px solid #021a40;"  />\n' +
    '  </div>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="personForm" ng-submit="vm.updatePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                             ng-model="vm.person.surname" flex="50"\n' +
    '                             layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '                  <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                             layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <div layout-gt-sm="row" flex="50">\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                    <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                   ng-required="true" ng-disabled="!vm.edit" flex="100"></md-datepicker>\n' +
    '                    <div ng-messages="personForm.birthday.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'GENDER\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                    <md-select name="gender" ng-model="vm.person.genderId" ng-required="true" ng-disabled="!vm.edit">\n' +
    '                      <md-option ng-repeat="gender in vm.personGenders" value="{{gender.id}}">{{gender.name |\n' +
    '                        translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="personForm.gender.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <neo-input name="email" label="CONTACT_EMAIL" icon="images/ic_email_black_48px.svg"\n' +
    '                           ng-model="vm.person.email" error="EMAIL_INVALID_FORMAT"\n' +
    '                           pattern="^.+@.+\\..+$" flex="45" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="nif" label="NIF/NIE" icon="images/ic_person_black_48px.svg" ng-model="vm.person.nif"\n' +
    '                           error="INVALID_NID" flex="45" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '                <neo-input name="hic" label="HEALTH_INSURANCE_CARD_NUMBER" icon="images/ic_healing_black_48px.svg"\n' +
    '                           ng-model="vm.person.healthInsuranceCardNumber" flex="45" layout-gt-sm="column"\n' +
    '                           is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="address" label="ADDRESS" icon="images/ic_location_black_48px.svg"\n' +
    '                           ng-model="vm.person.address" flex="45" layout-gt-sm="column"\n' +
    '                           is-disabled="!vm.edit"></neo-input>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="town" label="TOWN" icon="images/ic_location_city_black_48px.svg"\n' +
    '                             ng-model="vm.person.town" flex="70" layout-gt-sm="column"\n' +
    '                             is-disabled="!vm.edit"></neo-input>\n' +
    '                  <neo-input name="zipCode" label="POSTAL_CODE" ng-model="vm.person.zipCode"\n' +
    '                             error="INVALID_POSTAL_CODE" pattern="^[0-9]{5}$"\n' +
    '                             flex="30" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <h1 class="md-title">{{\'ASSOCIATIONS\' | translate}}</h1>\n' +
    '              <md-divider layout-padding></md-divider>\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="licenseType" label="LICENSE_TYPE" ng-model="vm.person.licenseType" flex="45"\n' +
    '                           layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '                <neo-input name="licenseCode" label="LICENSE_CODE" ng-model="vm.person.licenceCode" flex="45"\n' +
    '                           layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '              </div>\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="entityName" label="ENTITY" ng-model="vm.team.organisationName" flex="45"\n' +
    '                           layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '                <neo-input name="teamInfo" label="TEAM" ng-model="vm.team.info" flex="45"\n' +
    '                           layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '              </div>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right"\n' +
    '                       ng-disabled="(personForm.$invalid || personForm.$pristine)&& DISABLEBUTTON" type="submit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-warn md-fab-bottom-right"\n' +
    '                       ng-if="vm.edit" ng-click="vm.disableEdit()" style="margin-bottom: 72px;">\n' +
    '              <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '        <neo-print-card-template id="cardsPrintPreview" ng-hide="true" cards="vm.cards"></neo-print-card-template>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/person/information/information.tpl.html',
    '<div layout="column" layout-gt-sm="row">\n' +
    '  <div ui-view="text" style="min-width: 75%" flex></div>\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/informacio/text.tpl.html',
    '<form novalidate name="editForm" ng-submit="vm.updateEntitat()">\n' +
    '  <div class="md-whiteframe-1dp">\n' +
    '    <div layout="row" layout-align="space-around center">\n' +
    '      <div flex="40" layout="column" layout-padding>\n' +
    '\n' +
    '        <md-input-container>\n' +
    '          <label>{{\'NAME\' | translate}}</label>\n' +
    '          <md-icon md-svg-src="images/ic_title_black_48px.svg"></md-icon>\n' +
    '          <input name="name" title="name" type="text" required ng-model="vm.entitat.name" ng-disabled="!vm.edit"/>\n' +
    '          <div ng-messages="editForm.name.$error" role="alert">\n' +
    '            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <label>{{\'EMAIL\' | translate}}</label>\n' +
    '          <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '          <input title="email" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                 ng-model="vm.entitat.email" ng-disabled="!vm.edit"/>\n' +
    '          <div ng-messages="editForm.email.$error" role="alert">\n' +
    '            <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '              {{\'EMAIL_INVALID_FORMAT\' | translate}}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <div flex layout="row">\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>CCE</label>\n' +
    '            <input title="cce" type="text" ng-model="vm.entitat.cce" ng-disabled="!vm.edit"/>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container>\n' +
    '            <label>NIF/NIE</label>\n' +
    '            <input title="nif" type="text"\n' +
    '                   ng-pattern="/^(\\d{8})([A-Z])$|^([ABCDEFGHJKLMNPQRSUVW])(\\d{7})([0-9A-J])$|^[KLMXYZ]\\d{7,8}[A-Z]$/"\n' +
    '                   ng-model="vm.entitat.nif" ng-disabled="!vm.edit" required/>\n' +
    '            <div ng-messages="editForm.nif.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_NID\' | translate}}</div>\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '          <label>{{\'NAME_CONTACT\' | translate}}</label>\n' +
    '          <input title="pcontact" type="text" ng-model="vm.entitat.pname1" ng-disabled="!vm.edit"/>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <md-icon md-svg-src="images/ic_web_black_48px.svg"></md-icon>\n' +
    '          <label>{{\'WEB_PAGE\' | translate}}</label>\n' +
    '          <input title="web" type="text" ng-model="vm.entitat.web" ng-disabled="!vm.edit"/>\n' +
    '        </md-input-container>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex="45" layout="column" layout-padding>\n' +
    '        <md-input-container>\n' +
    '          <label>{{\'ENTITY_TYPE\' | translate}}</label>\n' +
    '          <md-select name="entityType" ng-model="vm.entitat.typeId" ng-required="true" ng-disabled="!vm.edit">\n' +
    '            <md-option ng-value="type.id" ng-repeat="type in vm.entityTypes">{{ \'ENTITY_TYPES.\' + type.name | translate\n' +
    '              }}\n' +
    '            </md-option>\n' +
    '          </md-select>\n' +
    '          <div ng-messages="entitatForm.entityType.$error" role="alert">\n' +
    '            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '          <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '          <input title="address" type="text" ng-model="vm.entitat.address" ng-disabled="!vm.edit" required/>\n' +
    '          <div ng-messages="editForm.address.$error" role="alert">\n' +
    '            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <div flex layout="row">\n' +
    '          <md-input-container class="md-block" flex="75">\n' +
    '            <label>{{\'TOWN\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_location_city_black_48px.svg"></md-icon>\n' +
    '            <md-select ng-model="vm.entitat.town" ng-disabled="!vm.edit" required>\n' +
    '              <md-option ng-value="town.id" ng-repeat="town in vm.towns">{{ town.name }}</md-option>\n' +
    '            </md-select>\n' +
    '            <div ng-messages="editForm.towns.$error" role="alert">\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '          <md-input-container class="md-block" flex>\n' +
    '            <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '            <input title="zipCode" type="text" name="zipCode" ng-model="vm.entitat.zipCode"\n' +
    '                   ng-pattern="/^[0-9]{5}$/" md-maxlength="5" ng-disabled="!vm.edit" required/>\n' +
    '            <div ng-messages="editForm.zipCode.$error" role="alert">\n' +
    '              <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}</div>\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '        <div flex layout="row">\n' +
    '\n' +
    '\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>{{\'PHONE\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '            <input title="phoneNumber" type="tel"\n' +
    '                   ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                   ng-model="vm.entitat.phoneNumber" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="editForm.phoneNumber.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>{{\'FAX\' | translate}}</label>\n' +
    '            <input title="fax" type="tel"\n' +
    '                   ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                   ng-model="vm.entitat.fax" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="editForm.fax.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_FAX_NUMBER\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div flex layout="row">\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>{{\'MOBILE_PHONE\' | translate}}</label>\n' +
    '            <input title="mobileNumber" type="tel"\n' +
    '                   ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                   ng-model="vm.entitat.mobileNumber" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="editForm.mobileNumber.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_MOBILE_PHONE_NUMBER\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Xarxes socials informació -->\n' +
    '        <div flex layout="row" ng-if="!vm.edit">\n' +
    '          <md-button ng-if="vm.entitat.facebook" class="md-flat" aria-label="Facebook"\n' +
    '                     href="https://www.facebook.com/{{vm.entitat.facebook}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '          </md-button>\n' +
    '          <md-button ng-if="vm.entitat.twitter" class="md-flat" aria-label="Twitter"\n' +
    '                     href="https://twitter.com/{{vm.entitat.twitter}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '          </md-button>\n' +
    '          <md-button ng-if="vm.entitat.instagram" class="md-flat" aria-label="Instagram"\n' +
    '                     href="https://www.instagram.com/{{vm.entitat.instagram}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Xarxes socials edició -->\n' +
    '        <div flex layout="row" ng-if="vm.edit">\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Facebook</label>\n' +
    '            <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '            <input title="facbook" type="text"\n' +
    '                   ng-model="vm.entitat.facebook"/>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Twitter</label>\n' +
    '            <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '            <input title="twitter" type="text"\n' +
    '                   ng-model="vm.entitat.twitter"/>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Instagram</label>\n' +
    '            <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '            <input title="instagram" type="text"\n' +
    '                   ng-model="vm.entitat.instagram"/>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div flex>\n' +
    '    <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-if="vm.edit"\n' +
    '               ng-disabled="editForm.$invalid">\n' +
    '      <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '    </md-button>\n' +
    '  </div>\n' +
    '  <div flex>\n' +
    '    <md-button class="md-fab md-warn md-fab-bottom-right"\n' +
    '               ng-if="vm.edit" ng-click="vm.disableEdit()" style="margin-bottom: 72px;">\n' +
    '      <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '      <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '    </md-button>\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/informacio/informacio.tpl.html',
    '<div layout="column" layout-gt-sm="row">\n' +
    '  <div layout="column" style="height: 100%" layout-align="space-between" flex-gt-sm="33">\n' +
    '    <div ui-view="image" flex="50"></div>\n' +
    '    <div ui-view="people" flex="50"></div>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-padding flex layout-align="center center">\n' +
    '    <div ui-view="text" style="min-width: 75%" flex></div>\n' +
    '  </div>\n' +
    '  <neo-action-button buttons="vm.buttons"></neo-action-button>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/print-cards/print-cards.tpl.html',
    '<div layout="column" layout-gt-sm="row">\n' +
    '  <div style="min-width: 75%" flex>\n' +
    '    <div layout-align="center center" layout="row" layout-padding>\n' +
    '      <div class="md-whiteframe-z2" flex-gt-md="70" flex="100">\n' +
    '        <form ng-cloak>\n' +
    '          <div layout="row" flex layout-align="space-around center">\n' +
    '            <div layout="column" flex layout-padding>\n' +
    '              <div class="md-toolbar-tools">\n' +
    '                <h1>{{\'PRINT_CARDS.TITLE\' | translate}}</h1>\n' +
    '                <span flex></span>\n' +
    '              </div>\n' +
    '\n' +
    '              <div flex ng-repeat="(index, team) in vm.licensesByTeam">\n' +
    '                <md-divider></md-divider>\n' +
    '                <md-checkbox ng-model="team.selected" ng-change="vm.selectAllAssociatedLicenses(index)" layout-padding\n' +
    '                             aria-label="team">\n' +
    '                  <h3>{{team.name}}</h3>\n' +
    '                </md-checkbox>\n' +
    '                <md-grid-list class="indented-grid" md-cols-xs="1" md-cols-sm="2" md-cols-md="3" md-cols-gt-md="4"\n' +
    '                              md-row-height="4:1">\n' +
    '                  <md-grid-tile class="content-tile-grid" ng-repeat="license in team.licenses">\n' +
    '                    <md-checkbox ng-model="license.selected" aria-label="license">\n' +
    '                      <span>{{license.name}}</span><!--<br>-->\n' +
    '                      <span>{{license.surname}}</span>\n' +
    '                    </md-checkbox>\n' +
    '                  </md-grid-tile>\n' +
    '                </md-grid-list>\n' +
    '              </div>\n' +
    '\n' +
    '              <md-divider ng-if="vm.licensesByTeam.length === 0"></md-divider>\n' +
    '              <span class="md-body-2" ng-if="vm.licensesByTeam.length === 0">{{\'NOT_FOUND_LICENSES\' | translate}}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-click="vm.generateReport()">\n' +
    '            <md-icon md-svg-src="images/ic_picture_as_pdf_white_48px.svg" class="s24"\n' +
    '                     aria-label="generate reports"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'PRINT_CARDS.GENERATE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <neo-print-card-template id="cardsPrintPreview" ng-hide="true" cards="vm.cards"></neo-print-card-template>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/edit-matches/edit-matches.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '  <md-card class="md-whiteframe-z2" flex-gt-md="100" flex="100">\n' +
    '    <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '      <md-card-header-text>\n' +
    '        <span class="md-headline">{{ \'CHAMPIONSHIPS.EDIT_CALENDAR\' | translate}}</span>\n' +
    '      </md-card-header-text>\n' +
    '    </md-card-header>\n' +
    '    <md-card-content layout="column" layout-align="space-around stretch">\n' +
    '\n' +
    '      <div flex>\n' +
    '        <h1 class="md-title">{{\'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout="row" layout-align="space-around none" layout-padding layout-wrap>\n' +
    '          <!-- NAME -->\n' +
    '          <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                     ng-model="vm.championship.name" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- CATEGORY -->\n' +
    '          <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                     ng-model="vm.category" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- SPORT -->\n' +
    '          <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                     ng-model="vm.sport" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- ROUNDS -->\n' +
    '          <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                     ng-model="vm.gender" flex="25" is-disabled="true"></neo-input>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="matches">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.TITLE\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '\n' +
    '        <form name="matchesForm" layout="column" layout-wrap layout-padding>\n' +
    '\n' +
    '          <div>\n' +
    '            <md-button class="md-raised md-primary" ng-click="vm.addMatchDay(vm.matchDays)">{{\'CALENDAR.ADD_MATCH_DAY\' |\n' +
    '              translate}}\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '\n' +
    '          <div id="matchday{{$index}}" class="matchday-container" ng-repeat="matchDay in vm.matchDays" flex>\n' +
    '            <md-list layout="column" flex>\n' +
    '              <div class="match-header" layout="row" layout-align="space-between center"\n' +
    '                   md-colors="{background: \'primary\'}" layout-padding flex>\n' +
    '                <span class="md-title">{{\'CHAMPIONSHIPS.MATCH_DAY\' | translate}} {{matchDay.number}}</span>\n' +
    '                <md-button class="md-icon-button md-warn" ng-click="vm.deleteMatchDay(vm.matchDays, $index)">\n' +
    '                  <md-tooltip md-direction="right" md-delay="50">{{\'DELETE\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>delete</md-icon>\n' +
    '                </md-button>\n' +
    '              </div>\n' +
    '              <div layout="row" layout-align="center">\n' +
    '                <md-input-container>\n' +
    '                  <input type="number" ng-model="matchDay.number" min="1" name="matchDay{{$index}}"\n' +
    '                         placeholder="{{\'CALENDAR.MATCH_DAY_NUMBER\' | translate}}"/>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container>\n' +
    '                  <md-datepicker name="date" ng-model="matchDay.date" ng-required="true"\n' +
    '                                 md-placeholder="Enter date"></md-datepicker>\n' +
    '                  <div ng-messages="matchesForm.iniDate.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '\n' +
    '\n' +
    '              <md-list-item class="match-container" ng-repeat="match in matchDay.matches"\n' +
    '                            layout-xs="column" layout-sm="column" layout-md="row" layout-gt-md="row"\n' +
    '                            layout-align="space-around stretch" layout-fill layout-wrap\n' +
    '                            ng-style="$odd && {\'background-color\': vm.getColor(\'primary-50\')} ||\n' +
    '                            {\'background-color\': vm.getColor(\'background\')}">\n' +
    '\n' +
    '\n' +
    '                <div flex="45" layout="row" layout-align="space-around stretch" layout-fill layout-wrap>\n' +
    '                  <md-input-container flex>\n' +
    '                    <md-select ng-model="match.localTeamId" placeholder="{{\'CALENDAR.LOCAL_TEAM\' | translate}}"\n' +
    '                               ng-required="true" md-no-asterisk="true">\n' +
    '                      <md-option ng-value="null">\n' +
    '                        <em>{{\'CALENDAR.REST\' | translate}}</em>\n' +
    '                      </md-option>\n' +
    '                      <md-option ng-repeat="(id, team) in vm.teams" ng-value="id">\n' +
    '                        {{team.teamName}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <md-input-container flex>\n' +
    '                    <md-select ng-model="match.visitorTeamId" placeholder="{{\'CALENDAR.VISITOR_TEAM\' | translate}}"\n' +
    '                               ng-required="true" md-no-asterisk="true">\n' +
    '                      <md-option ng-value="null">\n' +
    '                        <em>{{\'CALENDAR.REST\' | translate}}</em>\n' +
    '                      </md-option>\n' +
    '                      <md-option ng-repeat="(id, team) in vm.teams" ng-value="id">\n' +
    '                        {{team.teamName}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <div flex="25" layout="row" layout-align="space-around stretch" layout-fill>\n' +
    '                  <md-input-container flex="60">\n' +
    '                    <md-datepicker name="date" ng-model="match.date" ng-required="true"\n' +
    '                                   md-placeholder="Enter date"></md-datepicker>\n' +
    '                    <div ng-messages="matchesForm.iniDate.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container flex="40" md-no-float>\n' +
    '                    <label>hh:mm</label>\n' +
    '                    <input type="time" ng-model="match.time"/>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <div flex="25" layout="row" layout-align="space-around stretch" layout-fill layout-wrap>\n' +
    '                  <md-input-container flex>\n' +
    '                    <md-select ng-model="match.facilityId" placeholder="{{\'CALENDAR.FACILITY\' | translate}}"\n' +
    '                               ng-required="true" md-no-asterisk="true">\n' +
    '                      <md-option ng-value="null">\n' +
    '                        <em>{{\'CALENDAR.NOT_FACILITY_ASSIGNED\' | translate}}</em>\n' +
    '                      </md-option>\n' +
    '                      <md-option ng-repeat="facility in vm.facilities" ng-value="facility.id">\n' +
    '                        {{facility.name}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div flex>\n' +
    '                  <md-button class="md-icon-button md-warn" ng-click="vm.deleteMatch($parent.$index, $index)">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'DELETE\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>delete</md-icon>\n' +
    '                  </md-button>\n' +
    '                </div>\n' +
    '\n' +
    '              </md-list-item>\n' +
    '\n' +
    '              <div>\n' +
    '                <md-button class="md-raised md-primary" ng-click="vm.addMatch(matchDay)">{{\'CALENDAR.ADD_MATCH\' |\n' +
    '                  translate}}\n' +
    '                </md-button>\n' +
    '              </div>\n' +
    '\n' +
    '            </md-list>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '  <div flex>\n' +
    '    <a ui-sref="home.championships.championship">\n' +
    '      <md-button class="md-fab md-warn md-fab-bottom-right" style="margin-bottom: 72px;">\n' +
    '        <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '  <div flex>\n' +
    '    <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="matchesForm.$invalid"\n' +
    '               ng-click="vm.saveMatchDays()">\n' +
    '      <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '      <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '    </md-button>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/assign-teams/assign-teams.tpl.html',
    '<div layout="row" layout-align="space-around center" flex>\n' +
    '  <md-card flex="70">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '    <md-card-header layout-padding>\n' +
    '      <md-card-header-text>\n' +
    '        <span class="md-headline">{{ "CHAMPIONSHIPS.TEAMS_ASSIGNMENT" | translate }}</span>\n' +
    '      </md-card-header-text>\n' +
    '    </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="space-around center">\n' +
    '        <h1 class="md-title">{{\'CHAMPIONSHIPS.DATA\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout-lt-md="column" layout="row" flex layout-align="space-around center" layout-padding>\n' +
    '          <div flex-lt-md flex="50" layout-align="space-around center">\n' +
    '            <!-- NAME -->\n' +
    '            <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                       ng-model="vm.championship.name" flex\n' +
    '                       is-disabled="true"></neo-input>\n' +
    '            <!-- SPORT -->\n' +
    '            <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                       ng-model="vm.championship.sport" flex\n' +
    '                       is-disabled="true"></neo-input>\n' +
    '          </div>\n' +
    '          <div flex-lt-md flex="50" layout-align="space-around center">\n' +
    '            <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                       ng-model="vm.championship.category" flex\n' +
    '                       is-disabled="true"></neo-input>\n' +
    '            <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                       ng-model="vm.championship.gender" flex\n' +
    '                       is-disabled="true"></neo-input>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <md-checkbox ng-model="vm.displayAll" aria-label="Display all" ng-change="vm.setTeamsDisplay()">\n' +
    '          {{\'CHAMPIONSHIPS.DISPLAY_TEAMS_ALREADY_ASSIGNED\' | translate}}\n' +
    '        </md-checkbox>\n' +
    '        <div class="multiDemo" layout="row" layout-align="space-around">\n' +
    '          <div flex="50">\n' +
    '            <md-card>\n' +
    '              <md-card-title>\n' +
    '                <md-card-title-text>\n' +
    '                  <span class="md-headline">{{vm.unassignedTeams.listName | translate }}</span>\n' +
    '                </md-card-title-text>\n' +
    '              </md-card-title>\n' +
    '              <md-divider></md-divider>\n' +
    '              <md-card-content>\n' +
    '                <div class="panel panel-info">\n' +
    '                  <div class="panel-body" flex>\n' +
    '                    <ul dnd-list dnd-drop="vm.onDrop(vm.unassignedTeams, item, index)">\n' +
    '                      <li ng-repeat="item in vm.unassignedTeams.items" ng-if="item.display"\n' +
    '                          dnd-draggable="vm.getSelectedItemsIncluding(vm.unassignedTeams, item)"\n' +
    '                          dnd-dragstart="vm.onDragStart(vm.unassignedTeams, event)"\n' +
    '                          dnd-moved="vm.onMoved(vm.unassignedTeams)"\n' +
    '                          dnd-dragend="vm.unassignedTeams.dragging = false"\n' +
    '                          dnd-selected="item.selected = !item.selected"\n' +
    '                          ng-class="{\'selected\': item.selected}"\n' +
    '                          ng-hide="vm.unassignedTeams.dragging && item.selected">\n' +
    '                        {{item.teamName}} - {{item.gender | translate}} - {{item.town}}\n' +
    '                      </li>\n' +
    '                    </ul>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </md-card-content>\n' +
    '            </md-card>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <div flex="50">\n' +
    '            <md-card>\n' +
    '              <md-card-title>\n' +
    '                <md-card-title-text>\n' +
    '                  <span class="md-headline">{{vm.assignedTeams.listName | translate }}</span>\n' +
    '                </md-card-title-text>\n' +
    '              </md-card-title>\n' +
    '              <md-divider></md-divider>\n' +
    '              <md-card-content>\n' +
    '                <div class="panel panel-info">\n' +
    '                  <div class="panel-body" flex>\n' +
    '                    <ul dnd-list dnd-drop="vm.onDrop(vm.assignedTeams, item, index)">\n' +
    '                      <li ng-repeat="item in vm.assignedTeams.items"\n' +
    '                          dnd-draggable="vm.getSelectedItemsIncluding(vm.assignedTeams, item)"\n' +
    '                          dnd-dragstart="vm.onDragStart(vm.assignedTeams, event)"\n' +
    '                          dnd-moved="vm.onMoved(vm.assignedTeams)"\n' +
    '                          dnd-dragend="vm.assignedTeams.dragging = false"\n' +
    '                          dnd-selected="item.selected = !item.selected"\n' +
    '                          ng-class="{\'selected\': item.selected}"\n' +
    '                          ng-hide="vm.assignedTeams.dragging && item.selected">\n' +
    '                        {{item.teamName}} - {{item.gender | translate}} - {{item.town}}\n' +
    '                      </li>\n' +
    '                    </ul>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '              </md-card-content>\n' +
    '            </md-card>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '<md-button class="md-fab md-accent md-fab-bottom-right" ng-click="vm.updateAssignedTeams()">\n' +
    '  <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '</md-button>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/draw/draw.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '    <md-card class="md-whiteframe-z2" flex-gt-md="70" flex="100">\n' +
    '        <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '            <md-card-header-text>\n' +
    '                <span class="md-headline">{{ \'CHAMPIONSHIPS.DRAW.TITLE\' | translate}}</span>\n' +
    '            </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '        <md-card-content layout="column" layout-align="space-around stretch">\n' +
    '            <div flex>\n' +
    '                <h1 class="md-title">{{\'CHAMPIONSHIPS.DATA\' | translate}}</h1>\n' +
    '                <md-divider></md-divider>\n' +
    '                <div layout="row" layout-padding layout-wrap>\n' +
    '                    <!-- NAME -->\n' +
    '                    <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                               ng-model="vm.championship.name" flex="50" disabled="true"></neo-input>\n' +
    '                    <!-- ROUNDS -->\n' +
    '                    <neo-input name="rounds" label="CHAMPIONSHIPS.ROUNDS" ng-model="vm.championship.rounds" flex="33"\n' +
    '                               icon="images/ic_repeat_black_48px.svg" disabled="true"></neo-input>\n' +
    '                    <!-- CATEGORY -->\n' +
    '                    <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                               ng-model="vm.category" flex="33" disabled="true"></neo-input>\n' +
    '                    <!-- SPORT -->\n' +
    '                    <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                               ng-model="vm.sport" flex="33" disabled="true"></neo-input>\n' +
    '                    <!-- GENDER -->\n' +
    '                    <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                               ng-model="vm.gender" flex="33" disabled="true"></neo-input>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <form name="drawForm" ng-submit="vm.drawChampionship()" flex layout="row">\n' +
    '                <div flex>\n' +
    '                    <h1 class="md-title">{{\'CHAMPIONSHIPS.DRAW.SELECT_MATCH_DAYS\' | translate}}</h1>\n' +
    '                    <md-divider></md-divider>\n' +
    '                    <div layout-padding>\n' +
    '                        <md-input-container ng-repeat="matchDay in vm.matchDays">\n' +
    '                            <label>{{\'CHAMPIONSHIPS.MATCH_DAY\' | translate}} {{$index + 1}}</label>\n' +
    '                            <md-datepicker name="{{matchDay.label}}" ng-model="matchDay.date"\n' +
    '                                           md-current-view="month" ng-required="true"></md-datepicker>\n' +
    '                            <div ng-messages="drawForm.elements.namedItem(matchDay.label).$error" role="alert">\n' +
    '                                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                            </div>\n' +
    '                        </md-input-container>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="listTeams" flex>\n' +
    '                    <h1 class="md-title">{{\'CHAMPIONSHIPS.DRAW.SELECT_TEAM_ORDER\' | translate}}</h1>\n' +
    '                    <md-divider></md-divider>\n' +
    '\n' +
    '                    <div layout="row">\n' +
    '                        <ul class="matchIndex" flex="10">\n' +
    '                            <li ng-repeat="team in vm.teams">\n' +
    '                                {{$index + 1}}\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                        <ul dnd-list="vm.teams" flex="90">\n' +
    '                            <li ng-repeat="item in vm.teams"\n' +
    '                                dnd-draggable="item"\n' +
    '                                dnd-moved="vm.teams.splice($index, 1)"\n' +
    '                                dnd-effect-allowed="move"\n' +
    '                                dnd-selected="vm.selectedTeam = item"\n' +
    '                                ng-class="{\'selected\': vm.selectedTeam === item}">\n' +
    '                                {{item.name}}\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-disabled="drawForm.$invalid"\n' +
    '                           ng-if="vm.teams.length > 0">\n' +
    '                    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="draw"></md-icon>\n' +
    '                </md-button>\n' +
    '            </form>\n' +
    '        </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/assign-matches/assign-matches.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '  <md-card class="md-whiteframe-z2" flex-gt-md="100" flex="100">\n' +
    '    <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '      <md-card-header-text>\n' +
    '        <span class="md-headline">{{ \'CHAMPIONSHIPS.ASSIGN_MATCHES\' | translate}}</span>\n' +
    '      </md-card-header-text>\n' +
    '    </md-card-header>\n' +
    '    <md-card-content layout="column" layout-align="space-around stretch">\n' +
    '\n' +
    '      <div flex>\n' +
    '        <h1 class="md-title">{{\'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}:&nbsp;&nbsp;{{vm.championship.name}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout="row" layout-align="space-around none" layout-padding layout-wrap>\n' +
    '          <!-- NAME -->\n' +
    '          <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                     ng-model="vm.championship.name" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- CATEGORY -->\n' +
    '          <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                     ng-model="vm.category" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- SPORT -->\n' +
    '          <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                     ng-model="vm.sport" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- ROUNDS -->\n' +
    '          <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                     ng-model="vm.gender" flex="25" is-disabled="true"></neo-input>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="matches">\n' +
    '        <h1 class="md-title">{{\'CHAMPIONSHIPS.MATCHES\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '\n' +
    '        <form name="matchesForm" layout="column" layout-wrap layout-padding>\n' +
    '\n' +
    '          <div class="matchday-container" ng-repeat="matchDay in vm.matchDays" flex>\n' +
    '            <md-list layout="column" flex>\n' +
    '              <div class="match-header" md-colors="{background: \'primary\'}" layout-padding flex>\n' +
    '                <span class="md-title">{{\'CHAMPIONSHIPS.MATCH_DAY\' | translate}} {{matchDay.number}}</span>\n' +
    '              </div>\n' +
    '              <md-list-item class="match-container" ng-repeat="match in matchDay.matches"\n' +
    '                            layout-xs="column" layout-sm="column" layout-md="row" layout-gt-md="row"\n' +
    '                            layout-align="space-around stretch" layout-fill layout-wrap\n' +
    '                            md-colors="::{background: {{ $odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'}}}">\n' +
    '\n' +
    '                <div flex="50" layout="row" layout-align="space-around stretch" layout-fill layout-wrap>\n' +
    '                  <md-input-container md-no-float flex="35">\n' +
    '                    <input type="text" ng-readonly="true" class="no-border"\n' +
    '                           placeholder="{{vm.getTeamName(match.localTeamId) || (\'CALENDAR.REST\' | translate)}}"\n' +
    '                           value="{{vm.getTeamName(match.localTeamId) || (\'CALENDAR.REST\' | translate)}}"/>\n' +
    '                  </md-input-container>\n' +
    '                  <div ng-if="!vm.championship.jvp" flex layout="row" layout-align="space-around stretch" layout-fill layout-wrap >\n' +
    '                    <md-input-container md-no-float flex="45">\n' +
    '                      <input type="number" step="1" ng-model="match.localScore" min="0"\n' +
    '                             placeholder="{{\'SCORE\' | translate}}" ng-disabled="!vm.canEditScore(match)"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container md-no-float flex>\n' +
    '                      <input type="text" ng-readonly="true" class="no-border" value="-" placeholder="versus"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container md-no-float flex="45">\n' +
    '                      <input type="number" step="1" ng-model="match.visitorScore" min="0"\n' +
    '                             placeholder="{{\'SCORE\' | translate}}" ng-disabled="!vm.canEditScore(match)"/>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                  <div ng-if="vm.championship.jvp" flex layout="row" layout-align="space-around stretch" layout-fill layout-wrap >\n' +
    '                    <md-input-container md-no-float flex>\n' +
    '                      <input type="text" ng-readonly="true" class="no-border" value="-" placeholder="versus"/>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                  <md-input-container md-no-float flex="35">\n' +
    '                    <input type="text" ng-readonly="true" class="no-border"\n' +
    '                           placeholder="{{vm.getTeamName(match.visitorTeamId) || (\'CALENDAR.REST\' | translate)}}"\n' +
    '                           value="{{vm.getTeamName(match.visitorTeamId) || (\'CALENDAR.REST\' | translate)}}"/>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <div flex="25" layout="row" layout-align="space-around stretch" layout-fill>\n' +
    '                  <md-input-container flex="60">\n' +
    '                    <md-datepicker name="date" ng-model="match.date" ng-required="true"\n' +
    '                                   md-placeholder="Enter date" ng-disabled="!vm.canEditDate(match)"></md-datepicker>\n' +
    '                    <div ng-messages="matchesForm.iniDate.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container flex="40" md-no-float>\n' +
    '                    <label>hh:mm</label>\n' +
    '                    <input type="time" ng-model="match.time"   ng-disabled="!vm.canEditTime(match)"/>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <div flex="25" layout="row" layout-align="space-around stretch" layout-fill layout-wrap>\n' +
    '                  <md-input-container flex>\n' +
    '                    <md-select ng-model="match.facilityId" placeholder="{{\'CALENDAR.FACILITY\' | translate}}"\n' +
    '                               ng-required="true" md-no-asterisk="true" ng-disabled="!vm.canEditFacility(match)">\n' +
    '                      <md-option ng-value="null">\n' +
    '                        <em>{{\'CALENDAR.NOT_FACILITY_ASSIGNED\' | translate}}</em>\n' +
    '                      </md-option>\n' +
    '                      <md-option ng-repeat="(id, facility) in vm.getMatchFacilities(match)" ng-value="id">\n' +
    '                       {{facility.townName}} - {{facility.name}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </md-list-item>\n' +
    '            </md-list>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '  <div flex>\n' +
    '    <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="matchesForm.$invalid"\n' +
    '               ng-click="vm.saveMatches()">\n' +
    '      <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '      <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '    </md-button>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntament/informacio/text.tpl.html',
    '<form novalidate name="editForm" ng-submit="vm.updateAjuntament()">\n' +
    '  <div class="md-whiteframe-1dp">\n' +
    '    <div layout="row" layout-xs="column" layout-align-gt-xs="space-around center" layout-padding>\n' +
    '      <div flex-gt-xs="40" flex layout="column" layout-padding>\n' +
    '\n' +
    '        <md-input-container>\n' +
    '          <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '          <label>{{\'NAME\' | translate}}</label>\n' +
    '          <input name="name" title="name" type="text" required ng-model="vm.ajuntament.name" ng-disabled="!vm.edit"/>\n' +
    '          <div ng-messages="editForm.name.$error" role="alert">\n' +
    '            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '          <label>{{\'EMAIL\' | translate}}</label>\n' +
    '          <input name="email" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                 ng-model="vm.ajuntament.email" ng-disabled="!vm.edit"/>\n' +
    '          <div ng-messages="editForm.email.$error" role="alert">\n' +
    '            <div ng-message-exp="[\'required\', \'pattern\']">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '\n' +
    '        <md-input-container class="md-block">\n' +
    '          <md-icon md-svg-src="images/ic_web_black_48px.svg"></md-icon>\n' +
    '          <label>{{\'WEB\' | translate}}</label>\n' +
    '          <input name="web" type="text" ng-model="vm.ajuntament.web" ng-disabled="!vm.edit"/>\n' +
    '        </md-input-container>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex-gt-xs="45" layout="column">\n' +
    '        <md-input-container class="md-block">\n' +
    '          <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '          <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '          <input name="address" type="text" ng-model="vm.ajuntament.address" ng-disabled="!vm.edit" required/>\n' +
    '          <div ng-messages="editForm.address.$error" role="alert">\n' +
    '            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </md-input-container>\n' +
    '\n' +
    '        <div flex layout="row">\n' +
    '          <md-input-container class="md-block" flex="75">\n' +
    '            <label>{{\'TOWN\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_location_city_black_48px.svg"></md-icon>\n' +
    '            <md-select ng-model="vm.ajuntament.idTown" ng-disabled="!vm.edit" required name="towns">\n' +
    '              <md-option ng-value="town.id" ng-repeat="town in vm.towns">{{ town.name }}</md-option>\n' +
    '            </md-select>\n' +
    '            <div ng-messages="editForm.towns.$error" role="alert">\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block" flex>\n' +
    '            <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '            <input type="text" name="zipCode" ng-model="vm.ajuntament.zipCode"\n' +
    '                   ng-pattern="/^[0-9]{5}$/" md-maxlength="5" ng-disabled="!vm.edit" required/>\n' +
    '            <div ng-messages="editForm.zipCode.$error" role="alert">\n' +
    '              <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}</div>\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '        <div flex layout="row">\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>{{\'PHONE\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '            <input name="phoneNumber" type="tel"\n' +
    '                   ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                   ng-model="vm.ajuntament.phoneNumber" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="editForm.phoneNumber.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>{{\'FAX\' | translate}}</label>\n' +
    '            <input name="fax" type="tel"\n' +
    '                   ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                   ng-model="vm.ajuntament.fax" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="ajuntamentForm.fax.$error" role="alert">\n' +
    '              <div ng-message="pattern">{{\'INVALID_FAX_NUMBER\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Xarxes socials informació -->\n' +
    '        <div flex layout="row" ng-if="!vm.edit">\n' +
    '          <md-button ng-if="vm.ajuntament.facebook" class="md-flat" aria-label="Facebook"\n' +
    '                     href="https://www.facebook.com/{{vm.ajuntament.facebook}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '          </md-button>\n' +
    '          <md-button ng-if="vm.ajuntament.twitter" class="md-flat" aria-label="Twitter"\n' +
    '                     href="https://twitter.com/{{vm.ajuntament.twitter}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '          </md-button>\n' +
    '          <md-button ng-if="vm.ajuntament.instagram" class="md-flat" aria-label="Instagram"\n' +
    '                     href="https://www.instagram.com/{{vm.ajuntament.instagram}}" target="_blank">\n' +
    '            <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- Xarxes socials edició -->\n' +
    '        <div flex layout="row" ng-if="vm.edit">\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Facebook</label>\n' +
    '            <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '            <input name="facbook" type="text"\n' +
    '                   ng-model="vm.ajuntament.facebook"/>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Twitter</label>\n' +
    '            <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '            <input name="twitter" type="text"\n' +
    '                   ng-model="vm.ajuntament.twitter"/>\n' +
    '          </md-input-container>\n' +
    '          <md-input-container class="md-block">\n' +
    '            <label>Instagram</label>\n' +
    '            <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '            <input name="instagram" type="text"\n' +
    '                   ng-model="vm.ajuntament.instagram"/>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-if="vm.edit"\n' +
    '             ng-disabled="editForm.$invalid">\n' +
    '    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  </md-button>\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntament/informacio/informacio.tpl.html',
    '<div layout="column" layout-gt-sm="row">\n' +
    '  <div layout="column" style="height: 100%" layout-align="space-between" flex-gt-sm="33">\n' +
    '    <div ui-view="image" flex="50"></div>\n' +
    '    <div ui-view="people" flex="50"></div>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-padding flex layout-align="center center">\n' +
    '    <div ui-view="text" style="min-width: 75%" flex></div>\n' +
    '  </div>\n' +
    '  <div ui-view="actions"></div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/calendar/championship/championshipexcel.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '  <md-card class="md-whiteframe-z2" flex-gt-md="100" flex="100">\n' +
    '    <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '      <md-card-header-text>\n' +
    '        <span class="md-headline">{{ \'CALENDAR.TITLE\' | translate}}</span>\n' +
    '      </md-card-header-text>\n' +
    '    </md-card-header>\n' +
    '       \n' +
    '    <md-card-content layout="column" layout-align="space-around stretch">\n' +
    '  <md-table-container>\n' +
    '      <table md-table md-row-select="true"   id="table2">   \n' +
    '      <div flex>\n' +
    '        <h1 class="md-title">{{\'CALENDAR.CHAMPIONSHIP\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout="row" layout-align="space-around none" layout-padding layout-wrap>\n' +
    '          <!-- NAME -->\n' +
    '            <td md-cell> {{vm.championship.name}}</td>\n' +
    '          <!-- CATEGORY -->\n' +
    '            <td md-cell> {{vm.category}}</td>\n' +
    '          <!-- SPORT -->\n' +
    '            <td md-cell> {{vm.sport}}</td>\n' +
    '          <!-- ROUNDS -->\n' +
    '           <td md-cell>  {{vm.gender}} </td>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="matches">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.MATCHES\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '\n' +
    '\n' +
    '        <div layout-xs="column" layout-sm="column" layout-gt-sm="row" layout-wrap layout-padding>\n' +
    '            </table>\n' +
    '  </md-table-container>\n' +
    '        \n' +
    '   <md-table-container>\n' +
    '      <table md-table md-row-select="true"   id="table2">    \n' +
    '          <tbody  ng-repeat="matchDay in vm.matchDays" flex="50">\n' +
    '       \n' +
    '           <td md-cell>    <div class="match-header" md-colors="{background: \'primary\'}" layout-padding flex>\n' +
    '                <span class="md-title" ng-if="!matchDay.sportMatchDay">{{\'CALENDAR.MATCH_DAY\' | translate}} {{matchDay.number}}</span>\n' +
    '                <span class="md-title" ng-if="matchDay.sportMatchDay">{{\'CALENDAR.SPORT_MATCH_DAY\' | translate}}</span>\n' +
    '               </div></td>\n' +
    '           <td md-cell>    <md-list-item ng-if="matchDay.sportMatchDay">\n' +
    '                <span>{{matchDay.date}}</span>\n' +
    '          </md-list-item></td>\n' +
    '                  \n' +
    '              <tr md-row class="match-container" ng-repeat="match in matchDay.matches" layout="row"\n' +
    '                            layout-align="space-around center"\n' +
    '                            layout-wrap md-colors="::{background: {{ vm.postponedMatch(match) ? \'\\\'grey\\\'\' :\n' +
    '                            (vm.matchHasUnresolvedCancellation(match) ? \'\\\'warn-A100\\\'\' : ($odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'))}}} ">\n' +
    '                <td md-cell> <span flex="20">{{match.date}} {{match.time || \'--:--\'}}</span></td>\n' +
    '                <td md-cell> <span flex="25">{{match.team1.teamInfo.name || (\'CALENDAR.REST\' | translate)}}</span></td>\n' +
    '               <td md-cell>  <span flex="10" layout="row" layout-align="space-around center" layout-wrap>\n' +
    '                  <span flex="40">{{match.localScore || \' \'}}</span>\n' +
    '                  <span flex="20"> - </span>\n' +
    '                  <span flex="40">{{match.visitorScore || \' \'}}</span>\n' +
    '                </span></td>\n' +
    '                <td md-cell> <span flex="25">{{match.team2.teamInfo.name || (\'CALENDAR.REST\' | translate)}}</span></td>\n' +
    '              <td md-cell>   <span flex="20">{{match.facility.name || (\'CALENDAR.NOT_FACILITY_ASSIGNED\' | translate)}}</span></td>\n' +
    '              </tr>  \n' +
    '      </tbody>\n' +
    '</table>\n' +
    '                   </md-table-container>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-if="!vm.isEmpty(vm.facilities)" flex id="facilities">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.FACILITIES\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '         <md-table-container>\n' +
    '        <table layout="column" layout-wrap layout-padding>\n' +
    '          <tr layout="row" class="match-container" >\n' +
    '            <td md-cell> <span flex class="md-title">INSTAL·LACIO</span></td>\n' +
    '            <td md-cell> <span flex class="md-title">ADRERÇA</span></td>\n' +
    '            \n' +
    '            \n' +
    '            \n' +
    '            <td md-cell>  <span flex class="md-title">POBLACIÓ</span></td>\n' +
    '            <td md-cell>  <span flex class="md-title">CODI POSTAL</span></td>\n' +
    '          </tr>\n' +
    '\n' +
    '          <tr class="facility-container" ng-repeat="facility in vm.facilities" layout="row"\n' +
    '                        layout-align="space-around center"\n' +
    '                        layout-wrap md-colors="::{background: {{ $odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'}}}">\n' +
    '            \n' +
    '            <td md-cell> <span flex>{{facility.name}}</span></td>\n' +
    '           <td md-cell>  <span flex>{{facility.address}}</span></td>\n' +
    '          <td md-cell>   <span flex>{{facility.town.name}}</span></td>\n' +
    '           <td md-cell>  <span flex>{{facility.zipCode}}</span></td>\n' +
    '          </tr>\n' +
    '        </table>\n' +
    '              </md-table-container>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="teams">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.TEAMS\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <md-list layout="column" layout-wrap layout-padding>\n' +
    '          <md-list-item layout="row" layout-align="space-around center" layout-wrap\n' +
    '                        md-colors="{background: \'primary\'}" class="team-container">\n' +
    '\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.ENTITY_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.ENTITY_PHONE\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.CONTACT_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.CONTACT_PHONE\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_SHIRT_COLOR\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_PANTS_COLOR\' | translate}}</span>\n' +
    '          </md-list-item>\n' +
    '\n' +
    '          <md-list-item class="team-container" ng-repeat="team in vm.teams" layout="row"\n' +
    '                        layout-align="space-around center"\n' +
    '                        layout-wrap md-colors="::{background: {{ $odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'}}}">\n' +
    '            <span flex>{{team.teamInfo.name}}</span>\n' +
    '            <span flex>{{team.publicEntityModel.name}}</span>\n' +
    '            <span flex>{{team.publicEntityModel.phoneNumber}}</span>\n' +
    '            <span flex>{{team.teamInfo.contactName}}</span>\n' +
    '            <span flex>{{team.teamInfo.phoneNumber}}</span>\n' +
    '            <span flex>{{team.teamInfo.shirtColor}}</span>\n' +
    '            <span flex>{{team.teamInfo.pantsColor}}</span>\n' +
    '          </md-list-item>\n' +
    '        </md-list>\n' +
    '      </div>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '  <neo-action-button buttons="vm.buttons"></neo-action-button>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/calendar/championship/championship.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '  <md-card class="md-whiteframe-z2" flex-gt-md="100" flex="100">\n' +
    '    <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '      <md-card-header-text>\n' +
    '        <span class="md-headline">{{ \'CALENDAR.TITLE\' | translate}}:&nbsp;&nbsp;{{vm.championship.name}}</span>\n' +
    '      </md-card-header-text>\n' +
    '    </md-card-header>\n' +
    '    <md-card-content layout="column" layout-align="space-around stretch">\n' +
    '\n' +
    '      <div flex>\n' +
    '       \n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout="row" layout-align="space-around none" layout-padding layout-wrap>\n' +
    '          <!-- NAME -->\n' +
    '          <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                     ng-model="vm.championship.name" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- CATEGORY -->\n' +
    '          <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                     ng-model="vm.category" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- SPORT -->\n' +
    '          <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                     ng-model="vm.sport" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- ROUNDS -->\n' +
    '          <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                     ng-model="vm.gender" flex="25" is-disabled="true"></neo-input>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="matches">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.MATCHES\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '\n' +
    '\n' +
    '        <div layout-xs="column" layout-sm="column" layout-gt-sm="row" layout-wrap layout-padding>\n' +
    '\n' +
    '          <div layout="row" layout-align="space-around center" flex="60">\n' +
    '            <div layout="row">\n' +
    '              <span class="md-body-2"> {{\'POSTPONEMENTS.POSTPONED_MATCH\' | translate }}</span>\n' +
    '              <div\n' +
    '                style=" margin-left: 10px; border: 1px solid rgba(0, 0, 0, 0);  border-radius: 2px; height: 20px; width: 20px;"\n' +
    '                md-colors="::{background : {{\'\\\'grey\\\'\'}}}"></div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout="row">\n' +
    '              <span class="md-body-2">{{\'CANCELLATIONS.SUSPENDED_MATCH\' | translate}}</span>\n' +
    '              <div\n' +
    '                style=" margin-left: 10px; border: 1px solid rgba(0, 0, 0, 0);  border-radius: 2px; height: 20px; width: 20px;"\n' +
    '                md-colors="::{background :  {{\'\\\'warn-A100\\\'\'}}}"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="matchday-container" ng-repeat="matchDay in vm.matchDays" flex="50">\n' +
    '            <md-list layout="column" flex>\n' +
    '              <div class="match-header" md-colors="{background: \'primary\'}" layout-padding flex>\n' +
    '                <span class="md-title" ng-if="!matchDay.sportMatchDay">{{\'CALENDAR.MATCH_DAY\' | translate}} {{matchDay.number}}</span>\n' +
    '                <span class="md-title" ng-if="matchDay.sportMatchDay">{{\'CALENDAR.SPORT_MATCH_DAY\' | translate}}</span>\n' +
    '              </div>\n' +
    '              <md-list-item ng-if="matchDay.sportMatchDay">\n' +
    '                <span>{{matchDay.date}}</span>\n' +
    '              </md-list-item>\n' +
    '              <md-list-item class="match-container" ng-repeat="match in matchDay.matches" layout="row"\n' +
    '                            layout-align="space-around center"\n' +
    '                            layout-wrap md-colors="::{background: {{ vm.postponedMatch(match) ? \'\\\'grey\\\'\' :\n' +
    '                            (vm.matchHasUnresolvedCancellation(match) ? \'\\\'warn-A100\\\'\' : ($odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'))}}} ">\n' +
    '                <span flex="20">{{match.date}} {{match.time || \'--:--\'}}</span>\n' +
    '                <span flex="25">{{match.team1.teamInfo.name || (\'CALENDAR.REST\' | translate)}}</span>\n' +
    '                <span flex="10" layout="row" layout-align="space-around center" layout-wrap>\n' +
    '                  <span flex="40">{{match.localScore || \' \'}}</span>\n' +
    '                  <span flex="20"> - </span>\n' +
    '                  <span flex="40">{{match.visitorScore || \' \'}}</span>\n' +
    '                </span>\n' +
    '                <span flex="25">{{match.team2.teamInfo.name || (\'CALENDAR.REST\' | translate)}}</span>\n' +
    '                <span flex="20">{{match.facility.name || (\'CALENDAR.NOT_FACILITY_ASSIGNED\' | translate)}}</span>\n' +
    '              </md-list-item>\n' +
    '            </md-list>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-if="!vm.isEmpty(vm.facilities)" flex id="facilities">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.FACILITIES\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <md-list layout="column" layout-wrap layout-padding>\n' +
    '          <md-list-item layout="row" layout-align="space-around center" layout-wrap\n' +
    '                        md-colors="{background: \'primary\'}" class="facility-container">\n' +
    '\n' +
    '            <span flex class="md-title">{{\'CALENDAR.FACILITY_MAP\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.FACILITY_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.FACILITY_ADDRESS\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.FACILITY_TOWN\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.FACILITY_ZIP_CODE\' | translate}}</span>\n' +
    '          </md-list-item>\n' +
    '\n' +
    '          <md-list-item class="facility-container" ng-repeat="facility in vm.facilities" layout="row"\n' +
    '                        layout-align="space-around center"\n' +
    '                        layout-wrap md-colors="::{background: {{ $odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'}}}">\n' +
    '            <span flex>\n' +
    '              <md-button class="md-primary"\n' +
    '                         ng-href="https://maps.google.com/?q=@{{facility.latitude}},{{facility.longitude}}"\n' +
    '                         target="_blank">\n' +
    '              <md-tooltip md-direction="right" md-delay="50">{{\'FACILITIES.MAP\' | translate}}</md-tooltip>\n' +
    '                <md-icon>place</md-icon>\n' +
    '              </md-button>\n' +
    '            </span>\n' +
    '            <span flex>{{facility.name}}</span>\n' +
    '            <span flex>{{facility.address}}</span>\n' +
    '            <span flex>{{facility.townName}}</span>\n' +
    '            <span flex>{{facility.zipCode}}</span>\n' +
    '          </md-list-item>\n' +
    '        </md-list>\n' +
    '      </div>\n' +
    '\n' +
    '      <div flex id="teams">\n' +
    '        <h1 class="md-title">{{\'CALENDAR.TEAMS\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <md-list layout="column" layout-wrap layout-padding>\n' +
    '          <md-list-item layout="row" layout-align="space-around center" layout-wrap\n' +
    '                        md-colors="{background: \'primary\'}" class="team-container">\n' +
    '\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.ENTITY_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.ENTITY_PHONE\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.CONTACT_NAME\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.CONTACT_PHONE\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_SHIRT_COLOR\' | translate}}</span>\n' +
    '            <span flex class="md-title">{{\'CALENDAR.TEAM_PANTS_COLOR\' | translate}}</span>\n' +
    '          </md-list-item>\n' +
    '\n' +
    '          <md-list-item class="team-container" ng-repeat="team in vm.teams" layout="row"\n' +
    '                        layout-align="space-around center"\n' +
    '                        layout-wrap md-colors="::{background: {{ $odd ? \'\\\'primary-50\\\'\': \'\\\'background\\\'\'}}}">\n' +
    '            <span flex>{{team.teamInfo.name}}</span>\n' +
    '            <span flex>{{team.publicEntityModel.name}}</span>\n' +
    '            <span flex>{{team.publicEntityModel.phoneNumber}}</span>\n' +
    '            <span flex>{{team.teamInfo.contactName}}</span>\n' +
    '            <span flex>{{team.teamInfo.phoneNumber}}</span>\n' +
    '            <span flex>{{team.teamInfo.shirtColor}}</span>\n' +
    '            <span flex>{{team.teamInfo.pantsColor}}</span>\n' +
    '          </md-list-item>\n' +
    '        </md-list>\n' +
    '      </div>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '  <neo-action-button buttons="vm.buttons"></neo-action-button>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/teams/team/team.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline" ng-if="!vm.edit">{{\'TEAM_DATA\' | translate}}</span>\n' +
    '          <span class="md-headline" ng-if="vm.edit">{{\'TEAM_MODIFY_DATA\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="row">\n' +
    '        <form name="teamForm" ng-submit="vm.updateTeam()" flex>\n' +
    '          <div layout="column" flex>\n' +
    '            <div layout="column" layout-align="space-around" flex>\n' +
    '\n' +
    '              <div layout="column" layout-align="center none" style="padding: 1% 25% 0 25%;">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'NAME\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                  <input name="name" ng-required="true" ng-model="vm.team.name" ng-disabled="!vm.edit"/>\n' +
    '                  <div ng-messages="teamForm.name.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-autocomplete\n' +
    '                  ng-disabled="vm.entities.length === 1 || !vm.edit  || vm.team.inscribedToChampionship"\n' +
    '                  md-search-text="searchText"\n' +
    '                  md-items="entity in vm.entities | filterAccents: searchText"\n' +
    '                  md-selected-item="vm.entitySelected"\n' +
    '                  md-item-text="entity.name"\n' +
    '                  md-min-length="0"\n' +
    '                  md-require-match\n' +
    '                  md-clear-button="true"\n' +
    '                  ng-required="true"\n' +
    '                  md-floating-label="{{\'ENTITY\' | translate}}">\n' +
    '                  <md-item-template>\n' +
    '                    <span md-highlight-text="searchText" md-highlight-flags="^i">{{entity.name}}</span>\n' +
    '                  </md-item-template>\n' +
    '                  <md-not-found>\n' +
    '                    {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                  </md-not-found>\n' +
    '                </md-autocomplete>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout="row" layout-align="space-around center" flex="100">\n' +
    '                <div layout="column" flex="40" layout-padding>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '                    <md-select name="programme" ng-model="vm.team.programmeId" ng-required="true"\n' +
    '                               ng-disabled="!vm.edit || vm.team.inscribedToChampionship">\n' +
    '                      <md-option ng-repeat="program in vm.programs" value="{{program.id}}">\n' +
    '                        {{program.name | translate }}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="teamForm.programme.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'SPORT\' | translate}}</label>\n' +
    '                    <md-select name="sport" ng-model="vm.team.sportId" ng-required="true"\n' +
    '                               ng-disabled="!vm.edit  || vm.team.inscribedToChampionship">\n' +
    '                      <md-option ng-repeat="sport in vm.sports" value="{{sport.id}}">\n' +
    '                        {{\'SPORTS.\'+ sport.name | translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="teamForm.sport.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'CATEGORY\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_folder_black_48px.svg"></md-icon>\n' +
    '                    <md-select name="category" ng-model="vm.team.categoryId" ng-required="true"\n' +
    '                               ng-disabled="!vm.edit  || vm.team.inscribedToChampionship">\n' +
    '                      <md-option ng-repeat="category in vm.categories" value="{{category.id}}">\n' +
    '                        {{\'CATEGORIES.\'+category.name | translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="teamForm.category.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-content ng-show="vm.showInsurance"> {{\'INSURANCE_PRICE.CONTENT\' | translate}} <b><span\n' +
    '                    ng-bind="vm.price.price"></span> {{\'INSURANCE_PRICE.CURRENCY\' | translate}}</b><span\n' +
    '                    ng-show="vm.price.provisional">{{\'INSURANCE_PRICE.PROVISIONAL\' | translate}}</span></md-content>\n' +
    '                </div>\n' +
    '                <div layout="column" flex="40">\n' +
    '\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'GENDER\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                    <md-select name="gender" ng-model="vm.team.genderId" ng-required="true"\n' +
    '                               ng-disabled="!vm.edit  || vm.team.inscribedToChampionship">\n' +
    '                      <md-option ng-repeat="gender in vm.genders" value="{{gender.id}}">{{gender.name | translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="teamForm.gender.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container>\n' +
    '                    <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                    <label>{{\'COLOR_SHIRT\' | translate}}</label>\n' +
    '                    <input title="shirtColor" type="text" ng-model="vm.team.shirtColor"\n' +
    '                           ng-disabled="!vm.edit"/>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container>\n' +
    '                    <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                    <label>{{\'COLOR_PANTS\' | translate}}</label>\n' +
    '                    <input title="pantsColor" type="text" ng-model="vm.team.pantsColor"\n' +
    '                           ng-disabled="!vm.edit"/>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <md-divider></md-divider>\n' +
    '            <div layout="column" layout-align="space-around" layout-padding>\n' +
    '              <h1 class="md-title">{{\'DATA_COACH\' | translate}}</h1>\n' +
    '              <div layout="row" layout-align="space-around">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'NAME\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                  <input title="coachName" type="text" ng-model="vm.team.coachName" ng-disabled="!vm.edit"/>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'EMAIL\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                  <input name="coachEmail" type="email" ng-model="vm.team.coachEmail" ng-pattern="/^.+@.+\\..+$/"\n' +
    '                         ng-disabled="!vm.edit"/>\n' +
    '                  <div ng-messages="teamForm.coachEmail.$error" role="alert">\n' +
    '                    <div ng-message="pattern">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'PHONE\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                  <input name="coachPhoneNumber" type="tel" ng-model="vm.team.coachPhone"\n' +
    '                         ng-pattern="/^[+]{0,1}[0-9]+$/" ng-disabled="!vm.edit"/>\n' +
    '                  <div ng-messages="teamForm.coachPhoneNumber.$error" role="alert">\n' +
    '                    <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <md-divider></md-divider>\n' +
    '              <h1 class="md-title">{{\'DATA_DELEGATE\' | translate}}</h1>\n' +
    '              <div layout="row" layout-align="space-around">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'NAME\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                  <input name="delegateName" type="text" ng-model="vm.team.delegateName" ng-disabled="!vm.edit"/>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block">\n' +
    '                  <label>{{\'EMAIL\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                  <input name="delegateEmail" type="email" ng-model="vm.team.delegateEmail"\n' +
    '                         ng-pattern="/^.+@.+\\..+$/"\n' +
    '                         ng-disabled="!vm.edit"/>\n' +
    '                  <div ng-messages="teamForm.delegateEmail.$error" role="alert">\n' +
    '                    <div ng-message="pattern">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'PHONE\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                  <input name="delegatePhoneNumber" type="tel" ng-model="vm.team.delegatePhone"\n' +
    '                         ng-pattern="/^[+]{0,1}[0-9]+$/" ng-disabled="!vm.edit"/>\n' +
    '                  <div ng-messages="teamForm.delegatePhoneNumber.$error" role="alert">\n' +
    '                    <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <md-divider></md-divider>\n' +
    '              <h1 class="md-title">{{\'JVP_INFO\' | translate}}</h1>\n' +
    '              <div layout="row" layout-align="space-around">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'COACH_CODE\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                  <input title="coachCode" ng-model="vm.team.coachCode" disabled  />\n' +
    '                </md-input-container>\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'STAND_TUTOR_CODE\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                  <input title="standTutorCode" ng-model="vm.team.standTutorCode" disabled/>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right" type="submit"\n' +
    '                       ng-disabled="teamForm.$invalid || teamForm.$pristine"\n' +
    '                       ng-if="vm.edit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-warn md-fab-bottom-right" ng-click="vm.discardChanges()"\n' +
    '                       style="margin-bottom: 72px;" ng-if="vm.edit">\n' +
    '              <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '      <neo-action-button buttons="vm.buttons"></neo-action-button>\n' +
    '      <neo-print-team-template id="teamPrintPreview" ng-hide="true" team="vm.printTeam"></neo-print-team-template>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/teams/team/delete-confirmation.tmpl.html',
    '<div layout="column" layout-padding>\n' +
    '  <h3 > {{alertText}}</h3>\n' +
    '  <md-divider></md-divider>\n' +
    '  <span> {{textContent}}</span>\n' +
    '</div>\n' +
    '<div layout="row" layout-align="end end"  flex>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-raised" ng-click="cancel()">{{ cancelText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-warn md-raised" ng-click="delete()">{{deleteText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/teams/new-team/new-team.tpl.html',
    '<div layout="row" layout-align="space-around center" style="padding-top: 1%">\n' +
    '\n' +
    '  <md-card flex-xs="100" flex="60">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_TEAM_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="teamForm" ng-submit="vm.createTeam()" flex>\n' +
    '          <div layout="column" flex>\n' +
    '            <div>\n' +
    '              <h1 class="md-title">{{\'NEW_TEAM_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="column" layout-align="space-around">\n' +
    '\n' +
    '                <div layout="column" layout-align="center none" style="padding: 1% 25% 0 25%;">\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'NAME\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                    <input name="name" type="text" required ng-model="vm.team.name"/>\n' +
    '                    <div ng-messages="teamForm.name.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-autocomplete ng-disabled="vm.entities.length === 1"\n' +
    '                                   md-search-text="searchText"\n' +
    '                                   md-items="entity in vm.entities | filterAccents: searchText"\n' +
    '                                   md-selected-item="vm.entitySelected"\n' +
    '                                   md-item-text="entity.name"\n' +
    '                                   md-min-length="0"\n' +
    '                                   md-require-match\n' +
    '                                   md-clear-button="true"\n' +
    '                                   required\n' +
    '                                   md-floating-label="{{\'ENTITY\' | translate}}">\n' +
    '                    <md-item-template>\n' +
    '                      <span md-highlight-text="searchText" md-highlight-flags="^i">{{entity.name}}</span>\n' +
    '                    </md-item-template>\n' +
    '                    <md-not-found>\n' +
    '                      {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                    </md-not-found>\n' +
    '                  </md-autocomplete>\n' +
    '                </div>\n' +
    '\n' +
    '                <div layout="row" layout-align="space-around center" flex="100">\n' +
    '                  <div layout="column" flex="40" layout-padding>\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '                      <md-select name="programme" ng-model="vm.team.programmeId" ng-required="true">\n' +
    '                        <md-option ng-repeat="program in vm.programs" value="{{program.id}}">\n' +
    '                          {{program.name | translate }}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="teamForm.programme.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'SPORT\' | translate}}</label>\n' +
    '                      <!--\n' +
    '                                        TODO: pending sport icon\n' +
    '                                        <md-icon md-svg-src="images/football.svg"></md-icon>\n' +
    '                      -->\n' +
    '                      <md-select name="sport" ng-model="vm.team.sportId" required\n' +
    '                                 ng-disabled="!vm.programmeSelected">\n' +
    '                        <md-option ng-repeat="sport in vm.sports" value="{{sport.id}}">\n' +
    '                          {{\'SPORTS.\'+sport.name | translate}}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="teamForm.sport.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'CATEGORY\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/ic_folder_black_48px.svg"></md-icon>\n' +
    '                      <md-select name="category" ng-model="vm.team.categoryId" required>\n' +
    '                        <md-option ng-repeat="category in vm.categories" value="{{category.id}}">\n' +
    '                          {{\'CATEGORIES.\'+category.name | translate}}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="teamForm.category.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                    <md-content ng-show="vm.showInsurance"> {{\'INSURANCE_PRICE.CONTENT\' | translate}} <b><span\n' +
    '                      ng-bind="vm.price.price"></span> {{\'INSURANCE_PRICE.CURRENCY\' | translate}}</b><span\n' +
    '                      ng-show="vm.price.provisional">{{\'INSURANCE_PRICE.PROVISIONAL\' | translate}}</span></md-content>\n' +
    '                  </div>\n' +
    '                  <div layout="column" flex="40">\n' +
    '\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'GENDER\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                      <md-select name="gender" ng-model="vm.team.genderId" required>\n' +
    '                        <md-option ng-repeat="gender in vm.genders" value="{{gender.id}}">{{gender.name | translate}}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="teamForm.gender.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container>\n' +
    '                        <md-icon class="material-icons md-dark">color_lens</md-icon>\n' +
    '                      <label>{{\'COLOR_SHIRT\' | translate}}</label>\n' +
    '                      <input title="shirtColor" type="text" ng-model="vm.team.shirtColor"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container>\n' +
    '                        <md-icon class="material-icons md-dark">color_lens</md-icon>\n' +
    '                      <label>{{\'COLOR_PANTS\' | translate}}</label>\n' +
    '                      <input title="pantsColor" type="text" ng-model="vm.team.pantsColor"/>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '\n' +
    '                </div>\n' +
    '                <div flex layout="row" layout-align="center center" layout-padding>\n' +
    '                  <md-input-container>\n' +
    '                  <md-checkbox ng-model="vm.lodp" name="lopd" aria-label="LODP" ng-required="true">\n' +
    '                    <a target="_blank" href="http://cebllob.org/lopd.pdf">Autorització de tractament de dades de caràcter personal i Acord de comunicació de dades entre clubs/entitats/centres i el Consell Esportiu del Baix Llobregat</a>\n' +
    '                  </md-checkbox>\n' +
    '                    <div ng-messages="teamForm.lopd.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="column" layout-align="space-around" layout-padding>\n' +
    '                <h1 class="md-title">{{\'DATA_COACH\' | translate}}</h1>\n' +
    '                <div layout="row" layout-align="space-around">\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'NAME\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                    <input title="coachName" type="text" ng-model="vm.team.coachName"/>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'EMAIL\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                    <input name="coachEmail" type="email" ng-model="vm.team.coachEmail" ng-pattern="/^.+@.+\\..+$/"/>\n' +
    '                    <div ng-messages="teamForm.coachEmail.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'PHONE\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                    <input name="coachPhoneNumber" type="tel" ng-model="vm.team.coachPhone"\n' +
    '                           ng-pattern="/^[+]{0,1}[0-9]+$/"/>\n' +
    '                    <div ng-messages="teamForm.coachPhoneNumber.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <md-divider></md-divider>\n' +
    '                <h1 class="md-title">{{\'DATA_DELEGATE\' | translate}}</h1>\n' +
    '                <div layout="row" layout-align="space-around">\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'NAME\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                    <input name="delegateName" type="text" ng-model="vm.team.delegateName"/>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'EMAIL\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                    <input name="delegateEmail" type="email" ng-model="vm.team.delegateEmail"\n' +
    '                           ng-pattern="/^.+@.+\\..+$/"/>\n' +
    '                    <div ng-messages="teamForm.delegateEmail.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'PHONE\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                    <input name="delegatePhoneNumber" type="tel" ng-model="vm.team.delegatePhone"\n' +
    '                           ng-pattern="/^[+]{0,1}[0-9]+$/"/>\n' +
    '                    <div ng-messages="teamForm.delegatePhoneNumber.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="teamForm.$invalid" type="submit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/statistics/teams/teams.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <div layout="row" layout-align="center center">\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'SEASON\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedSeasonId" ng-change="vm.changeSeason()">\n' +
    '        <md-option ng-repeat="season in vm.seasons" ng-value="season.id">\n' +
    '          {{season.name}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'PHASES.PHASE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedPhase" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'PHASES.ALL\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="phase in vm.phases" ng-value="phase">\n' +
    '          {{phase}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedProgramme" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'ALL_PROGRAMMES\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="programme in vm.programmes" ng-value="programme">\n' +
    '          {{programme | translate}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="column">\n' +
    '  <h1 class="md-title">{{vm.myChartObject.options.title | translate}}</h1>\n' +
    '  <div google-chart chart="vm.myChartObject" style="width:100%;" agc-on-ready="vm.readyHandler(chartWrapper)"></div>\n' +
    '  <div layout="row" layout-align="end center">\n' +
    '    <neo-download-csv-table html-table="vm.htmlTable"\n' +
    '                            filename="STATISTICS.TEAMS_EXCEL_FILENAME"></neo-download-csv-table>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/statistics/neoindi/neoindi.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    '\n' +
    '\n' +
    '  <script> window.location= \'http://neoprograma.cebllob.com/neoindi\'; </script>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/statistics/licenses/licenses.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <div layout="row" layout-align="center center">\n' +
    '     \n' +
    '    <md-input-container>\n' +
    '      <label>{{\'SEASON\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedSeasonId" ng-change="vm.changeSeason()">\n' +
    '        <md-option ng-repeat="season in vm.seasons" ng-value="season.id">\n' +
    '          {{season.name}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'PHASES.PHASE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedPhase" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'PHASES.ALL\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="phase in vm.phases" ng-value="phase">\n' +
    '          {{phase}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedProgramme" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'ALL_PROGRAMMES\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="programme in vm.programmes" ng-value="programme">\n' +
    '          {{programme | translate}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'LICENSE_TYPE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedLicenseType" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'PERSON_TYPES.ALL\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="licenseType in vm.licenseTypes" ng-value="licenseType">\n' +
    '          {{\'PERSON_TYPES.\' + licenseType | translate}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="column">\n' +
    '  <h1 class="md-title">{{vm.myChartObject.options.title | translate}}</h1>\n' +
    '  <div google-chart chart="vm.myChartObject" style="width:100%;" agc-on-ready="vm.readyHandler(chartWrapper)"></div>\n' +
    '  <div layout="row" layout-align="end center">\n' +
    '    <neo-download-csv-table html-table="vm.htmlTable"\n' +
    '                            filename=\'STATISTICS.LICENSES_EXCEL_FILENAME\'></neo-download-csv-table>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/statistics/entities/entities.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <div layout="row" layout-align="center center">\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'SEASON\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedSeasonId" ng-change="vm.changeMandatoryFilter()">\n' +
    '        <md-option ng-repeat="season in vm.seasons" ng-value="season.id">\n' +
    '          {{season.name}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'ENTITY\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedEntityId" ng-change="vm.changeMandatoryFilter()">\n' +
    '        <md-option ng-repeat="entity in vm.entities" ng-value="entity.id">\n' +
    '          {{entity.name}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '\n' +
    '    <md-input-container>\n' +
    '      <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '      <md-select ng-model="vm.selectedProgramme" ng-change="vm.changeFilter()">\n' +
    '        <md-option ng-value="undefined"><em>{{\'ALL_PROGRAMMES\' | translate}}</em></md-option>\n' +
    '        <md-option ng-repeat="programme in vm.programmes" ng-value="programme.name">\n' +
    '          {{programme.name | translate}}\n' +
    '        </md-option>\n' +
    '      </md-select>\n' +
    '    </md-input-container>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="row" layout-align="center center" ng-if="!vm.selectedEntityId" flex="100">\n' +
    '  <span style="padding-top: 1%" ><b>{{\'STATISTICS.SELECT_AN_ENTITY\' | translate}}</b></span>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="column" layout-align="space-between center" ng-if="vm.selectedEntityId">\n' +
    '  <div layout="column">\n' +
    '    <h1 class="md-title">{{vm.myChartObjectPlayers.options.title | translate}}</h1>\n' +
    '    <div google-chart chart="vm.myChartObjectPlayers" style="width:100%;"\n' +
    '         agc-on-ready="vm.readyPlayerHandler(chartWrapper)"></div>\n' +
    '    <div layout="row" layout-align="end center">\n' +
    '      <neo-download-csv-table html-table="vm.htmlPlayerTable"\n' +
    '                              filename=\'STATISTICS.PLAYER_LICENSES_EXCEL_FILENAME\'></neo-download-csv-table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div layout="column">\n' +
    '    <h1 class="md-title">{{vm.myChartObjectNoPlayers.options.title | translate}}</h1>\n' +
    '    <div google-chart chart="vm.myChartObjectNoPlayers" style="width:100%;"\n' +
    '         agc-on-ready="vm.readyNoPlayerHandler(chartWrapper)"></div>\n' +
    '    <div layout="row" layout-align="end center">\n' +
    '      <neo-download-csv-table html-table="vm.htmlNoPlayerTable"\n' +
    '                              filename=\'STATISTICS.NO_PLAYER_LICENSES_EXCEL_FILENAME\'></neo-download-csv-table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div layout="column">\n' +
    '    <h1 class="md-title">{{vm.myChartObjectTeams.options.title | translate}}</h1>\n' +
    '    <div google-chart chart="vm.myChartObjectTeams" style="width:100%;"\n' +
    '         agc-on-ready="vm.readyTeamHandler(chartWrapper)"></div>\n' +
    '    <div layout="row" layout-align="end center">\n' +
    '      <neo-download-csv-table html-table="vm.htmlTeamTable"\n' +
    '                              filename=\'STATISTICS.TEAM_EXCEL_FILENAME\'></neo-download-csv-table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/user/profile/profile.tpl.html',
    '<div layout="row" layout-align="center center" flex layout-padding>\n' +
    '  <div ui-view="details" flex></div>\n' +
    '  <div ui-view="actions" ng-if="vm.isAdmin"></div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/user/profile/details.tpl.html',
    '<div layout="row" layout-align="center center" flex layout-padding>\n' +
    '  <div class="md-whiteframe-2dp" flex="75" layout-padding>\n' +
    '    <h1 class="md-title">{{\'USER_DATA\' | translate}}</h1>\n' +
    '    <md-divider></md-divider>\n' +
    '    <form novalidate name="userProfileForm" ng-submit="vm.updateEmail()">\n' +
    '      <div layout="row">\n' +
    '        <div flex="33" layout="row" layout-align="center" layout-padding>\n' +
    '          <img\n' +
    '            src="http://www.motorolasolutions.com/content/dam/msi/images/business/products/accessories/_images/_staticfiles/b2b_product_placeholder_lg_us-en.jpg"\n' +
    '            style="width: 168px; height: 168px">\n' +
    '        </div>\n' +
    '        <div layout="row" flex="66">\n' +
    '          <div layout="column" flex="50">\n' +
    '            <md-input-container class="md-block">\n' +
    '              <label>Email</label>\n' +
    '              <input title="email" required ng-pattern="/^.+@.+\\..+$/" ng-model="vm.profile.email"\n' +
    '                     ng-disabled="!vm.edit">\n' +
    '              <div ng-messages="editForm.email.$error" role="alert">\n' +
    '                <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '                  Aquest camp és obligatori i ha de ser com: example@example.com\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-if="vm.edit"\n' +
    '                 ng-disabled="userProfileForm.$invalid">\n' +
    '        <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '</div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/seasons/new-season/new-season.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="50" flex-xs="100" flex="70" >\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_SEASON_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="seasonForm">\n' +
    '        <div layout-align="center center" layout="row" layout-padding>\n' +
    '          <div layout="column" flex layout-padding>\n' +
    '            <div layout="column" layout-align="center none" style="padding: 0 10% 0 10%">\n' +
    '              <md-input-container>\n' +
    '                <label>{{\'SEASON_NAME\' | translate}}</label>\n' +
    '                <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                <input title="name" type="text" required ng-model="vm.temporada.name"/>\n' +
    '                <div ng-messages="seasonForm.name.$error" role="alert">\n' +
    '                  <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                </div>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '            <div layout="column" layout-gt-md="row" layout-align="space-around center" style="padding: 0 0 2% 0">\n' +
    '              <div layout="row" layout-align="start center" layout-padding>\n' +
    '                <label>{{\'INI_DATE\' | translate}}</label>\n' +
    '                <md-datepicker ng-model="vm.temporada.data1" md-current-view="year" ng-required="true"\n' +
    '                               md-placeholder="{{\'INI_DATE\' | translate}}"></md-datepicker>\n' +
    '              </div>\n' +
    '              <div layout="row" layout-align="start center" layout-padding>\n' +
    '                <label>{{\'END_DATE\' | translate}}</label>\n' +
    '                <md-datepicker ng-model="vm.temporada.data2" md-current-view="year" ng-required="true"\n' +
    '                               md-placeholder="{{\'END_DATE\' | translate}}"></md-datepicker>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <md-divider></md-divider>\n' +
    '            <div layout="column" layout-gt-md="row" layout-align="space-around center" style="padding: 0 0 2% 0">\n' +
    '              <div layout="row" layout-align="start center" layout-padding>\n' +
    '                <label>{{\'SPORT_MATCH_DAY\' | translate}}</label>\n' +
    '                <md-datepicker ng-model="vm.temporada.datajornadaesportiva" md-current-view="year" ng-required="false"\n' +
    '                               md-placeholder="{{\'SPORT_MATCH_DAY\' | translate}}"></md-datepicker>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <md-divider></md-divider>\n' +
    '            <div layout-align="center center">\n' +
    '              <span><i>{{\'AUTOMATIC_IMPORT\' | translate}}</i></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="seasonForm.$invalid"\n' +
    '                     ng-click="vm.confirmAlta()">\n' +
    '            <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/seasons/season/season.tpl.html',
    '<h2>season</h2>\n' +
    '<p>{{season.ctrlName}}</p>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referees/referee/referee.tpl.html',
    '<div layout="row" layout-align="space-around center" style="padding-top: 1%;">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline" ng-if="!vm.edit">{{\'REFEREES.REFEREE_PERSON_DATA\' | translate}}</span>\n' +
    '          <span class="md-headline" ng-if="vm.edit">{{\'REFEREES.MODIFY_REFEREE_PERSON_DATA\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.updatePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '                <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                           ng-model="vm.person.surname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="50">\n' +
    '                  <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                 ng-required="true" ng-disabled="!vm.edit" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <div layout-gt-sm="row" flex="50">\n' +
    '\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="50">\n' +
    '                  <label>{{\'GENDER\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                  <md-select name="gender" ng-model="vm.person.genderId" ng-required="true" ng-disabled="!vm.edit">\n' +
    '                    <md-option ng-repeat="gender in vm.personGenders" value="{{gender.id}}">{{gender.name |\n' +
    '                      translate}}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="refereeForm.gender.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '\n' +
    '                <neo-input name="nif" label="NIF/NIE" icon="images/ic_person_black_48px.svg" ng-model="vm.person.nif"\n' +
    '                           flex="45" layout-gt-sm="column" is-disabled="!vm.edit" md-maxlength="50"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <neo-input name="email" label="CONTACT_EMAIL" icon="images/ic_email_black_48px.svg"\n' +
    '                         ng-model="vm.person.email" error="EMAIL_INVALID_FORMAT"\n' +
    '                         pattern="^.+@.+\\..+$" flex="45" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '\n' +
    '              <neo-input name="iban" label="IBAN" icon="images/ic_person_black_48px.svg" ng-model="vm.license.iban"\n' +
    '                         is-disabled="!vm.edit"\n' +
    '                         pattern="^ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}$" error="IBAN_INVALID_FORMAT"\n' +
    '                         flex="45" layout-gt-sm="column"></neo-input>\n' +
    '\n' +
    '              <neo-input name="hic" label="HEALTH_INSURANCE_CARD_NUMBER" icon="images/ic_healing_black_48px.svg"\n' +
    '                         ng-model="vm.person.healthInsuranceCardNumber" flex="45" layout-gt-sm="column"\n' +
    '                         is-disabled="!vm.edit"></neo-input>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <neo-input name="address" label="ADDRESS" icon="images/ic_location_black_48px.svg"\n' +
    '                         ng-model="vm.person.address" flex="45" layout-gt-sm="column"\n' +
    '                         is-disabled="!vm.edit"></neo-input>\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '                <neo-input name="town" label="TOWN" icon="images/ic_location_city_black_48px.svg"\n' +
    '                           ng-model="vm.person.town" flex="70" layout-gt-sm="column"\n' +
    '                           is-disabled="!vm.edit"></neo-input>\n' +
    '                <neo-input name="zipCode" label="POSTAL_CODE" ng-model="vm.person.zipCode"\n' +
    '                           error="INVALID_POSTAL_CODE" pattern="^[0-9]{5}$"\n' +
    '                           flex="30" layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout="row" layout-align="end center">\n' +
    '              <md-input-container flex="30">\n' +
    '                <label>{{\'REFEREES.CODE\' | translate}}</label>\n' +
    '                <md-icon>assignment_ind</md-icon>\n' +
    '                <input name="refereeCode" disabled ng-model="vm.license.code" name="refereeCode">\n' +
    '              </md-input-container>\n' +
    '              <!--              <neo-input name="refereeCode" label="REFEREES.CODE" ng-model="vm.license.code"\n' +
    '                                       flex="40" layout-gt-sm="column" is-disabled="true"></neo-input>-->\n' +
    '            </div>\n' +
    '\n' +
    '            <h1 class="md-title">{{\'ASSOCIATIONS\' | translate}}</h1>\n' +
    '            <md-divider layout-padding></md-divider>\n' +
    '            <div layout-align="center-center">\n' +
    '\n' +
    '            </div>\n' +
    '            <div layout="row" layout-align="start center">\n' +
    '              <div ng-if="vm.initialState.belongsToTownHall">\n' +
    '                <span>&nbsp;{{\'REFEREES.BELONGS_TO_TONWHALL\' | translate}}<b> {{vm.initialState.belongingTownHall.name}}</b></span>\n' +
    '              </div>\n' +
    '              <div ng-if="vm.initialState.belongsToEntity">\n' +
    '                <span>&nbsp;{{\'REFEREES.BELONGS_TO_ENTITY\' | translate}} <b> {{vm.initialState.belongingEntity.name}}</b></span>\n' +
    '              </div>\n' +
    '              <div ng-if="vm.initialState.belongsToCouncil">\n' +
    '                <span>{{\'REFEREES.BELONGS_TO_COUNCIL\' | translate}} <b> {{\'COUNCIL\' | translate}}</b></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div layout="row" layout-align="center" flex ng-if="vm.edit">\n' +
    '              <div layout="row" layout-align="space-around center" flex="50" ng-if="vm.isAdmin()">\n' +
    '                <md-checkbox ng-model="vm.belongsToCouncil" aria-label="council"\n' +
    '                             ng-change="vm.setRefereeToCouncil()">\n' +
    '                  {{\'COUNCIL\' | translate}}\n' +
    '                </md-checkbox>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout="row" layout-align="space-around center" flex="50">\n' +
    '                <md-checkbox ng-model="vm.belongsToTownHall" aria-label="townHall"\n' +
    '                             ng-change="vm.setRefereeToTownhall()">\n' +
    '                  {{\'TOWN_HALL\' | translate}}\n' +
    '                </md-checkbox>\n' +
    '                <md-autocomplete layout-padding ng-disabled="!vm.isTowhallSelectable"\n' +
    '                                 md-selected-item="vm.selectedTownhall"\n' +
    '                                 md-search-text="townHallSearch" md-clear-button="true"\n' +
    '                                 md-items="townHall in vm.townHalls | filterAccents: townHallSearch"\n' +
    '                                 md-item-text="townHall.name" md-min-length="0" md-require-match\n' +
    '                                 ng-required="vm.isTowhallSelectable"\n' +
    '                                 md-floating-label="{{\'TOWN_HALL\' | translate}}">\n' +
    '                  <md-item-template>\n' +
    '                                <span md-highlight-text="vm.townHallSearch"\n' +
    '                                      md-highlight-flags="^i">{{townHall.name}}</span>\n' +
    '                  </md-item-template>\n' +
    '                  <md-not-found>\n' +
    '                    {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                  </md-not-found>\n' +
    '                </md-autocomplete>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout="row" layout-align="space-around center" flex="50" ng-if="!vm.isAdmin()">\n' +
    '                <md-checkbox ng-model="vm.belongsToEntity" aria-label="entity"\n' +
    '                             ng-change="vm.setRefereeToEntity()">\n' +
    '                  {{\'ENTITY\' | translate}}\n' +
    '                </md-checkbox>\n' +
    '                <md-autocomplete ng-disabled="!vm.isEntitySelectable" md-selected-item="vm.selectedEntity"\n' +
    '                                 md-search-text="entitySearch" md-clear-button="true"\n' +
    '                                 md-items="entity in vm.entities | filterAccents: entitySearch"\n' +
    '                                 md-item-text="entity.name" md-min-length="0" md-require-match\n' +
    '                                 ng-required="vm.isEntitySelectable"\n' +
    '                                 md-floating-label="{{\'ENTITY\' | translate}}">\n' +
    '                  <md-item-template>\n' +
    '                    <span md-highlight-text="vm.entitySearch" md-highlight-flags="^i">{{entity.name}}</span>\n' +
    '                  </md-item-template>\n' +
    '                  <md-not-found>\n' +
    '                    Not Found\n' +
    '                  </md-not-found>\n' +
    '                </md-autocomplete>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right"\n' +
    '                       ng-disabled="refereeForm.$invalid || refereeForm.$pristine" type="submit"\n' +
    '                       ng-click="vm.updateLicense()">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-warn md-fab-bottom-right"\n' +
    '                       ng-if="vm.edit" ng-click="vm.disableEdit()" style="margin-bottom: 72px;">\n' +
    '              <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '<div>\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referees/new-referee/new-referee.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'REFEREES.NEW\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '          <form name="refereeForm" ng-submit="vm.saveReferee()" flex>\n' +
    '            <div layout="column" layout-padding flex>\n' +
    '              <h1 class="md-title">{{\'ASSOCIATIONS\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="row" layout-align="center" flex>\n' +
    '                <div layout="row" layout-align="space-around center" flex="50" ng-if="vm.isAdmin()">\n' +
    '                  <md-checkbox ng-model="vm.belongsToCouncil" aria-label="council"\n' +
    '                               ng-change="vm.setRefereeToCouncil()">\n' +
    '                    {{\'COUNCIL\' | translate}}\n' +
    '                  </md-checkbox>\n' +
    '                </div>\n' +
    '\n' +
    '                <div layout="row" layout-align="space-around center" flex="50">\n' +
    '                  <md-checkbox ng-model="vm.belongsToTownHall" aria-label="townHall"\n' +
    '                               ng-change="vm.setRefereeToTownhall()">\n' +
    '                    {{\'TOWN_HALL\' | translate}}\n' +
    '                  </md-checkbox>\n' +
    '                  <md-autocomplete layout-padding ng-disabled="!vm.isTowhallSelectable"\n' +
    '                                   md-selected-item="vm.selectedTownhall"\n' +
    '                                   md-search-text="townHallSearch" md-clear-button="true"\n' +
    '                                   md-items="townHall in vm.townHalls | filterAccents: townHallSearch"\n' +
    '                                   md-item-text="townHall.name" md-min-length="0" md-require-match\n' +
    '                                   ng-required="vm.isTowhallSelectable"\n' +
    '                                   md-floating-label="{{\'TOWN_HALL\' | translate}}">\n' +
    '                    <md-item-template>\n' +
    '                                <span md-highlight-text="vm.townHallSearch"\n' +
    '                                      md-highlight-flags="^i">{{townHall.name}}</span>\n' +
    '                    </md-item-template>\n' +
    '                    <md-not-found>\n' +
    '                      {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                    </md-not-found>\n' +
    '                  </md-autocomplete>\n' +
    '                </div>\n' +
    '\n' +
    '                <div layout="row" layout-align="space-around center" flex="50" ng-if="!vm.isAdmin()">\n' +
    '                  <md-checkbox ng-model="vm.belongsToEntity" aria-label="entity"\n' +
    '                               ng-change="vm.setRefereeToEntity()">\n' +
    '                    {{\'ENTITY\' | translate}}\n' +
    '                  </md-checkbox>\n' +
    '                  <md-autocomplete ng-disabled="!vm.isEntitySelectable" md-selected-item="vm.selectedEntity"\n' +
    '                                   md-search-text="entitySearch" md-clear-button="true"\n' +
    '                                   md-items="entity in vm.entities | filterAccents: entitySearch"\n' +
    '                                   md-item-text="entity.name" md-min-length="0" md-require-match\n' +
    '                                   ng-required="vm.isEntitySelectable"\n' +
    '                                   md-floating-label="{{\'ENTITY\' | translate}}">\n' +
    '                    <md-item-template>\n' +
    '                      <span md-highlight-text="vm.entitySearch" md-highlight-flags="^i">{{entity.name}}</span>\n' +
    '                    </md-item-template>\n' +
    '                    <md-not-found>\n' +
    '                      Not Found\n' +
    '                    </md-not-found>\n' +
    '                  </md-autocomplete>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <h1 class="md-title">{{\'PERSONAL_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                             ng-model="vm.person.name" flex="50" layout-gt-sm="column"></neo-input>\n' +
    '                  <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                             ng-model="vm.person.surname" flex="45"\n' +
    '                             layout-gt-sm="column"></neo-input>\n' +
    '                </div>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                  <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                             layout-gt-sm="column"></neo-input>\n' +
    '\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                    <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                   ng-required="true" md-max-date="vm.today"></md-datepicker>\n' +
    '                    <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <div layout-gt-sm="row" flex="50">\n' +
    '\n' +
    '\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'GENDER\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                    <md-select name="gender" ng-model="vm.person.genderId" ng-required="true">\n' +
    '                      <md-option ng-repeat="gender in vm.personGenders" value="{{gender.id}}">{{gender.name |\n' +
    '                        translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="refereeForm.gender.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <neo-input name="nif" label="NIF/NIE" icon="images/ic_person_black_48px.svg" ng-model="vm.person.nif"\n' +
    '                             flex="45" layout-gt-sm="column" md-maxlength="50"></neo-input>\n' +
    '                </div>\n' +
    '\n' +
    '                <neo-input name="email" label="CONTACT_EMAIL" icon="images/ic_email_black_48px.svg"\n' +
    '                           ng-model="vm.person.email" error="EMAIL_INVALID_FORMAT"\n' +
    '                           pattern="^.+@.+\\..+$" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '\n' +
    '                <neo-input name="iban" label="IBAN" icon="images/ic_person_black_48px.svg" ng-model="vm.person.iban"\n' +
    '                           pattern="^ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}$" error="IBAN_INVALID_FORMAT" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '\n' +
    '\n' +
    '                <neo-input name="hic" label="HEALTH_INSURANCE_CARD_NUMBER" icon="images/ic_healing_black_48px.svg"\n' +
    '                           ng-model="vm.person.healthInsuranceCardNumber" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="address" label="ADDRESS" icon="images/ic_location_black_48px.svg"\n' +
    '                           ng-model="vm.person.address" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="town" label="TOWN" icon="images/ic_location_city_black_48px.svg"\n' +
    '                             ng-model="vm.person.town" flex="70" layout-gt-sm="column"></neo-input>\n' +
    '                  <neo-input name="zipCode" label="POSTAL_CODE" ng-model="vm.person.zipCode"\n' +
    '                             error="INVALID_POSTAL_CODE" pattern="^[0-9]{5}$"\n' +
    '                             flex="30" layout-gt-sm="column"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div flex layout="row" layout-align="center center" layout-padding>\n' +
    '                <md-input-container>\n' +
    '                  <md-checkbox ng-model="vm.lopd" name="lopd" aria-label="LODP" ng-required="true">\n' +
    '                     <a target="_blank" href="http://cebllob.org/lopd.pdf">Autorització de tractament de dades de caràcter personal i Acord de comunicació de dades entre clubs/entitats/centres i el Consell Esportiu del Baix Llobregat</a>\n' +
    '                  </md-checkbox>\n' +
    '                  <div ng-messages="refereeForm.lopd.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div flex>\n' +
    '              <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="refereeForm.$invalid" type="submit">\n' +
    '                <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '              </md-button>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/new-line/new-line.tpl.html',
    ' <md-card>\n' +
    '      <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.updatePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '\n' +
    '                <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.surname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="50">\n' +
    '                  <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                 ng-disabled="!vm.edit" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '              \n' +
    '                </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '<div layout="row" layout-align="space-around center">\n' +
    ' <md-card  flex-gt-md="100" flex="100">\n' +
    '      <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.createLinea()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                 <md-input-container class="md-block" flex="50">\n' +
    '                  <label>Data</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="vm.linea.fecha" md-current-view="day"\n' +
    '                                 ng-disabled="false" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '             \n' +
    '                \n' +
    '                  <div layout-gt-sm="row" layout-align="space-between center" flex="90">\n' +
    '                  \n' +
    '                    <neo-input name="esport" label="Concepte" is-required="true"\n' +
    '                               ng-model="vm.linea.esport"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                              ></neo-input>\n' +
    '                  </div>\n' +
    '                \n' +
    '             <div layout-gt-sm="row" layout-align="space-between center" flex="40">\n' +
    '                  \n' +
    '                    <neo-input name="rounds" label="Num. partits" is-required="true"\n' +
    '                               ng-model="vm.linea.numpartits"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                               ></neo-input>\n' +
    '                  </div>\n' +
    '                \n' +
    '                 <div layout-gt-sm="row" layout-align="space-between center" flex="40">\n' +
    '                  \n' +
    '                    <neo-input name="preu" label="Preu brut" is-required="true"\n' +
    '                               ng-model="vm.linea.preu"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                               ></neo-input>\n' +
    '                  </div>\n' +
    '               \n' +
    '\n' +
    '                \n' +
    '                 \n' +
    '                    <md-checkbox type="checkbox" name="sinirpf" label="Sin IRPF" ng-required="false"\n' +
    '                                 ng-model="vm.linea.sinirpf" flex="40" ng-checked="false"> Sin_IRPF </md-checkbox>\n' +
    '                \n' +
    '                  <md-checkbox type="checkbox" name="sintexto" label="Sin texto" ng-required="false"\n' +
    '                                 ng-model="vm.linea.sintexto" flex="40" ng-checked="false"> Sin_Texto </md-checkbox>\n' +
    '                  <md-select placeholder="Selecciar receptor" ng-model="selectreceptor" style=";color: black">\n' +
    '      <md-option ng-value="recept" ng-repeat="recept in receptores"  ng-selected="{{recept.idReceptor}} == {{sel}}">{{recept.nombre}}</md-option>\n' +
    '    </md-select>\n' +
    '            </div>\n' +
    '              \n' +
    '                </div>\n' +
    '             <div flex>\n' +
    '              <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="refereeForm.$invalid" type="submit">\n' +
    '                <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '              </md-button>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '</div>     \n' +
    '    ');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/line/line.tpl.html',
    ' <md-card>\n' +
    '      <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.updatePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '\n' +
    '                <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.surname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="50">\n' +
    '                  <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                 ng-disabled="!vm.edit" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '              \n' +
    '                </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '<div layout="row" layout-align="space-around center">\n' +
    ' <md-card  flex-gt-md="100" flex="100">\n' +
    '      <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.createLinea()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                \n' +
    '                 <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                  \n' +
    '                    <neo-input name="Num. Factura" label="Num. Factura" is-required="false"\n' +
    '                               ng-model="numinvoice"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"  is-disabled="true"\n' +
    '                               ></neo-input>\n' +
    '                  </div>\n' +
    '                 <md-input-container class="md-block" flex="50">\n' +
    '                  <label>Data</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="fecha" md-current-view="day"\n' +
    '                                 ng-disabled="false" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                \n' +
    '              \n' +
    '                \n' +
    '                  <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                  \n' +
    '                    <neo-input name="esport" label="Esport" is-required="true"\n' +
    '                               ng-model="esport"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                              ></neo-input>\n' +
    '                  </div>\n' +
    '                \n' +
    '             <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                  \n' +
    '                    <neo-input name="rounds" label="Num. partits" is-required="true"\n' +
    '                               ng-model="numpartits"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                               ></neo-input>\n' +
    '                  </div>\n' +
    '                \n' +
    '                 <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                  \n' +
    '                    <neo-input name="preu" label="Preu" is-required="true"\n' +
    '                               ng-model="preu"\n' +
    '                               layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                               ></neo-input>\n' +
    '                  </div>\n' +
    '                  <md-checkbox type="checkbox" name="sinirpf" label="Sin IRPF" ng-required="false"\n' +
    '                                 ng-model="sinirpf" flex="40" > Sin_IRPF </md-checkbox>\n' +
    '                \n' +
    '                  <md-checkbox type="checkbox" name="sintexto" label="Sin Texto" ng-required="false"\n' +
    '                                 ng-model="sintexto" flex="40" > Sin_Texto </md-checkbox>\n' +
    '                 <md-select placeholder="Selecciar receptor" ng-model="selectreceptor" style=";color: black">\n' +
    '      <md-option ng-value="recept" ng-repeat="recept in receptores"  ng-selected="{{recept.idReceptor}} == {{sel}}">{{recept.nombre}}</md-option>\n' +
    '    </md-select>\n' +
    '                 <div layout-gt-sm="row" layout-align="space-between center" flex="15">\n' +
    '                <md-button  ng-click="vm.esborrar()" >\n' +
    '            <md-icon md-svg-src="images/baseline-delete-24px.svg" class="s24"\n' +
    '                     aria-label="Esborrar linea"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">Esborrar linea</md-tooltip>\n' +
    '                </md-button></div>\n' +
    '            </div>\n' +
    '              \n' +
    '                </div>\n' +
    '             <div flex>\n' +
    '              <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="refereeForm.$invalid" type="submit">\n' +
    '                <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '              </md-button>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '</div>     \n' +
    '    ');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/invoices-trimestral/invoices-trimestral.tpl.html',
    '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>\n' +
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '     \n' +
    '      <md-datepicker md-current-view="year" ng-required="true" ng-model="vm.iniDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.currentSeason.iniDate"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '    \n' +
    '      <md-button type="submit" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '    \n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   \n' +
    '\n' +
    '    <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '             <md-button ng-click="exportToExcel(\'#table1\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">Partits arbitrats</span> \n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <md-table-container>\n' +
    '          <table  md-table ng-model="vm.selected"  id="table1" >\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '                \n' +
    '                \n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '               \n' +
    '           \n' +
    '              <th md-column md-order-by="cognom1"><span class="md-title">Cognom</span></th>\n' +
    '            \n' +
    '                <th md-column md-order-by="nom"><span class="md-title">Nom</span></th>\n' +
    '             \n' +
    '              <th md-column show-gt-xs hide><span class="md-title">DNI</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">Adreça</span></th>\n' +
    '               <th md-column show-gt-xs hide><span class="md-title">Municipi</span></th>\n' +
    '             <th md-column show-gt-xs hide><span class="md-title">Base 1er trim</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">% Retenció 1er trim</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Import Retenció 1er trim</span></th>\n' +
    '                    <th md-column show-gt-xs hide><span class="md-title">Base 2on trim</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">% Retenció 2on trim</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Import Retenció 2on trim</span></th>\n' +
    '                    <th md-column show-gt-xs hide><span class="md-title">Base 3er trim</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">% Retenció 3er trim</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Import Retenció 3er trim</span></th>\n' +
    '                    <th md-column show-gt-xs hide><span class="md-title">Base 4t trim</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">% Retenció 4t trim</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Import Retenció 4t trim</span></th>\n' +
    '                     <th md-column show-gt-xs hide><span class="md-title">Acumulat anual base</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">Acumulat anual retenció</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select"\n' +
    '                ng-repeat="persona in vm.filteredList = (vm.llistatpersones | filter:searchText ) | orderBy: vm.query.order">\n' +
    '             \n' +
    '          \n' +
    '                 \n' +
    '                 <td md-cell><span class="md-body-2">{{ persona.cognom1 }} {{ persona.cognom2 }} </span></td>\n' +
    '                \n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.nom }}</span></td>\n' +
    '          \n' +
    '            <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.dni }}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.adress}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.municipi}}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base1}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf_tipo_1}}%</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.import_irpf_1}}</span></td>\n' +
    '                <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base2}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf_tipo_2}}%</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.import_irpf_2}}</span></td>\n' +
    '                <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base3}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf_tipo_3}}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.import_irpf_3}}</span></td>\n' +
    '                <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base4}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf_tipo_4}}%</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.import_irpf_4}}</span></td>\n' +
    '                    <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base_acumulada}}</span></td>\n' +
    '                     <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.retencio_acumulada}}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-hide="vm.filteredList.length"> No s\'han trobat dades </span>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '    <md-button class="md-fab md-accent md-fab-bottom-right" ng-click="vm.imprimir()" >\n' +
    '            <md-icon md-svg-src="images/baseline-import_export-24px.svg" class="s24"\n' +
    '                     aria-label="Exportar a SAGE"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">Exportar a SAGE</md-tooltip>\n' +
    '          </md-button>\n' +
    '</div>\n' +
    '            <div>\n' +
    ' \n' +
    '</div>\n' +
    '<div ng-hide="true">\n' +
    ' <neo-print-invoice-template id="invoicePrintPreview" ng-hide="true" persona="vm.persona"></neo-print-invoice-template>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/invoices-list/invoices-list.tpl.html',
    '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>\n' +
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       ng-required="true"\n' +
    '                       md-min-length="0"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.currentSeason.iniDate"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.iniDate"\n' +
    '                     md-max-date="vm.currentSeason.endDate"\n' +
    '                     ng-disabled="vm.iniDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '    \n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   \n' +
    '\n' +
    '    <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '             <md-button ng-click="exportToExcel(\'table1\', \'Report\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">Partits arbitrats</span> \n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <md-table-container>\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected"  id="table1">\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '                \n' +
    '                \n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '                 <th>Facturar</th>\n' +
    '             <th md-column md-order-by="numinvoice"><span class="md-title">Num.Factura</span></th>\n' +
    '              <th md-column md-order-by="fecha"><span class="md-title">Data</span></th>\n' +
    '               <th md-column md-order-by="idreceptor"><span class="md-title">idReceptor</span></th>\n' +
    '              <th md-column md-order-by="cognom1"><span class="md-title">Cognom 1</span></th>\n' +
    '               <th md-column md-order-by="cognom2"><span class="md-title">Cognom 2</span></th>\n' +
    '                <th md-column md-order-by="nom"><span class="md-title">Nom</span></th>\n' +
    '             \n' +
    '              <th md-column show-gt-xs hide><span class="md-title">DNI</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">Adreça</span></th>\n' +
    '               <th md-column show-gt-xs hide><span class="md-title">Municipi</span></th>\n' +
    '             <th md-column show-gt-xs hide><span class="md-title">Concepte</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">Num. partits</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Preu brut</span></th>\n' +
    '                <th md-column show-gt-xs hide><span class="md-title">Total</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select"\n' +
    '                ng-repeat="persona in vm.filteredList = (vm.llistatpersones | filter:searchText ) | orderBy: vm.query.order">\n' +
    '                  <td md-cell><md-checkbox ng-model="persona.selected" aria-label="license" ng-click="vm.enable()"></md-checkbox></td>\n' +
    '                   <td md-cell><span class="md-body-2">{{ persona.numinvoice }} </span></td>\n' +
    '                   <td md-cell><span class="md-body-2">{{ persona.fecha }} </span></td>\n' +
    '                     <td md-cell><span class="md-body-2">{{ persona.idreceptor }} </span></td>\n' +
    '                 <td md-cell><span class="md-body-2">{{ persona.cognom1 }} </span></td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.cognom2 }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.nom }}</span></td>\n' +
    '          \n' +
    '            <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.dni }}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.adress}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.municipi}}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.esport}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.numpartits }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.preu }}</span></td>\n' +
    '                    <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.total}}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-hide="vm.filteredList.length"> No s\'han trobat dades </span>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '</div>\n' +
    '            <div>\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="(vm.filteredList.length > 0)&&((vm.isAdm)||(vm.isCorn))"></neo-action-button>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/invoices-group/invoices-group.tpl.html',
    '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>\n' +
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '     \n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.currentSeason.iniDate"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.iniDate"\n' +
    '                     md-max-date="vm.currentSeason.endDate"\n' +
    '                     ng-disabled="vm.iniDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '    \n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   \n' +
    '\n' +
    '    <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '             <md-button ng-click="exportToExcel(\'#table1\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">Partits arbitrats</span> \n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <md-table-container>\n' +
    '          <table  md-table ng-model="vm.selected"  id="table1" >\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '                \n' +
    '                \n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '                <th></th>\n' +
    '             <th md-column md-order-by="numinvoice"><span class="md-title">Num.Factura</span></th>\n' +
    '              <th md-column md-order-by="fecha"><span class="md-title">Data</span></th>\n' +
    '               <th md-column md-order-by="fechafact"><span class="md-title">Data Factura</span></th>\n' +
    '              <th md-column md-order-by="cognom1"><span class="md-title">Cognom 1</span></th>\n' +
    '               <th md-column md-order-by="cognom2"><span class="md-title">Cognom 2</span></th>\n' +
    '                <th md-column md-order-by="nom"><span class="md-title">Nom</span></th>\n' +
    '             \n' +
    '              <th md-column show-gt-xs hide><span class="md-title">DNI</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">Adreça</span></th>\n' +
    '               <th md-column show-gt-xs hide><span class="md-title">Municipi</span></th>\n' +
    '             <th md-column show-gt-xs hide><span class="md-title">Base</span></th>\n' +
    '                 <th md-column show-gt-xs hide><span class="md-title">Retenció IRPF</span></th>\n' +
    '                   <th md-column show-gt-xs hide><span class="md-title">Total</span></th>\n' +
    '                      <th md-column md-order-by="receptor"><span class="md-title">Receptor</span></th>\n' +
    '               \n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select"\n' +
    '                ng-repeat="persona in vm.filteredList = (vm.llistatpersones | filter:searchText ) | orderBy: vm.query.order">\n' +
    '             \n' +
    '            <td md-cell><md-checkbox ng-model="persona.selected" aria-label="license" ng-click="vm.enable()"></md-checkbox></td>\n' +
    '                   <td md-cell><span class="md-body-2">{{ persona.numinvoice }} </span></td>\n' +
    '                   <td md-cell><span class="md-body-2">{{ persona.fecha }} </span></td>\n' +
    '                 <td md-cell><span class="md-body-2">{{ persona.fechafact }} </span></td>\n' +
    '                 <td md-cell><span class="md-body-2">{{ persona.cognom1 }} </span></td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.cognom2 }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.nom }}</span></td>\n' +
    '          \n' +
    '            <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.dni }}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.adress}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.municipi}}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.base}}</span></td>\n' +
    '             <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.irpf }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-2">{{ persona.total }}</span></td>\n' +
    '                         <td md-cell><span class="md-body-2">{{ persona.receptor }} </span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-hide="vm.filteredList.length"> No s\'han trobat dades </span>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '     <md-button class="md-fab md-accent md-fab-bottom-right" ng-click="vm.imprimir()" ng-disabled="vm.dis">\n' +
    '            <md-icon md-svg-src="images/ic_print_black_24px.svg" class="s24"\n' +
    '                     aria-label="Imprimir factures"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">Imprimir factures</md-tooltip>\n' +
    '          </md-button>\n' +
    '</div>\n' +
    '            <div>\n' +
    ' \n' +
    '</div>\n' +
    '<div ng-hide="true">\n' +
    ' <neo-print-invoice-template id="invoicePrintPreview" ng-hide="true" persona="vm.persona"></neo-print-invoice-template>\n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/invoices-group/invoice.html',
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '<head>\n' +
    '  <meta charset="UTF-8">\n' +
    '  <style>\n' +
    '\n' +
    '* {\n' +
    '	border: 0;\n' +
    '	box-sizing: content-box;\n' +
    '	color: inherit;\n' +
    '	font-family: inherit;\n' +
    '	font-size: inherit;\n' +
    '	font-style: inherit;\n' +
    '	font-weight: inherit;\n' +
    '	line-height: inherit;\n' +
    '	list-style: none;\n' +
    '	margin: 0;\n' +
    '	padding: 0;\n' +
    '	text-decoration: none;\n' +
    '	vertical-align: top;\n' +
    '}\n' +
    '\n' +
    '/* content editable */\n' +
    '\n' +
    '*[contenteditable] { border-radius: 0.25em; min-width: 1em; outline: 0; }\n' +
    '\n' +
    '*[contenteditable] { cursor: pointer; }\n' +
    '\n' +
    '*[contenteditable]:hover, *[contenteditable]:focus, td:hover *[contenteditable], td:focus *[contenteditable], img.hover { background: #DEF; box-shadow: 0 0 1em 0.5em #DEF; }\n' +
    '\n' +
    'span[contenteditable] { display: inline-block; }\n' +
    '\n' +
    '/* heading */\n' +
    '\n' +
    'h1 { font: bold 100% sans-serif; letter-spacing: 0.5em; text-align: center; text-transform: uppercase; }\n' +
    '\n' +
    '/* table */\n' +
    '\n' +
    'table { font-size: 75%; table-layout: fixed; width: 100%; }\n' +
    'table { border-collapse: separate; border-spacing: 2px; }\n' +
    'th, td { border-width: 1px; padding: 0.5em; position: relative; text-align: left; }\n' +
    'th, td { border-radius: 0.25em; border-style: solid; }\n' +
    'th { background: #EEE; border-color: #BBB; }\n' +
    'td { border-color: #DDD; }\n' +
    '\n' +
    '/* page */\n' +
    '\n' +
    'html { font: 16px/1 \'Open Sans\', sans-serif; overflow: auto; padding: 0.5in; }\n' +
    'html { background: #999; cursor: default; }\n' +
    '\n' +
    'body { box-sizing: border-box; height: 11in; margin: 0 auto; overflow: hidden; padding: 0.5in; width: 8.5in; }\n' +
    'body { background: #FFF; border-radius: 1px; box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5); }\n' +
    '\n' +
    '/* header */\n' +
    '\n' +
    'header { margin: 0 0 3em; }\n' +
    'header:after { clear: both; content: ""; display: table; }\n' +
    '\n' +
    'header h1 { background: #000; border-radius: 0.25em; color: #FFF; margin: 0 0 1em; padding: 0.5em 0; }\n' +
    'header address { float: left; font-size: 75%; font-style: normal; line-height: 1.25; margin: 0 1em 1em 0; }\n' +
    'header address p { margin: 0 0 0.25em; }\n' +
    'header span, header img { display: block; float: right; }\n' +
    'header span { margin: 0 0 1em 1em; max-height: 25%; max-width: 60%; position: relative; }\n' +
    'header img { max-height: 100%; max-width: 100%; }\n' +
    'header input { cursor: pointer; -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; height: 100%; left: 0; opacity: 0; position: absolute; top: 0; width: 100%; }\n' +
    '\n' +
    '/* article */\n' +
    '\n' +
    'article, article address, table.meta, table.inventory { margin: 0 0 3em; }\n' +
    'article:after { clear: both; content: ""; display: table; }\n' +
    'article h1 { clip: rect(0 0 0 0); position: absolute; }\n' +
    '\n' +
    'article address { float: left; font-size: 100%; font-weight: normal; }\n' +
    '\n' +
    '/* table meta & balance */\n' +
    '\n' +
    'table.meta, table.balance { float: right; width: 36%; }\n' +
    'table.meta:after, table.balance:after { clear: both; content: ""; display: table; }\n' +
    '\n' +
    '/* table meta */\n' +
    '\n' +
    'table.meta th { width: 60%; }\n' +
    'table.meta td { width: 40%; }\n' +
    '\n' +
    '/* table items */\n' +
    '\n' +
    'table.inventory { clear: both; width: 100%; }\n' +
    '/*"table.inventory th { font-weight: bold; text-align: center; }"+*/\n' +
    '\n' +
    'table.inventory th:nth-child(1) { text-align:  center;width: 64%;font-weight: bold;  }\n' +
    'table.inventory th:nth-child(2) { text-align:  center; width: 12%; font-weight: bold; }\n' +
    'table.inventory th:nth-child(3) { text-align:  center; width: 12%;font-weight: bold;  }\n' +
    'table.inventory th:nth-child(4) { text-align:  center; width: 12%;font-weight: bold;  }\n' +
    '\n' +
    '\n' +
    'table.inventory td:nth-child(1) { width: 64%; }\n' +
    'table.inventory td:nth-child(2) { text-align: right; width: 12%; }\n' +
    'table.inventory td:nth-child(3) { text-align: right; width: 12%; }\n' +
    'table.inventory td:nth-child(4) { text-align: right; width: 12%; }\n' +
    '\n' +
    '/* table balance */\n' +
    '\n' +
    'table.balance th, table.balance td { width: 50%; }\n' +
    'table.balance td { text-align: right; }\n' +
    '\n' +
    '/* aside */\n' +
    '\n' +
    'aside h1 { border: none; border-width: 0 0 1px; margin: 0 0 1em; }\n' +
    'aside h1 { border-color: #999; border-bottom-style: solid; }\n' +
    '\n' +
    '/* javascript */\n' +
    '\n' +
    '.add, .cut\n' +
    '{\n' +
    '	border-width: 1px;\n' +
    '	display: block;\n' +
    '	font-size: .8rem;\n' +
    '	padding: 0.25em 0.5em;	\n' +
    '	float: left;\n' +
    '	text-align: center;\n' +
    '	width: 0.6em;\n' +
    '}\n' +
    '\n' +
    '.add, .cut\n' +
    '{\n' +
    '	background: #9AF;\n' +
    '	box-shadow: 0 1px 2px rgba(0,0,0,0.2);\n' +
    '	background-image: -moz-linear-gradient(#00ADEE 5%, #0078A5 100%);\n' +
    '	background-image: -webkit-linear-gradient(#00ADEE 5%, #0078A5 100%);\n' +
    '	border-radius: 0.5em;\n' +
    '	border-color: #0076A3;\n' +
    '	color: #FFF;\n' +
    '	cursor: pointer;\n' +
    '	font-weight: bold;\n' +
    '	text-shadow: 0 -1px 2px rgba(0,0,0,0.333);\n' +
    '}\n' +
    '\n' +
    '.add { margin: -2.5em 0 0; }\n' +
    '\n' +
    '.add:hover { background: #00ADEE; }\n' +
    '\n' +
    '.cut { opacity: 0; position: absolute; top: 0; left: -1.5em; }\n' +
    '.cut { -webkit-transition: opacity 100ms ease-in; }\n' +
    '\n' +
    'tr:hover .cut { opacity: 1; }\n' +
    '\n' +
    '@media print {\n' +
    '	* { -webkit-print-color-adjust: exact; }\n' +
    '	html { background: none; padding: 0; }\n' +
    '	body { box-shadow: none; margin: 0; }\n' +
    '	span:empty { display: none; }\n' +
    '	.add, .cut { display: none; }\n' +
    '}\n' +
    '\n' +
    '@page { margin: 0; }\n' +
    '\n' +
    '</style>\n' +
    '</head>\n' +
    '\n' +
    '<body>\n' +
    '    <div id="divaprint" ng-show="false">\n' +
    '    <header>\n' +
    '			<h1>Factura</h1>\n' +
    '                        <p><u>Dades de l\'emissor</u></p>\n' +
    '                        <br>\n' +
    '			<address contenteditable>\n' +
    '                            \n' +
    '				<p>persona2.name persona2.surname1 persona2.surname2</p>\n' +
    '				<p>persona2.dni</p>\n' +
    '				<p>persona2.adress</p>\n' +
    '                                <p>persona2.poblacio persona2.cp</p>\n' +
    '			</address>\n' +
    '			<span></span>\n' +
    '		</header>\n' +
    '    	<article>\n' +
    '			   <p><u>Dades del preceptor</u></p>\n' +
    '                        <br>\n' +
    '			<address contenteditable>\n' +
    '				<p>rece2.nombre\n' +
    '                                    <br>rece2.direccion\n' +
    '                                    <br>rece2.direccion2\n' +
    '                                <br>rece2.nif\n' +
    '                                <br>rece2.telf</p>\n' +
    '			</address>\n' +
    '			<table class="meta">\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Factura número</span></th>\n' +
    '					<td><span contenteditable>invoice.numinvoice</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Data</span></th>\n' +
    '					<td><span contenteditable>invoice.data</span></td>\n' +
    '				/</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Total</span></th>\n' +
    '					<td><span>invoice.total</span><span id="prefix" contenteditable> €</span></td>\n' +
    '				</tr>\n' +
    '			</table>\n' +
    '			<table class="inventory">\n' +
    '				<thead>\n' +
    '					<tr>\n' +
    '						<th><span contenteditable>Acció</span></th>\n' +
    '						\n' +
    '						<th><span contenteditable>Partit</span></th>\n' +
    '						<th><span contenteditable>€/Partit</span></th>\n' +
    '						<th><span contenteditable>Total</span></th>\n' +
    '					</tr>\n' +
    '				</thead>\n' +
    '				<tbody>\n' +
    '					<tr>\n' +
    '						<td><a class="cut">-</a><span contenteditable>linea.concepte0</span></td>\n' +
    '						\n' +
    '                                                <td><span contenteditable>linea.partits0</span></td>\n' +
    '						<td><span contenteditable>linea.preu0</span><span data-prefix> €</span></td>\n' +
    '						<td><span>linea.total0</span><span data-prefix> €</span></td>\n' +
    '					</tr>\n' +
    '				</tbody>\n' +
    '			</table>\n' +
    '			<a class="add">+</a>\n' +
    '			<table class="balance">\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Subtotal</span></th>\n' +
    '					<td><span>invoice.base</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>I.R.P.F. -15%</span></th>\n' +
    '					<td><span contenteditable>invoice.irpf</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>TOTAL</span></th>\n' +
    '					<td><span>invoice.total</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '			</table>\n' +
    '		</article>\n' +
    '    \n' +
    '    	<aside>\n' +
    '			<h1><span contenteditable>Forma de pagament</span></h1>\n' +
    '			<div contenteditable>\n' +
    '				<p>Tranferència Bancària: persona2.iban</p>\n' +
    '			</div>\n' +
    '		</aside>\n' +
    '        </div>\n' +
    '\n' +
    '<br><br><br><br><br><br><br><br>\n' +
    '<p style="font-size:60%;">\n' +
    '    D\'acord amb el que estableix la Llei Orgànica 3/2018 LOPD-GDD i la Normativa Europea 2016/679, RGPD l\'informem que les dades personals recollides en aquest document seran incorporades a un tractament informatitzat sota la responsabilitat de Consell Esportiu del Baix Llobregat. Pot exercir els seus drets d\'accés, rectificació, supressió, oposició, limitació i portabilitat a: Parc Torreblanca, Ctra. Nacional 340 km. 1249, 08980, Barcelona.\n' +
    '</p>\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/facturar/facturar.tpl.html',
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/postponements/postponed-matches/postponed-matches.tpl.html',
    '<div layout="column">\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form name="listFilters" layout="row" flex-gt-md="70" flex="100" layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       md-min-length="0"\n' +
    '                       ng-required="true"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.initDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.initDate"\n' +
    '                     ng-disabled="vm.initDate === null"></md-datepicker>\n' +
    '      <md-button ng-disabled="listFilters.$invalid" class="md-raised md-primary" ng-click="vm.applyFilters()">\n' +
    '        {{\'FILTER\' | translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-show="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="95" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'POSTPONEMENTS.POSTPONED_MATCHES\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-hide="vm.showList">{{\'POSTPONEMENTS.NOT_FOUND_POSTPONEMENTS\' | translate}}</span>\n' +
    '        <md-table-container ng-show="vm.showList">\n' +
    '          <table md-table md-row-select="false" ng-model="vm.selected" md-progress="vm.promiseMatches">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="date">{{ \'POSTPONEMENTS.MATCH_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="time">{{ \'POSTPONEMENTS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="postponement.date">{{ \'POSTPONEMENTS.MATCH_REQUESTED_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="postponement.time">{{ \'POSTPONEMENTS.MATCH_REQUESTED_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="postponement.state">{{ \'POSTPONEMENTS.STATE\' | translate}}</th>\n' +
    '              <th md-column>\n' +
    '                <div flex layout="column" layout-align="center center">{{ \'ACTIONS\' | translate}}</div>\n' +
    '              </th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time || "--:--"}}</td>\n' +
    '              <td md-cell>{{match.lastPostponement.date}}</td>\n' +
    '              <td md-cell>{{match.lastPostponement.time || "--:--"}}</td>\n' +
    '              <td md-cell>{{match.championship}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name}}</td>\n' +
    '              <td md-cell>{{\'POSTPONEMENTS.STATES.\' + match.lastPostponement.state | translate}}</td>\n' +
    '              <td md-cell>\n' +
    '                <div flex layout="row" layout-align="space-around center">\n' +
    '                  <md-button class="md-icon-button" ng-if="vm.showEditButton(match)" aria-label="edit"\n' +
    '                             ng-if="vm.showEditButton(match)"\n' +
    '                             ng-click="vm.editPostponement(match)">\n' +
    '                    <md-tooltip md-direction="left" md-delay="50">{{\'EDIT\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>mode_edit</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <md-button class="md-icon-button" ng-if="vm.showAcceptAndRejectButton(match)" aria-label="accept"\n' +
    '                             ng-click="vm.acceptPostponement(match)">\n' +
    '                    <md-tooltip md-direction="down" md-delay="50">{{\'POSTPONEMENTS.ACCEPT\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>check_circle</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <md-button class="md-icon-button" ng-if="vm.showAcceptAndRejectButton(match)"\n' +
    '                             aria-label="reject" ng-click="vm.rejectPostponement(match)">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'POSTPONEMENTS.REJECT\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>cancel</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <md-button class="md-icon-button" ng-if="vm.showCreateButton(match)"\n' +
    '                             ui-sref="home.postponements.new({matchId : match.id})"\n' +
    '                             aria-label="new">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'POSTPONEMENTS.NEW\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>add_box</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <span ng-if="vm.showResolveSwitch(match)">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'POSTPONEMENTS.RESOLVE\' | translate}}</md-tooltip>\n' +
    '                    <md-switch ng-model="match.lastPostponement.resolved"\n' +
    '                               ng-change="vm.changeResolutionPostponement(match)">\n' +
    '                  </md-switch>\n' +
    '                  </span>\n' +
    '                  <span ng-if="vm.showExpiredPostponement(match)" md-colors="{color:\'warn\'}"><i>{{ \'POSTPONEMENTS.EXPIRED\' | translate}}</i></span>\n' +
    '                </div>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.showList"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/postponements/new-postponement/new-postponement.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'POSTPONEMENTS.NEW\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="postponementForm" novalidate>\n' +
    '        <div layout-align="center stretch" layout="column">\n' +
    '          <div layout="row" flex>\n' +
    '            <div flex="50" layout="column" layout-align="top none" layout-wrap\n' +
    '                 ng-repeat="team in [vm.localTeam, vm.visitorTeam]">\n' +
    '              <h1 class="md-title">{{team.columnName | translate}}</h1>\n' +
    '              <div layout-padding>\n' +
    '                <div flex layout="row">\n' +
    '                  <neo-input name="teamName" label="TEAM_NAME" neo-icon="title" ng-model="team.name"\n' +
    '                             is-disabled="true" flex no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="COACH_NAME" neo-icon="person" ng-model="team.coachName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="COACH_PHONE" neo-icon="phone" ng-model="team.coachPhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="DELEGATE_NAME" neo-icon="person" ng-model="team.delegateName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="DELEGATE_PHONE" neo-icon="phone" ng-model="team.delegatePhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="entityName" label="ENTITIES.NAME" ng-model="team.entityName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="townHallName" label="TOWNHALLS.NAME" ng-model="team.townHallName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <md-divider></md-divider>\n' +
    '\n' +
    '          <h1 class="md-title">{{\'POSTPONEMENTS.DETAILS\' | translate}}</h1>\n' +
    '          <div layout="row" flex layout-align="space-around">\n' +
    '            <div flex="45" layout="column" layout-align="space-between">\n' +
    '              <!-- Date & recovery dates -->\n' +
    '              <div layout="row">\n' +
    '                <md-input-container flex="45">\n' +
    '                  <md-datepicker name="suggestedDate" ng-model="vm.postponement.date" ng-required="true"\n' +
    '                                 md-placeholder="{{\'POSTPONEMENTS.DATE\' | translate}}"\n' +
    '                                 md-min-date="vm.minDate"></md-datepicker>\n' +
    '                  <div ng-messages="postponementForm.suggestedDate.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block" flex>\n' +
    '                  <label>{{\'POSTPONEMENTS.RECOVERY_DATES\' | translate}}</label>\n' +
    '                  <md-select ng-model="vm.selectedRecoveryDate"\n' +
    '                             placeholder="{{\'POSTPONEMENTS.RECOVERY_DATES\' | translate}}"\n' +
    '                             ng-required="false">\n' +
    '                    <md-option ng-repeat="aSuggestedDate in vm.suggestedDates" ng-value="aSuggestedDate">\n' +
    '                      {{aSuggestedDate}}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <!-- Time & Facility -->\n' +
    '              <div layout="row" flex>\n' +
    '                <md-input-container flex="45">\n' +
    '                  <label>{{\'POSTPONEMENTS.TIME\' | translate}}</label>\n' +
    '                  <md-icon class="material-icons md-dark">access_time</md-icon>\n' +
    '                  <input name="time" type="time" ng-disabled="!vm.canSetTime"\n' +
    '                         ng-model="vm.postponement.time" ng-required="vm.canSetTime" title="time"/>\n' +
    '                  <div ng-messages="postponementForm.time.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block" flex>\n' +
    '                  <label>{{\'POSTPONEMENTS.NEW_FACILITY\' | translate}}</label>\n' +
    '                  <md-select name="facility" ng-model="vm.postponement.facility" ng-disabled="!vm.canSetFacility"\n' +
    '                             aria-label="facility" ng-required="vm.canSetFacility">\n' +
    '                    <md-option ng-repeat="facility in vm.facilities" value="{{facility.id}}">\n' +
    '                      {{facility.name | translate }}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="postponementForm.facility.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div flex="45" layout="column">\n' +
    '              <!-- Details -->\n' +
    '              <md-input-container class="md-block">\n' +
    '                <label>{{\'POSTPONEMENTS.MORE_INFORMATION\' | translate}}</label>\n' +
    '                <md-icon class="material-icons md-dark">info_outline</md-icon>\n' +
    '                <textarea ng-model="vm.postponement.details" md-maxlength="500" rows="5" md-select-on-focus\n' +
    '                          title="more_info"></textarea>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="postponementForm.$invalid"\n' +
    '                     ng-click="vm.savePostponement()">\n' +
    '            <md-icon class="material-icons md-light">save</md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/postponements/edit-postponement/edit-postponement.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'POSTPONEMENTS.EDIT\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="postponementForm" novalidate>\n' +
    '        <div layout-align="center stretch" layout="column">\n' +
    '          <div layout="row" flex>\n' +
    '            <div flex="50" layout="column" layout-align="top none" layout-wrap\n' +
    '                 ng-repeat="team in [vm.localTeam, vm.visitorTeam]">\n' +
    '              <h1 class="md-title">{{team.columnName | translate}}</h1>\n' +
    '              <div layout-padding>\n' +
    '                <div flex layout="row">\n' +
    '                  <neo-input name="teamName" label="TEAM_NAME" neo-icon="title" ng-model="team.name"\n' +
    '                             is-disabled="true" flex no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="COACH_NAME" neo-icon="person" ng-model="team.coachName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="COACH_PHONE" neo-icon="phone" ng-model="team.coachPhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="DELEGATE_NAME" neo-icon="person" ng-model="team.delegateName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="DELEGATE_PHONE" neo-icon="phone" ng-model="team.delegatePhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="entityName" label="ENTITIES.NAME" ng-model="team.entityName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="townHallName" label="TOWNHALLS.NAME" ng-model="team.townHallName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <md-divider></md-divider>\n' +
    '\n' +
    '          <h1 class="md-title">{{\'POSTPONEMENTS.DETAILS\' | translate}}</h1>\n' +
    '          <div layout="row" flex layout-align="space-around">\n' +
    '            <div flex="45" layout="column" layout-align="space-between">\n' +
    '              <!-- Date & recovery dates -->\n' +
    '              <div layout="row">\n' +
    '                <md-input-container flex="45">\n' +
    '                  <md-datepicker name="suggestedDate" ng-model="vm.postponement.date" ng-required="true"\n' +
    '                                 md-placeholder="{{\'POSTPONEMENTS.DATE\' | translate}}"></md-datepicker>\n' +
    '                  <div ng-messages="postponementForm.suggestedDate.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block" flex>\n' +
    '                  <label>{{\'POSTPONEMENTS.RECOVERY_DATES\' | translate}}</label>\n' +
    '                  <md-select ng-model="vm.selectedRecoveryDate"\n' +
    '                             placeholder="{{\'POSTPONEMENTS.RECOVERY_DATES\' | translate}}"\n' +
    '                             ng-required="false">\n' +
    '                    <md-option ng-repeat="aSuggestedDate in vm.suggestedDates" ng-value="aSuggestedDate">\n' +
    '                      {{aSuggestedDate}}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <!-- Time & Facility -->\n' +
    '              <div layout="row" flex>\n' +
    '                <md-input-container flex="45">\n' +
    '                  <label>{{\'POSTPONEMENTS.TIME\' | translate}}</label>\n' +
    '                  <md-icon class="material-icons md-dark">access_time</md-icon>\n' +
    '                  <input name="time" type="time" ng-disabled="!vm.canSetTime"\n' +
    '                         ng-model="vm.postponement.time" ng-required="vm.canSetTime"/>\n' +
    '                  <div ng-messages="postponementForm.time.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block" flex>\n' +
    '                  <label>{{\'POSTPONEMENTS.NEW_FACILITY\' | translate}}</label>\n' +
    '                  <md-select name="facility" ng-model="vm.postponement.facilityId" ng-disabled="!vm.canSetFacility"\n' +
    '                             aria-label="facility" ng-required="vm.canSetFacility">\n' +
    '                    <md-option ng-repeat="facility in vm.facilities" value="{{facility.id}}">\n' +
    '                      {{facility.name | translate }}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="postponementForm.facility.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div flex="45" layout="column">\n' +
    '              <!-- Details -->\n' +
    '              <md-input-container class="md-block">\n' +
    '                <label>{{\'POSTPONEMENTS.MORE_INFORMATION\' | translate}}</label>\n' +
    '                <md-icon class="material-icons md-dark">info_outline</md-icon>\n' +
    '                <textarea ng-model="vm.postponement.details" md-maxlength="500" rows="5" md-select-on-focus></textarea>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-warn md-fab-bottom-right" ng-click="vm.cancelEdition()"\n' +
    '                     style="margin-bottom: 72px;">\n' +
    '            <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="postponementForm.$invalid"\n' +
    '                     ng-click="vm.updatePostponement()">\n' +
    '            <md-icon class="material-icons md-light">save</md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/phases/phase/phase.tpl.html',
    '<div layout="row" layout-align="center center" ui-view style="padding-top: 2%">\n' +
    '  <md-card flex-gt-md="50" flex-xs="100" flex="70">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'PHASES.PHASE_DATA\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="phaseForm" style="min-width: 75%" ng-submit="vm.updatePhase()">\n' +
    '        <div layout="column" layout-align="center none" style="padding: 0 10% 0 10%">\n' +
    '          <md-input-container>\n' +
    '            <label>{{\'PHASES.PHASE_NAME\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '            <input name="name" type="text" required ng-model="vm.phase.name" ng-disabled="!vm.edit"/>\n' +
    '            <div ng-messages="phaseForm.name.$error" role="alert">\n' +
    '              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '        <div layout="column" layout-gt-md="row" layout-align="space-around center" style="padding: 0 0 2% 0">\n' +
    '          <div layout="row" layout-align="start center" layout-padding>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'INI_DATE\' | translate}}</label>\n' +
    '              <md-datepicker name="iniDate" ng-model="vm.phase.iniDate" md-current-view="month"\n' +
    '                             ng-required="true" ng-disabled="!vm.edit"></md-datepicker>\n' +
    '              <div ng-messages="phaseForm.iniDate.$error" role="alert">\n' +
    '                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '          <div layout="row" layout-align="start center" layout-padding>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'END_DATE\' | translate}}</label>\n' +
    '              <md-datepicker name="endDate" ng-model="vm.phase.endDate" md-current-view="month"\n' +
    '                             ng-required="true" ng-disabled="!vm.edit"></md-datepicker>\n' +
    '              <div ng-messages="phaseForm.endDate.$error" role="alert">\n' +
    '                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-if="vm.edit"\n' +
    '                     ng-disabled="phaseForm.$invalid">\n' +
    '            <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="!vm.edit"></neo-action-button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/phases/new-phase/new-phase.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="50" flex-xs="100" flex="70">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_PHASE_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="phaseForm">\n' +
    '        <div layout-align="center center" layout="row" layout-padding>\n' +
    '          <div layout="column" layout-padding>\n' +
    '            <div layout="row" layout-align="space-around center" flex>\n' +
    '              <div layout="column" flex-lt-md="100" flex="50">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'PHASES.PHASE_NAME\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_title_black_48px.svg"></md-icon>\n' +
    '                  <input name="name" type="text" required ng-model="vm.phase.name"/>\n' +
    '                  <div ng-messages="phaseForm.name.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <div layout="column" flex-lt-md="100" flex="35" ng-if="vm.can(\'REGIONAL_PHASE\', \'C\')">\n' +
    '                <md-radio-group name="type" required ng-model="vm.phase.type">\n' +
    '                  <md-radio-button value="regional">{{ "PHASES.PHASES_TYPES.REGIONAL" | translate }}\n' +
    '                  </md-radio-button>\n' +
    '                  <md-radio-button value="local">{{ "PHASES.PHASES_TYPES.LOCAL" | translate }}\n' +
    '                  </md-radio-button>\n' +
    '                </md-radio-group>\n' +
    '                <div layout="row" ng-if="vm.phase.type === \'local\'" flex>\n' +
    '                  <md-autocomplete flex md-selected-item="vm.selectedTownHall"\n' +
    '                                   md-search-text="vm.searchText"\n' +
    '                                   md-items="townHall in vm.townHalls | filterAccents: vm.searchText"\n' +
    '                                   md-item-text="townHall.name"\n' +
    '                                   md-min-length="0"\n' +
    '                                   md-require-match\n' +
    '                                   ng-required="true"\n' +
    '                                   md-clear-button="true"\n' +
    '                                   md-floating-label="{{\'SELECT_TOWNHALL\' | translate}}">\n' +
    '                    <md-item-template>\n' +
    '                                <span md-highlight-text="filter.searchText"\n' +
    '                                      md-highlight-flags="^i">{{ townHall.name }}</span>\n' +
    '                    </md-item-template>\n' +
    '                    <md-not-found>\n' +
    '                      {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                    </md-not-found>\n' +
    '                  </md-autocomplete>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div layout="column" layout-gt-md="row" layout-align="space-around center" style="padding: 0 0 2% 0">\n' +
    '              <div layout="row" layout-align="start center" layout-padding>\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'INI_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="iniDate" ng-model="vm.iniDate" md-current-view="month"\n' +
    '                                 ng-required="true"></md-datepicker>\n' +
    '                  <div ng-messages="phaseForm.iniDate.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <div layout="row" layout-align="start center" layout-padding>\n' +
    '\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'END_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="endDate" ng-model="vm.endDate" md-current-view="month"\n' +
    '                                 ng-required="true"></md-datepicker>\n' +
    '                  <div ng-messages="phaseForm.endDate.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="phaseForm.$invalid"\n' +
    '                     ng-click="vm.savePhase()">\n' +
    '            <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/phases/inscription/inscription.tpl.html',
    '<div ui-view>\n' +
    '  <form ng-submit="vm.getInscriptions()" name="townHallFilter">\n' +
    '    <div layout="row" layout-align="center center">\n' +
    '\n' +
    '      <md-autocomplete flex="33"\n' +
    '                       md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.townHallSearch"\n' +
    '                       md-items="townHall in vm.myTownHalls | filterAccents: vm.townHallSearch"\n' +
    '                       md-item-text="townHall.name"\n' +
    '                       md-min-length="0"\n' +
    '                       md-require-match\n' +
    '                       ng-required="true"\n' +
    '                       ng-disabled="vm.onlyOneTownHall"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{ \'Selecciona un ajuntament\' | translate}}">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.townHallSearch" md-highlight-flags="^i">{{ townHall.name }}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-button type="submit" ng-if="!vm.onlyOneTownHall" class="md-raised md-primary">Filtrar</md-button>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '  <form name="phaseInscriptionForm" ng-submit="vm.submitInscription()" flex="100">\n' +
    '    <div layout="row" layout-align="space-around center" flex="100">\n' +
    '      <md-card flex="100">\n' +
    '        <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding>\n' +
    '            <md-card-header-text>\n' +
    '              <span class="md-headline">{{ \'PHASES.INSCRIPTION\' | translate}}</span>\n' +
    '            </md-card-header-text>\n' +
    '          </md-card-header>\n' +
    '        </div>\n' +
    '        <md-card-content>\n' +
    '\n' +
    '          <md-table-container ng-if="vm.inscriptions.length>0">\n' +
    '            <table md-table md-row-select="false" ng-model="vm.selected">\n' +
    '              <thead md-head md-order="vm.order">\n' +
    '              <tr md-row ng-hide="!vm.inscriptions.length">\n' +
    '                <th md-column md-order-by="teamNameOrder"><span\n' +
    '                  class="md-title"> {{ \'TEAM\' | translate }} </span></th>\n' +
    '                <th md-column md-order-by="sport"><span\n' +
    '                  class="md-title"> {{ \'SPORT\' | translate }} </span>\n' +
    '                </th>\n' +
    '                <th md-column mdDesc md-order-by="categoryOrder"><span\n' +
    '                  class="md-title"> {{ \'CATEGORY\' | translate }} </span></th>\n' +
    '                <th md-column md-order-by="gender"><span\n' +
    '                  class="md-title"> {{ \'GENDER\' | translate }} </span></th>\n' +
    '                <th ng-repeat="phase in vm.inscriptions[0].phases" md-column>\n' +
    '                  <div layout="column" layout-align="center center">\n' +
    '                    <span class="md-title">{{ phase.name }}</span>\n' +
    '                  </div>\n' +
    '                </th>\n' +
    '              </tr>\n' +
    '              </thead>\n' +
    '              <tbody md-body>\n' +
    '              <tr md-row class="pointer-cursor"\n' +
    '                  ng-repeat="inscription in vm.inscriptions">\n' +
    '                <td md-cell><span class="md-body-1"> {{ inscription.teamName | translate }} </span>\n' +
    '                </td>\n' +
    '                <td md-cell><span class="md-body-1"> {{ inscription.teamSport | translate }} </span>\n' +
    '                </td>\n' +
    '                <td md-cell><span class="md-body-1"> {{ inscription.teamCategory | translate }} </span>\n' +
    '                </td>\n' +
    '                <td md-cell><span class="md-body-1"> {{ inscription.teamGender | translate }} </span>\n' +
    '                </td>\n' +
    '                <td md-cell layout-wrap ng-repeat="phase in inscription.phases">\n' +
    '                  <div layout="column" layout-align="center center">\n' +
    '                    <md-checkbox ng-model="phase.inscribed" ng-click="vm.hasChangedModel()"\n' +
    '                                 aria-label="inscription"></md-checkbox>\n' +
    '                  </div>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </md-table-container>\n' +
    '          <span class="md-body-2"\n' +
    '                ng-if="vm.inscriptions.length<1 && !vm.isSelectedTownhallUndefined">{{ \'RESULT_NOT_FOUND\' | translate}}</span>\n' +
    '          <span class="md-body-3" ng-if="vm.isSelectedTownhallUndefined">{{ \'SELECT_TOWNHALL_TO_FILTER\' | translate}}</span>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '    </div>\n' +
    '    <div flex>\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right" type="submit" ng-disabled="vm.disableButtons">\n' +
    '        <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </div>\n' +
    '    <div flex>\n' +
    '      <md-button class="md-fab md-warn md-fab-bottom-right" ng-click="vm.discardChanges()" style="margin-bottom: 72px;" ng-disabled="vm.disableButtons">\n' +
    '        <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/person/person.tpl.html',
    '<div ui-view></div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/new-person/new-person.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '    \n' +
    '     <style type="text/css">\n' +
    '        .fileUpload {\n' +
    '    position: relative;\n' +
    '    overflow: hidden;\n' +
    '    margin: 10px;\n' +
    '}\n' +
    '.fileUpload input.upload {\n' +
    '    position: absolute;\n' +
    '    top: 0;\n' +
    '    right: 0;\n' +
    '    margin: 1;\n' +
    '    padding: 0;\n' +
    '    font-size: 20px;\n' +
    '    cursor: pointer;\n' +
    '    opacity: 0;\n' +
    '    filter: alpha(opacity=0);\n' +
    '}\n' +
    '        </style>\n' +
    '        \n' +
    ' \n' +
    '  \n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_PERSON_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '         <div   width="200" height="200"  class="dropzone" file-dropzone="[image/png, image/jpeg, image/gif, image/jpg]"\n' +
    '                  file="image" file-name="imageFileName" data-max-file-size="3" >\n' +
    '   \n' +
    '      <img id="im" ng-src={{image}} width="200" height="200" alt="Arrossegar aqui foto" style="width: 200px;height: 200px;line-height: 200px;text-align: center;padding:1px;border:1px solid #021a40;" />\n' +
    '       <form action>\n' +
    '       <div class="fileUpload btn btn-primary" >\n' +
    '      \n' +
    '    <input type="file" fileread="image" >\n' +
    '    </div>\n' +
    '  </form>\n' +
    '    </div>\n' +
    '  \n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="personForm" ng-submit="vm.savePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '              <h1 class="md-title">{{\'ASSOCIATIONS\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around">\n' +
    '                <md-autocomplete flex="35" ng-disabled="vm.entities.length === 1" md-selected-item="vm.person.entity"\n' +
    '                                 md-search-text="entitySearch" md-clear-button="true"\n' +
    '                                 md-items="entity in vm.entities | filterAccents: entitySearch"\n' +
    '                                 md-item-text="entity.name" md-min-length="0" md-require-match ng-required="true"\n' +
    '                                 md-floating-label="{{\'ENTITY\' | translate}}">\n' +
    '                  <md-item-template>\n' +
    '                    <span md-highlight-text="vm.entitySearch" md-highlight-flags="^i">{{entity.name}}</span>\n' +
    '                  </md-item-template>\n' +
    '                  <md-not-found>\n' +
    '                    {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                  </md-not-found>\n' +
    '                </md-autocomplete>\n' +
    '                <md-autocomplete flex="35" md-selected-item="vm.person.team" md-search-text="teamSearch"\n' +
    '                                 md-items="team in vm.entityTeams | filterAccents: teamSearch" md-item-text="team.name"\n' +
    '                                 md-min-length="0" md-require-match ng-required="true"\n' +
    '                                 ng-disabled="!vm.person.entity" md-clear-button="true"\n' +
    '                                 md-floating-label="{{\'TEAM\' | translate}}">\n' +
    '                  <md-item-template>\n' +
    '                    <span md-highlight-text="vm.teamSearch" md-highlight-flags="^i">{{team.name}}</span>\n' +
    '                  </md-item-template>\n' +
    '                </md-autocomplete>\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="20">\n' +
    '                  <label>{{\'LICENSE_TYPE\' | translate}}</label>\n' +
    '                  <md-select name="licenseType" ng-model="vm.person.licenseType" ng-required="true">\n' +
    '                    <md-option ng-repeat="license in vm.licenseTeamTypes" value="{{license.id}}">\n' +
    '                      {{\'PERSON_TYPES.\'+license.name | translate}}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="personForm.licenseType.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '\n' +
    '              <h1 class="md-title">{{\'PERSONAL_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" is-required="true"\n' +
    '                             ng-model="vm.person.surname" flex="50"\n' +
    '                             layout-gt-sm="column"></neo-input>\n' +
    '                  <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                             layout-gt-sm="column"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <div layout-gt-sm="row" flex="50">\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                    <md-datepicker name="birthday" ng-model="vm.person.birthday" md-current-view="year"\n' +
    '                                   ng-required="true"></md-datepicker>\n' +
    '                    <div ng-messages="personForm.birthday.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '\n' +
    '                  <md-input-container class="md-block" flex="50">\n' +
    '                    <label>{{\'GENDER\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                    <md-select name="gender" ng-model="vm.person.genderId" ng-required="true">\n' +
    '                      <md-option ng-repeat="gender in vm.personGenders" value="{{gender.id}}">{{gender.name | translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="personForm.gender.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '\n' +
    '                <neo-input name="email" label="CONTACT_EMAIL" icon="images/ic_email_black_48px.svg"\n' +
    '                           ng-model="vm.person.email" error="EMAIL_INVALID_FORMAT"\n' +
    '                           pattern="^.+@.+\\..+$" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="nif" label="NIF/NIE" icon="images/ic_person_black_48px.svg" ng-model="vm.person.nif"\n' +
    '                           error="INVALID_NID" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '                <neo-input name="hic" label="HEALTH_INSURANCE_CARD_NUMBER" icon="images/ic_healing_black_48px.svg"\n' +
    '                           ng-model="vm.person.healthInsuranceCard" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '              </div>\n' +
    '\n' +
    '              <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '                <neo-input name="address" label="ADDRESS" icon="images/ic_location_black_48px.svg"\n' +
    '                           ng-model="vm.person.address" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '                <div layout-gt-sm="row" flex="45">\n' +
    '                  <neo-input name="town" label="TOWN" icon="images/ic_location_city_black_48px.svg"\n' +
    '                             ng-model="vm.person.town" flex="70" layout-gt-sm="column"></neo-input>\n' +
    '                  <neo-input name="zipCode" label="POSTAL_CODE" ng-model="vm.person.zipCode"\n' +
    '                             error="INVALID_POSTAL_CODE" pattern="^[0-9]{5}$"\n' +
    '                             flex="30" layout-gt-sm="column"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '\n' +
    '            <div flex layout="row" layout-align="center center" layout-padding>\n' +
    '              <md-input-container>\n' +
    '                <md-checkbox ng-model="vm.lodp" name="lopd" aria-label="LODP" ng-required="true">\n' +
    '                   <a target="_blank" href="http://cebllob.org/lopd.pdf">Autorització de tractament de dades de caràcter personal i Acord de comunicació de dades entre clubs/entitats/centres i el Consell Esportiu del Baix Llobregat</a>\n' +
    '                </md-checkbox>\n' +
    '                <div ng-messages="personForm.lopd.$error" role="alert">\n' +
    '                  <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                </div>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="personForm.$invalid || !vm.lodp" type="submit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/new-person/duplicate-dialog.tpl.html',
    '<md-dialog flex="70">\n' +
    '  <form ng-cloak>\n' +
    '    <md-toolbar class="md-accent md-raised">\n' +
    '      <div class="md-toolbar-tools">\n' +
    '        <h2>{{\'PEOPLE.DUPLICATED_TITLE\' | translate}}</h2>\n' +
    '        <span flex></span>\n' +
    '      </div>\n' +
    '    </md-toolbar>\n' +
    '\n' +
    '    <md-list>\n' +
    '      <md-list-item class="md-2-line" ng-repeat="(id, duplicated) in duplicatedPersons">\n' +
    '        <md-checkbox ng-model="duplicated.check" ng-change="unselectOthers(id)"></md-checkbox>\n' +
    '        <div class="md-list-item-text">\n' +
    '          <h3>{{duplicated.name}} {{duplicated.surname1}} {{duplicated.surname2}} ({{parseDate(duplicated.bornDate)}})</h3>\n' +
    '\n' +
    '          <p ng-repeat="license in duplicated.licensesList">\n' +
    '            {{license.team.name}} <span ng-if="license.town">({{license.town}})</span> -\n' +
    '            {{\'SPORTS.\' + getSportName(license.team.sportId) | translate}} - {{\'PERSON_TYPES.\' + getLicenseName(license.licenceTypeId) |\n' +
    '            translate}}\n' +
    '          </p>\n' +
    '\n' +
    '          <p ng-repeat="noTeamLicence in duplicated.noTeamLicencesList">\n' +
    '            {{\'PERSON_TYPES.\' + getLicenseName(noTeamLicence.licenceTypeId) |\n' +
    '            translate}} - {{noTeamLicence.organisationName | translate}}\n' +
    '          </p>\n' +
    '\n' +
    '          <!--<p ng-repeat="noTeamlicense in duplicated.noTeamlicensesList">\n' +
    '            {{license.organisation}} <span ng-if="license.town">({{license.town}})</span> - {{license.team}} -\n' +
    '            {{\'SPORTS.\' + license.sport | translate}} - {{\'PERSON_TYPES.\' + getLicenseName(license.licenseTypeId) |\n' +
    '            translate}}\n' +
    '          </p>-->\n' +
    '        </div>\n' +
    '      </md-list-item>\n' +
    '    </md-list>\n' +
    '\n' +
    '    <md-dialog-actions layout="row">\n' +
    '      <md-button class="md-accent md-raised" ng-click="cancel()" flex="none">\n' +
    '        {{\'CANCEL\' | translate}}\n' +
    '      </md-button>\n' +
    '      <div flex></div>\n' +
    '      <md-button class="md-accent md-raised" ng-click="newPerson()" flex="none">\n' +
    '        {{\'PEOPLE.NEW_PERSON\' | translate}}\n' +
    '      </md-button>\n' +
    '      <md-button class="md-accent md-raised" ng-click="selectedPerson()" ng-disabled="!someSelected()" flex="none">\n' +
    '        {{\'USE_SELECTED_PERSON\' | translate}}\n' +
    '      </md-button>\n' +
    '    </md-dialog-actions>\n' +
    '  </form>\n' +
    '</md-dialog>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/facilities/new-facility/new-facility.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '    <md-card class="md-whiteframe-z2" flex-gt-md="70" flex="100">\n' +
    '        <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '            <md-card-header-text>\n' +
    '                <span class="md-headline">{{ \'FACILITIES.NEW_DATA\' | translate}}</span>\n' +
    '            </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '        <md-card-content layout="row" layout-gt-md="column" layout-align="space-around stretch">\n' +
    '            <form name="facilityForm" ng-submit="vm.submitFacility()">\n' +
    '                <div flex layout="row" layout-align="space-around stretch">\n' +
    '                    <!-- TOWN HALL -->\n' +
    '                    <div layout="column" flex="45">\n' +
    '                        <md-autocomplete layout-padding ng-disabled="vm.townHalls.length === 1"\n' +
    '                                         md-selected-item="vm.facility.townHall"\n' +
    '                                         md-search-text="townHallSearch" md-clear-button="true"\n' +
    '                                         md-items="townHall in vm.townHalls | filterAccents: townHallSearch"\n' +
    '                                         md-item-text="townHall.name" md-min-length="0" md-require-match\n' +
    '                                         ng-required="true"\n' +
    '                                         md-floating-label="{{\'TOWN_HALL\' | translate}}">\n' +
    '                            <md-item-template>\n' +
    '                                <span md-highlight-text="vm.townHallSearch"\n' +
    '                                      md-highlight-flags="^i">{{townHall.name}}</span>\n' +
    '                            </md-item-template>\n' +
    '                            <md-not-found>\n' +
    '                                {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                            </md-not-found>\n' +
    '                        </md-autocomplete>\n' +
    '                        <!-- NAME -->\n' +
    '                        <md-input-container>\n' +
    '                            <label>{{\'NAME\' | translate}}</label>\n' +
    '                            <md-icon>title</md-icon>\n' +
    '                            <input name="name" type="text" ng-model="vm.facility.name" required>\n' +
    '                            <div ng-messages="facilityForm.name.$error" role="alert">\n' +
    '                                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                                <!--<div ng-message="pattern">{{error | translate}}</div>-->\n' +
    '                            </div>\n' +
    '                        </md-input-container>\n' +
    '                    </div>\n' +
    '                    <div layout="column" flex="45" layout-align="space-around stretch" style="padding-top: 1%">\n' +
    '                        <md-input-container>\n' +
    '                            <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '                            <md-icon>location_on</md-icon>\n' +
    '                            <input name="address" type="text" ng-model="vm.facility.address" required>\n' +
    '                            <div ng-messages="facilityForm.address.$error" role="alert">\n' +
    '                                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                                <div ng-message="pattern">{{error | translate}}</div>\n' +
    '                            </div>\n' +
    '                        </md-input-container>\n' +
    '\n' +
    '                        <div layout="row" flex="45" layout-align="space-around scratch" style="padding-top: 1%">\n' +
    '                          <md-input-container class="md-block">\n' +
    '                            <label>{{\'TOWN\' | translate}}</label>\n' +
    '                            <md-icon>location_on</md-icon>\n' +
    '                            <input name="town" type="text" ng-model="vm.facility.townName" required>\n' +
    '                            <div ng-messages="facilityForm.townName.$error" role="alert">\n' +
    '                              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                            </div>\n' +
    '                          </md-input-container>\n' +
    '                            <md-input-container class="md-block" flex="20">\n' +
    '                                <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '                                <input name="zipCode" type="text" ng-model="vm.facility.zipCode"\n' +
    '                                       md-maxlength="5"\n' +
    '                                       ng-pattern="/^[0-9]{5}$/">\n' +
    '                                <div ng-messages="facilityForm.zipCode.$error" role="alert">\n' +
    '                                    <div ng-message="pattern">{{error | translate}}</div>\n' +
    '                                    <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </md-input-container>\n' +
    '                            <div layout="row" style="padding: 2% 0 6% 0">\n' +
    '                                <md-button class="md-raised md-primary" ng-click="vm.searchLocation()">Cerca</md-button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div flex id="map_canvas">\n' +
    '                    <ui-gmap-google-map center="vm.map.center" zoom="vm.map.zoom" options="vm.map.options"\n' +
    '                                        data-tap-disabled="true" events="vm.map.events">\n' +
    '                        <ui-gmap-markers models="vm.map.markers" coords="\'self\'">\n' +
    '                        </ui-gmap-markers>\n' +
    '                    </ui-gmap-google-map>\n' +
    '                </div>\n' +
    '                <div flex>\n' +
    '                    <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="facilityForm.$invalid"\n' +
    '                               type="submit">\n' +
    '                        <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                        <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '                    </md-button>\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/facilities/facility/facility.tpl.html',
    '<div layout="row" layout-padding layout-align="space-around center" flex>\n' +
    '    <md-card class="md-whiteframe-z2" flex-gt-md="70" flex="100">\n' +
    '        <md-card-header layout-padding class="md-whiteframe-1dp">\n' +
    '            <md-card-header-text>\n' +
    '                <span class="md-headline">{{ \'FACILITIES.NEW_DATA\' | translate}}</span>\n' +
    '            </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '        <md-card-content layout="row" layout-gt-md="column" layout-align="space-around stretch">\n' +
    '            <form name="facilityForm" ng-submit="vm.submitFacility()">\n' +
    '                <div flex layout="row" layout-align="space-around stretch">\n' +
    '                    <!-- TOWN HALL -->\n' +
    '                    <div layout="column" flex="45">\n' +
    '                        <md-autocomplete layout-padding ng-disabled="vm.townHalls.length === 1 || !vm.edit"\n' +
    '                                         md-selected-item="vm.facility.townHall"\n' +
    '                                         md-search-text="townHallSearch" md-clear-button="true"\n' +
    '                                         md-items="townHall in vm.townHalls | filterAccents: townHallSearch"\n' +
    '                                         md-item-text="townHall.name" md-min-length="0" md-require-match\n' +
    '                                         ng-required="true"\n' +
    '                                         md-floating-label="{{\'TOWN_HALL\' | translate}}">\n' +
    '                            <md-item-template>\n' +
    '                                <span md-highlight-text="vm.townHallSearch"\n' +
    '                                      md-highlight-flags="^i">{{townHall.name}}</span>\n' +
    '                            </md-item-template>\n' +
    '                            <md-not-found>\n' +
    '                                {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '                            </md-not-found>\n' +
    '                        </md-autocomplete>\n' +
    '                        <!-- NAME -->\n' +
    '                        <md-input-container>\n' +
    '                            <label>{{\'NAME\' | translate}}</label>\n' +
    '                            <md-icon>title</md-icon>\n' +
    '                            <input name="name" type="text" ng-model="vm.facility.name" required ng-disabled="!vm.edit">\n' +
    '                            <div ng-messages="facilityForm.name.$error" role="alert">\n' +
    '                                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                                <!--<div ng-message="pattern">{{error | translate}}</div>-->\n' +
    '                            </div>\n' +
    '                        </md-input-container>\n' +
    '                    </div>\n' +
    '                    <div layout="column" flex="45" layout-align="space-around stretch" style="padding-top: 1%">\n' +
    '                        <md-input-container>\n' +
    '                            <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '                            <md-icon>location_on</md-icon>\n' +
    '                            <input name="address" type="text" ng-model="vm.facility.address" required\n' +
    '                                   ng-disabled="!vm.edit">\n' +
    '                            <div ng-messages="facilityForm.address.$error" role="alert">\n' +
    '                                <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                                <div ng-message="pattern">{{error | translate}}</div>\n' +
    '                            </div>\n' +
    '                        </md-input-container>\n' +
    '\n' +
    '                        <div layout="row" flex="45" layout-align="space-around scratch" style="padding-top: 1%">\n' +
    '                          <md-input-container class="md-block">\n' +
    '                            <label>{{\'TOWN\' | translate}}</label>\n' +
    '                            <md-icon>location_on</md-icon>\n' +
    '                            <input name="town" type="text" ng-model="vm.facility.townName" required ng-disabled="!vm.edit">\n' +
    '                            <div ng-messages="facilityForm.townName.$error" role="alert">\n' +
    '                              <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                            </div>\n' +
    '                          </md-input-container>\n' +
    '                            <md-input-container class="md-block" flex="20">\n' +
    '                                <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '                                <input name="zipCode" type="text" ng-model="vm.facility.zipCode" required\n' +
    '                                       md-maxlength="5"\n' +
    '                                       ng-pattern="/^[0-9]{5}$/" ng-disabled="!vm.edit">\n' +
    '                                <div ng-messages="facilityForm.zipCode.$error" role="alert">\n' +
    '                                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                                    <div ng-message="pattern">{{error | translate}}</div>\n' +
    '                                    <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </md-input-container>\n' +
    '                            <div layout="row" style="padding: 2% 0 6% 0">\n' +
    '                                <md-button class="md-raised md-primary" ng-click="vm.searchLocation()"\n' +
    '                                           ng-disabled="!vm.edit">{{\'SEARCH\' | translate}}\n' +
    '                                </md-button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div flex id="map_canvas">\n' +
    '                    <ui-gmap-google-map center="vm.map.center" zoom="vm.map.zoom" options="vm.map.options"\n' +
    '                                        data-tap-disabled="true" events="vm.map.events">\n' +
    '                        <ui-gmap-markers models="vm.map.markers" coords="\'self\'">\n' +
    '                        </ui-gmap-markers>\n' +
    '                    </ui-gmap-google-map>\n' +
    '                </div>\n' +
    '                <div flex>\n' +
    '                    <md-button class="md-fab md-accent md-fab-bottom-right"\n' +
    '                               ng-disabled="facilityForm.$invalid || facilityForm.$pristine"\n' +
    '                               type="submit" ng-if="vm.edit">\n' +
    '                        <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                        <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '                    </md-button>\n' +
    '                </div>\n' +
    '                <div flex>\n' +
    '                    <md-button class="md-fab md-warn md-fab-bottom-right"\n' +
    '                               ng-if="vm.edit" ng-click="vm.disableEdit()" style="margin-bottom: 72px;">\n' +
    '                        <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '                        <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '                    </md-button>\n' +
    '                </div>\n' +
    '                <neo-action-button buttons="vm.buttons" ng-if="vm.hasPermission"></neo-action-button>\n' +
    '            </form>\n' +
    '        </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/new-entitat/new-entitat.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_ENTITY_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="column">\n' +
    '        <form name="entitatForm" ng-submit="vm.addEntitat()">\n' +
    '          <div layout="column">\n' +
    '            <div>\n' +
    '              <h1 class="md-title">{{\'SELECT_TOWNHALL_AND_TYPE\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '                <md-input-container class="md-block" flex="40">\n' +
    '                  <label>{{\'TOWN_HALL\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_location_city_black_48px.svg"></md-icon>\n' +
    '                  <md-select name="ajuntament" ng-model="vm.entitat.townHall" ng-required="true"\n' +
    '                             ng-disabled="vm.onyOneTownHall">\n' +
    '                    <md-option ng-value="townHall" ng-repeat="townHall in vm.townHalls">{{ townHall.name }}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="entitatForm.ajuntament.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block" flex="40">\n' +
    '                  <label>{{\'ENTITY_TYPE\' | translate}}</label>\n' +
    '                  <md-select name="entityType" ng-model="vm.entitat.typeId" ng-required="true">\n' +
    '                    <md-option ng-value="type.id" ng-repeat="type in vm.entityTypes">{{ \'ENTITY_TYPES.\' + type.name |\n' +
    '                      translate }}\n' +
    '                    </md-option>\n' +
    '                  </md-select>\n' +
    '                  <div ng-messages="entitatForm.entityType.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <h1 class="md-title">{{\'NEW_ENTITY_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout-xs="column" layout-gt-xs="row" layout-align="space-around center">\n' +
    '\n' +
    '                <div flex="40" layout="column">\n' +
    '                  <md-input-container>\n' +
    '                    <label>{{\'NAME\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_title_black_48px.svg"></md-icon>\n' +
    '                    <input title="name" type="text" required ng-model="vm.entitat.name"/>\n' +
    '                    <div ng-messages="entitatForm.name.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'EMAIL\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                    <input name="email" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                           ng-model="vm.entitat.email"/>\n' +
    '                    <div ng-messages="entitatForm.email.$error" role="alert">\n' +
    '                      <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '                        {{\'EMAIL_INVALID_FORMAT\' | translate}}\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <div flex layout="row">\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>CCE</label>\n' +
    '                      <input name="cce" type="text" ng-model="vm.entitat.cce"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container>\n' +
    '                      <label>NIF</label>\n' +
    '                      <input name="nif" type="text"\n' +
    '                             ng-pattern="/^(\\d{8})([A-Z])$|^([ABCDEFGHJKLMNPQRSUVW])(\\d{7})([0-9A-J])$|^[KLMXYZ]\\d{7,8}[A-Z]$/"\n' +
    '                             ng-model="vm.entitat.nif"/>\n' +
    '                      <div ng-messages="entitatForm.nif.$error" role="alert">\n' +
    '                        <div ng-message="pattern">{{\'INVALID_NID\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                      <div flex layout="row">\n' +
    '                        <md-input-container class="md-block">\n' +
    '                      <label>{{\'NAME_CONTACT\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/ic_person_black_48px.svg"></md-icon>\n' +
    '                      <input name="personName" type="text"\n' +
    '\n' +
    '                             ng-model="vm.entitat.pname1"/>\n' +
    '\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                   <div flex layout="row">\n' +
    '                        <md-input-container class="md-block">\n' +
    '                      <md-icon md-svg-src="images/ic_web_black_48px.svg"></md-icon>\n' +
    '                      <label>{{\'WEB_PAGE\' | translate}}</label>\n' +
    '                      <input name="web" type="text" ng-model="vm.entitat.web"/>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div flex-gt-xs="45" flex layout="column">\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '                    <input name="address" type="text" ng-model="vm.entitat.address"/>\n' +
    '                  </md-input-container>\n' +
    '                  <div flex layout="row">\n' +
    '                    <md-input-container class="md-block" flex="75">\n' +
    '                      <label>{{\'TOWN\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/ic_location_city_black_48px.svg"></md-icon>\n' +
    '                        <md-select ng-model="vm.entitat.town" required>\n' +
    '                        <md-option ng-value="town.id" ng-repeat="town in vm.towns">{{ town.name }}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container class="md-block" flex="25">\n' +
    '                      <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '                      <input name="zipCode" type="text" name="zipCode" ng-model="vm.entitat.zipCode"\n' +
    '                             ng-pattern="/^[0-9]{5}$/" md-maxlength="5">\n' +
    '                      <div ng-messages="entitatForm.zipCode.$error" role="alert">\n' +
    '                        <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                  <div flex layout="row">\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'MOBILE_PHONE\' | translate}}</label>\n' +
    '                      <input name="mobileNumber" type="tel"\n' +
    '                             ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                             ng-model="vm.entitat.mobileNumber"/>\n' +
    '                      <div ng-messages="entitatForm.mobileNumber.$error" role="alert">\n' +
    '                        <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'FAX\' | translate}}</label>\n' +
    '                      <input name="fax" type="tel"\n' +
    '                             ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                             ng-model="vm.entitat.fax"/>\n' +
    '                      <div ng-messages="entitatForm.fax.$error" role="alert">\n' +
    '                        <div ng-message="pattern">{{\'INVALID_FAX_NUMBER\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                      <div flex layout="row">\n' +
    '\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>{{\'PHONE\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                      <input name="phoneNumber" type="tel"\n' +
    '                             ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                             ng-model="vm.entitat.phoneNumber"/>\n' +
    '                      <div ng-messages="entitatForm.phoneNumber.$error" role="alert">\n' +
    '                        <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                       </div>\n' +
    '                  <div flex layout="row">\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>Facebook</label>\n' +
    '                      <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '                      <input name="facebook" type="text"\n' +
    '                             ng-model="vm.entitat.facebook"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>Twitter</label>\n' +
    '                      <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '                      <input name="twitter" type="text"\n' +
    '                             ng-model="vm.entitat.twitter"/>\n' +
    '                    </md-input-container>\n' +
    '                    <md-input-container class="md-block">\n' +
    '                      <label>Instagram</label>\n' +
    '                      <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '                      <input name="instagram" type="text"\n' +
    '                             ng-model="vm.entitat.instagram"/>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '\n' +
    '\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div layout="column" layout-padding>\n' +
    '            <div>\n' +
    '              <h1 class="md-title">{{\'USER_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="row" layout-align="space-around left">\n' +
    '                <div flex="40" layout="column" layout-padding>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'ACCESS_EMAIL\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                    <input name="username" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                           ng-model="vm.entitat.username"/>\n' +
    '                    <div ng-messages="entitatForm.username.$error" role="alert">\n' +
    '                      <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '                        {{\'EMAIL_INVALID_FORMAT\' | translate}}\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div flex-gt-xs="45" flex layout="column"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="entitatForm.$invalid"\n' +
    '                       type="submit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/entitat.tpl.html',
    '<div ui-view></div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitat/delete-confirmation.tmpl.html',
    '<div layout="column" layout-padding>\n' +
    '  <h3> {{alertText}}</h3>\n' +
    '  <md-divider></md-divider>\n' +
    '  <span> {{textContent}}</span>\n' +
    '</div>\n' +
    '<div layout="row" layout-align="end end" flex>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-raised" ng-click="cancel()">{{ cancelText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-warn md-raised" ng-click="delete()">{{deleteText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/delete-confirmation.tmpl.html',
    '<div layout="column" layout-padding>\n' +
    '  <h3 > {{alertText}}</h3>\n' +
    '  <md-divider></md-divider>\n' +
    '  <span> {{textContent}}</span>\n' +
    '</div>\n' +
    '<div layout="row" layout-align="end end"  flex>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-raised" ng-click="cancel()">{{ cancelText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '  <md-input-container>\n' +
    '    <md-button class="md-warn md-raised" ng-click="delete()">{{deleteText}}</md-button>\n' +
    '  </md-input-container>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championship/championship.tpl.html',
    '<div layout="row" layout-align="center center" ui-view style="padding-top: 2%">\n' +
    '\n' +
    '  <md-card flex-gt-md="50" flex-xs="100" flex="70">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline" ng-if="!vm.edit">{{\'CHAMPIONSHIPS.DATA\' | translate}}</span>\n' +
    '          <span class="md-headline" ng-if="vm.edit">{{\'CHAMPIONSHIPS.MODIFY_DATA\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '\n' +
    '\n' +
    '      <div layout="column" layout-gt-sm="row">\n' +
    '        <div style="min-width: 75%;" flex>\n' +
    '          <div layout-align="center center" layout="row">\n' +
    '            <div flex>\n' +
    '              <form name="championshipForm" ng-submit="vm.updateChampionship()">\n' +
    '                <div layout="column" layout-padding>\n' +
    '                  <div>\n' +
    '\n' +
    '                    <div layout-gt-sm="row" layout-align="space-around none" flex>\n' +
    '                      <!-- NAME -->\n' +
    '                      <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                                 is-required="true"\n' +
    '                                 ng-model="vm.championship.name" flex="45" layout-gt-sm="column"\n' +
    '                                 is-disabled="!vm.edit"></neo-input>\n' +
    '                      <!-- PHASE -->\n' +
    '                      <md-input-container class="md-block" flex="45">\n' +
    '                        <label>{{\'CHAMPIONSHIPS.PHASE\' | translate}}</label>\n' +
    '                        <md-select name="phase" ng-model="vm.championship.phaseId" ng-required="true"\n' +
    '                                   ng-disabled="!vm.edit || vm.championship.hasTeams">\n' +
    '                          <md-option ng-repeat="phase in vm.phases" value="{{phase.id}}">\n' +
    '                            {{phase.name | translate }}\n' +
    '                          </md-option>\n' +
    '                        </md-select>\n' +
    '                        <div ng-messages="championshipForm.phase.$error" role="alert">\n' +
    '                          <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                        </div>\n' +
    '                      </md-input-container>\n' +
    '                    </div>\n' +
    '                    <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                      <!-- PROGRAMME TYPE -->\n' +
    '                      <md-input-container class="md-block" flex="45">\n' +
    '                        <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '                        <md-select name="programme" ng-model="vm.championship.programmeId" ng-required="true"\n' +
    '                                   ng-disabled="true">\n' +
    '                          <md-option ng-repeat="programme in vm.programmes" value="{{programme.id}}">\n' +
    '                            {{programme.name | translate }}\n' +
    '                          </md-option>\n' +
    '                        </md-select>\n' +
    '                        <div ng-messages="championshipForm.programme.$error" role="alert">\n' +
    '                          <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                        </div>\n' +
    '                      </md-input-container>\n' +
    '                      <md-input-container class="md-block" flex="45">\n' +
    '                        <label>{{\'CHAMPIONSHIPS.TYPE\' | translate}}</label>\n' +
    '                        <md-select name="type" ng-model="vm.championship.typeId" ng-required="true" ng-disabled="true">\n' +
    '                          <md-option ng-repeat="type in vm.championshipTypes" value="{{type.id}}">\n' +
    '                            {{type.name | translate}}\n' +
    '                          </md-option>\n' +
    '                        </md-select>\n' +
    '                        <div ng-messages="championshipForm.type.$error" role="alert">\n' +
    '                          <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                        </div>\n' +
    '                      </md-input-container>\n' +
    '                    </div>\n' +
    '                    <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                      <!-- SPORT -->\n' +
    '                      <md-input-container class="md-block" flex="45">\n' +
    '                        <label>{{\'SPORT\' | translate}}</label>\n' +
    '                        <md-icon md-svg-src="images/football.svg"></md-icon>\n' +
    '                        <md-select name="sport" ng-model="vm.championship.sportId" ng-required="true"\n' +
    '                                   ng-disabled="!vm.edit || vm.championship.hasTeams">\n' +
    '                          <md-option ng-repeat="sport in vm.sports" value="{{sport.id}}">\n' +
    '                            {{\'SPORTS.\' + sport.name | translate }}\n' +
    '                          </md-option>\n' +
    '                        </md-select>\n' +
    '                        <div ng-messages="championshipForm.sport.$error" role="alert">\n' +
    '                          <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                        </div>\n' +
    '                      </md-input-container>\n' +
    '                      <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                        <!-- JVP -->\n' +
    '                        <md-checkbox ng-model="vm.championship.jvp" aria-label="verd-play"\n' +
    '                                     ng-disabled="!vm.edit || vm.championship.hasBeenDrawn">\n' +
    '                          {{\'CHAMPIONSHIPS.VPLAY\' | translate}}\n' +
    '                        </md-checkbox>\n' +
    '                        <!-- ROUNDS -->\n' +
    '                        <neo-input name="rounds" label="CHAMPIONSHIPS.ROUNDS" is-required="true"\n' +
    '                                   ng-model="vm.championship.rounds"\n' +
    '                                   error="CHAMPIONSHIPS.MAX_ROUNDS" layout-gt-sm="column"\n' +
    '                                   icon="images/ic_repeat_black_48px.svg"\n' +
    '                                   pattern="^([0-9])$"\n' +
    '                                   is-disabled="!vm.edit || vm.championship.hasBeenDrawn"></neo-input>\n' +
    '                         <md-checkbox ng-model="vm.championship.invisible" aria-label="invisible"  ng-disabled="!vm.edit">\n' +
    '                      {{\'CHAMPIONSHIPS.INVISIBLE\' | translate}}\n' +
    '                    </md-checkbox>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                    <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                      <div layout-gt-sm="row" flex="45">\n' +
    '                        <!-- CATEGORY -->\n' +
    '                        <md-input-container class="md-block" flex="50">\n' +
    '                          <label>{{\'CATEGORY\' | translate}}</label>\n' +
    '                          <md-icon md-svg-src="images/ic_folder_black_48px.svg"></md-icon>\n' +
    '                          <md-select name="category" ng-model="vm.championship.categoryId" ng-required="true"\n' +
    '                                     ng-disabled="!vm.edit || vm.championship.hasTeams">\n' +
    '                            <md-option ng-repeat="category in vm.categories" value="{{category.id}}">\n' +
    '                              {{\'CATEGORIES.\'+category.name | translate}}\n' +
    '                            </md-option>\n' +
    '                          </md-select>\n' +
    '                          <div ng-messages="championshipForm.category.$error" role="alert">\n' +
    '                            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                          </div>\n' +
    '                        </md-input-container>\n' +
    '                        <!-- GENDER -->\n' +
    '                        <md-input-container class="md-block" flex="50">\n' +
    '                          <label>{{\'GENDER\' | translate}}</label>\n' +
    '                          <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                          <md-select name="gender" ng-model="vm.championship.genderId" ng-required="true"\n' +
    '                                     ng-disabled="!vm.edit || vm.championship.hasTeams">\n' +
    '                            <md-option ng-repeat="gender in vm.genders"\n' +
    '                                       value="{{gender.id}}">{{gender.name | translate}}\n' +
    '                            </md-option>\n' +
    '                          </md-select>\n' +
    '                          <div ng-messages="championshipForm.gender.$error" role="alert">\n' +
    '                            <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                          </div>\n' +
    '                        </md-input-container>\n' +
    '                      </div>\n' +
    '                      <!-- SCORES -->\n' +
    '                      <div layout-gt-sm="row" flex="45">\n' +
    '                        <neo-input name="victory_points" label="CHAMPIONSHIPS.SCORE.VICTORY"\n' +
    '                                   is-required="!vm.championship.jvp"\n' +
    '                                   ng-model="vm.championship.winPoints" flex layout-gt-sm="column"\n' +
    '                                   error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                                   is-disabled="vm.championship.jvp || !vm.edit || vm.championship.hasBeenDrawn"\n' +
    '                                   pattern="^([0-9]+)$"\n' +
    '                                   ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                        <neo-input name="tie_points" label="CHAMPIONSHIPS.SCORE.TIE" is-required="!vm.championship.jvp"\n' +
    '                                   ng-model="vm.championship.drawPoints" flex layout-gt-sm="column"\n' +
    '                                   error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                                   is-disabled="vm.championship.jvp || !vm.edit || vm.championship.hasBeenDrawn"\n' +
    '                                   pattern="^([0-9]+)$"\n' +
    '                                   ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                        <neo-input name="loss_points" label="CHAMPIONSHIPS.SCORE.LOSS"\n' +
    '                                   is-required="!vm.championship.jvp"\n' +
    '                                   ng-model="vm.championship.lostPoints" flex layout-gt-sm="column"\n' +
    '                                   error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                                   is-disabled="vm.championship.jvp || !vm.edit || vm.championship.hasBeenDrawn "\n' +
    '                                   pattern="^([0-9]+)$"\n' +
    '                                   ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div layout-gt-sm="row" layout-align="center center" flex>\n' +
    '                      <!-- EDITABLE MATCHES -->\n' +
    '                      <md-switch ng-model="vm.championship.editableMatches" aria-label="editable-matches"\n' +
    '                                 ng-if="vm.isAdmin()" ng-disabled="!vm.edit">\n' +
    '                        {{\'CHAMPIONSHIPS.EDITABLE_MATCHES\' | translate}}\n' +
    '                      </md-switch>\n' +
    '                      <span class="md-body-1" md-colors="{color:\'warn\'}"\n' +
    '                            ng-if="!vm.championship.editableMatches && !vm.isAdmin()">{{\'CHAMPIONSHIPS.ALERT_ASSIGN_MATCHES_PERIOD\' | translate}}</span>\n' +
    '                    </div>\n' +
    '\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div flex>\n' +
    '                  <md-button type="submit" class="md-fab md-accent md-fab-bottom-right" ng-if="vm.edit"\n' +
    '                             ng-disabled="championshipForm.$invalid">\n' +
    '                    <md-icon class="material-icons md-24" aria-label="save">save</md-icon>\n' +
    '                  </md-button>\n' +
    '                </div>\n' +
    '              </form>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/new-championship/new-championship.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_CHAMPIONSHIP_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="row">\n' +
    '        <div flex="100">\n' +
    '          <form name="championshipForm" ng-submit="vm.saveChampionship()">\n' +
    '            <div layout="column" layout-padding>\n' +
    '              <div layout-padding>\n' +
    '                <h1 class="md-title">{{\'CHAMPIONSHIPS.NEW\' | translate}}</h1>\n' +
    '                <md-divider></md-divider>\n' +
    '                <div layout-gt-sm="row" layout-align="space-around none" flex >\n' +
    '                  <!-- NAME -->\n' +
    '                  <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                             is-required="true"\n' +
    '                             ng-model="vm.championship.name" flex="45" layout-gt-sm="column"></neo-input>\n' +
    '                  <!-- PHASE -->\n' +
    '                  <md-input-container class="md-block" flex="45">\n' +
    '                    <label>{{\'CHAMPIONSHIPS.PHASE\' | translate}}</label>\n' +
    '                    <md-select name="phase" ng-model="vm.championship.phaseId" ng-required="true">\n' +
    '                      <md-option ng-repeat="phase in vm.phases" value="{{phase.id}}">\n' +
    '                        {{phase.name | translate }}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="championshipForm.phase.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                  <!-- PROGRAMME TYPE -->\n' +
    '                  <md-input-container class="md-block" flex="45">\n' +
    '                    <label>{{\'PROGRAM_TYPE\' | translate}}</label>\n' +
    '                    <md-select name="programme" ng-model="vm.championship.programmeId" ng-required="true"\n' +
    '                               ng-disabled="true">\n' +
    '                      <md-option ng-repeat="programme in vm.programmes" value="{{programme.id}}">\n' +
    '                        {{programme.name | translate }}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="championshipForm.programme.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <!-- CHAMPIONSHIP TYPE -->\n' +
    '                  <md-input-container class="md-block" flex="45">\n' +
    '                    <label>{{\'CHAMPIONSHIPS.TYPE\' | translate}}</label>\n' +
    '                    <md-select name="type" ng-model="vm.championship.typeId" ng-required="true" ng-disabled="true">\n' +
    '                      <md-option ng-repeat="type in vm.championshipTypes" value="{{type.id}}">\n' +
    '                        {{type.name | translate}}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="championshipForm.type.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                  <!-- SPORT -->\n' +
    '                  <md-input-container class="md-block" flex="45">\n' +
    '                    <label>{{\'SPORT\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/football.svg"></md-icon>\n' +
    '                    <md-select name="sport" ng-model="vm.championship.sportId" ng-required="true">\n' +
    '                      <md-option ng-repeat="sport in vm.sports" value="{{sport.id}}">\n' +
    '                        {{\'SPORTS.\' + sport.name | translate }}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                    <div ng-messages="championshipForm.sport.$error" role="alert">\n' +
    '                      <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <div layout-gt-sm="row" layout-align="space-between center" flex="45">\n' +
    '                    <!-- JVP -->\n' +
    '                    <md-checkbox ng-model="vm.championship.jvp" aria-label="verd-play">\n' +
    '                      {{\'CHAMPIONSHIPS.VPLAY\' | translate}}\n' +
    '                    </md-checkbox>\n' +
    '                    <!-- ROUNDS -->\n' +
    '                    <neo-input name="rounds" label="CHAMPIONSHIPS.ROUNDS" is-required="true"\n' +
    '                               ng-model="vm.championship.rounds"\n' +
    '                               error="CHAMPIONSHIPS.MAX_ROUNDS" layout-gt-sm="column"\n' +
    '                               icon="images/ic_repeat_black_48px.svg"\n' +
    '                               pattern="^([0-9])$"></neo-input>\n' +
    '                     <md-checkbox ng-model="vm.championship.invisible" aria-label="invisible">\n' +
    '                      {{\'CHAMPIONSHIPS.INVISIBLE\' | translate}}\n' +
    '                    </md-checkbox>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div layout-gt-sm="row" layout-align="space-around center" flex>\n' +
    '                  <div layout-gt-sm="row" flex="45">\n' +
    '                    <!-- CATEGORY -->\n' +
    '                    <md-input-container class="md-block" flex="50">\n' +
    '                      <label>{{\'CATEGORY\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/ic_folder_black_48px.svg"></md-icon>\n' +
    '                      <md-select name="category" ng-model="vm.championship.categoryId" required>\n' +
    '                        <md-option ng-repeat="category in vm.categories" value="{{category.id}}">\n' +
    '                          {{\'CATEGORIES.\'+category.name | translate}}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="championshipForm.category.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                    <!-- GENDER -->\n' +
    '                    <md-input-container class="md-block" flex="50">\n' +
    '                      <label>{{\'GENDER\' | translate}}</label>\n' +
    '                      <md-icon md-svg-src="images/gender-male-female.svg"></md-icon>\n' +
    '                      <md-select name="gender" ng-model="vm.championship.genderId" ng-required="true">\n' +
    '                        <md-option ng-repeat="gender in vm.genders" value="{{gender.id}}">{{gender.name | translate}}\n' +
    '                        </md-option>\n' +
    '                      </md-select>\n' +
    '                      <div ng-messages="championshipForm.gender.$error" role="alert">\n' +
    '                        <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                      </div>\n' +
    '                    </md-input-container>\n' +
    '                  </div>\n' +
    '                  <!-- SCORES -->\n' +
    '                  <div layout-gt-sm="row" flex="45">\n' +
    '                    <neo-input name="victory_points" label="CHAMPIONSHIPS.SCORE.VICTORY"\n' +
    '                               is-required="!vm.championship.jvp"\n' +
    '                               ng-model="vm.championship.winPoints" flex layout-gt-sm="column"\n' +
    '                               error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                               is-disabled="vm.championship.jvp" pattern="^([0-9]+)$"\n' +
    '                               ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                    <neo-input name="tie_points" label="CHAMPIONSHIPS.SCORE.TIE" is-required="!vm.championship.jvp"\n' +
    '                               ng-model="vm.championship.drawPoints" flex layout-gt-sm="column"\n' +
    '                               error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                               is-disabled="vm.championship.jvp" pattern="^([0-9]+)$"\n' +
    '                               ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                    <neo-input name="loss_points" label="CHAMPIONSHIPS.SCORE.LOSS" is-required="!vm.championship.jvp"\n' +
    '                               ng-model="vm.championship.lostPoints" flex layout-gt-sm="column"\n' +
    '                               error="CHAMPIONSHIPS.SCORE.ERROR"\n' +
    '                               is-disabled="vm.championship.jvp" pattern="^([0-9]+)$"\n' +
    '                               ng-show="!vm.championship.jvp"></neo-input>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div layout-gt-sm="row" layout-align="center center" flex>\n' +
    '                  <!-- EDITABLE MATCHES -->\n' +
    '                  <md-switch ng-model="vm.championship.editableMatches" aria-label="editable-matches"\n' +
    '                             ng-if="vm.isAdmin()">\n' +
    '                    {{\'CHAMPIONSHIPS.EDITABLE_MATCHES\' | translate}}\n' +
    '                  </md-switch>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div flex>\n' +
    '              <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="championshipForm.$invalid"\n' +
    '                         type="submit">\n' +
    '                <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '                <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '              </md-button>\n' +
    '            </div>\n' +
    '          </form>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/cancellations/new-cancellation/new-cancellation.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'CANCELLATIONS.NEW\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="cancellationForm" novalidate>\n' +
    '        <div layout-align="center stretch" layout="column">\n' +
    '          <div layout="row" flex>\n' +
    '            <div flex="50" layout="column" layout-align="top none" layout-wrap\n' +
    '                 ng-repeat="team in [vm.localTeam, vm.visitorTeam]">\n' +
    '              <h1 class="md-title">{{team.columnName | translate}}</h1>\n' +
    '              <div layout-padding>\n' +
    '                <div flex layout="row">\n' +
    '                  <neo-input name="teamName" label="TEAM_NAME" neo-icon="title" ng-model="team.name"\n' +
    '                             is-disabled="true" flex no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="COACH_NAME" neo-icon="person" ng-model="team.coachName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="COACH_PHONE" neo-icon="phone" ng-model="team.coachPhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="DELEGATE_NAME" neo-icon="person" ng-model="team.delegateName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="DELEGATE_PHONE" neo-icon="phone" ng-model="team.delegatePhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <md-divider></md-divider>\n' +
    '\n' +
    '          <h1 class="md-title">{{\'CANCELLATIONS.DETAILS\' | translate}}</h1>\n' +
    '          <div layout="row" flex layout-align="space-around">\n' +
    '            <!-- Cancellation Type -->\n' +
    '            <div flex="45" layout="column">\n' +
    '              <md-input-container flex>\n' +
    '                <md-select ng-model="vm.cancellation.typeId"\n' +
    '                           placeholder="{{\'CANCELLATIONS.CANCELLATION_TYPE\' | translate}}"\n' +
    '                           ng-required="true" md-no-asterisk="true">\n' +
    '                  <md-option ng-repeat="cancellation in vm.cancellationTypes" ng-value="cancellation.id">\n' +
    '                    {{\'CANCELLATIONS.TYPES.\' + cancellation.name | translate}}\n' +
    '                  </md-option>\n' +
    '                </md-select>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '            <!-- Details -->\n' +
    '            <div flex="45" layout="column">\n' +
    '              <md-input-container class="md-block">\n' +
    '                <label>{{\'CANCELLATIONS.MORE_INFORMATION\' | translate}}</label>\n' +
    '                <md-icon class="material-icons md-dark">info_outline</md-icon>\n' +
    '                <textarea ng-model="vm.cancellation.details" md-maxlength="500" rows="5" md-select-on-focus\n' +
    '                          title="more_info"></textarea>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="cancellationForm.$invalid"\n' +
    '                     ng-click="vm.saveCancellation()">\n' +
    '            <md-icon class="material-icons md-light">save</md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/cancellations/edit-cancellation/edit-cancellation.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'CANCELLATIONS.EDIT\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="cancellationForm" novalidate>\n' +
    '        <div layout-align="center stretch" layout="column">\n' +
    '          <div layout="row" flex>\n' +
    '            <div flex="50" layout="column" layout-align="top none" layout-wrap\n' +
    '                 ng-repeat="team in [vm.localTeam, vm.visitorTeam]">\n' +
    '              <h1 class="md-title">{{team.columnName | translate}}</h1>\n' +
    '              <div layout-padding>\n' +
    '                <div flex layout="row">\n' +
    '                  <neo-input name="teamName" label="TEAM_NAME" neo-icon="title" ng-model="team.name"\n' +
    '                             is-disabled="true" flex no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="COACH_NAME" neo-icon="person" ng-model="team.coachName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="COACH_PHONE" neo-icon="phone" ng-model="team.coachPhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '                <div flex layout="column" layout-gt-sm="row">\n' +
    '                  <neo-input name="coachName" label="DELEGATE_NAME" neo-icon="person" ng-model="team.delegateName"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                  <neo-input name="coachPhone" label="DELEGATE_PHONE" neo-icon="phone" ng-model="team.delegatePhone"\n' +
    '                             is-disabled="true" flex="45" no-margin="true"></neo-input>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <md-divider></md-divider>\n' +
    '\n' +
    '          <h1 class="md-title">{{\'CANCELLATIONS.DETAILS\' | translate}}</h1>\n' +
    '          <div layout="row" flex layout-align="space-around">\n' +
    '            <!-- Cancellation Type -->\n' +
    '            <div flex="45" layout="column">\n' +
    '              <md-input-container flex>\n' +
    '                <md-select ng-model="vm.cancellation.typeId"\n' +
    '                           placeholder="{{\'CANCELLATIONS.CANCELLATION_TYPE\' | translate}}"\n' +
    '                           ng-required="true" md-no-asterisk="true">\n' +
    '                  <md-option ng-repeat="cancellation in vm.cancellationTypes" ng-value="cancellation.id">\n' +
    '                    {{\'CANCELLATIONS.TYPES.\' + cancellation.name | translate}}\n' +
    '                  </md-option>\n' +
    '                </md-select>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '            <!-- Details -->\n' +
    '            <div flex="45" layout="column">\n' +
    '              <md-input-container class="md-block">\n' +
    '                <label>{{\'CANCELLATIONS.MORE_INFORMATION\' | translate}}</label>\n' +
    '                <md-icon class="material-icons md-dark">info_outline</md-icon>\n' +
    '                <textarea ng-model="vm.cancellation.details" md-maxlength="500" rows="5" md-select-on-focus\n' +
    '                          title="more_info"></textarea>\n' +
    '              </md-input-container>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-warn md-fab-bottom-right" ng-click="vm.cancelEdition()"\n' +
    '                     style="margin-bottom: 72px;">\n' +
    '            <md-icon md-svg-src="images/ic_cancel_white_48px.svg" class="s24" aria-label="cancel"></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'CANCEL\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '        <div flex>\n' +
    '          <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="cancellationForm.$invalid"\n' +
    '                     ng-click="vm.editCancellation()">\n' +
    '            <md-icon class="material-icons md-light">save</md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/cancellations/canceled-matches/canceled-matches.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       md-min-length="0"\n' +
    '                       ng-required="true"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.initDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.initDate" md-max-date="vm.today"\n' +
    '                     ng-disabled="vm.initDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="95" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'CANCELLATIONS.CANCELED_MATCHES\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-hide="vm.showList">{{\'CANCELLATIONS.NOT_FOUND_CANCELLATIONS\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.showList">\n' +
    '          <table md-table md-row-select="false" ng-model="vm.selected" md-progress="vm.promiseMatches">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="originalDate">{{ \'CANCELLATIONS.MATCH_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="originalTime">{{ \'CANCELLATIONS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="type">{{ \'CANCELLATIONS.TYPE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="resolved">{{ \'CANCELLATIONS.STATE\' | translate}}</th>\n' +
    '              <th md-column>\n' +
    '                <div flex layout="row" layout-align="center center">\n' +
    '                  {{\'ACTIONS\' | translate}}\n' +
    '                </div>\n' +
    '              </th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time || "--:--"}}</td>\n' +
    '              <td md-cell>{{match.championship}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name}}</td>\n' +
    '              <td md-cell>{{\'CANCELLATIONS.TYPES.\' + match.lastCancellation.type.name | translate}}</td>\n' +
    '              <td md-cell ng-if="match.lastCancellation.resolved">{{\'CANCELLATIONS.RESOLVED\' | translate}}</td>\n' +
    '              <td md-cell ng-if="!match.lastCancellation.resolved">{{\'CANCELLATIONS.UNRESOLVED\' | translate}}</td>\n' +
    '              <td md-cell>\n' +
    '                <div flex layout="row" layout-align="center center">\n' +
    '                  <md-button class="md-icon-button" aria-label="edit" ng-if="vm.showEditButton(match)"\n' +
    '                             ng-click="vm.editCancellation(match)">\n' +
    '                    <md-tooltip md-direction="left" md-delay="50">{{\'EDIT\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>mode_edit</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <md-button class="md-icon-button" aria-label="edit" ng-if="vm.showPostponeButton(match)"\n' +
    '                             ng-click="vm.postponeCancellation(match)">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'POSTPONEMENTS.POSTPONE\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>event_busy</md-icon>\n' +
    '                  </md-button>\n' +
    '                  <md-switch ng-if="vm.showResolveSwitch(match)" ng-model="match.lastCancellation.resolved"\n' +
    '                             ng-change="vm.updateMatchState(match)"></md-switch>\n' +
    '                </div>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.showList"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/new-ajuntament/new-ajuntament.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '\n' +
    '  <md-card flex-gt-md="70" flex="100">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'NEW_TOWNHALL_UPLOAD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div layout-align="center center" layout="column" flex>\n' +
    '        <form name="ajuntamentForm" ng-submit="vm.addAjuntament()" flex>\n' +
    '          <div layout="column" flex>\n' +
    '            <h1 class="md-title">{{\'NEW_TOWN_HALL_DATA\' | translate}}</h1>\n' +
    '            <md-divider></md-divider>\n' +
    '            <div layout-xs="column" flex layout-gt-xs="row" layout-align="space-around center">\n' +
    '              <div flex-gt-xs="40" flex layout="column">\n' +
    '                <md-input-container>\n' +
    '                  <label>{{\'NAME\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_title_black_48px.svg"></md-icon>\n' +
    '                  <input title="name" type="text" required ng-model="vm.ajuntament.name"/>\n' +
    '                  <div ng-messages="ajuntamentForm.name.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block">\n' +
    '                  <label>{{\'CONTACT_EMAIL\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                  <input title="email" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                         ng-model="vm.ajuntament.email"/>\n' +
    '                  <div ng-messages="ajuntamentForm.email.$error" role="alert">\n' +
    '                    <div ng-message-exp="[\'required\', \'pattern\']">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '                <md-input-container class="md-block">\n' +
    '                  <md-icon md-svg-src="images/ic_web_black_48px.svg"></md-icon>\n' +
    '                  <label>{{\'WEB_PAGE\' | translate}}</label>\n' +
    '                  <input title="web" type="text" ng-model="vm.ajuntament.web"/>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '              <div flex-gt-xs="45" flex layout="column">\n' +
    '                <md-input-container class="md-block">\n' +
    '                  <label>{{\'ADDRESS\' | translate}}</label>\n' +
    '                  <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '                  <input title="address" type="text" ng-model="vm.ajuntament.address"/>\n' +
    '                </md-input-container>\n' +
    '                <div flex layout="row">\n' +
    '                  <md-input-container class="md-block" flex="75">\n' +
    '                    <label>{{\'TOWN\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_location_city_black_48px.svg"></md-icon>\n' +
    '                    <md-select ng-model="vm.ajuntament.idTown" ng-required="true">\n' +
    '                      <md-option ng-value="town.id" ng-repeat="town in vm.towns">{{ town.name }}\n' +
    '                      </md-option>\n' +
    '                    </md-select>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block" flex="25">\n' +
    '                    <label>{{\'POSTAL_CODE\' | translate}}</label>\n' +
    '                    <input title="zipCode" type="text" name="zipCode" ng-model="vm.ajuntament.zipCode"\n' +
    '                           ng-pattern="/^[0-9]{5}$/" md-maxlength="5">\n' +
    '                    <div ng-messages="ajuntamentForm.zipCode.$error" role="alert">\n' +
    '                      <div ng-message="md-maxlength">{{\'MAXIMUM_CHARACTERS_POSTAL_CODE\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div flex layout="row">\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'PHONE\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '                    <input title="phoneNumber" type="tel"\n' +
    '                           ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                           ng-model="vm.ajuntament.phoneNumber"/>\n' +
    '                    <div ng-messages="ajuntamentForm.phoneNumber.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'INVALID_PHONE_NUMBER\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'FAX\' | translate}}</label>\n' +
    '                    <input title="fax" type="tel"\n' +
    '                           ng-pattern="/^[+]{0,1}[0-9]+$/"\n' +
    '                           ng-model="vm.ajuntament.fax"/>\n' +
    '                    <div ng-messages="ajuntamentForm.fax.$error" role="alert">\n' +
    '                      <div ng-message="pattern">{{\'INVALID_FAX_NUMBER\' | translate}}</div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div flex layout="row">\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>Facebook</label>\n' +
    '                    <md-icon md-svg-src="images/if_facebook_circle_color_107175.svg" aria-label="Facebook"></md-icon>\n' +
    '                    <input title="facbook" type="text"\n' +
    '                           ng-model="vm.ajuntament.facebook"/>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>Twitter</label>\n' +
    '                    <md-icon md-svg-src="images/if_twitter_circle_color_107170.svg" aria-label="Twitter"></md-icon>\n' +
    '                    <input title="twitter" type="text"\n' +
    '                           ng-model="vm.ajuntament.twitter"/>\n' +
    '                  </md-input-container>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>Instagram</label>\n' +
    '                    <md-icon md-svg-src="images/if_instagram_2362135.svg" aria-label="Instagram"></md-icon>\n' +
    '                    <input title="instagram" type="text"\n' +
    '                           ng-model="vm.ajuntament.instagram"/>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div layout="column">\n' +
    '            <div>\n' +
    '              <h1 class="md-title">{{\'USER_DATA\' | translate}}</h1>\n' +
    '              <md-divider></md-divider>\n' +
    '              <div layout="row" layout-align="space-around left">\n' +
    '                <div flex="40" layout="column" layout-padding>\n' +
    '                  <md-input-container class="md-block">\n' +
    '                    <label>{{\'ACCESS_EMAIL\' | translate}}</label>\n' +
    '                    <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '                    <input title="email" type="email" required ng-pattern="/^.+@.+\\..+$/"\n' +
    '                           ng-model="vm.ajuntament.username"/>\n' +
    '                    <div ng-messages="ajuntamentForm.username.$error" role="alert">\n' +
    '                      <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '                        {{\'EMAIL_INVALID_FORMAT\' | translate}}\n' +
    '                      </div>\n' +
    '                    </div>\n' +
    '                  </md-input-container>\n' +
    '                </div>\n' +
    '                <div flex-gt-xs="45" flex layout="column"></div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div flex>\n' +
    '            <md-button class="md-fab md-accent md-fab-bottom-right" ng-disabled="ajuntamentForm.$invalid"\n' +
    '                       type="submit">\n' +
    '              <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'SAVE\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntament/ajuntament.tpl.html',
    '<!--<md-nav-bar class="md-primary md-hue-2" md-selected-nav-item="vm.currentNavItem" nav-bar-aria-label="navigation links">\n' +
    '  <md-nav-item md-nav-sref="home.ajuntaments.ajuntament.informacio" name="informacio">Informació</md-nav-item>\n' +
    '  <md-nav-item md-nav-sref="home.ajuntaments.ajuntament.entitats" name="entitats">Entitats</md-nav-item>\n' +
    '</md-nav-bar>-->\n' +
    '\n' +
    '<div ui-view></div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/resultats/resultats.tpl.html',
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/classification/classification.tpl.html',
    '<div layout="row" layout-align="space-around center" flex>\n' +
    '  <md-card flex="90">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{"CHAMPIONSHIPS.CLASSIFICATION" | translate }}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <div flex>\n' +
    '        <h1 class="md-title">{{\'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</h1>\n' +
    '        <md-divider></md-divider>\n' +
    '        <div layout="row" layout-align="space-around none" layout-padding layout-wrap>\n' +
    '          <!-- NAME -->\n' +
    '          <neo-input name="name" label="CHAMPIONSHIPS.NAME" icon="images/ic_title_black_48px.svg"\n' +
    '                     ng-model="vm.championship.name" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- CATEGORY -->\n' +
    '          <neo-input name="category" label="CATEGORY" icon="images/ic_folder_black_48px.svg"\n' +
    '                     ng-model="vm.category" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- SPORT -->\n' +
    '          <neo-input name="sport" label="SPORT" icon="images/football.svg"\n' +
    '                     ng-model="vm.sport" flex="25" is-disabled="true"></neo-input>\n' +
    '          <!-- ROUNDS -->\n' +
    '          <neo-input name="gender" label="GENDER" icon="images/gender-male-female.svg"\n' +
    '                     ng-model="vm.gender" flex="25" is-disabled="true"></neo-input>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentMatch" md-total="{{vm.maxMatches}}"\n' +
    '                           md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                           md-on-paginate="vm.getNewPage"></md-table-pagination>\n' +
    '      <h3 ng-if="vm.classification.length === 0">{{\'CHAMPIONSHIPS.CLASSIFICATION_NOT_PLAYED_YET\' |\n' +
    '        translate}}</h3>\n' +
    '      <md-table-container ng-if="vm.classification.length !== 0">\n' +
    '        <table md-table md-progress="vm.promiseClassification">\n' +
    '          <thead md-head>\n' +
    '          <tr md-row>\n' +
    '            <th ng-repeat="header in vm.classificationHeaders" md-column>\n' +
    '              <div layout="column" layout-align="center center">\n' +
    '                <span class="md-title">{{header| translate}}</span>\n' +
    '              </div>\n' +
    '            </th>\n' +
    '          </tr>\n' +
    '          </thead>\n' +
    '          <tbody md-body>\n' +
    '          <tr md-row ng-repeat="team in vm.classification">\n' +
    '            <td md-cell class="md-body-1">{{team.teamName}}</td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.points}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.playedGames}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.wins}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.playedGames - team.wins - team.loses}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.loses}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.scoreFor}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.scoreAgainst}}</div>\n' +
    '            </td>\n' +
    '            <td md-cell class="md-body-1">\n' +
    '              <div layout="column" layout-align="center center">{{team.penalties}}</div>\n' +
    '            </td>\n' +
    '          </tr>\n' +
    '          </tbody>\n' +
    '        </table>\n' +
    '      </md-table-container>\n' +
    '      <md-divider></md-divider>\n' +
    '      <md-table-container style="padding-top: 20px;">\n' +
    '        <table md-table md-progress="vm.promiseMatches">\n' +
    '          <thead md-head>\n' +
    '          <tr md-row>\n' +
    '            <th ng-repeat="header in vm.matchHeaders" md-column>\n' +
    '              <span class="md-title">{{header | translate}}</span>\n' +
    '            </th>\n' +
    '          </tr>\n' +
    '          </thead>\n' +
    '          <tbody md-body>\n' +
    '          <tr md-row md-select="vm.select" ng-repeat="match in vm.matchDay.matches">\n' +
    '            <td md-cell class="md-body-1">{{match.localTeam}}</td>\n' +
    '            <td md-cell class="md-body-1">{{match.localScore}}</td>\n' +
    '            <td md-cell class="md-body-1">{{match.visitorScore}}</td>\n' +
    '            <td md-cell class="md-body-1">{{match.visitorTeam}}</td>\n' +
    '          </tr>\n' +
    '          </tbody>\n' +
    '        </table>\n' +
    '      </md-table-container>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/classificacio/classificacio.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    '<html>\n' +
    '    <head>\n' +
    '        <title>TODO supply a title</title>\n' +
    '        <meta charset="UTF-8">\n' +
    '        <meta name="viewport" content="width=device-width, initial-scale=1.0">\n' +
    '    </head>\n' +
    '    <body>\n' +
    '        <div>TODO write content</div>\n' +
    '    </body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('public/calendar/calendar.tpl.html',
    '<neo-list data="vm.data"></neo-list>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/votacio/votaciotutorgrada.tpl.html',
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1" >{{vm.campionat}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text style="text-align:right">\n' +
    '            <span class="md-headline">{{vm.suspes}}</span>\n' +
    '          </md-card-header-text>\n' +
    '              </md-card-header>\n' +
    '          \n' +
    '        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">Data</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip local</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip visitant</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">C.C.</span>\n' +
    '          </md-card-header-text>\n' +
    '           \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '     \n' +
    '         \n' +
    '        <md-card-header layout-padding>\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.data}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.elocal}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.evisitant}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <md-checkbox ng-model="vm.cc" aria-label="Checkbox 1">\n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          </md-card-header-text>\n' +
    '            \n' +
    '        </md-card-header>\n' +
    '            <md-card-header layout-padding>\n' +
    '                 <md-card-header-text>\n' +
    '            <span class="md-body-1">{{perfilnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1">{{equipnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                      <md-card-header-text>\n' +
    '            <span class="md-body-1"></span>\n' +
    '          </md-card-header-text>\n' +
    '            </md-card-header>\n' +
    '          <md-card-content>\n' +
    '  <md-table-container>\n' +
    '      <table md-table md-row-select="true" >\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item1.iditem}}</td>\n' +
    '               <td md-cell>{{item1.nom}}</td>\n' +
    '              <td md-cell>{{item1.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select1"  ng-init="select1 =vm.init1" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion1 in opcions1"  >{{opcion1.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '            <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item2.iditem}}</td>\n' +
    '               <td md-cell>{{item2.nom}}</td>\n' +
    '              <td md-cell>{{item2.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select2"  ng-init="select2 =vm.init2" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion2 in opcions2" >{{opcion2.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item3.iditem}}</td>\n' +
    '               <td md-cell>{{item3.nom}}</td>\n' +
    '              <td md-cell>{{item3.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select3" ng-init="select3 =vm.init3" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion3 in opcions3" >{{opcion3.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '      </table>\n' +
    '  </md-table-container>\n' +
    '       \n' +
    '          </md-card-content>\n' +
    '          \n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '    </div>\n' +
    '<md-button type="submit" class="md-fab md-accent md-fab-bottom-right"  ng-click="vm.click()"\n' +
    '             ng-disabled="editForm.$invalid">\n' +
    '    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  </md-button>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/votacio/votaciotecnic.tpl.html',
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1" >{{vm.campionat}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text style="text-align:right">\n' +
    '            <span class="md-headline">{{vm.suspes}}</span>\n' +
    '          </md-card-header-text>\n' +
    '              </md-card-header>\n' +
    '          \n' +
    '        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">Data</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip local</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip visitant</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">C.C.</span>\n' +
    '          </md-card-header-text>\n' +
    '           \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '     \n' +
    '         \n' +
    '        <md-card-header layout-padding>\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.data}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.elocal}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.evisitant}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <md-checkbox ng-model="vm.cc" aria-label="Checkbox 1">\n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          </md-card-header-text>\n' +
    '            \n' +
    '        </md-card-header>\n' +
    '            <md-card-header layout-padding>\n' +
    '                 <md-card-header-text>\n' +
    '            <span class="md-body-1">{{perfilnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1">{{equipnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                      <md-card-header-text>\n' +
    '            <span class="md-body-1"></span>\n' +
    '          </md-card-header-text>\n' +
    '            </md-card-header>\n' +
    '          <md-card-content>\n' +
    '  <md-table-container>\n' +
    '      <table md-table md-row-select="true" >\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item10.iditem}}</td>\n' +
    '               <td md-cell>{{item10.nom}}</td>\n' +
    '              <td md-cell>{{item10.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select10"  ng-init="select10 =vm.init10" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion10 in opcions10"  >{{opcion10.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '            <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item11.iditem}}</td>\n' +
    '               <td md-cell>{{item11.nom}}</td>\n' +
    '              <td md-cell>{{item11.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select11"  ng-init="select11 =vm.init11" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion11 in opcions11" >{{opcion11.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item12.iditem}}</td>\n' +
    '               <td md-cell>{{item12.nom}}</td>\n' +
    '              <td md-cell>{{item12.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select12" ng-init="select12 =vm.init12" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions12" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item13.iditem}}</td>\n' +
    '               <td md-cell>{{item13.nom}}</td>\n' +
    '              <td md-cell>{{item13.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select13" ng-init="select13 =vm.init13" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions13" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select" >\n' +
    '                <td md-cell>{{item14.iditem}}</td>\n' +
    '               <td md-cell>{{item14.nom}}</td>\n' +
    '              <td md-cell>{{item14.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select14" ng-init="select14 =vm.init14" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions14" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item15.iditem}}</td>\n' +
    '               <td md-cell>{{item15.nom}}</td>\n' +
    '              <td md-cell>{{item15.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select15" ng-init="select15=vm.init15" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions15">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item16.iditem}}</td>\n' +
    '               <td md-cell>{{item16.nom}}</td>\n' +
    '              <td md-cell>{{item16.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select16" ng-init="select16=vm.init16" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions16" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '        \n' +
    '        \n' +
    '            \n' +
    '         \n' +
    '         \n' +
    '      </table>\n' +
    '  </md-table-container>\n' +
    '       \n' +
    '          </md-card-content>\n' +
    '          \n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '    </div>\n' +
    '<md-button type="submit" class="md-fab md-accent md-fab-bottom-right"  ng-click="vm.click()"\n' +
    '             ng-disabled="editForm.$invalid">\n' +
    '    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  </md-button>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/votacio/votaciopublic.tpl.html',
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1" >{{vm.campionat}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text style="text-align:right">\n' +
    '            <span class="md-headline">{{vm.suspes}}</span>\n' +
    '          </md-card-header-text>\n' +
    '              </md-card-header>\n' +
    '          \n' +
    '        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">Data</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip local</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip visitant</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">C.C.</span>\n' +
    '          </md-card-header-text>\n' +
    '           \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '     \n' +
    '         \n' +
    '        <md-card-header layout-padding>\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.data}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.elocal}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.evisitant}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <md-checkbox ng-model="vm.cc" aria-label="Checkbox 1">\n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          </md-card-header-text>\n' +
    '            \n' +
    '        </md-card-header>\n' +
    '            <md-card-header layout-padding>\n' +
    '                 <md-card-header-text>\n' +
    '            <span class="md-body-1">{{perfilnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1">{{equipnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                      <md-card-header-text>\n' +
    '            <span class="md-body-1"></span>\n' +
    '          </md-card-header-text>\n' +
    '            </md-card-header>\n' +
    '          <md-card-content>\n' +
    '  <md-table-container>\n' +
    '      <table md-table md-row-select="true" >\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item4.iditem}}</td>\n' +
    '               <td md-cell>{{item4.nom}}</td>\n' +
    '              <td md-cell>{{item4.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select4"  ng-init="select4 =vm.init4" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion4 in opcions4"  >{{opcion4.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '            <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item5.iditem}}</td>\n' +
    '               <td md-cell>{{item5.nom}}</td>\n' +
    '              <td md-cell>{{item5.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select5"  ng-init="select5 =vm.init5" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion5 in opcions5" >{{opcion5.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item6.iditem}}</td>\n' +
    '               <td md-cell>{{item6.nom}}</td>\n' +
    '              <td md-cell>{{item6.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select6" ng-init="select6 =vm.init6" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion6 in opcions6" >{{opcion6.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item7.iditem}}</td>\n' +
    '               <td md-cell>{{item7.nom}}</td>\n' +
    '              <td md-cell>{{item7.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select7" ng-init="select7 =vm.init7" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion7 in opcions7" >{{opcion7.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '      </table>\n' +
    '  </md-table-container>\n' +
    '       \n' +
    '          </md-card-content>\n' +
    '          \n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '    </div>\n' +
    '<md-button type="submit" class="md-fab md-accent md-fab-bottom-right"  ng-click="vm.click()"\n' +
    '             ng-disabled="editForm.$invalid">\n' +
    '    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  </md-button>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/votacio/votacio.tpl.html',
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1" >{{vm.campionat}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text style="text-align:right">\n' +
    '            <span class="md-headline">{{vm.suspes}}</span>\n' +
    '          </md-card-header-text>\n' +
    '              </md-card-header>\n' +
    '          \n' +
    '        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">Data</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip local</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip visitant</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">C.C.</span>\n' +
    '          </md-card-header-text>\n' +
    '           \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '     \n' +
    '         \n' +
    '        <md-card-header layout-padding>\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.data}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.elocal}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.evisitant}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <md-checkbox ng-model="vm.cc" aria-label="Checkbox 1">\n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          </md-card-header-text>\n' +
    '            \n' +
    '        </md-card-header>\n' +
    '            <md-card-header layout-padding>\n' +
    '                 <md-card-header-text>\n' +
    '            <span class="md-body-1">{{perfilnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1">{{equipnom}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                      <md-card-header-text>\n' +
    '            <span class="md-body-1"></span>\n' +
    '          </md-card-header-text>\n' +
    '            </md-card-header>\n' +
    '          <md-card-content>\n' +
    '  <md-table-container>\n' +
    '      <table md-table md-row-select="true" >\n' +
    '          <tr md-row md-select="vm.select" ng-show="false">\n' +
    '                <td md-cell>{{item35.iditem}}</td>\n' +
    '               <td md-cell>{{item35.nom}}</td>\n' +
    '              <td md-cell>{{item35.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select35"  ng-init="select35 =vm.init35" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion35 in opcions35"  >{{opcion35.name}}</option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '            <tr md-row md-select="vm.select"  ng-show="false">\n' +
    '                <td md-cell>{{item36.iditem}}</td>\n' +
    '               <td md-cell>{{item36.nom}}</td>\n' +
    '              <td md-cell>{{item36.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select36"  ng-init="select36 =vm.init36" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion36 in opcions36" >{{opcion36.name}}</option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select"  ng-show="vm.show">\n' +
    '                <td md-cell>{{item8.iditem}}</td>\n' +
    '               <td md-cell>{{item8.nom}}</td>\n' +
    '              <td md-cell>{{item8.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select8"  ng-init="select8 =vm.init8" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion8 in opcions8" >{{opcion8.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select"  ng-show="vm.show">\n' +
    '                <td md-cell>{{item9.iditem}}</td>\n' +
    '               <td md-cell>{{item9.nom}}</td>\n' +
    '              <td md-cell>{{item9.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select9"  ng-init="select9 =vm.init9" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion9 in opcions9">{{opcion9.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item17.iditem}}</td>\n' +
    '               <td md-cell>{{item17.nom}}</td>\n' +
    '              <td md-cell>{{item17.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select17" ng-init="select17 =vm.init17" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions17" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item18.iditem}}</td>\n' +
    '               <td md-cell>{{item18.nom}}</td>\n' +
    '              <td md-cell>{{item18.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select18" ng-init="select18 =vm.init18" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions18" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select" >\n' +
    '                <td md-cell>{{item19.iditem}}</td>\n' +
    '               <td md-cell>{{item19.nom}}</td>\n' +
    '              <td md-cell>{{item19.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select19" ng-init="select19 =vm.init19" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions19" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item20.iditem}}</td>\n' +
    '               <td md-cell>{{item20.nom}}</td>\n' +
    '              <td md-cell>{{item20.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select20" ng-init="select20=vm.init20" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions20">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item21.iditem}}</td>\n' +
    '               <td md-cell>{{item21.nom}}</td>\n' +
    '              <td md-cell>{{item21.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select21" ng-init="select21=vm.init21" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions21" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item22.iditem}}</td>\n' +
    '               <td md-cell>{{item22.nom}}</td>\n' +
    '              <td md-cell>{{item22.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select22" ng-init="select22=vm.init22" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions22" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item23.iditem}}</td>\n' +
    '               <td md-cell>{{item23.nom}}</td>\n' +
    '              <td md-cell>{{item23.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select23" ng-init="select23=vm.init23" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions23" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item24.iditem}}</td>\n' +
    '               <td md-cell>{{item24.nom}}</td>\n' +
    '              <td md-cell>{{item24.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select24" ng-init="select24=vm.init24" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions24" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item25.iditem}}</td>\n' +
    '               <td md-cell>{{item25.nom}}</td>\n' +
    '              <td md-cell>{{item25.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select25" ng-init="select25=vm.init25" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions25">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item26.iditem}}</td>\n' +
    '               <td md-cell>{{item26.nom}}</td>\n' +
    '              <td md-cell>{{item26.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select26" ng-init="select26=vm.init26" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions26">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item27.iditem}}</td>\n' +
    '               <td md-cell>{{item27.nom}}</td>\n' +
    '              <td md-cell>{{item27.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select27" ng-init="select27=vm.init27" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions27" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item28.iditem}}</td>\n' +
    '               <td md-cell>{{item28.nom}}</td>\n' +
    '              <td md-cell>{{item28.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select28" ng-init="select28=vm.init28" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions28" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '       <!--   <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item29.iditem}}</td>\n' +
    '               <td md-cell>{{item29.nom}}</td>\n' +
    '              <td md-cell>{{item29.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select29"  ng-init="select29=vm.init29"  style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions29" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item30.iditem}}</td>\n' +
    '               <td md-cell>{{item30.nom}}</td>\n' +
    '              <td md-cell>{{item30.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select30"  ng-init="select30=vm.init30"  style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions30" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '           <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item31.iditem}}</td>\n' +
    '               <td md-cell>{{item31.nom}}</td>\n' +
    '              <td md-cell>{{item31.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select31"  ng-init="select31=vm.init31" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions31">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '         --> \n' +
    '\n' +
    '                   <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item37.iditem}}</td>\n' +
    '               <td md-cell>{{item37.nom}}</td>\n' +
    '              <td md-cell>{{item37.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select37"  ng-init="select37=vm.init37" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions37">{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '            <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item43.iditem}}</td>\n' +
    '               <td md-cell>{{item43.nom}}</td>\n' +
    '              <td md-cell>{{item43.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select43"  ng-init="select43=vm.init43" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions43" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <!--\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item38.iditem}}</td>\n' +
    '               <td md-cell>{{item38.nom}}</td>\n' +
    '              <td md-cell>{{item38.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select38"  ng-init="select38=vm.init38" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions38" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item39.iditem}}</td>\n' +
    '               <td md-cell>{{item39.nom}}</td>\n' +
    '              <td md-cell>{{item39.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select39"  ng-init="select39=vm.init39" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions39" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item40.iditem}}</td>\n' +
    '               <td md-cell>{{item40.nom}}</td>\n' +
    '              <td md-cell>{{item40.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select40"  ng-init="select40=vm.init40" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions40" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          -->\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item41.iditem}}</td>\n' +
    '               <td md-cell>{{item41.nom}}</td>\n' +
    '              <td md-cell>{{item41.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select41"  ng-init="select41=vm.init41" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions41" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell>{{item42.iditem}}</td>\n' +
    '               <td md-cell>{{item42.nom}}</td>\n' +
    '              <td md-cell>{{item42.respetoa}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select42"  ng-init="select42=vm.init42" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions42" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '             <tr md-row md-select="vm.select">\n' +
    '                <td md-cell></td>\n' +
    '               <td md-cell>Marcador local</td>\n' +
    '              <td md-cell>{{vm.marcadorlocal}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select60"  ng-init="select60=vm.init60" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions60" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          <tr md-row md-select="vm.select">\n' +
    '                <td md-cell></td>\n' +
    '               <td md-cell>Marcador Visitant</td>\n' +
    '              <td md-cell>{{vm.marcadorvisitant}}</td>\n' +
    '              <td md-cell><select placeholder="Valoració" ng-model="select61"  ng-init="select61=vm.init61" style=";color: black"  >\n' +
    '                      <option  ng-repeat="opcion in opcions61" >{{opcion.name}}<option>\n' +
    '                  </select></td>\n' +
    '          </tr>\n' +
    '          \n' +
    '           <tr md-row>\n' +
    '                     <td md-cell>Observacions</td>\n' +
    '              <td md-cell>Partit</td>\n' +
    '              <td md-cell><input type="text" ng-model="observ"  value="{{observacions}}"></td>\n' +
    '           </tr>\n' +
    '      </table>\n' +
    '  </md-table-container>\n' +
    '       \n' +
    '          </md-card-content>\n' +
    '          \n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '    </div>\n' +
    '<md-button type="submit" class="md-fab md-accent md-fab-bottom-right"  ng-click="vm.click()"\n' +
    '             ng-disabled="editForm.$invalid">\n' +
    '    <md-icon md-svg-src="images/ic_save_white_48px.svg" class="s24" aria-label="save"></md-icon>\n' +
    '  </md-button>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/teams/teams.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.teams.newTeam({entity: vm.getEntityId()})">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'NEW_TEAM\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/statistics/statistics.tpl.html',
    '<div ui-view></div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/user/change-username.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'CHANGE_EMAIL\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="changeUsernameForm" ng-submit="vm.changeUsername()">\n' +
    '        <div layout="column" layout-align="center" layout-padding>\n' +
    '          <div layout="column" layout-align="start stretch">\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'PASSWORD\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="password" ng-model="vm.changeUsernameModel.password" ng-required="true"\n' +
    '                     ng-pattern="/^.{4,}?/">\n' +
    '              <div ng-messages="changeUsernameForm.password.$error" role="alert">\n' +
    '                <div ng-message="pattern">{{\'PASSWORD_INVALID_FORMAT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'NEW_EMAIL\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="email" name="newUsername" ng-model="vm.changeUsernameModel.newUsername" ng-required="true"\n' +
    '                     ng-pattern="/^.+@.+\\..+$/">\n' +
    '              <div ng-messages="changeUsernameForm.newUsername.$error" role="alert">\n' +
    '                <div ng-message-exp="[\'required\', \'pattern\']">\n' +
    '                  {{\'EMAIL_INVALID_FORMAT\' | translate}}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'EMAIL_REPEAT\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="email" name="newUsername2" ng-model="vm.username2" ng-required="true"\n' +
    '              neo-match="vm.changeUsernameModel.newUsername">\n' +
    '              <div ng-messages="changeUsernameForm.newUsername2.$error" role="alert">\n' +
    '                <div ng-message="neoMatch">{{\'EMAIL_INVALID_MATCH\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '          <div layout="column" flex layout-align="center end">\n' +
    '            <md-button class="md-raised md-primary" ng-disabled="changeUsernameForm.$invalid"\n' +
    '                       type="submit">{{\'SEND\' | translate}}\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/user/change-password.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{\'CHANGE_PASSWORD\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="changePasswordForm" ng-submit="vm.changePassword()">\n' +
    '        <div layout="column" layout-align="center" layout-padding>\n' +
    '          <div layout="column" layout-align="start stretch">\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'OLD_PASSWORD\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="oldPassword" ng-model="vm.changePasswordModel.oldPassword" ng-required="true"\n' +
    '                     ng-pattern="/^.{4,}?/">\n' +
    '              <div ng-messages="changePasswordForm.oldPassword.$error" role="alert">\n' +
    '                <div ng-message="pattern">{{\'PASSWORD_INVALID_FORMAT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'NEW_PASSWORD\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="newPassword" ng-model="vm.changePasswordModel.newPassword" ng-required="true"\n' +
    '                     ng-pattern="/^.{4,}?/">\n' +
    '              <div ng-messages="changePasswordForm.newPassword.$error" role="alert">\n' +
    '                <div ng-message="pattern">{{\'PASSWORD_INVALID_FORMAT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'REPEAT_NEW_PASSWORD\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="newPassword2" ng-model="vm.newpwd2" ng-required="true"\n' +
    '                     neo-match="vm.changePasswordModel.newPassword">\n' +
    '              <div ng-messages="changePasswordForm.newPassword.$error" role="alert">\n' +
    '                <div ng-message="neoMatch">{{\'PASSWORD_INVALID_MATCH\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '          <div layout="column" flex layout-align="center end">\n' +
    '            <md-button class="md-raised md-primary" ng-disabled="changePasswordForm.$invalid"\n' +
    '                       type="submit">{{\'SEND\' | translate}}\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/seasons/seasons.tpl.html',
    '<div ui-view>\n' +
    '  <md-content layout="column" flex-gt-md="30" flex="70" style="margin: auto">\n' +
    '    <md-input-container>\n' +
    '      <md-icon md-svg-src="images/ic_search_black_48px.svg" class="s24" aria-label="search"></md-icon>\n' +
    '      <input ng-model="searchText" placeholder="Buscar">\n' +
    '    </md-input-container>\n' +
    '  </md-content>\n' +
    '\n' +
    '  <div layout="row" layout-align="space-around center">\n' +
    '    <md-card flex-gt-md="70" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'SEASONS_LIST\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '\n' +
    '        <md-table-container>\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected">\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '              <th md-column md-order-by="name"><span class="md-title">Nom</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">Data inici</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">Data fi</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" class="pointer-cursor"\n' +
    '                ng-repeat="season in vm.filteredList = (vm.listSeasons | filterAccents: searchText) | orderBy: vm.query.order" style="cursor: default;">\n' +
    '              <td md-cell><span class="md-body-1">{{ season.name }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{season.iniDate}}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{season.endDate}}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-if="!vm.filteredList.length">{{\'SEASONS_NOT_FOUND\' | translate}}</span>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.seasons.newSeason">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'NEW_SEASON\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/sancions/sancions.tpl.html',
    '<div layout="column" ui-view>\n' +
    ' \n' +
    '  <div layout="row" layout-align="space-around center">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">SANCIONS</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '           <md-button ng-click="exportToExcel(\'table2\', \'Report\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '          \n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-if="vm.sancions.length === 0">{{\'CHAMPIONSHIPS.MATCHES_NOT_FOUND\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.sancions.length > 0">\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected"  id="table2">\n' +
    '            <thead md-head >\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="idEquipo">idEquip</th>\n' +
    '              <th md-column md-order-by="Equipo">Equip</th>\n' +
    '              <th md-column md-order-by="Campeonato">Campionat</th>\n' +
    '              <th md-column md-order-by="sancionAplicada">Sanció aplicada</th>\n' +
    '              <th md-column md-order-by="sancion">Sanció</th>\n' +
    '              <th md-column md-order-by="articulo">Article</th>\n' +
    '              <th md-column md-order-by="descalificado">Descalificat</th>\n' +
    '              <th md-column md-order-by="descalificacionAplicada">Descalificació aplicada</th>\n' +
    '               <th md-column md-order-by="sanciondes">Sanció descalificacio</th>\n' +
    '                 <th md-column md-order-by="insercion">Data inserció</th>\n' +
    '                    <th md-column md-order-by="idPartido">idPartit</th>\n' +
    '                       <th md-column md-order-by="fecha_hora">Data partit</th>\n' +
    '                          <th md-column md-order-by="local">Equip local</th>\n' +
    '                 <th md-column md-order-by="visitant">Equip visitant</th>\n' +
    '                 <th md-column md-order-by="poblacio">Població</th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" ng-repeat="sancio in vm.sancions">\n' +
    '              <td md-cell>{{sancio.idEquipo}}</td>\n' +
    '              <td md-cell>{{sancio.equipo}}</td>\n' +
    '              <td md-cell>{{sancio.campeonato}}</td>\n' +
    '              <td md-cell>{{sancio.sancionAplicada}}</td>\n' +
    '              <td md-cell>{{sancio.sancion}}.</td>\n' +
    '              <td md-cell>{{sancio.articulo}}</td>\n' +
    '              <td md-cell>{{sancio.descalificaddo}}</td>\n' +
    '             \n' +
    '               <td md-cell>{{sancio.descalificacionAplicada}}</td>\n' +
    '                <td md-cell>{{sancio.sancionDescalificado}}</td>\n' +
    '                  <td md-cell>{{sancio.insercion}}</td>\n' +
    '                   <td md-cell>{{sancio.idPartido}}</td>\n' +
    '                    <td md-cell>{{sancio.fecha_hora}}</td>\n' +
    '                     <td md-cell>{{sancio.local}}</td>\n' +
    '                    <td md-cell>{{sancio.visitant}}</td>\n' +
    '                     <td md-cell>{{sancio.poblacio}}</td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '      \n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referees/referees.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '  <div>\n' +
    '  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>\n' +
    '</div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/resultats/resultats.tpl.html',
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          <md-card-header layout-padding style="background-color:#7F8FB1;color: white">\n' +
    '                <md-card-header-text>\n' +
    '            <span class="md-body-1" >{{vm.campionat}}</span>\n' +
    '          </md-card-header-text>\n' +
    '                <md-card-header-text style="text-align:right">\n' +
    '            <span class="md-headline">{{vm.suspes}}</span>\n' +
    '          </md-card-header-text>\n' +
    '              </md-card-header>\n' +
    '          \n' +
    '        <md-card-header layout-padding style="background-color:#D2E0E6;color: black">\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">Data</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip local</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1">Equip visitant</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <span class="md-body-1"></span>\n' +
    '          \n' +
    '            <span class="md-body-1"></span>\n' +
    '          </md-card-header-text>\n' +
    '           \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '     \n' +
    '         \n' +
    '        <md-card-header layout-padding>\n' +
    '        \n' +
    '              <md-card-header-text>\n' +
    '            <span class="md-body-1">{{vm.data}}</span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '                 <span class="md-body-1"><div  ng-click="clicatlocal(1)"> {{vm.elocal}}</div></span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '                 <span class="md-body-1"><div  ng-click="clicatlocal(2)">{{vm.evisitant}}</div></span>\n' +
    '          </md-card-header-text>\n' +
    '             <md-card-header-text>\n' +
    '            <md-checkbox ng-model="vm.cc"ng-click="ccchange()">C.C.\n' +
    '           \n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          \n' +
    '           \n' +
    '              <md-checkbox ng-model="vm.suspeschk"  ng-click="ccchangesuspes()">Suspendre\n' +
    '            \n' +
    '          </md-checkbox>\n' +
    '          </md-card-header-text>\n' +
    '            \n' +
    '            \n' +
    '        </md-card-header>\n' +
    '          \n' +
    '      </div>\n' +
    '        \n' +
    '        <md-card-content>\n' +
    '\n' +
    '        <md-table-container>\n' +
    '          <table md-table md-row-select="true" >\n' +
    '          \n' +
    '            <tbody md-body>\n' +
    '                <tr md-row  class="pointer-cursor" ng-hide="true">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Públic</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"  size="5"> <input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ppl "  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"  size="5"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ppv" style="width: 4em;text-align: right;"/></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '              <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Tutor de Grada</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ptgl"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ptgv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '            \n' +
    '              <tr md-row  class="pointer-cursor"  ng-hide="true">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Tècnic a tècnic contrari</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pttl"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pttv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '              <tr md-row  class="pointer-cursor" ng-hide="true">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Tècnic a equip contrari</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ptel"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.ptev"  style="width: 4em;text-align: right;"" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '              <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Tutor de joc a tècnic</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pdtl"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pdtv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '             <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Tutor de joc a públic</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pdpl"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pdpv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '              <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Marcador</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.marcadorl"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.marcadorv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '            <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">VerdPlay</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pvpl"  style="width: 4em;text-align: right;"/></span> Punts</td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.pvpv"  style="width: 4em;text-align: right;" /></span> Punts</td>\n' +
    '       \n' +
    '            </tr>\n' +
    '             <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Targetes verdes</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.tvl" style="width: 4em;text-align: right;" /></span></td>\n' +
    '                 <td md-cell show-gt-xs hide><span class="md-body-1"><input type="text" name="myDecimal" placeholder="Decimal" ng-model="vm.tvv"  style="width: 4em;text-align: right;" /></span></td>\n' +
    '       \n' +
    '            </tr>\n' +
    '              <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Puntuació marcador</span></td>\n' +
    '              <td md-cell show-gt-xs hide style="text-align:left"><span ng-show="true" class="md-body-1">{{vm.pl}}</span> </td>\n' +
    '              <td md-cell show-gt-xs hide style="text-align:left"><span ng-show="true" class="md-body-1">{{vm.pv}}</span> </td>\n' +
    '       \n' +
    '            </tr>\n' +
    '            \n' +
    '               <tr md-row  class="pointer-cursor">\n' +
    '                \n' +
    '              <td md-cell><span class="md-body-1">Ultims partits</span></td>\n' +
    '              \n' +
    '              <td md-cell show-gt-xs hide style="text-align:left"><span class="md-body-1"> <md-button class="md-warn" ng-model="boto1" ng-click="verpartido(vm.partido1)" ng-style="stboto1" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title1}} <md-tooltip md-direction="top">{{tooltip1}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto2" ng-click="verpartido(vm.partido2)" ng-style="stboto2" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title2}}<md-tooltip md-direction="top">{{tooltip2}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto3" ng-click="verpartido(vm.partido3)" ng-style="stboto3" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title3}}<md-tooltip md-direction="top">{{tooltip3}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto4" ng-click="verpartido(vm.partido4)" ng-style="stboto4" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title4}}<md-tooltip md-direction="top">{{tooltip4}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto5" ng-click="verpartido(vm.partido5)" ng-style="stboto5"  style="background-color: white;color:black;min-width: 35px;min-height:  35px;">{{title5}}<md-tooltip md-direction="top">{{tooltip5}}</md-tooltip></md-button></span> </td>\n' +
    '              <td md-cell show-gt-xs hide style="text-align:left"><span class="md-body-1"> <md-button class="md-warn" ng-model="boto6" ng-click="verpartido(vm.partido6)" ng-style="stboto6" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title6}} <md-tooltip md-direction="top">{{tooltip6}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto7" ng-click="verpartido(vm.partido7)" ng-style="stboto7" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title7}}<md-tooltip md-direction="top">{{tooltip7}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto8" ng-click="verpartido(vm.partido8)" ng-style="stboto8" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title8}}<md-tooltip md-direction="top">{{tooltip8}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto9" ng-click="verpartido(vm.partido9)" ng-style="stboto9" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title9}}<md-tooltip md-direction="top">{{tooltip9}}</md-tooltip></md-button> <md-button class="md-warn" ng-model="boto10"ng-click="verpartido(vm.partido10)" ng-style="stboto10" style="background-color: white;color:black; min-width: 35px;min-height:  35px;">{{title10}}<md-tooltip md-direction="top">{{tooltip10}}</md-tooltip></md-button></span> </td>\n' +
    '       \n' +
    '            </tr>\n' +
    '            <tr md-row class="pointer-cursor">\n' +
    '                \n' +
    '                  <td md-cell colspan="3" style="width:200px;vertical-align:middle;" >   <md-button flex="35" class="md-primary md-raised" ng-click="truredescalificaciolocal()" ng-hide="vm.isDescalificatLocal">\n' +
    '      Treure descalificació\n' +
    '          </md-button>\n' +
    '             <md-button flex="35" class="md-primary md-raised" ng-click="truredescalificaciovisitant()"  ng-hide="vm.isDescalificatVisitant">\n' +
    '      Treure descalificació\n' +
    '          </md-button></td>\n' +
    '                \n' +
    '            </tr>\n' +
    '        \n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '       \n' +
    '\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '         <div class="md-whiteframe-1dp" flex>\n' +
    '           <md-table-container>\n' +
    '          <table md-table md-row-select="true" ng-if="vm.isAdmin()">\n' +
    '          \n' +
    '            <tbody md-body>\n' +
    '            <tr md-row  class="pointer-cursor" style="vertical-align:middle">\n' +
    '                \n' +
    '              <td md-cell style="width:450px;vertical-align:middle">\n' +
    '        \n' +
    '               \n' +
    '             <md-select placeholder="Selecció sanció" ng-model="sancion" ng-change="vm.changesancio(sancion.idsancion)"  style=";color: black">\n' +
    '      <md-option ng-value="sancio" ng-repeat="sancio in sancions"  ng-selected="{{sancio.idsancion}} == {{sancionaplicada}}">{{sancio.articulo}} - {{sancio.sancion}}</md-option>\n' +
    '    </md-select></td>\n' +
    '                    \n' +
    '       \n' +
    '        <td md-cell style="width:100px;vertical-align:middle;">   <span class="md-body-1">Equip local</span>  </td>\n' +
    '          <td md-cell style="width:100px;vertical-align:middle;">     <md-select placeholder="Seleccionar" ng-model="vm.sancionLocal"   style=";color: black">\n' +
    '      <md-option ng-value="1"   ng-selected="{{!sancionLocalBool}}">No infractor</md-option>\n' +
    '      <md-option ng-value="2" ng-selected="{{sancionLocalBool}}">Infractor</md-option>\n' +
    '    </md-select></td>\n' +
    '           \n' +
    '          <td md-cell style="width:100px;vertical-align:middle;">    <span class="md-body-1">Equip visitant</span></td>\n' +
    '         <td md-cell style="width:100px;vertical-align:middle;">    <md-select placeholder="Seleccionar" ng-model="vm.sancionVisit"   style=";color: black">\n' +
    '      <md-option ng-value="1"  ng-selected="{{!sancionVisitBool}}">No infractor</md-option>\n' +
    '      <md-option ng-value="2" ng-selected="{{sancionVisitBool}}">Infractor</md-option>\n' +
    '    </md-select></td>\n' +
    '                    \n' +
    '          \n' +
    '          \n' +
    '              <td md-cell style="width:100px;vertical-align:middle;">   <md-button flex="35" class="md-primary md-raised" ng-click="aplicarsancio()">\n' +
    '      Aplicar\n' +
    '          </md-button></td>\n' +
    '          <td md-cell style="width:150px;vertical-align:middle;" ng-show="vm.treure">   <md-button flex="15" class="md-primary md-raised" ng-click="treuresancio()">\n' +
    '      Treure\n' +
    '          </md-button></td>\n' +
    '          </tr>\n' +
    '           </tbody>\n' +
    '          </table>\n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="60" flex="100">\n' +
    '         <div class="md-whiteframe-1dp" flex>\n' +
    '          \n' +
    '          <md-card-header layout-padding style="background-color:#FFFFFF;color:white">\n' +
    '         \n' +
    '               \n' +
    '            \n' +
    '                  <md-button flex="15" class="md-primary md-raised" ng-click="votar2()">\n' +
    '      Recàlcul resultat\n' +
    '    </md-button>\n' +
    '              <md-button flex="20" class="md-primary md-raised" ng-click="mesures()" ng-hide="true">\n' +
    '      Mesures correctores\n' +
    '    </md-button>\n' +
    '                    \n' +
    '          </md-card-header>\n' +
    '          \n' +
    '          \n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="row" layout="column"       layout-align="center center">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '      \n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '          \n' +
    '          <md-card-header layout-padding style="background-color:#D2E0E6;color: black;align-content: flex-start">\n' +
    '         \n' +
    '                <md-card-header-text>\n' +
    '              <md-select placeholder="Perfil" ng-model="user" ng-change="vm.change(user.id)" md-on-open="loadUsers()" style=";color: black">\n' +
    '      <md-option ng-value="user" ng-repeat="user in users">{{user.name}}</md-option>\n' +
    '    </md-select> </md-card-header-text>\n' +
    '              \n' +
    '               <md-card-header-text ng-if="vm.espotVotar">\n' +
    '                  <md-button style=" max-width: 10px;" class="md-primary md-raised" ng-click="votar(vm.idpartit)">\n' +
    '      Vota\n' +
    '    </md-button>\n' +
    '                   \n' +
    '                    </md-card-header-text>\n' +
    '         \n' +
    '         \n' +
    '          \n' +
    '            <md-card-header-text >\n' +
    '                 \n' +
    '                    <md-button style=" max-width: 10px;" class="md-primary md-raised" ng-show="vm.poteliminar" ng-if="vm.isAdmin()" ng-click="eliminarvotacio(user.name)">\n' +
    '      Eliminar\n' +
    '    </md-button>\n' +
    '                    </md-card-header-text>\n' +
    '         \n' +
    '          </md-card-header>\n' +
    '          \n' +
    '      </div>\n' +
    '            \n' +
    '         <md-card-content>\n' +
    '       \n' +
    '        <md-table-container >\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected" id="table2">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column>Data</th>\n' +
    '              <th md-column>Perfil</th>\n' +
    '              <th md-column >Respecte a</th>\n' +
    '              <th md-column >Item</th>\n' +
    '              <th md-column >Valor</th>\n' +
    '              <th md-column>Nom</th>\n' +
    '              <th md-column >email</th>\n' +
    '              <th md-column >Observacions</th>\n' +
    '              <th md-column >{{ \'ACTIONS\' | translate}}</th>  </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" ng-repeat="valoracio in valoracions">\n' +
    '              <td md-cell>{{valoracio.fecha}}</td>\n' +
    '              <td md-cell>{{valoracio.perfil}}</td>\n' +
    '              <td md-cell>{{valoracio.respecto}}</td>\n' +
    '              <td md-cell>{{valoracio.item_Valorado}}</td>\n' +
    '              <td md-cell>{{valoracio.vporc}}</td>\n' +
    '              <td md-cell>{{valoracio.nomusuari}}</td>\n' +
    '              <td md-cell>{{valoracio.email}}</td>\n' +
    '              <td md-cell>{{valoracio.observacions}}</td>\n' +
    '            \n' +
    '             \n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '    \n' +
    '      </md-card-content>\n' +
    '   \n' +
    '    </md-card>\n' +
    '    \n' +
    '</div>');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/referee-new-invoice/referee-new-invoice.tpl.html',
    '\n' +
    '     <md-card>\n' +
    '      <md-card-content>\n' +
    '      <div layout-align="center center" layout="row" flex>\n' +
    '\n' +
    '        <form name="refereeForm" ng-submit="vm.updatePerson()" flex>\n' +
    '          <div layout="column" layout-padding flex>\n' +
    '            <div layout-gt-sm="row" layout-align="space-around center">\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="name" label="NAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.name" flex="45" layout-gt-sm="column" is-disabled="true"></neo-input>\n' +
    '\n' +
    '                <neo-input name="surname" label="SURNAME" icon="images/ic_person_black_48px.svg" \n' +
    '                           ng-model="vm.person.surname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '              </div>\n' +
    '              <div layout-gt-sm="row" flex="45">\n' +
    '\n' +
    '                <neo-input name="secondSurname" label="SECOND_SURNAME" ng-model="vm.person.secondSurname" flex="50"\n' +
    '                           layout-gt-sm="column" is-disabled="!vm.edit"></neo-input>\n' +
    '\n' +
    '                <md-input-container class="md-block" flex="50">\n' +
    '                  <label>{{\'BIRTH_DATE\' | translate}}</label>\n' +
    '                  <md-datepicker name="birthday" ng-model="vm.person.bornDate" md-current-view="year"\n' +
    '                                 ng-disabled="!vm.edit" flex="100"\n' +
    '                                 md-max-date="vm.today"></md-datepicker>\n' +
    '                  <div ng-messages="refereeForm.birthday.$error" role="alert">\n' +
    '                    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '                    <div ng-message="valid">{{\'DATE_INVALID_FORMAT\' | translate}}</div>\n' +
    '                  </div>\n' +
    '                </md-input-container>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '              \n' +
    '                </div>\n' +
    '        </form>\n' +
    '      </div>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '\n' +
    '              \n' +
    '              \n' +
    '   <div layout="row" layout-align="space-around center" ng-if="true">\n' +
    '\n' +
    '  <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{vm.title | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '\n' +
    '      <md-table-container>\n' +
    '        <table md-table md-row-select="true" ng-model="vm.selected">\n' +
    '          <thead md-head md-order="vm.defaultOrderBy">\n' +
    '          <tr md-row ng-show="true">\n' +
    '            <th ng-repeat="header in vm.headers" md-column>\n' +
    '              <span class="md-body-1">{{header.name | translate}}</span>\n' +
    '            </th>\n' +
    '          </tr>\n' +
    '          </thead>\n' +
    '          <tbody md-body>\n' +
    '          <tr md-row md-select="vm.select" ng-style="{\'cursor\' : vm.cursor} " ui-sref="home.line({licenceId: vm.refId, lineId:value.id})"\n' +
    '              ng-repeat="value in vm.filteredValues = (vm.values | filterAccents: vm.searchText) | orderBy: vm.defaultOrderBy">\n' +
    '            <td md-cell ng-repeat="header in vm.headers"><span class="md-body-1">{{value[header.id] | translate}}</span></td>\n' +
    '          </tr>\n' +
    '          </tbody>\n' +
    '\n' +
    '        </table>\n' +
    '      </md-table-container>\n' +
    '      <span class="md-body-2" ng-hide="vm.filteredListHasSomeItem()">{{vm.notFoundMessage | translate}}</span>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '\n' +
    '  </md-card>\n' +
    '       <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/postponements/postponements.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       md-min-length="0"\n' +
    '                       ng-required="true"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.initDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.today"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.initDate"\n' +
    '                     ng-disabled="vm.initDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'POSTPONEMENTS.MATCHES_TO_POSTPONE\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-hide="vm.showList">{{\'POSTPONEMENTS.NOT_FOUND\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.showList">\n' +
    '          <table md-table md-row-select="false" ng-model="vm.selected" md-progress="vm.promiseMatches">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="date">{{ \'CHAMPIONSHIPS.MATCH_DATE\' | translate}}\n' +
    '              </th>\n' +
    '              <th md-column md-order-by="time">{{ \'CHAMPIONSHIPS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="facility">{{ \'FACILITIES.FACILITY\' | translate}}</th>\n' +
    '              <th md-column>\n' +
    '                <div flex layout="row" layout-align="center center">\n' +
    '                  {{ \'ACTIONS\' | translate}}\n' +
    '                </div>\n' +
    '              </th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.championship}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name}}</td>\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time || \'--:--\'}}</td>\n' +
    '              <td md-cell>{{match.facility.name}}</td>\n' +
    '              <td md-cell>\n' +
    '                <div flex layout="row" layout-align="center center">\n' +
    '                  <md-button class="md-icon-button" aria-label="edit" ng-if="match.canPostpone"\n' +
    '                             ng-click="vm.postponeMatch(match)">\n' +
    '                    <md-tooltip md-direction="right" md-delay="50">{{\'POSTPONEMENTS.POSTPONE\' | translate}}</md-tooltip>\n' +
    '                    <md-icon>event_busy</md-icon>\n' +
    '                  </md-button>\n' +
    '                </div>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.showList"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/phases/phases.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.phases.newPhase">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'PHASES.NEW_PHASE\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/persons.tpl.html',
    '<div ui-view>\n' +
    '    <neo-list data="vm.data"></neo-list>\n' +
    '    <div layout-padding>\n' +
    '        <neo-action-button buttons="vm.buttons" ng-if="vm.hasPermission"></neo-action-button>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/persons/importAthletesDialog.tmpl.html',
    '<md-dialog flex="60">\n' +
    '    <form ng-cloak>\n' +
    '        <md-toolbar class="md-accent md-raised">\n' +
    '            <div class="md-toolbar-tools">\n' +
    '                <h2>{{\'PEOPLE.IMPORT_ATHLETES\' | translate}}</h2>\n' +
    '                <span flex></span>\n' +
    '            </div>\n' +
    '        </md-toolbar>\n' +
    '        <md-list ng-if="athletesToImport.length === 0">\n' +
    '            <md-list-item>\n' +
    '                <div class="md-list-item-text">\n' +
    '                    <span>{{notFoundMessage | translate}}</span>\n' +
    '                </div>\n' +
    '            </md-list-item>\n' +
    '            <md-dialog-actions layout="row">\n' +
    '                <md-button class="md-warn md-raised" ng-click="cancel()" flex="none">\n' +
    '                    {{\'CANCEL\' | translate}}\n' +
    '                </md-button>\n' +
    '            </md-dialog-actions>\n' +
    '        </md-list>\n' +
    '        <md-list ng-if="athletesToImport.length !== 0">\n' +
    '            <md-list-item class="md-2-line" ng-repeat="athlete in athletesToImport">\n' +
    '                <md-checkbox ng-click="listToImport(athlete, importList)"></md-checkbox>\n' +
    '                <div class="md-list-item-text">\n' +
    '                    <h3>{{athlete.name}} {{athlete.surname1}} {{athlete.surname2}} - {{athlete.bornDate}}</h3>\n' +
    '                </div>\n' +
    '            </md-list-item>\n' +
    '\n' +
    '            <md-dialog-actions layout="row">\n' +
    '                <md-button class="md-warn md-raised" ng-click="cancel()" flex="none">\n' +
    '                    {{\'CANCEL\' | translate}}\n' +
    '                </md-button>\n' +
    '                <md-button class="md-accent md-raised" ng-click="importPeople()" flex="none">\n' +
    '                    {{\'IMPORT\' | translate}}\n' +
    '                </md-button>\n' +
    '            </md-dialog-actions>\n' +
    '        </md-list>\n' +
    '    </form>\n' +
    '</md-dialog>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/matches/matches.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       ng-required="true"\n' +
    '                       md-min-length="0"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.currentSeason.iniDate"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.iniDate"\n' +
    '                     md-max-date="vm.currentSeason.endDate"\n' +
    '                     ng-disabled="vm.iniDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'CHAMPIONSHIPS.MATCHES\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '           <md-button ng-click="exportToExcel(\'table2\', \'Report\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-if="vm.matches.length === 0">{{\'CHAMPIONSHIPS.MATCHES_NOT_FOUND\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.matches.length > 0">\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected" md-progress="vm.promiseMatches" id="table2">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="town">{{ \'TOWN\' | translate}}</th>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="matchday">{{ \'CHAMPIONSHIPS.MATCH_DAY\' | translate}}</th>\n' +
    '              <th md-column md-order-by="date">{{ \'CHAMPIONSHIPS.MATCH_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="time">{{ \'CHAMPIONSHIPS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="facility">{{ \'FACILITIES.FACILITY\' | translate}}</th>\n' +
    '              <th md-column >{{ \'ACTIONS\' | translate}}</th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.town}}</td>\n' +
    '              <td md-cell>{{match.championship.name}}</td>\n' +
    '              <td md-cell>{{match.matchDay}}</td>\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name || (\'CALENDAR.REST\' | translate)}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name || (\'CALENDAR.REST\' | translate)}}</td>\n' +
    '              <td md-cell>\n' +
    '                <span>{{match.facility.name || \'-\'}}</span>\n' +
    '                <md-button ng-if="match.facility.name"\n' +
    '                           class="md-icon-button"\n' +
    '                           ui-sref="home.facilities.facility({facilityId: match.facility.id})">\n' +
    '                  <md-tooltip md-direction="right" md-delay="50">{{\'FACILITIES.MAP\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>maps</md-icon>\n' +
    '                </md-button>\n' +
    '              </td>\n' +
    '              <td md-cell>\n' +
    '                <md-button class="md-icon-button" ng-if="match.championship.editableMatches"\n' +
    '                           ui-sref="home.championships.championship.assignMatches({championshipId: match.championship.id})">\n' +
    '                  <md-tooltip md-direction="right" md-delay="50">{{\'EDIT\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>edit</md-icon>\n' +
    '                </md-button>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.matches.length > 0"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/license-search/license-search.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.searchLicenses()" name="searchLicenses" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <neo-input label="NAME"  ng-model="vm.searchName"></neo-input>\n' +
    '      <neo-input label="SURNAME"  ng-model="vm.searchSurname"></neo-input>\n' +
    '      <neo-input label="SECOND_SURNAME" ng-model="vm.searchSecondSurname"></neo-input>\n' +
    '\n' +
    '      <md-button type="submit"  class="md-raised md-primary">{{\'SEARCH\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.hasSearched">\n' +
    '    <md-card flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'LICENSES.SEARCH_RESULTS\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-if="vm.licences.length === 0">{{\'NOT_FOUND_LICENSES\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.licences.length > 0">\n' +
    '          <table md-table  md-progress="vm.promiseMatches">\n' +
    '            <thead md-head >\n' +
    '            <tr md-row>\n' +
    '              <th md-column >{{ \'NAME\' | translate}}</th>\n' +
    '              <th md-column >{{ \'SURNAME\' | translate}}</th>\n' +
    '              <th md-column >{{ \'SECOND_SURNAME\' | translate}}</th>\n' +
    '              <th md-column >{{ \'LICENSE_TYPE\' | translate}}</th>\n' +
    '              <th md-column >{{ \'SPORT\' | translate}}</th>\n' +
    '              <th md-column >{{ \'PROGRAM_TYPE\' | translate}}</th>\n' +
    '              <th md-column >{{ \'CATEGORY\' | translate}}</th>\n' +
    '              <th md-column >{{ \'ORGANISATION_NAME\' | translate}}</th>\n' +
    '              <th md-column >{{ \'TEAM_NAME\' | translate}}</th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row ng-repeat="licence in vm.licences">\n' +
    '              <td md-cell>{{licence.name}}</td>\n' +
    '              <td md-cell>{{licence.surname1}}</td>\n' +
    '              <td md-cell>{{licence.surname2}}</td>\n' +
    '              <td md-cell>{{licence.licenseType}}</td>\n' +
    '              <td md-cell>{{licence.sport}}</td>\n' +
    '              <td md-cell>{{licence.program}}</td>\n' +
    '              <td md-cell>{{licence.category}}</td>\n' +
    '              <td md-cell>{{licence.organisationName}}</td>\n' +
    '              <td md-cell>{{licence.teamName}}</td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.licencesPerPage" md-page="vm.currentPage" md-total="{{vm.maxLicences}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.licences.length > 0"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/informestg/informestg.tpl.html',
    '<table>\n' +
    '    <thead>\n' +
    '        <tr>\n' +
    '            <th>Id</th>\n' +
    '            <th> Non</th>\n' +
    '            <th> Cognom</th>\n' +
    '            <th> email</th>\n' +
    '            <th> Població</th>\n' +
    '               <th> Campionat</th>\n' +
    '               <th> Data</th>\n' +
    '                <th> Equip local</th>\n' +
    '                 <th> Equip Visitant</th>\n' +
    '             <th> GradaL</th>\n' +
    '             <th> GradaV</th>\n' +
    '           \n' +
    '               \n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="partit in partidos">\n' +
    '             <td> {{partit.id}}</td>\n' +
    '            <td> {{partit.nombre}}</td>\n' +
    '            <td> {{partit.apellido}}</td>\n' +
    '            <td> {{partit.email}}</td>\n' +
    '            <td> {{partit.poblacion}}</td>\n' +
    '            <td> {{partit.campionat}}</td>\n' +
    '              <td> {{partit.fecha}}</td>\n' +
    '              <td> {{partit.elocal}}</td>\n' +
    '                <td> {{partit.evisitant}}</td>\n' +
    '            <td> {{partit.gradaL}}</td>\n' +
    '             <td> {{partit.gradaV}}</td>\n' +
    '          \n' +
    '             \n' +
    '             \n' +
    '    </tr>\n' +
    '        \n' +
    '    </tbody>   \n' +
    '</table>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/informestecnic/informestecnic.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    '<table>\n' +
    '    <thead>\n' +
    '        <tr>\n' +
    '            <th>Id></th>\n' +
    '            <th> Non</th>\n' +
    '            <th> Cognom</th>\n' +
    '            <th> email</th>\n' +
    '            <th> Població</th>\n' +
    '               <th> Campionat</th>\n' +
    '               <th> Data</th>\n' +
    '                <th> Equip local</th>\n' +
    '                 <th> Equip Visitant</th>\n' +
    '             <th> TècL a TècV</th>\n' +
    '             <th> TècV a TècL</th>\n' +
    '              <th> TècL a EqV</th>\n' +
    '               <th> TècV a EqL</th>\n' +
    '               \n' +
    '               \n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="partit in partidos">\n' +
    '             <td> {{partit.id}}</td>\n' +
    '            <td> {{partit.nombre}}</td>\n' +
    '            <td> {{partit.apellido}}</td>\n' +
    '            <td> {{partit.email}}</td>\n' +
    '            <td> {{partit.poblacion}}</td>\n' +
    '            <td> {{partit.campionat}}</td>\n' +
    '              <td> {{partit.fecha}}</td>\n' +
    '              <td> {{partit.elocal}}</td>\n' +
    '                <td> {{partit.evisitant}}</td>\n' +
    '            <td> {{partit.tecnicL}}</td>\n' +
    '             <td> {{partit.tecnicV}}</td>\n' +
    '             <td> {{partit.equipL}}</td>\n' +
    '             <td> {{partit.equipV}}</td>\n' +
    '             \n' +
    '             \n' +
    '    </tr>\n' +
    '        \n' +
    '    </tbody>   \n' +
    '</table>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/informespublic/informespublic.tpl.html',
    '<table>\n' +
    '    <thead>\n' +
    '        <tr>\n' +
    '            <th>Id</th>\n' +
    '            <th> Non</th>\n' +
    '            <th> Cognom</th>\n' +
    '            <th> email</th>\n' +
    '            <th> Població</th>\n' +
    '               <th> Campionat</th>\n' +
    '               <th> Data</th>\n' +
    '                <th> Equip local</th>\n' +
    '                 <th> Equip Visitant</th>\n' +
    '             <th> Item Valorat</th>\n' +
    '             <th> Valor</th>\n' +
    '           \n' +
    '               \n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="partit in partidos">\n' +
    '             <td> {{partit.id}}</td>\n' +
    '            <td> {{partit.nombre}}</td>\n' +
    '            <td> {{partit.apellido}}</td>\n' +
    '            <td> {{partit.email}}</td>\n' +
    '            <td> {{partit.poblacion}}</td>\n' +
    '            <td> {{partit.campionat}}</td>\n' +
    '              <td> {{partit.fecha}}</td>\n' +
    '              <td> {{partit.elocal}}</td>\n' +
    '                <td> {{partit.evisitant}}</td>\n' +
    '            <td> {{partit.item_Valorado}}</td>\n' +
    '             <td> {{partit.vporc}}</td>\n' +
    '          \n' +
    '             \n' +
    '             \n' +
    '    </tr>\n' +
    '        \n' +
    '    </tbody>   \n' +
    '</table>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/informes/informes.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    '<table>\n' +
    '    <thead>\n' +
    '        <tr>\n' +
    '             <th> Id</th>\n' +
    '            <th> Non</th>\n' +
    '            <th> Cognom</th>\n' +
    '            <th> email</th>\n' +
    '            <th> Població</th>\n' +
    '               <th> Campionat</th>\n' +
    '               <th> Data</th>\n' +
    '                <th> Equip local</th>\n' +
    '                 <th> Equip Visitant</th>\n' +
    '             <th> TècL</th>\n' +
    '             <th> TècV</th>\n' +
    '              <th> PúbL</th>\n' +
    '               <th> PúbV</th>\n' +
    '                <th> VPL</th>\n' +
    '               <th> VPV</th>\n' +
    '                <th> TVL</th>\n' +
    '               <th> TVV</th>\n' +
    '        </tr>\n' +
    '    </thead>\n' +
    '    <tbody>\n' +
    '        <tr ng-repeat="partit in partidos">\n' +
    '             <td> {{partit.idPartido}}</td>\n' +
    '            <td> {{partit.nombre}}</td>\n' +
    '            <td> {{partit.apellido}}</td>\n' +
    '            <td> {{partit.email}}</td>\n' +
    '            <td> {{partit.poblacion}}</td>\n' +
    '            <td> {{partit.campionat}}</td>\n' +
    '              <td> {{partit.fecha}}</td>\n' +
    '              <td> {{partit.elocal}}</td>\n' +
    '                <td> {{partit.evisitant}}</td>\n' +
    '            <td> {{partit.tecnicL}}</td>\n' +
    '             <td> {{partit.tecnicV}}</td>\n' +
    '             <td> {{partit.publicL}}</td>\n' +
    '             <td> {{partit.publicV}}</td>\n' +
    '              <td> {{partit.puntsvpL}}</td>\n' +
    '              <td> {{partit.puntsvpV}}</td>\n' +
    '              <td> {{partit.tvL}}</td>\n' +
    '              <td> {{partit.tvV}}</td>\n' +
    '    </tr>\n' +
    '        \n' +
    '    </tbody>   \n' +
    '</table>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/facilities/facilities.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '  <div layout-padding ng-if="vm.hasPermission">\n' +
    '    <a ui-sref="home.facilities.newFacility">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'FACILITIES.NEW\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/entitats/entitats.tpl.html',
    '<div ui-view>\n' +
    '  <md-content layout="column" flex-gt-md="30" flex="70" style="margin: auto">\n' +
    '    <md-input-container>\n' +
    '      <md-icon md-svg-src="images/ic_search_black_48px.svg" class="s24" aria-label="search"></md-icon>\n' +
    '      <input ng-model="searchText" placeholder="Buscar">\n' +
    '    </md-input-container>\n' +
    '  </md-content>\n' +
    '\n' +
    '  <div layout="row" layout-align="space-around center">\n' +
    '    <md-card flex-gt-md="70" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'ENTITY_LIST\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '\n' +
    '        <md-table-container>\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected">\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '              <th md-column md-order-by="name"><span class="md-title">{{\'NAME\' | translate}}</span></th>\n' +
    '              <th md-column md-order-by="town" show-gt-xs hide><span class="md-title">{{\'TOWN\' | translate}}</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" class="pointer-cursor"\n' +
    '                ng-repeat="entitat in vm.filteredList = (vm.llistaEntitats | filterAccents: searchText)| orderBy: vm.query.order"\n' +
    '                md-on-select="" ui-sref="home.entitats.entitat.informacio({entitatId: entitat.id})">\n' +
    '              <td md-cell><span class="md-body-1">{{ entitat.name }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{ entitat.townName }}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-hide="vm.filteredList.length">{{\'NOT_FOUND_ENTITIES\' | translate}}</span>\n' +
    '\n' +
    '      </md-card-content>\n' +
    '\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.entitats.newEntitat" ng-if="vm.can(\'ENTITY\', \'C\')">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'NEW_ENTITY\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/comite/comite.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       ng-required="true"\n' +
    '                       md-min-length="0"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-min-date="vm.currentSeason.iniDate"\n' +
    '                     md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.iniDate"\n' +
    '                    ></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'CHAMPIONSHIPS.MATCHES\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '           <md-button ng-click="exportToExcel(\'table2\', \'Report\')">\n' +
    '                 <md-icon md-svg-src = \'../../images/notebook.svg\'></md-icon>\n' +
    '            </md-button> \n' +
    '           <md-button  ng-disabled="listFilters.$invalid" class="md-raised md-primary" ng-click="sancions()" ng-show="vm.sancionsshow">SANCIONS\n' +
    '      </md-button>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-if="vm.matches.length === 0">{{\'CHAMPIONSHIPS.MATCHES_NOT_FOUND\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.matches.length > 0">\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected" md-progress="vm.promiseMatches" id="table2">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="town">{{ \'TOWN\' | translate}}</th>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="matchday">{{ \'CHAMPIONSHIPS.MATCH_DAY\' | translate}}</th>\n' +
    '              <th md-column md-order-by="date">{{ \'CHAMPIONSHIPS.MATCH_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="time">{{ \'CHAMPIONSHIPS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="facility">{{ \'FACILITIES.FACILITY\' | translate}}</th>\n' +
    '               <th md-column md-order-by="cc">CC</th>\n' +
    '                 <th md-column md-order-by="VT">VT</th>\n' +
    '                   <th md-column md-order-by="Sus">Sus</th>\n' +
    '                      <th md-column md-order-by="TJ">TJ</th>\n' +
    '                 <th md-column md-order-by="Res">Res</th>\n' +
    '              <th md-column >{{ \'ACTIONS\' | translate}}</th>\n' +
    '              <th md-column md-order-by="Obs">Obs</th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.town}}</td>\n' +
    '              <td md-cell>{{match.championship.name}}</td>\n' +
    '              <td md-cell>{{match.matchDay}}</td>\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name || (\'CALENDAR.REST\' | translate)}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name || (\'CALENDAR.REST\' | translate)}}</td>\n' +
    '              <td md-cell>\n' +
    '                <span>{{match.facility.name || \'-\'}}</span>\n' +
    '                <md-button ng-if="match.facility.name"\n' +
    '                           class="md-icon-button"\n' +
    '                           ui-sref="home.facilities.facility({facilityId: match.facility.id})">\n' +
    '                  <md-tooltip md-direction="right" md-delay="50">{{\'FACILITIES.MAP\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>maps</md-icon>\n' +
    '                </md-button>\n' +
    '              </td>\n' +
    '               <td md-cell>{{match.isCC}}</td>\n' +
    '                <td md-cell>{{match.isVotatTecnic}}</td>\n' +
    '                  <td md-cell>{{match.isSuspes}}</td>\n' +
    '                    <td md-cell>{{match.isVotatTJ}}</td>\n' +
    '                   <td md-cell>{{match.resultat}}</td>\n' +
    '              <td md-cell>\n' +
    '                <md-button class="md-icon-button" \n' +
    '                          ng-click="verpartido(match.idPartit,match.localTeam.name,match.visitorTeam.name)">\n' +
    '                  <md-tooltip md-direction="right" md-delay="50">{{\'EDIT\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>edit</md-icon>\n' +
    '                </md-button>\n' +
    '              </td>\n' +
    '               <td md-cell>{{match.isObservacions}}</td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.matches.length > 0"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/championships/championships.tpl.html',
    '<div ui-view>\n' +
    '  <neo-list data="vm.data"></neo-list>\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.championships.newChampionship" ng-if="vm.can(\'LOCAL_PHASE\', \'C\')">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'CHAMPIONSHIPS.NEW\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/cancellations/cancellations.tpl.html',
    '<div layout="column" ui-view>\n' +
    '  <div layout="row" layout-align="space-around center" layout-padding>\n' +
    '    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '          layout-align="space-around center">\n' +
    '      <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"\n' +
    '                       md-search-text="vm.searchText"\n' +
    '                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"\n' +
    '                       md-item-text="townhall.name"\n' +
    '                       md-require-match\n' +
    '                       md-min-length="0"\n' +
    '                       ng-required="true"\n' +
    '                       ng-disabled="vm.townhalls.length === 1"\n' +
    '                       md-clear-button="true"\n' +
    '                       md-floating-label="{{\'SELECT_TOWNHALL_TO_FILTER\' | translate}}" style="padding-top: 15px">\n' +
    '        <md-item-template>\n' +
    '          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>\n' +
    '        </md-item-template>\n' +
    '        <md-not-found>\n' +
    '          {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '        </md-not-found>\n' +
    '      </md-autocomplete>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.initDate"\n' +
    '                     md-placeholder="{{\'INI_DATE\' | translate}}" md-max-date="vm.endDate"></md-datepicker>\n' +
    '      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"\n' +
    '                     md-placeholder="{{\'END_DATE\' | translate}}" md-min-date="vm.initDate" md-max-date="vm.today"\n' +
    '                     ng-disabled="vm.initDate === null"></md-datepicker>\n' +
    '      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{\'FILTER\' |\n' +
    '        translate}}\n' +
    '      </md-button>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">\n' +
    '    <md-card flex-gt-md="80" flex="100">\n' +
    '\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'CANCELLATIONS.MATCHES_TO_CANCEL\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '        <span class="md-body-2" ng-hide="vm.showList">{{\'CANCELLATIONS.NOT_FOUND\' | translate}}</span>\n' +
    '        <md-table-container ng-if="vm.showList">\n' +
    '          <table md-table md-row-select="false" ng-model="vm.selected" md-progress="vm.promiseMatches">\n' +
    '            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">\n' +
    '            <tr md-row>\n' +
    '              <th md-column md-order-by="championship">{{ \'CHAMPIONSHIPS.CHAMPIONSHIP\' | translate}}</th>\n' +
    '              <th md-column md-order-by="localTeam">{{ \'CHAMPIONSHIPS.LOCAL_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="visitorTeam">{{ \'CHAMPIONSHIPS.VISITOR_TEAM\' | translate}}</th>\n' +
    '              <th md-column md-order-by="date">{{ \'CHAMPIONSHIPS.MATCH_DATE\' | translate}}</th>\n' +
    '              <th md-column md-order-by="time">{{ \'CHAMPIONSHIPS.MATCH_TIME\' | translate}}</th>\n' +
    '              <th md-column md-order-by="facility">{{ \'FACILITIES.FACILITY\' | translate}}</th>\n' +
    '              <th md-column>{{ \'CANCELLATIONS.CANCEL\' | translate}}</th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row ng-repeat="match in vm.matches">\n' +
    '              <td md-cell>{{match.championship}}</td>\n' +
    '              <td md-cell>{{match.localTeam.name}}</td>\n' +
    '              <td md-cell>{{match.visitorTeam.name}}</td>\n' +
    '              <td md-cell>{{match.date}}</td>\n' +
    '              <td md-cell>{{match.time || \'--:--\'}}</td>\n' +
    '              <td md-cell>{{match.facility.name}}</td>\n' +
    '              <td md-cell>\n' +
    '                <md-button class="md-icon-button" aria-label="edit" ng-if="match.canCancel"\n' +
    '                           ng-click="vm.cancelMatch(match)">\n' +
    '                  <md-tooltip md-direction="bottom" md-delay="50">{{\'CANCELLATIONS.CANCEL\' | translate}}</md-tooltip>\n' +
    '                  <md-icon>report</md-icon>\n' +
    '                </md-button>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <md-table-pagination md-limit="vm.matchesPerPage" md-page="vm.currentPage" md-total="{{vm.maxMatches}}"\n' +
    '                             md-label="{{vm.paginationLabel}}" md-page-select="true"\n' +
    '                             md-on-paginate="vm.getNewPage" ng-if="vm.showList"></md-table-pagination>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/jvp2.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    ' <div id="content">\n' +
    '<iframe name="thatframe2" width="100%" height="1000" frameborder="0">\n' +
    '</iframe>\n' +
    ' </div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/jvp.tpl.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    'To change this license header, choose License Headers in Project Properties.\n' +
    'To change this template file, choose Tools | Templates\n' +
    'and open the template in the editor.\n' +
    '-->\n' +
    ' <div id="content">\n' +
    '<iframe name="thatframe" width="100%" height="1000" frameborder="0">\n' +
    '</iframe>\n' +
    ' </div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/ajuntaments/ajuntaments.tpl.html',
    '<div ui-view>\n' +
    '  <md-content layout="column" flex-gt-md="30" flex="70" style="margin: auto">\n' +
    '    <md-input-container>\n' +
    '      <md-icon md-svg-src="images/ic_search_black_48px.svg" class="s24" aria-label="search"></md-icon>\n' +
    '      <input ng-model="searchText" placeholder="Buscar">\n' +
    '    </md-input-container>\n' +
    '  </md-content>\n' +
    '\n' +
    '  <div layout="row" layout-align="space-around center">\n' +
    '    <md-card flex-gt-md="70" flex="100">\n' +
    '      <div class="md-whiteframe-1dp" flex>\n' +
    '        <md-card-header layout-padding>\n' +
    '          <md-card-header-text>\n' +
    '            <span class="md-headline">{{\'TOWN_HALL_LIST\' | translate}}</span>\n' +
    '          </md-card-header-text>\n' +
    '        </md-card-header>\n' +
    '      </div>\n' +
    '      <md-card-content>\n' +
    '\n' +
    '        <md-table-container>\n' +
    '          <table md-table md-row-select="true" ng-model="vm.selected">\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '              <th md-column md-order-by="name"><span class="md-title">{{\'NAME\' | translate}}</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">{{\'EMAIL\' | translate}}</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">{{\'PHONE\' | translate}}</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row md-select="vm.select" class="pointer-cursor"\n' +
    '                ui-sref="home.ajuntaments.ajuntament.informacio({ajuntamentId: ajuntament.id})"\n' +
    '                ng-repeat="ajuntament in vm.filteredList = (vm.llistaAjuntaments | filterAccents: searchText ) | orderBy: vm.query.order">\n' +
    '              <td md-cell><span class="md-body-1">{{ ajuntament.name }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{ ajuntament.email }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{ ajuntament.phoneNumber }}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-if="!vm.filteredList.length">{{\'NOT_FOUND_TOWN_HALLS\' | translate}}</span>\n' +
    '      </md-card-content>\n' +
    '      <div ng-hide="vm.visibletab">       \n' +
    '        <md-card-content>\n' +
    '\n' +
    '        <md-table-container >\n' +
    '          <table md-table md-row-select="false" >\n' +
    '            <thead md-head md-order="vm.query.order">\n' +
    '            <tr md-row ng-hide="!vm.filteredList.length">\n' +
    '              <th md-column md-order-by="name"><span class="md-title">{{\'NAME\' | translate}}</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">{{\'EMAIL\' | translate}}</span></th>\n' +
    '              <th md-column show-gt-xs hide><span class="md-title">{{\'PHONE\' | translate}}</span></th>\n' +
    '            </tr>\n' +
    '            </thead>\n' +
    '            <tbody md-body>\n' +
    '            <tr md-row class="pointer-cursor"\n' +
    '               \n' +
    '                ng-repeat="ajuntament in vm.filteredList = (vm.llistaAjuntamentsread | filterAccents: searchText ) | orderBy: vm.query.order">\n' +
    '              <td md-cell><span class="md-body-1">{{ ajuntament.name }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{ ajuntament.email }}</span></td>\n' +
    '              <td md-cell show-gt-xs hide><span class="md-body-1">{{ ajuntament.phoneNumber }}</span></td>\n' +
    '            </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </md-table-container>\n' +
    '        <span class="md-body-2" ng-if="!vm.filteredList.length">{{\'NOT_FOUND_TOWN_HALLS\' | translate}}</span>\n' +
    '      </md-card-content>\n' +
    '      </div>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '\n' +
    '  <div layout-padding>\n' +
    '    <a ui-sref="home.ajuntaments.newAjuntament" ng-if="vm.can(\'TOWN_HALL\', \'C\')">\n' +
    '      <md-button class="md-fab md-accent md-fab-bottom-right">\n' +
    '        <md-icon md-svg-src="images/ic_add_white_48px.svg" class="s24" aria-label="add"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{\'NEW_TOWN_HALL\' | translate}}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-print-team-template/neo-print-team-template-directive.tpl.html',
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '<head>\n' +
    '  <meta charset="UTF-8">\n' +
    '</head>\n' +
    '<style>\n' +
    '  body {\n' +
    '    -webkit-print-color-adjust: exact;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-container span {\n' +
    '    font-size: 0.75em;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-container p {\n' +
    '    line-height: 90%;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-info-container {\n' +
    '    width: 50%;\n' +
    '    float: left;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-table {\n' +
    '    width: 100%;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-header {\n' +
    '    margin-top: 25.4mm;\n' +
    '    background-color: #15478C;\n' +
    '    color: white;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-odd-rows {\n' +
    '    background-color: #AED6F1;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-table-title {\n' +
    '    text-align: left;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-container > .page-logo {\n' +
    '    margin: 0 auto;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-container > .page-logo > img {\n' +
    '    width: 15%;\n' +
    '  }\n' +
    '\n' +
    '  .print-team-container > .page-logo > img:nth-child(n+2) {\n' +
    '    max-width: 15%;\n' +
    '    margin-left: 5%;\n' +
    '  }\n' +
    '\n' +
    '  @page {\n' +
    '    margin: 25.4mm 13.2mm 19mm 19mm;\n' +
    '  }\n' +
    '\n' +
    '  @media print {\n' +
    '    tr {\n' +
    '      page-break-inside: avoid;\n' +
    '    }\n' +
    '  }\n' +
    '</style>\n' +
    '<body>\n' +
    '<div layout-padding class="print-team-container">\n' +
    '\n' +
    '  <div class="page-logo">\n' +
    '    <img src="images/cebllob-imprenta_transparente.gif">\n' +
    '    <img src="images/ucec.jpg">\n' +
    '    <img src="images/gencat_esport.jpg">\n' +
    '    <img src="images/ccbl.png">\n' +
    '    <img src="images/juga-verd-play.png">\n' +
    '  </div>\n' +
    '\n' +
    '  <h1>Full d\'inscripció a la competició dels Jocs Esportius Escolars de Catalunya</h1>\n' +
    '\n' +
    '  <div>\n' +
    '    <div class="print-team-info-container">\n' +
    '      <p>{{\'ENTITY\' | translate}}: {{vm.team.entityName}}</p>\n' +
    '      <p>{{\'TEAM\' | translate}}: {{vm.team.teamName}}</p>\n' +
    '      <p>{{\'SPORT\' | translate}}: {{vm.team.sportName | translate}}</p>\n' +
    '      <p>{{\'CATEGORY\' | translate}}: {{vm.team.categoryName | translate}}</p>\n' +
    '      <p>{{\'PROGRAM_TYPE\' | translate}}: {{vm.team.programName | translate}}</p>\n' +
    '      <p>{{\'PRINT_DATE\' | translate}}: {{vm.currentDate}}</p>\n' +
    '    </div>\n' +
    '    <div class="print-team-info-container">\n' +
    '      <p>{{\'CONTACT_PERSON\' | translate}}: {{vm.team.coachName}}</p>\n' +
    '      <p>{{\'EMAIL\' | translate}}: {{vm.team.coachEmail}}</p>\n' +
    '      <p>{{\'PHONE\' | translate}}: {{vm.team.coachPhone}}</p>\n' +
    '      <p>{{\'COLOR_SHIRT\' | translate}}: {{vm.team.shirtColor}}</p>\n' +
    '      <p>{{\'COLOR_PANTS\' | translate}}: {{vm.team.pantsColor }}</p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <md-table-container>\n' +
    '    <table md-table md-row-select="false" ng-model="vm.selected" class="print-team-table">\n' +
    '      <thead md-head>\n' +
    '      <tr md-row class="print-team-header">\n' +
    '        <th ng-repeat="header in vm.headers" md-column class="print-team-table-title">\n' +
    '          <span class="md-title">{{header | translate}}</span>\n' +
    '        </th>\n' +
    '      </tr>\n' +
    '      </thead>\n' +
    '      <tbody md-body>\n' +
    '      <tr md-row ng-repeat="(index, person) in vm.team.persons | orderBy: [\'licenseType\', \'category\', \'licenseCode\']"\n' +
    '          ng-class="{\'print-team-odd-rows\': index%2 === 1}">\n' +
    '        <td md-cell><span class="md-body-1">{{person.licenseCode}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.name}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.surnames}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.nif}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.licenseType | translate}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.category | translate}}</span></td>\n' +
    '        <td md-cell><span class="md-body-1">{{person.bornDate}}</span></td>\n' +
    '      </tr>\n' +
    '      </tbody>\n' +
    '    </table>\n' +
    '  </md-table-container>\n' +
    '</div>\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/toolbar/toolbar-directive.tpl.html',
    '<md-toolbar class="md-whiteframe-1dp" layout="row" layout-align="space-between center"\n' +
    '            md-colors="{backgroundColor: \'background\'}">\n' +
    '  <div flex layout="row" class="md-toolbar-tools" layout-margin layout-align="start center">\n' +
    '    <a ui-sref="home" style="height: 75%">\n' +
    '      <img src="images/neo.png" alt="Logo NEO" height="100%">\n' +
    '    </a>\n' +
    '    <a href="http://cebllob.org" style="height: inherit" target="_blank">\n' +
    '      <img src="images/consell.png" alt="Logo CEBLLOB" height="100%">\n' +
    '    </a>\n' +
    '    <a href="http://cebllob.org/?page_id=140" style="height: inherit"\n' +
    '       target="_blank">\n' +
    '      <img src="images/juga-verd-play.png" alt="Logo Juga Verd Play" height="100%">\n' +
    '    </a>\n' +
    '  </div>\n' +
    '\n' +
    '  <div flex layout="row" layout-margin layout-align="start center">\n' +
    '    <md-button class="md-primary" ui-sref="public.calendar">\n' +
    '      <md-icon>date_range</md-icon>\n' +
    '      {{\'CALENDAR.TITLE\' | translate}}\n' +
    '    </md-button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div flex layout="row" layout-align="end center">\n' +
    '    <div>\n' +
    '      <md-menu ng-if="vm.authManager.isAuthenticated() && !vm.$state.includes(\'public\')" md-position-mode="target-right bottom">\n' +
    '        <md-button ng-click="vm.openMenu($mdMenu, $event)">\n' +
    '          <md-icon md-colors="{color: \'grey\'}">person</md-icon>\n' +
    '          <span class="black-font">{{userName}}</span>\n' +
    '        </md-button>\n' +
    '        <md-menu-content>\n' +
    '          <md-menu-item>\n' +
    '            <md-button ui-sref="home.changePassword">\n' +
    '              <md-icon>lock</md-icon>\n' +
    '              <span>{{\'CHANGE_PASSWORD\' | translate}}</span>\n' +
    '            </md-button>\n' +
    '          </md-menu-item>\n' +
    '          <md-menu-item>\n' +
    '            <md-button ui-sref="home.changeUsername">\n' +
    '              <md-icon>email</md-icon>\n' +
    '              <span>{{\'CHANGE_EMAIL\' | translate}}</span>\n' +
    '            </md-button>\n' +
    '          </md-menu-item>\n' +
    '        </md-menu-content>\n' +
    '      </md-menu>\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <md-button ng-if="!vm.authManager.isAuthenticated()" class="md-raised md-primary" aria-label="LogIn"\n' +
    '                 ui-sref="authentication.login">\n' +
    '        <md-icon>exit_to_app</md-icon>\n' +
    '        {{\'LOGIN\' | translate}}\n' +
    '      </md-button>\n' +
    '      <md-button ng-if="vm.authManager.isAuthenticated()" class="md-raised md-primary" aria-label="LogOut"\n' +
    '                 ng-click="logout()">\n' +
    '        <md-icon>exit_to_app</md-icon>\n' +
    '        {{\'LOGOUT\' | translate}}\n' +
    '      </md-button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</md-toolbar>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-print-invoice-template/neo-print-invoice-template-directive.tpl.html',
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '<head>\n' +
    '  <meta charset="UTF-8">\n' +
    '  <style>\n' +
    '\n' +
    '</style>\n' +
    '</head>\n' +
    '\n' +
    '<body>\n' +
    '    <header>\n' +
    '			<h1>Factura</h1>\n' +
    '                        <p><u>Dades de l\'emissor</u></p>\n' +
    '                        <br>\n' +
    '			<address contenteditable>\n' +
    '                            \n' +
    '				<p>{{persona2.name}}</p>\n' +
    '				<p>101 E. Chapman Ave<br>Orange, CA 92866</p>\n' +
    '				<p>(800) 555-1234</p>\n' +
    '			</address>\n' +
    '			<span></span>\n' +
    '		</header>\n' +
    '    	<article>\n' +
    '			   <p><u>Dades del preceptor</u></p>\n' +
    '                        <br>\n' +
    '			<address contenteditable>\n' +
    '				<p>CONSELL ESPORTIU DEL BAIX LLOBREGAT\n' +
    '                                    <br>Crta. N-340, km 1249 (ParcTorreblanca)\n' +
    '                                    <br>08980 - Sant Feliu de Llobregat\n' +
    '                                <br>G-58014838\n' +
    '                                <br>936852039</p>\n' +
    '			</address>\n' +
    '			<table class="meta">\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Factura número</span></th>\n' +
    '					<td><span contenteditable>101138</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Data</span></th>\n' +
    '					<td><span contenteditable>28/03/2017</span></td>\n' +
    '				/</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Total</span></th>\n' +
    '					<td><span>600.00</span><span id="prefix" contenteditable> €</span></td>\n' +
    '				</tr>\n' +
    '			</table>\n' +
    '			<table class="inventory">\n' +
    '				<thead>\n' +
    '					<tr>\n' +
    '						<th><span contenteditable>Acció</span></th>\n' +
    '						\n' +
    '						<th><span contenteditable>Partit</span></th>\n' +
    '						<th><span contenteditable>€/Parit</span></th>\n' +
    '						<th><span contenteditable>Total</span></th>\n' +
    '					</tr>\n' +
    '				</thead>\n' +
    '				<tbody>\n' +
    '					<tr>\n' +
    '						<td><a class="cut">-</a><span contenteditable>Front End Consultation</span></td>\n' +
    '						\n' +
    '                                                <td><span contenteditable>4</span></td>\n' +
    '						<td><span contenteditable>150.00</span><span data-prefix> €</span></td>\n' +
    '						<td><span>600.00</span><span data-prefix> €</span></td>\n' +
    '					</tr>\n' +
    '				</tbody>\n' +
    '			</table>\n' +
    '			<a class="add">+</a>\n' +
    '			<table class="balance">\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>Base</span></th>\n' +
    '					<td><span>600.00</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>I.R.P.F. -15%</span></th>\n' +
    '					<td><span contenteditable>0.00</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '				<tr>\n' +
    '					<th><span contenteditable>TOTAL</span></th>\n' +
    '					<td><span>600.00</span><span data-prefix> €</span></td>\n' +
    '				</tr>\n' +
    '			</table>\n' +
    '		</article>\n' +
    '    \n' +
    '    	<aside>\n' +
    '			<h1><span contenteditable>Forma de pagament</span></h1>\n' +
    '			<div contenteditable>\n' +
    '				<p>Tranferència Bancària: </p>\n' +
    '			</div>\n' +
    '		</aside>\n' +
    '\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-print-card-template/neo-print-card-template-directive.tpl.html',
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '<head>\n' +
    '  <meta charset="UTF-8">\n' +
    '  <style>\n' +
    '   body {\n' +
    '    margin: 0 !important;\n' +
    '    -webkit-print-color-adjust: exact;\n' +
    '  }\n' +
    '\n' +
    '  .cards-container {\n' +
    '    position: absolute;\n' +
    '     height: 470mm;\n' +
    '    margin: 0mm 0mm 0mm 100mm !important;\n' +
    '  }\n' +
    '\n' +
    '  .page-margin-top {\n' +
    '    margin-top: 0mm !important;\n' +
    '  }\n' +
    '\n' +
    '  .card-dimensions {\n' +
    '    width: 73mm;\n' +
    '    height: 47mm;\n' +
    '    /*border: 1px solid rgba(0, 0, 0, 0.2);*/\n' +
    '    margin-top: 222mm;\n' +
    '    margin-right: 4mm;\n' +
    '    \n' +
    '    float: left;\n' +
    '    display: block;\n' +
    '  }\n' +
    '\n' +
    '  .card-dimensions > .card-data {\n' +
    '    padding: 3mm;\n' +
    '    width: 60%;\n' +
    '    float: left;\n' +
    '  }\n' +
    '\n' +
    '  .card-dimensions > .card-images {\n' +
    '    float: right;\n' +
    '    width: 30%;\n' +
    '    height: 100%;\n' +
    '  }\n' +
    '\n' +
    '  .card-dimensions > .card-images .card-logo {\n' +
    '    float: right;\n' +
    '    padding: 2mm 2mm 2mm 0;\n' +
    '    width: 80%;\n' +
    '    height: auto;\n' +
    '  }\n' +
    '\n' +
    '  .card-dimensions > .card-images .card-photo {\n' +
    '    float: right;\n' +
    '    margin: 0 2mm 0 2mm;\n' +
    '    width: 20mm;\n' +
    '    height: 28mm;\n' +
    '    border: 0px solid rgba(0, 0, 0, 0);\n' +
    '  }\n' +
    '\n' +
    '  .cards-container p {\n' +
    '    font-size: 2.2mm;\n' +
    '    line-height: 2.3mm;\n' +
    '  }\n' +
    '\n' +
    '\n' +
    '  .cards-container p {\n' +
    '    font-size: 2.2mm;\n' +
    '    line-height: 2.3mm;\n' +
    '  }\n' +
    'div.break-after {\n' +
    '   display: block; /* unhide all tabs */\n' +
    '    break-before: always;\n' +
    '    page-break-before: always;\n' +
    '}\n' +
    '\n' +
    '\n' +
    '.break-before {\n' +
    '    display: block; /* unhide all tabs */\n' +
    '    break-before: always;\n' +
    '    page-break-before: always;\n' +
    '\n' +
    '}\n' +
    '</style>\n' +
    '</head>\n' +
    '\n' +
    '<body>\n' +
    '<div class="cards-container">\n' +
    '   \n' +
    '  <div ng-repeat="card in vm.cards" class="card-dimensions">\n' +
    '      <div class="break-after" ></div>\n' +
    '    <div class="card-data">\n' +
    '      <p>{{\'NAME\' | translate | uppercase }}: {{card.name}}&nbsp;&nbsp;&nbsp;&nbsp;{{\'PROGRAMME\' | translate | uppercase }}: JJEE</p>\n' +
    '      <p>{{\'SURNAMES\' | translate | uppercase}}: {{card.surname}}</p>\n' +
    '      <p>{{card.birthday}} - {{\'CATEGORIES.\' + card.personCategory | translate}}</p>\n' +
    '      <p>{{\'CALENDAR.ENTITY_NAME\' | translate | uppercase }}: {{card.entity}}</p>\n' +
    '      <p>{{\'TEAM\' | translate | uppercase }}: {{card.team}}</p>\n' +
    '      <p>{{\'CATEGORY\' | translate | uppercase}} {{\'TEAM\' | translate | uppercase}}: {{\'CATEGORIES.\' + card.teamCategory | translate}}</p>\n' +
    '      <p>{{\'SPORTS.\' + card.sport | translate}} / {{\'PERSON_TYPES.\' + card.licenceType | translate}}</p>\n' +
    '      <p>{{\'SCHOOL_YEAR\' | translate | uppercase}}: {{card.season.initDate}} - {{card.season.endDate}}</p>\n' +
    '      <p>{{\'TOWN_HALL\' | translate | uppercase }}: {{card.townHall}}</p>\n' +
    '      <p>{{\'LICENCE_CODE_SHORT\' | translate | uppercase}}: {{card.licenseCode}}</p>\n' +
    '    </div>\n' +
    '    <div class="card-images">\n' +
    '      <img class="card-logo" src="images/consell.png">\n' +
    '      <div class="card-photo"> <img ng-src="{{card.foto[0]}}"  alt="" style=" width: 25mm; height: 35mm;"  />\n' +
    '      </div>\n' +
    '    </div>\n' +
    '   \n' +
    '      	\n' +
    '  </div>\n' +
    '</div>\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-navigation-bar/neo-navigation-bar-directive.tpl.html',
    '<md-menu-bar id="navigation-bar">\n' +
    '  <md-menu ng-repeat="item in vm.items | filter:vm.hasPermissionMenu">\n' +
    '    <md-button ng-click="vm.performAction(item, $mdMenu)" ng-class="{\'item-selected\': item.selected}">\n' +
    '      {{item.text | translate}}\n' +
    '    </md-button>\n' +
    '    <md-menu-content width="2" class="navbar-subitems-container">\n' +
    '      <md-menu-item class="navbar-subitems" ng-repeat="child in item.children | filter:vm.hasPermission">\n' +
    '        <md-button aria-label="submenu-option" ng-click="vm.performAction(child, $mdMenu)">\n' +
    '          {{child.text | translate}}\n' +
    '        </md-button>\n' +
    '      </md-menu-item>\n' +
    '    </md-menu-content>\n' +
    '  </md-menu>\n' +
    '  <md-divider></md-divider>\n' +
    '</md-menu-bar>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-list/neo-list-directive.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"\n' +
    '        layout-align="space-around center">\n' +
    '    <md-autocomplete flex="50" ng-repeat="filter in vm.filters"\n' +
    '                     md-selected-item="filter.selectedItem"\n' +
    '                     md-search-text="filter.searchText"\n' +
    '                     md-items="option in filter.options | filterAccents: filter.searchText"\n' +
    '                     md-item-text="option[filter.showField]"\n' +
    '                     md-min-length="0"\n' +
    '                     md-require-match\n' +
    '                     ng-required="filter.required"\n' +
    '                     ng-disabled="filter.options.length === 1 || vm.isDisabledFilter(filter.dependsOn)"\n' +
    '                     md-clear-button="true"\n' +
    '                     md-floating-label="{{filter.label | translate}}">\n' +
    '      <md-item-template>\n' +
    '        <span md-highlight-text="filter.searchText" md-highlight-flags="^i">{{option[filter.showField]}}</span>\n' +
    '      </md-item-template>\n' +
    '      <md-not-found>\n' +
    '        {{\'RESULT_NOT_FOUND\' | translate}}\n' +
    '      </md-not-found>\n' +
    '    </md-autocomplete>\n' +
    '    <md-button type="submit" ng-disabled="vm.isDisabledFilterButton || listFilters.$invalid"\n' +
    '               ng-if="vm.filters && vm.filterFunction"\n' +
    '               class="md-raised md-primary">Filtrar\n' +
    '    </md-button>\n' +
    '  </form>\n' +
    '</div>\n' +
    '\n' +
    '<div layout="row" layout-align="space-around center" ng-if="!vm.showList" flex>\n' +
    '  <h4>{{"YOU_NEED_TO_FILTER"| translate}}</h4>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<md-content layout="column" flex-gt-md="30" flex="70" style="margin: auto" ng-hide="!vm.values" ng-if="vm.showList">\n' +
    '  <md-input-container>\n' +
    '    <md-icon md-svg-src="images/ic_search_black_48px.svg" class="s24" aria-label="search"></md-icon>\n' +
    '    <input ng-model="vm.searchText" placeholder="Buscar">\n' +
    '  </md-input-container>\n' +
    '</md-content>\n' +
    '\n' +
    '\n' +
    '<div layout="row" layout-align="space-around center" ng-if="vm.showList">\n' +
    '\n' +
    '  <md-card flex-gt-md="{{vm.cardWidth}}" flex="100">\n' +
    '\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{vm.title | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '\n' +
    '      <md-table-container>\n' +
    '        <table md-table md-row-select="true" ng-model="vm.selected">\n' +
    '          <thead md-head md-order="vm.defaultOrderBy">\n' +
    '          <tr md-row ng-show="vm.filteredListHasSomeItem()">\n' +
    '            <th ng-repeat="header in vm.headers" md-column mdDesc="{{header.orderDesc}}"\n' +
    '                md-order-by="{{header.canOrder ? (header.orderBy || header.id) : undefined}}">\n' +
    '              <span class="md-title">{{header.name | translate}}</span>\n' +
    '            </th>\n' +
    '          </tr>\n' +
    '          </thead>\n' +
    '          <tbody md-body>\n' +
    '          <tr md-row md-select="vm.select" ng-style="{\'cursor\' : vm.cursor}" ui-sref="{{vm.getStateLink(value)}}"\n' +
    '              ng-repeat="value in vm.filteredValues = (vm.values | filterAccents: vm.searchText) | orderBy: vm.defaultOrderBy">\n' +
    '            <td md-cell ng-repeat="header in vm.headers"><span class="md-body-1">{{value[header.id] | translate}}</span></td>\n' +
    '          </tr>\n' +
    '          </tbody>\n' +
    '        </table>\n' +
    '      </md-table-container>\n' +
    '      <span class="md-body-2" ng-hide="vm.filteredListHasSomeItem()">{{vm.notFoundMessage | translate}}</span>\n' +
    '\n' +
    '    </md-card-content>\n' +
    '\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-input/neo-input-directive.tpl.html',
    '<md-input-container ng-class="{\'no-margin-neo-input\': noMargin}">\n' +
    '  <label>{{label | translate}}</label>\n' +
    '  <md-icon ng-if="icon" md-svg-src="{{icon}}"></md-icon>\n' +
    '  <md-icon ng-if="neoIcon" class="material-icons md-dark md-inactive">{{neoIcon}}</md-icon>\n' +
    '  <input name="{{name}}" type="text" ng-required="isRequired" ng-model="ngModel" ng-pattern="vm.pattern"\n' +
    '         ng-disabled="isDisabled" ng-readonly="isReadonly"/>\n' +
    '  <div ng-messages="form[name].$error" role="alert">\n' +
    '    <div ng-message="required">{{\'REQUIRED_INPUT\' | translate}}</div>\n' +
    '    <div ng-message="pattern">{{error | translate}}</div>\n' +
    '  </div>\n' +
    '</md-input-container>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-download-csv-table/neo-download-csv-table-directive.tpl.html',
    '<md-button layout="row" layout-align="center center" md-colors="{background: \'accent\'}" ng-click="vm.exportToCsv()">\n' +
    '  {{\'CSV\' | translate}} <i class="material-icons">file_download</i></md-button>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/neo-action-button/neo-action-button-directive.tpl.html',
    '<div layout="row" class="lock-size" layout-align="end right" ng-cloak="">\n' +
    '  <md-fab-speed-dial md-open="false" md-direction="up" class="md-fab-bottom-right md-fling md-scale"\n' +
    '                     ng-if="vm.buttons.dial">\n' +
    '    <md-fab-trigger>\n' +
    '      <md-button aria-label="menu" class="md-fab md-accent" ng-class="[vm.buttons.attrClass]">\n' +
    '        <md-icon ng-if="vm.buttons.icon">{{vm.buttons.icon}}</md-icon>\n' +
    '        <md-icon ng-if="vm.buttons.buttonImage" md-svg-src="{{vm.buttons.buttonImage}}" class="material-icons md-24" aria-label="more"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{ vm.buttons.tooltip | translate }}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </md-fab-trigger>\n' +
    '    <md-fab-actions>\n' +
    '      <ng-repeat ng-repeat="action in vm.buttons.actions">\n' +
    '        <a ng-click="vm.goToNewState(action)" ng-if="action.changeState">\n' +
    '          <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]">\n' +
    '            <md-icon ng-if="action.icon">{{action.icon}}</md-icon>\n' +
    '            <md-icon ng-if="action.buttonImage" md-svg-src="{{action.buttonImage}}" class="material-icons md-24" aria-label=""></md-icon>\n' +
    '            <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip | translate }}</md-tooltip>\n' +
    '          </md-button>\n' +
    '        </a>\n' +
    '        <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]"\n' +
    '                   ng-click="action.execute()" ng-if="!action.changeState">\n' +
    '          <md-icon ng-if="action.icon">{{action.icon}}</md-icon>\n' +
    '          <md-icon ng-if="action.buttonImage" md-svg-src="{{action.buttonImage}}" class="material-icons md-24" aria-label=""></md-icon>\n' +
    '          <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip | translate }}</md-tooltip>\n' +
    '        </md-button>\n' +
    '      </ng-repeat>\n' +
    '    </md-fab-actions>\n' +
    '  </md-fab-speed-dial>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('directives/error-toast/error-toast-directive.tpl.html',
    '<!-- -->\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/actionButton/action-button.tpl.html',
    '<div layout="row" class="lock-size" layout-align="end right" ng-cloak="">\n' +
    '  <md-fab-speed-dial md-open="false" md-direction="up" class="md-fab-bottom-right md-fling md-scale"\n' +
    '                     ng-if="vm.buttons.dial">\n' +
    '    <md-fab-trigger>\n' +
    '      <md-button aria-label="menu" class="md-fab md-accent">\n' +
    '        <md-icon md-svg-src="{{vm.buttons.buttonImage}}" class="s24" aria-label="more"></md-icon>\n' +
    '        <md-tooltip md-delay="50" md-direction="left">{{ vm.buttons.tooltip }}</md-tooltip>\n' +
    '      </md-button>\n' +
    '    </md-fab-trigger>\n' +
    '    <md-fab-actions>\n' +
    '      <ng-repeat ng-repeat="action in vm.buttons.actions">\n' +
    '        <a ui-sref="{{action.stateToChange}}" ng-if="action.changeState">\n' +
    '        <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]">\n' +
    '          <md-icon md-svg-src="{{action.buttonImage}}" class="s24" aria-label=""></md-icon>\n' +
    '          <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip }}</md-tooltip>\n' +
    '        </md-button>\n' +
    '        </a>\n' +
    '        <md-button aria-label="" class="md-fab md-raised md-mini" ng-class="[action.attrClass]"\n' +
    '                   ng-click="action.execute()" ng-if="!action.changeState">\n' +
    '          <md-icon md-svg-src="{{action.buttonImage}}" class="s24" aria-label=""></md-icon>\n' +
    '          <md-tooltip md-delay="50" md-direction="left">{{ action.tooltip }}</md-tooltip>\n' +
    '        </md-button>\n' +
    '      </ng-repeat>\n' +
    '    </md-fab-actions>\n' +
    '  </md-fab-speed-dial>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('authentication/reset-password/reset-password.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{vm.cardTitle | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="restorePasswordForm" ng-submit="vm.sendRestoreEmail()">\n' +
    '        <div layout="column" layout-align="center stretch" class="horizontal-padding" flex-gt-md="70"\n' +
    '             flex-offset-gt-md="15">\n' +
    '          <p class="md-body-2">{{\'EMAIL_RESET_PASSWORD\' | translate}}</p>\n' +
    '          <md-input-container>\n' +
    '            <label>{{\'EMAIL\' | translate}}</label>\n' +
    '            <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '            <input type="email" name="email" ng-model="vm.email" ng-required="true" ng-pattern="/^.+@.+\\..+$/">\n' +
    '            <div ng-messages="restorePasswordForm.email.$error" role="alert">\n' +
    '              <div ng-message-exp="[\'required\',\'pattern\']">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '        </div>\n' +
    '        <div layout="column" layout-align="center end" flex>\n' +
    '          <md-button class="md-raised md-primary" ng-disabled="restorePasswordForm.$invalid" type="submit">\n' +
    '            <md-icon md-svg-icon="images/ic_exit_white_48px.svg"></md-icon>\n' +
    '            {{\'SEND\' | translate}}\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('authentication/reset-password/new-password.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{vm.cardTitle | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="newPasswordForm" ng-submit="vm.sendPassword()">\n' +
    '        <div layout="column" layout-align="center stretch" class="horizontal-padding" flex-gt-md="70"\n' +
    '             flex-offset-gt-md="15">\n' +
    '          <div layout="column">\n' +
    '            <md-input-container>\n' +
    '              <label>{{\'NEW_PASSWORD\' | translate}}</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="password" ng-model="vm.pwd" ng-required="true" ng-pattern="/^.{4,}?/">\n' +
    '              <div ng-messages="restorePasswordForm.password.$error" role="alert">\n' +
    '                <div ng-message="pattern">{{\'PASSWORD_INVALID_FORMAT\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '\n' +
    '            <md-input-container>\n' +
    '              <label>Repeteix la nova contrasenya</label>\n' +
    '              <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '              <input type="password" name="password2" ng-model="vm.pwd2" ng-required="true" ng-pattern="vm.pwd">\n' +
    '              <div ng-messages="restorePasswordForm.password2.$error" role="alert">\n' +
    '                <div ng-message="pattern">{{\'PASSWORD_INVALID_MATCH\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </md-input-container>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div layout="column" layout-align="center end" flex>\n' +
    '          <md-button class="md-raised md-primary" ng-disabled="restorePasswordForm.$invalid" type="submit">\n' +
    '            <md-icon md-svg-icon="images/ic_exit_white_48px.svg"></md-icon>\n' +
    '            {{\'SET_NEW_PASSWORD\' | translate}}\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('authentication/registration/registration.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header layout-padding>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-headline">{{vm.cardTitle | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="restorePasswordForm" ng-submit="vm.sendPassword()">\n' +
    '        <div layout="column" layout-align="center stretch" class="horizontal-padding" flex-gt-md="70"\n' +
    '             flex-offset-gt-md="15">\n' +
    '          <md-input-container>\n' +
    '            <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '            <label>{{\'PASSWORD\' | translate}}</label>\n' +
    '            <input type="password" name="password" ng-model="vm.pwd" ng-required="true" ng-pattern="/^.{4,}?/">\n' +
    '            <div ng-messages="restorePasswordForm.password.$error" role="alert">\n' +
    '              <div ng-message="pattern">\n' +
    '                {{\'PASSWORD_INVALID_FORMAT\' | translate}}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '          <md-input-container>\n' +
    '            <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '            <label>{{\'REPEAT_PASSWORD\' | translate}}</label>\n' +
    '            <input type="password" name="password2" ng-model="vm.pwd2" ng-required="true" ng-pattern="vm.pwd">\n' +
    '            <div ng-messages="restorePasswordForm.password2.$error" role="alert">\n' +
    '              <div ng-message="pattern">\n' +
    '                {{\'PASSWORD_INVALID_MATCH\' | translate}}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '        </div>\n' +
    '        <div layout="column" layout-align="center end" flex>\n' +
    '          <md-button class="md-raised md-primary" ng-disabled="restorePasswordForm.$invalid" type="submit">\n' +
    '            <md-icon md-svg-icon="images/ic_exit_white_48px.svg"></md-icon>\n' +
    '            {{\'REGISTER\' | translate}}\n' +
    '          </md-button>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('authentication/login/login.tpl.html',
    '<div layout="row" layout-align="space-around center">\n' +
    '  <md-card flex-sm="90" flex-lg="50" flex-md="65">\n' +
    '    <div class="md-whiteframe-1dp" flex>\n' +
    '      <md-card-header>\n' +
    '        <md-card-header-text>\n' +
    '          <span class="md-title">{{\'LOGIN\' | translate}}</span>\n' +
    '        </md-card-header-text>\n' +
    '      </md-card-header>\n' +
    '    </div>\n' +
    '    <md-card-content>\n' +
    '      <form name="logInForm" ng-submit="vm.login()">\n' +
    '        <div layout="column" layout-align="center stretch" class="horizontal-padding" flex-gt-md="70"\n' +
    '             flex-offset-gt-md="15">\n' +
    '          <md-input-container>\n' +
    '            <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '            <label>Email</label>\n' +
    '            <input type="email" name="email" ng-model="vm.email" ng-required="true" ng-pattern="/^.+@.+\\..+$/">\n' +
    '            <div ng-messages="logInForm.email.$error" role="alert">\n' +
    '              <div ng-message-exp="[\'required\',\'pattern\']">{{\'EMAIL_INVALID_FORMAT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </md-input-container>\n' +
    '\n' +
    '          <md-input-container>\n' +
    '            <md-icon md-svg-src="images/ic_lock_black_48px.svg"></md-icon>\n' +
    '            <label>{{\'PASSWORD\' | translate}}</label>\n' +
    '            <input type="password" name="password" autocomplete="on" ng-model="vm.password" ng-required="true" ng-pattern="/^.{4,}?/">\n' +
    '          </md-input-container>\n' +
    '\n' +
    '          <div layout="column" layout-align="center start" layout-padding>\n' +
    '            <a ui-sref="authentication.reset" class="link-style no-padding">{{\'RESET_PASSWORD\' | translate}}</a>\n' +
    '          </div>\n' +
    '\n' +
    '          <div layout="column" layout-align="center end" flex>\n' +
    '            <md-button class="md-raised md-primary md-button" type="submit"\n' +
    '                       ng-disabled="logInForm.$invalid">\n' +
    '              <md-icon md-svg-src="images/ic_exit_white_48px.svg" class="s24" aria-label="logIn"></md-icon>\n' +
    '              {{\'LOGIN\' | translate}}\n' +
    '              <md-tooltip md-delay="50" md-direction="left">{{\'LOGIN\' | translate}}</md-tooltip>\n' +
    '            </md-button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </md-card-content>\n' +
    '  </md-card>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('server-not-found/server-not-found.tpl.html',
    '<div layout="column" layout-align="center center" layout-padding>\n' +
    '<h1>{{\'SERVER_NOT_FOUND\' | translate}}</h1>\n' +
    '<h3>{{\'TRY_AGAIN\' | translate}}</h3>\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/home.tpl.html',
    '<div layout-fill layout="column">\n' +
    '  <header>\n' +
    '    <neo-toolbar logout="vm.logout()" user-name="vm.userEmail"></neo-toolbar>\n' +
    '  </header>\n' +
    '\n' +
    '  <main class="md-padding" layout="column" flex style=" overflow-y: auto;">\n' +
    '    <neo-navigation-bar></neo-navigation-bar>\n' +
    '    <div ui-view flex></div>\n' +
    '\n' +
    '  </main>\n' +
    '  <footer>\n' +
    '    <div class="md-whiteframe-2dp" style="width: 100%" layout="row" layout-align="center center">\n' +
    '      <div layout="row" hide-sm hide-xs flex="70" flex-md="100" layout-align="space-around center">\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> +34 936 852 039</p>\n' +
    '        </div>\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> cebllob@cebllob.cat</p>\n' +
    '        </div>\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> Carretera N - 340 Km. 1249 Parc de Torreblanca - Sant Feliu de Llobregat -\n' +
    '            08980</p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </footer>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('authentication/authentication.tpl.html',
    '<div layout-fill layout="column">\n' +
    '  <header>\n' +
    '    <neo-toolbar logout="vm.logout()"></neo-toolbar>\n' +
    '  </header>\n' +
    '\n' +
    '  <main class="md-padding" layout="column" flex style=" overflow-y: auto;">\n' +
    '    <div ui-view flex></div>\n' +
    '  </main>\n' +
    '  <footer>\n' +
    '    <div class="md-whiteframe-2dp" style="width: 100%" layout="row" layout-align="center center">\n' +
    '      <div layout="row" hide-sm hide-xs flex="70" flex-md="100" layout-align="space-around center">\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_phone_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> +34 936 852 039</p>\n' +
    '        </div>\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_email_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> cebllob@cebllob.cat</p>\n' +
    '        </div>\n' +
    '        <div layout="row">\n' +
    '          <md-icon md-svg-src="images/ic_location_black_48px.svg"></md-icon>\n' +
    '          <p class="md-caption"> Carretera N - 340 Km. 1249 Parc de Torreblanca - Sant Feliu de Llobregat -\n' +
    '            08980</p>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </footer>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('neo').run(['$templateCache', function($templateCache) {
  $templateCache.put('index2.html',
    '<!DOCTYPE html>\n' +
    '<html lang=\'en\' data-ng-app=\'neo\'>\n' +
    '<head>\n' +
    '  <title>Programa NEO</title>\n' +
    '  <meta charset="utf-8">\n' +
    '  <meta name=\'viewport\' content=\'width=device-width, minimum-scale=1.0, initial-scale=1.0, user-scalable=yes\'>\n' +
    '  <!-- inject:head:js -->\n' +
    '  <!-- endinject -->\n' +
    '  <!-- inject:html -->\n' +
    '  <!-- endinject -->\n' +
    '  <!-- bower:css -->\n' +
    '  <!-- endbower -->\n' +
    '  <!-- inject:css -->\n' +
    '  <!-- endinject -->\n' +
    '  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">\n' +
    '  <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic">\n' +
    '</head>\n' +
    '<body>\n' +
    '\n' +
    '<div layout-fill ui-view></div>\n' +
    '<div id="neoLoader" layout-fill layout="column" ng-show="changingState || httpCallWaiting">\n' +
    '  <div flex layout="column" layout-align="center center">\n' +
    '    <md-progress-circular md-mode="indeterminate"></md-progress-circular>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- TODO: Hack to fix exceptions caused by latest version of angular-google-maps -->\n' +
    '<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBgzZNxB7Kz6NrLVFLYVsOMRoGBgxS7h10"></script>\n' +
    '<!-- bower:js -->\n' +
    '<!-- endbower -->\n' +
    '<!-- inject:js -->\n' +
    '<!-- endinject -->\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.people
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio.people', []);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name informacio.people.controller:PeopleCtrl
   *
   * @description
   *
   */
  EntitatPeopleCtrl.$inject = ["users"];
  angular
  .module('neo.home.entitats.entitat.informacio.people')
  .controller('EntitatPeopleCtrl', EntitatPeopleCtrl);

  function EntitatPeopleCtrl(users) {
    var vm = this;
    vm.ctrlName = 'EntitatPeopleCtrl';
    vm.users = users;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.image
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio.image', []);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name informacio.image.controller:ImageCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio.image')
  .controller('ImageCtrl', ImageCtrl);

  function ImageCtrl() {
    var vm = this;
    vm.ctrlName = 'ImageCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.people
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.people', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.people')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments.ajuntament.informaciopeople', {
      url: '/people',
      templateUrl: 'home/ajuntaments/ajuntament/informacio/people/people.tpl.html',
      controller: 'AjuntamentPeopleCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name informacio.people.controller:PeopleCtrl
   *
   * @description
   *
   */
  AjuntamentPeopleCtrl.$inject = ["users"];
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.people')
  .controller('AjuntamentPeopleCtrl', AjuntamentPeopleCtrl);

  function AjuntamentPeopleCtrl(users) {
    var vm = this;
    vm.ctrlName = 'AjuntamentPeopleCtrl';
    vm.users = users;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.image
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.image', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.image')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('neo.home.ajuntaments.ajuntament.informacio.image', {
      url: '/image',
      templateUrl: 'home/ajuntaments/ajuntament/informacio/image/image.tpl.html',
      controller: 'ImageCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name informacio.image.controller:ImageCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.image')
  .controller('ImageCtrl', ImageCtrl);

  function ImageCtrl() {
    var vm = this;
    vm.ctrlName = 'ImageCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name inscription.inscribedTeams
   * @description
   *
   */
  angular
    .module('neo.home.phases.phase.inscribedTeams', [
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.phases.phase.inscribedTeams')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.phases.phase.inscribedTeams', {
      url: '/inscribed-teams',
      templateUrl: 'home/phases/phase/inscribed-teams/inscribed-teams.tpl.html',
      controller: 'InscribedTeamsCtrl',
      controllerAs: 'vm',
      resolve: {
        categories: ["Categories", function (Categories) {
          return Categories.query().$promise;
        }],
        genders: ["Genders", function (Genders) {
          return Genders.query().$promise;
        }],
        sports: ["Sports", function (Sports) {
          return Sports.query().$promise;
        }],
        towns: ["Poblacions", function (Poblacions) {
          return Poblacions.query().$promise;
        }],
        InscribedTeams: ["InscribedTeams", "$stateParams", function(InscribedTeams, $stateParams){
          return InscribedTeams.query({phaseId: $stateParams.phaseId}).$promise;
        }]
      }
    })
    .state('home.phases.phase.inscribedTeamsNumber', {
      url: '/inscribed-teams-number',
      templateUrl: 'home/phases/phase/inscribed-teams/inscribed-teams.tpl.html',
      controller: 'InscribedTeamsNumberCtrl',
      controllerAs: 'vm',
      resolve: {
        categories: ["Categories", function (Categories) {
          return Categories.query().$promise;
        }],
        genders: ["Genders", function (Genders) {
          return Genders.query().$promise;
        }],
        sports: ["Sports", function (Sports) {
          return Sports.query().$promise;
        }],
        inscribedTeamsNumber: ["InscribedTeamsNumber", "$stateParams", function(InscribedTeamsNumber, $stateParams){
          return InscribedTeamsNumber.query({phaseId: $stateParams.phaseId}).$promise;
        }]
      }
    })
  }

}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name inscription.inscribedTeams.controller:InscribedTeamsNumberCtrl
   *
   * @description
   *
   */
  InscribedTeamsNumberCtrl.$inject = ["$filter", "inscribedTeamsNumber", "sports", "categories", "genders"];
  angular
  .module('neo.home.phases.phase.inscribedTeams')
  .controller('InscribedTeamsNumberCtrl', InscribedTeamsNumberCtrl);

  function InscribedTeamsNumberCtrl($filter, inscribedTeamsNumber, sports, categories, genders) {
    var vm = this;
    vm.ctrlName = 'InscribedTeamsNumberCtrl';

    vm.data = {
      title: 'PHASES.INSCRIBED_TEAMS_NUMBER',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'quantity', name: 'QUANTITY', canOrder: true},
        {id: 'sport', name: 'SPORT', canOrder: true},
        {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
        {id: 'gender', name: 'GENDER', canOrder: true}
      ],
      /*      state: {
       //TODO
       slink: ''
       },*/
      defaultOrderBy: ['sport', 'gender', 'categoryOrder'],
      defaultTypeOrderBy: [true, true, false],
      values: parseNumberOfTeams(inscribedTeamsNumber)
    };

    function parseNumberOfTeams(data) {
      //parser de les dades per a omplir la llista
      var numberOfInscribedTeams = [];
      angular.forEach(data, function (numberOfTeams) {
        var category = findItemById(categories, numberOfTeams.categoryId);
        var newNumber = {
          quantity: numberOfTeams.quantity,
          sport: $filter('translate')('SPORTS.' + findItemById(sports, numberOfTeams.sportId).name),
          category: $filter('translate')('CATEGORIES.' + category.name),
          categoryOrder: category.startYear,
          gender: $filter('translate')(findItemById(genders, numberOfTeams.genderId).name)
        };
        numberOfInscribedTeams.push(newNumber);
      });
      return numberOfInscribedTeams;
    }


    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name inscription.inscribedTeams.controller:InscribedTeamsCtrl
     *
     * @description
     *
     */
    InscribedTeamsCtrl.$inject = ["InscribedTeams", "categories", "genders", "sports", "towns", "$filter"];
    angular
      .module('neo.home.phases.phase.inscribedTeams')
      .controller('InscribedTeamsCtrl', InscribedTeamsCtrl);

  function InscribedTeamsCtrl(InscribedTeams, categories, genders, sports, towns, $filter) {
      var vm = this;
      vm.ctrlName = 'InscribedTeamsCtrl';
      vm.data = {
        title: 'PHASES.INSCRIBED_TEAMS',
        notFoundMessage: 'RESULT_NOT_FOUND',
        headers: [
          {id: 'team', name: 'TEAM', canOrder: true, orderBy: 'teamOrder'},
          {id: 'sport', name: 'SPORT', canOrder: true},
          {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
          {id: 'gender', name: 'GENDER', canOrder: true},
          {id: 'entity', name: 'ENTITY', canOrder: false},
          {id: 'town', name: 'TOWN', canOrder: false},
          {id: 'championship', name: 'CHAMPIONSHIPS.CHAMPIONSHIP', canOrder: true}
        ],
        /*        state: {
         //TODO
         slink: ''
         },*/
        defaultOrderBy: ['championship', 'sport', 'categoryOrder', 'gender', 'team'],
        defaultTypeOrderBy: [true, false, true],
        values: parseTeams(InscribedTeams),
        areRowsClickable: false
      };

      function parseTeams(data) {
        //parser de les dades per a omplir la llista
        var inscribedTeams = [];
        angular.forEach(data, function (inscribedTeam) {
          var category = findItemById(categories, inscribedTeam.teamCategoryId);
          var newInscribedTeam = {
            team: inscribedTeam.teamName,
            teamOrder: $filter('lowercase')(inscribedTeam.teamName),
            sport: $filter('translate')('SPORTS.' + findItemById(sports, inscribedTeam.teamSportId).name),
            category: $filter('translate')('CATEGORIES.' + category.name),
            categoryOrder: category.startYear,
            gender: $filter('translate')(findItemById(genders, inscribedTeam.teamGenderId).name),
            entity: inscribedTeam.entityName,
            town: getTownName(inscribedTeam.entityTownId),
            championship: isInscribedToChampionship(inscribedTeam.hasJoinedAChampionship)
          };
          inscribedTeams.push(newInscribedTeam);
        });
        return inscribedTeams;
      }

    function findItemById(collection, itemId) {
        return _.find(collection, function (i) {
          return i.id === itemId;
        });
      }

    function getTownName(entityTown) {
        var item = findItemById(towns, entityTown);
      if (angular.isUndefined(item)) {
        return '-'
      }
        return item.name;
      }

    function isInscribedToChampionship(hasJoined) {
        if (hasJoined === false) {
          return $filter('translate')('CHAMPIONSHIPS.NOT_ASSIGNED');
        }
        else {
          return $filter('translate')('CHAMPIONSHIPS.ASSIGNED');
        }
      }
    }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name person.information
   * @description
   *
   */
  angular
    .module('neo.home.persons.person.information', [
      'ui.router','neo.home.persons.newPerson'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.persons.person.information')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.persons.person.information', {
          url: '/information',
          views: {
            '': {
              templateUrl: 'home/persons/person/information/information.tpl.html',
              controller: 'InformationPersonCtrl',
              controllerAs: 'vm'
            },
            'text@home.persons.person.information': {
              templateUrl: 'home/persons/person/information/text.tpl.html'
            }
          },
          resolve: {
            townHall: ["licenseTeamPerson", "TownHallAssociated", function(licenseTeamPerson, TownHallAssociated) {
              return TownHallAssociated.query({id: licenseTeamPerson.organisationId}).$promise;
            }],
            currentSeason: ["CurrentSeason", function (CurrentSeason) {
              return CurrentSeason.get().$promise;
            }],
            team: ["Teams", "licenseTeamPerson", function (Teams, licenseTeamPerson) {
              return Teams.get({id: licenseTeamPerson.teamId}).$promise;
            }],
            foto: ["Foto", "licenseTeamPerson", function (Foto, licenseTeamPerson) {
              return Foto.query({personId: licenseTeamPerson.person.id}).$promise;
            }]
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name person.information.controller:InformationCtrl
   *
   * @description
   *
   */
  InformationPersonCtrl.$inject = ["$scope", "$mdToast", "$state", "$filter", "$stateParams", "townHall", "licenseTeamPerson", "licenseTypes", "genders", "Person", "categories", "LicenseTeamPerson", "sports", "currentSeason", "team", "ActionSendEmailEes", "foto"];
  angular
    .module('neo.home.persons.person.information')
    .controller('InformationPersonCtrl', InformationPersonCtrl);

  function InformationPersonCtrl($scope,$mdToast, $state, $filter, $stateParams, townHall, licenseTeamPerson,
                                 licenseTypes, genders, Person, categories, LicenseTeamPerson, sports, currentSeason, team, ActionSendEmailEes,foto) {
    var vm = this;
    
 
  
  $scope.image = null;
  $scope.imageFileName = '';
  
  $scope.uploadme = {};
  $scope.uploadme.src = '';
  
  
    vm.ctrlName = 'InformationPersonCtrl';
   
    $scope.image=foto[0];
    $scope.DISABLEBUTTON = false;
   
    vm.updatePerson = updatePerson;

    var findItemById = function (collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    };

    vm.person = buildPersonModel(licenseTeamPerson, licenseTypes);
    vm.cards = [
      {
        name: licenseTeamPerson.person.name,
        surname: licenseTeamPerson.person.surname + (
          licenseTeamPerson.person.secondSurname !== null ? licenseTeamPerson.person.secondSurname : ''),
        birthday: moment(licenseTeamPerson.person.bornDate).format('L'),
        entity: licenseTeamPerson.organisationName,
        team: licenseTeamPerson.teamName,
        category: licenseTeamPerson.teamCategoryName,
        townHall: townHall.name,
        licenseCode: licenseTeamPerson.licenceCode
      }
    ];

    vm.team = buildTeamModel(licenseTeamPerson);
    vm.personGenders = _.filter(genders, function (g) {
      return g.person;
    });
    vm.personCategory = undefined;

    var personBornYear = moment(vm.person.bornDate).year();
    angular.forEach(categories, function (category) {
      if (personBornYear >= category.startYear && personBornYear <= category.endYear) {
        vm.personCategory = category;
      }
    });

    vm.cards = [
      {
        name: licenseTeamPerson.person.name,
        surname: licenseTeamPerson.person.surname+' ' + (
          licenseTeamPerson.person.secondSurname !== null ? licenseTeamPerson.person.secondSurname : ''),
        personCategory: vm.personCategory.name,
        birthday: moment(licenseTeamPerson.person.bornDate).format('L'),
        entity: licenseTeamPerson.organisationName,
        team: licenseTeamPerson.teamName,
        teamCategory: licenseTeamPerson.teamCategoryName,
        sport: findItemById(sports, team.sportId).name,
        licenceType: findItemById(licenseTypes, licenseTeamPerson.licenceTypeId).name,
        townHall: townHall.name,
        licenseCode: licenseTeamPerson.licenceCode,
        season: {
          initDate: moment(currentSeason.iniDate).format('YYYY'),
          endDate: moment(currentSeason.endDate).format('YYYY')
        }
      }
    ];


    vm.edit = false;
    if (licenseTeamPerson.ees) {
      vm.buttons = {
        dial: true,
        icon: 'more_vert',
        tooltip: 'ACTIONS',
        actions: [{
          icon: 'edit',
          tooltip: 'EDIT',
          execute: enableEdit
        }, {
          icon: 'print',
          tooltip: 'PRINT',
          execute: printCard
        }, {
          icon: 'delete',
          attrClass: 'md-warn',
          tooltip: 'DELETE',
          execute: deleteLicence
        }, {
          buttonImage: 'images/ic_send_black_48px.svg',
          attrClass: '',
          tooltip: $filter('translate')('ESCOLA_EMAIL'),
          execute: resendEmailEes
        }]
      };
    }
    else {
      vm.buttons = {
        dial: true,
        icon: 'more_vert',
        tooltip: 'ACTIONS',
        actions: [{
          icon: 'edit',
          tooltip: 'EDIT',
          execute: enableEdit
        }, {
          icon: 'print',
          tooltip: 'PRINT',
          execute: printCard
        }, {
          icon: 'delete',
          attrClass: 'md-warn',
          tooltip: 'DELETE',
          execute: deleteLicence
        }]
      };
    }

    vm.disableEdit = function () {
      vm.edit = false;
      vm.person = buildPersonModel(licenseTeamPerson, licenseTypes);
      vm.person.foto=$scope.image;
      vm.buttons.dial = true;
    };

    function deleteLicence() {
      LicenseTeamPerson.remove({licenseId: $stateParams.license, teamId: $stateParams.team}, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('PEOPLE.SUCCESSFUL_DELETE'))
              .position('bottom left')
              .hideDelay(3000));
          $state.go('home.persons');
        },
        function (err) {
          var message = 'PEOPLE.' + err.data.message || 'PEOPLE.ERROR_DELETE';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function buildPersonModel(licenseTeamPerson, licenseTypes) {
      var personModel = _.cloneDeep(licenseTeamPerson.person);
      personModel.licenceCode = licenseTeamPerson.licenceCode;
      personModel.bornDate = moment(personModel.bornDate).toDate();
      personModel.licenseType = $filter('translate')('PERSON_TYPES.' + findItemById(licenseTypes, licenseTeamPerson.licenceTypeId).name);
      
      return personModel;
    }

    function buildTeamModel(licenseTeamPerson) {
      var teamModel = {};
      teamModel.organisationName = licenseTeamPerson.organisationName;
      teamModel.info = $filter('translate')(licenseTeamPerson.programmeName) + " - " +
        $filter('translate')('CATEGORIES.' + licenseTeamPerson.teamCategoryName) + " - " +
        $filter('translate')(licenseTeamPerson.teamName);
      return teamModel;
    }

    function enableEdit() {
      vm.edit = true;
      vm.buttons.dial = false;
    }

    function printCard() {
      setTimeout(function () {
        var template = document.getElementById('cardsPrintPreview').innerHTML;
        var printWin = window.open('', '',
          'left=0, top=0, width=' + screen.availWidth + ', height=' + screen.availHeight
          + ', toolbar=0, scrollbars=0, status=0');
        printWin.document.write(template);
        printWin.document.close();
        setTimeout(function () {
          printWin.focus();
          printWin.print();
          printWin.close();
        }, 250);
      }, 250);
    }

    function preservesCategory(date) {
      var newYear = moment(date).year();
      if (newYear < vm.personCategory.startYear || newYear > vm.personCategory.endYear) {
        showToast('BORN_YEAR_AND_CATEGORY_TEAM_INCOMPATIBLE');
        return false;
      }
      return true;
    }

    function showToast(dateError) {
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')(dateError))
          .position('bottom left')
          .hideDelay(3000));
    }

    var parseDate = function (updatedPerson) {
      return moment(updatedPerson.bornDate).format("YYYY-MM-DD");
    };

    function updatePerson() {
       
      var updatedPerson = angular.copy(vm.person);
      if (preservesCategory(updatedPerson.bornDate)) {
        updatedPerson.bornDate = parseDate(updatedPerson);
        updatedPerson.foto=document.getElementById('im').src;
        delete updatedPerson.id;
        Person.update({personId: vm.person.id}, updatedPerson, function () {
            $state.go('home.persons', {}, {reload: true});
            showToast('PEOPLE.SUCCESSFUL_UPDATE');
          },
          function (err) {
            if (err.status === 400) {
              showToast('BAD_REQUEST_PERSON');
            } else if (err.status === 409) {
              // TODO: Whats happen if the person already exists?
              showToast('PEOPLE.EXISTING_PERSON');
            } else {
              showToast('SERVER_ERROR');
            }
          });
      }
    }

    function resendEmailEes() {
      if (!vm.person.email) {
        alert("es obligatori l'email de l'esportista per poder fer la invitació ");
      }
      else {
        ActionSendEmailEes.get({id: vm.person.id, ido: licenseTeamPerson.organisationId},
          function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($filter('translate')('SUCCESSFUL_EMAIL_RESEND'))
                .position('bottom left')
                .hideDelay(3000)
            );
          }, function (error) {
            var message = null;
            if (error.status === 409) {
              message = 'ALREADY_REGISTERED_USER_AND_NOT_RESEND';
            } else {
              message = 'ERROR_SENDING_MAIL';
            }
            $mdToast.show(
              $mdToast.simple()
                .textContent($filter('translate')(message))
                .position('bottom left')
                .hideDelay(3000)
            );
          });
      }
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitat.informacio
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio', [
    'ui.router',
    'ngMaterial',
    'neo.home.entitats.entitat.informacio.image',
    'neo.home.entitats.entitat.informacio.people'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.entitats.entitat.informacio')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.entitats.entitat.informacio', {
          url: '/informacio',
          views: {
            '': {
              templateUrl: 'home/entitats/entitat/informacio/informacio.tpl.html',
              controller: 'InformacioEntitatCtrl',
              controllerAs: 'vm'
            },
            'image@home.entitats.entitat.informacio': {
              templateUrl: 'home/entitats/entitat/informacio/image/image.tpl.html',
              controller: 'ImageCtrl',
              controllerAS: 'vm'
            },
            'people@home.entitats.entitat.informacio': {
              templateUrl: 'home/entitats/entitat/informacio/people/people.tpl.html',
              controller: 'EntitatPeopleCtrl',
              controllerAs: 'vm',
              resolve: {
                users: ["$stateParams", "OrganisationUsers", "$q", function ($stateParams, OrganisationUsers, $q) {
                  var deferred = $q.defer();
                  OrganisationUsers.query({id: $stateParams.entitatId},
                      function (data) {
                        // returned 200
                        deferred.resolve(data);
                      },
                      function (response) {
                        deferred.reject(response);
                      }
                  );

                  return deferred.promise;
                  //return [{email: "prova@email.com", id: 1}];
                }]
              }
            },
            'text@home.entitats.entitat.informacio': {
              templateUrl: 'home/entitats/entitat/informacio/text.tpl.html'
            }
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitat.informacio.controller:InformacioEntitatCtrl
   *
   * @description
   *
   */
  InformacioEntitatCtrl.$inject = ["$state", "$stateParams", "$filter", "$mdDialog", "entitat", "towns", "Entitats", "$mdToast", "entityTypes", "AclService"];
  angular
    .module('neo.home.entitats.entitat.informacio')
    .controller('InformacioEntitatCtrl', InformacioEntitatCtrl);

  function InformacioEntitatCtrl($state, $stateParams, $filter, $mdDialog, entitat, towns, Entitats, $mdToast, entityTypes, AclService) {
    var vm = this;

    vm.can = AclService.can;
    vm.entityTypes = entityTypes;

    vm.ctrlName = 'InformacioEntitatCtrl';
    vm.entitat = entitat;
    vm.towns = towns;
    vm.edit = false;
    vm.isOpen = false;

    //Buttons
    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'Accions',
      actions: []
    };

    if (vm.can('ENTITY', 'U')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: enableEdit,
          icon: 'edit',
          tooltip: $filter('translate')('EDIT')
        }
      )
    }
    if (vm.can('ENTITY', 'R')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: printCard,
          icon: 'print',
          tooltip: $filter('translate')('PRINT_CARDS.PRINT_CARD')
        }
      )
    }
    if (vm.can('ENTITY', 'D')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: deleteEntity,
          icon: 'delete',
          attrClass: 'md-warn',
          tooltip: $filter('translate')('DELETE')
        }
      )
    }

    vm.updateEntitat = updateEntitat;

    vm.disableEdit = function () {
      vm.edit = false;
      vm.buttons.dial = true;
    };

    function enableEdit() {
      vm.edit = true;
      vm.buttons.dial = false;
    }

    function printCard() {
      $state.go('home.entitats.entitat.printCards', $stateParams)
    }

    function updateEntitat() {
      Entitats.update({id: $stateParams.entitatId}, vm.entitat, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Entitat modificada correctament')
              .position('bottom left')
              .hideDelay(3000)
          );
          $state.reload();
        },
        function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Hi ha hagut algun error')
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function deleteEntity() {
      $mdDialog.show({
        controller: ["$scope", "$mdDialog", "$filter", function DialogController($scope, $mdDialog, $filter) {
          $scope.alertText = $filter('translate')('ALERT');
          $scope.textContent = $filter('translate')('ENTITIES.CONFIRM_DELETE');
          $scope.cancelText = $filter('translate')('CANCEL');
          $scope.deleteText = $filter('translate')('DELETE');

          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.delete = function () {
            //then
            $mdDialog.hide();
          };
        }],
        templateUrl: 'home/entitats/entitat/delete-confirmation.tmpl.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true
      })
        .then(function () {
          Entitats.remove({id: $stateParams.entitatId},
            function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')('ENTITIES.SUCCESSFUL_DELETE'))
                  .position('bottom left')
                  .hideDelay(3000));
              $state.go('home.entitats', {}, {reload: true});
            },
            function (error) {
              var message = 'TOAST_ERROR';
              if (error.status > 0) {
                message = angular.isDefined(error.data.message) ? error.data.message : message;
              }
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')(message))
                  .position('bottom left')
                  .hideDelay(3000)
              );
            });
        });
    }
  }

}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name printCard
   * @description
   *
   */
  angular
    .module('neo.home.entitats.entitat.printCards', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.entitats.entitat.printCards')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.entitats.entitat.printCards', {
        url: '/print-cards',
        templateUrl: 'home/entitats/entitat/print-cards/print-cards.tpl.html',
        controller: 'PrintCardsCtrl',
        controllerAs: 'vm',
        resolve: {
          townHall: ["$stateParams", "TownHallAssociated", function ($stateParams, TownHallAssociated) {
            return TownHallAssociated.query({id: $stateParams.entitatId}).$promise;
          }],
          athletesCards: ["$stateParams", "EntityLicenses", function ($stateParams, EntityLicenses) {
            return EntityLicenses.query({id: $stateParams.entitatId}).$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          licencesTypes: ["LicenseTypes", function (LicenseTypes) {
            return LicenseTypes.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function (CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name printCard.controller:PrintCardCtrl
   *
   * @description
   *
   */
  PrintCardsCtrl.$inject = ["athletesCards", "townHall", "entitat", "categories", "sports", "licencesTypes", "currentSeason", "Foto"];
  angular
      .module('neo.home.entitats.entitat.printCards')
      .controller('PrintCardsCtrl', PrintCardsCtrl);

  function PrintCardsCtrl(athletesCards, townHall, entitat, categories, sports, licencesTypes, currentSeason, Foto) {
    var vm = this;
    vm.ctrlName = 'PrintCardsCtrl';

    vm.cards = [];

    var SCHOOL_GAMES_ID = 1;

    vm.licensesByTeam = {};
    angular.forEach(athletesCards, function (license) {
      var card = license.license;
      if (card.team.programmeId === SCHOOL_GAMES_ID) {
        var teamId = card.team.id;
        if (!(teamId in vm.licensesByTeam)) {
          vm.licensesByTeam[teamId] = {
            name: card.team.name,
            licenses: [],
            selected: true
          }
        }

        vm.licensesByTeam[teamId].licenses.push({
          selected: true,
          name: card.person.name,
          surname: card.person.surname1 +' '+ (card.person.surname2 !== null ? card.person.surname2 : ''),
          birthday: moment(card.person.bornDate).format('L'),
          entity: entitat.name,
          team: card.team.name,
          teamCategory: findItemById(categories, card.team.categoryId).name,
          sport: findItemById(sports, card.team.sportId).name,
          personCategory: card.category.name,
          licenceType: findItemById(licencesTypes, card.licenceTypeId).name,
          townHall: townHall.name,
          licenseCode: license.licenseCode,
          season: {
            initDate: moment(currentSeason.iniDate).format('YYYY'),
            endDate: moment(currentSeason.endDate).format('YYYY')
          },id:card.person.id,foto:""
        });
      }
    });

    vm.selectAllAssociatedLicenses = function (teamIndex) {
      var isTeamSelected = vm.licensesByTeam[teamIndex].selected === true;
      angular.forEach(vm.licensesByTeam[teamIndex].licenses, function (license) {
        license.selected = isTeamSelected;
      });
    };

    vm.generateReport = function () {
      _.remove(vm.cards);
    
      angular.forEach(vm.licensesByTeam, function (team) {
        angular.forEach(team.licenses, function (license) {
          if (license.selected) {
            license.foto=Foto.query({personId:license.id});
            vm.cards.push(license);
            
      
          }
        });
      });

      var template = document.getElementById('cardsPrintPreview').innerHTML;
      var printWin = window.open('', '',
          'left=0, top=0, width=' + screen.availWidth + ', height=' + screen.availHeight
          + ', toolbar=0, scrollbars=0, status=0');
      
      printWin.document.write(template);
      printWin.document.close();
      //printWin.onload = function () {
      setTimeout(function () {
        printWin.focus();
        printWin.print();
        printWin.close();
      }, 500);
  }
    

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.championships.championship.editMatches
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.editMatches', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.championships.championship.editMatches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.championships.championship.editMatches', {
        url: '/edit-matches',
        templateUrl: 'home/championships/championship/edit-matches/edit-matches.tpl.html',
        controller: 'EditMatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          facilities: ["Facilities", function (Facilities) {
            return Facilities.query().$promise
          }],
          championshipCalendar: ["$stateParams", "ChampionshipCalendarPublic", function ($stateParams, ChampionshipCalendarPublic) {
            return ChampionshipCalendarPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          teams: ["InscribedTeams", "$stateParams", "championship", function (InscribedTeams, $stateParams, championship) {
            return InscribedTeams.query({
              phaseId: championship.phaseId,
              categoryId: championship.categoryId,
              sportId: championship.sportId
            }).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships.championship.editMatches.controller:EditMatchesCtrl
   *
   * @description
   *
   */
  EditMatchesCtrl.$inject = ["$location", "$mdColors", "$filter", "$mdToast", "$state", "ChampionshipMatches", "championship", "categories", "sports", "genders", "championshipCalendar", "facilities", "towns", "teams"];
  angular
    .module('neo.home.championships.championship.editMatches')
    .controller('EditMatchesCtrl', EditMatchesCtrl);

  function EditMatchesCtrl($location, $mdColors, $filter, $mdToast, $state, ChampionshipMatches, championship, categories, sports, genders, championshipCalendar, facilities, towns, teams) {
    var vm = this;
    vm.ctrlName = 'EditMatchesCtrl';

    vm.championship = championship;

    vm.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);

    vm.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);

    vm.facilities = buildFacilities(championshipCalendar.facilities.concat(facilities), towns);
    vm.matchDays = buildMatchDays(championshipCalendar.matchDays, vm.teams, vm.facilities, championshipCalendar.sportMatchDay);
    vm.teams = buildTeams(_.filter(teams, function (t) {
      return _.contains(t.joinedChampionships, championship.id)
    }));

    vm.getTeamName = getTeamName;
    vm.getFacilityName = getFacilityName;
    vm.saveMatchDays = saveMatchDays;

    vm.addMatch = addMatch;
    vm.addMatchDay = addMatchDay;
    vm.deleteMatch = deleteMatch;
    vm.deleteMatchDay = deleteMatchDay;

    vm.getColor = getColor;

    function addMatch(matchDay) {

      matchDay.matches.push({
        id: null,
        date: moment(matchDay.date).toDate(),
        time: null,
        localTeamId: null,
        visitorTeamId: null,
        facilityId: null
      });
    }

    function addMatchDay(matchDays) {
      var newMatchDay = {
        number: _.isEmpty(matchDays) ? 1 : _.max(matchDays, 'number').number + 1,
        date: moment().toDate(),
        matches: []
      };
      addMatch(newMatchDay);
      matchDays.push(newMatchDay);
      $location.hash('matchday' + (matchDays.length - 1));
    }

    function deleteMatch(matchDayIndex, matchIndex) {
      vm.matchDays[matchDayIndex].matches.splice(matchIndex, 1);
    }

    function deleteMatchDay(matchDays, index) {
      matchDays.splice(index, 1);
    }

    function buildTeams(teams) {
      var newTeams = {};
      angular.forEach(teams, function (team) {
        newTeams[team.teamId] = team;
      });
      return newTeams;
    }

    function buildFacilities(facilities, towns) {
      var newFacilities = {};
      angular.forEach(facilities, function (facility) {
        newFacilities[facility.id] = facility;
        newFacilities[facility.id].town = findItemById(towns, facility.idTown);
      });
      return newFacilities;
    }

    function buildMatchDays(matchDays, sportMatchDay) {
      angular.forEach(matchDays, function (matchDay) {
        matchDay.matches = buildMatches(matchDay.matches);
        matchDay.sportMatchDay = false;
      });
      matchDays = addSportMatchDay(matchDays, sportMatchDay);
      return matchDays;
    }

    function buildMatches(matches) {
      var newMatches = [];
      angular.forEach(matches, function (match) {
        newMatches.push({
          id: match.id,
          date: moment(match.date).toDate(),
          time: _.isNull(match.time) ? null : moment(match.time, 'HH:mm').toDate(),
          localTeamId: match.localTeamId,
          visitorTeamId: match.visitorTeamId,
          facilityId: match.facilityId
        });
      });
      return newMatches;
    }

    function addSportMatchDay(matchDays, sportMatchDay) {
      matchDays = _.sortBy(matchDays, 'date');
      if (_.size(matchDays) && sportMatchDay > _.head(matchDays).date && sportMatchDay < _.last(matchDays).date) {
        matchDays.push({
          sportMatchDay: true,
          date: sportMatchDay
        });
      }
      return _.sortBy(matchDays, 'date');
    }

    function getTeamName(teamId) {
      var team = vm.teams[teamId];
      return angular.isUndefined(team) ? undefined : team.teamInfo.name;
    }

    function getFacilityName(facilityId) {
      var facility = vm.facilities[facilityId];
      return angular.isUndefined(facility) ? undefined : facility.name;
    }


    function getColor(colorName) {
      return $mdColors.getThemeColor(colorName);
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function saveMatchDays() {
      var matchDaysToSave = [];
      angular.forEach(vm.matchDays, function (matchDay) {

        var matchesToSave = [];
        angular.forEach(matchDay.matches, function (match) {
          matchesToSave.push({
            id: match.id,
            localTeamId: match.localTeamId,
            visitorTeamId: match.visitorTeamId,
            date: moment(match.date).format('YYYY-MM-DD'),
            time: _.isNull(match.time) ? null : moment(match.time).format('HH:mm'),
            facilityId: match.facilityId
          })
        });

        matchDaysToSave.push({
          number: matchDay.number,
          date: moment(matchDay.date).format('YYYY-MM-DD'),
          matches: matchesToSave
        });
      });

      ChampionshipMatches.replace({id: vm.championship.id}, matchDaysToSave, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CHAMPIONSHIPS.MATCH_DAYS_SUCCESSFUL_UPDATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.reload();
      }, function (err) {
        var message = err.data.message || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.championships.championship.draw
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.draw', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.championships.championship.draw')
    .config(config);

  function config($stateProvider) {
    assignedTeams.$inject = ["AssignTeams", "$stateParams"];
    assignedDates.$inject = ["PhaseMatchDates", "championship"];
    $stateProvider
      .state('home.championships.championship.draw', {
        url: '/draw',
        templateUrl: 'home/championships/championship/draw/draw.tpl.html',
        controller: 'DrawCtrl',
        controllerAs: 'vm',
        resolve: {
          teams: assignedTeams,
          matchDaysDates: assignedDates
        }
      });

    function assignedTeams(AssignTeams, $stateParams) {
      return AssignTeams.query({championshipId: $stateParams.championshipId}).$promise;
    }

    function assignedDates(PhaseMatchDates, championship) {
      return PhaseMatchDates.query({phaseId: championship.phaseId}).$promise;
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships.championship.draw.controller:DrawCtrl
   *
   * @description
   *
   */
  DrawCtrl.$inject = ["$stateParams", "$mdToast", "$filter", "championship", "categories", "sports", "genders", "teams", "ChampionshipCalendar", "matchDaysDates", "$state"];
  angular
    .module('neo.home.championships.championship.draw')
    .controller('DrawCtrl', DrawCtrl);

  function DrawCtrl($stateParams, $mdToast, $filter, championship, categories, sports, genders, teams, ChampionshipCalendar, matchDaysDates, $state) {
    var vm = this;
    vm.ctrlName = 'DrawCtrl';

    vm.championship = championship;

    vm.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);
    vm.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);

    vm.teams = angular.copy(teams);
    vm.matchDays = fillMatchDays(championship.rounds, vm.teams.length, matchDaysDates);

    vm.drawChampionship = drawChampionship;

    function fillMatchDays(rounds, numberOfTeams, matchDaysDates) {
      var matchDays = [];
      var matchesForRound = (numberOfTeams % 2 === 0)? numberOfTeams - 1: numberOfTeams;
      _.range(matchesForRound * rounds ).forEach(function(index) {
        var date = _.isUndefined(matchDaysDates[index]) ? new Date() : matchDaysDates[index]
        matchDays.push({
          name: 'matchDay_' + index,
          date: date
        });
      });

      return matchDays;
    }

    function drawChampionship() {
      var calendarModel = {
        matchDates: _.map(vm.matchDays, function(matchDay) {
          return moment(matchDay.date).format('YYYY-MM-DD');
        }),
        orderedTeams: _.map(vm.teams, 'id')
      };
      ChampionshipCalendar.save({championshipId: $stateParams.championshipId}, calendarModel, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CALENDAR.SUCCESSFUL_CREATE_CALENDAR'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('public.championshipCalendar', {championshipId: $stateParams.championshipId}, {reload: true});
      }, function (err) {
        var message = err.data || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championship.assignTeams
   * @description
   *
   */
  angular
      .module('neo.home.championships.championship.assignTeams', [
        'ui.router',
        'dndLists'
      ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.championships.championship.assignTeams')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.championships.championship.assignTeams', {
          url: '/assign-teams',
          templateUrl: 'home/championships/championship/assign-teams/assign-teams.tpl.html',
          controller: 'AssignTeamsCtrl',
          controllerAs: 'vm',
          resolve: {
            teams: ["InscribedTeams", "$stateParams", "championship", function (InscribedTeams, $stateParams, championship) {
              return InscribedTeams.query({
                phaseId: championship.phaseId,
                categoryId: championship.categoryId,
                sportId: championship.sportId
              }).$promise;
            }],
            towns: ["Poblacions", function (Poblacions) {
              return Poblacions.query().$promise;
            }]
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championship.assignTeams.controller:AssignTeamsCtrl
   *
   * @description
   *
   */
  AssignTeamsCtrl.$inject = ["$filter", "$stateParams", "$mdToast", "$state", "AssignTeams", "championship", "sports", "categories", "genders", "teams", "towns"];
  angular
    .module('neo.home.championships.championship.assignTeams')
    .controller('AssignTeamsCtrl', AssignTeamsCtrl);

  function AssignTeamsCtrl($filter, $stateParams, $mdToast, $state, AssignTeams, championship, sports, categories, genders, teams, towns) {
    var vm = this;
    vm.ctrlName = 'AssignTeamsCtrl';

    function buildTeams(teams) {
      var newTeams = [];
      angular.forEach(teams, function (t) {
        t.town = findItemById(towns, t.entityTownId).name;
        t.gender = findItemById(genders, t.teamGenderId).name;
        newTeams.push(t);
      });
      return newTeams;
    }

    vm.teams = buildTeams(teams);

    vm.championship = championship;
    vm.championship.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.championship.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);
    vm.championship.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);

    vm.assignedTeams = {
      listName: 'CHAMPIONSHIPS.ASSIGNED_TEAMS',
      items: [],
      dragging: false
    };

    vm.unassignedTeams = {
      listName: 'CHAMPIONSHIPS.TEAMS_TO_ASSIGN',
      items: [],
      dragging: false
    };

    vm.displayAll = false;
    vm.setTeamsDisplay = function () {
      var championshipId = parseInt($stateParams.championshipId);
      angular.forEach(vm.unassignedTeams.items, function (team) {
        team.display = vm.displayAll || !team.hasJoinedAChampionship || team.joinedChampionships.includes(championshipId);
      });
      angular.forEach(vm.assignedTeams.items, function (team) {
        team.display = vm.displayAll || !team.hasJoinedAChampionship || team.joinedChampionships.includes(championshipId);
      });
    };

    angular.forEach(vm.teams, function (team) {
      var championshipId = parseInt($stateParams.championshipId);
      if (team.joinedChampionships.includes(championshipId)) {
        vm.assignedTeams.items.push(team);
      } else {
        vm.unassignedTeams.items.push(team);
      }
    });

    vm.setTeamsDisplay();

    vm.teamsLists = [
      vm.unassignedTeams,
      vm.assignedTeams
    ];

    vm.getSelectedItemsIncluding = function (list, item) {
      item.selected = true;
      return list.items.filter(function (item) {
        return item.selected;
      });
    };

    vm.onDragStart = function (list, event) {
      list.dragging = true;
      if (event.dataTransfer.setDragImage) {
        var img = new Image();
        img.src = 'images/ic_content_copy_black_48px.svg';
        event.dataTransfer.setDragImage(img, 0, 0);
      }
    };

    vm.onDrop = function (list, items, index) {
      angular.forEach(items, function (item) {
        item.selected = false;
      });
      list.items = list.items.slice(0, index)
        .concat(items)
        .concat(list.items.slice(index));
      return true;
    };

    vm.onMoved = function (list) {
      list.items = list.items.filter(function (item) {
        return !item.selected;
      });
    };

    vm.updateAssignedTeams = function () {
      var assignedArray = [];
      angular.forEach(vm.assignedTeams.items, function (team) {
        assignedArray.push(team.teamId);
      });

      AssignTeams.update({championshipId: $stateParams.championshipId}, assignedArray, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CHAMPIONSHIPS.SUCCESSFUL_TEAMS_UPDATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.championships.championship', {championshipId: vm.championship.id});
      }, function (err) {
        var message = err.data || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name championship.assignMatches
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.assignMatches', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.championships.championship.assignMatches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.championships.championship.assignMatches', {
        url: '/assign-matches',
        templateUrl: 'home/championships/championship/assign-matches/assign-matches.tpl.html',
        controller: 'AssignMatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          facilities: ["Facilities", function (Facilities) {
            return Facilities.query().$promise
          }],
          //TODO: Revisar
          championshipCalendar: ["$stateParams", "ChampionshipCalendarPublic", function ($stateParams, ChampionshipCalendarPublic) {
            return ChampionshipCalendarPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championship.assignMatches.controller:AssignMatchesCtrl
   *
   * @description
   *
   */
  AssignMatchesCtrl.$inject = ["$filter", "$mdToast", "ChampionshipMatches", "AclService", "championshipCalendar", "championship", "categories", "sports", "genders", "towns", "facilities", "entities"];
  angular
    .module('neo.home.championships.championship.assignMatches')
    .controller('AssignMatchesCtrl', AssignMatchesCtrl);

  function AssignMatchesCtrl($filter, $mdToast, ChampionshipMatches, AclService, championshipCalendar, championship, categories, sports, genders, towns, facilities, entities) {
    var vm = this;
    vm.ctrlName = 'AssignMatchesCtrl';

    vm.championship = championship;

    vm.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);

    vm.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);
    vm.teams = buildTeams(championshipCalendar.teams);
    vm.myTeamsId = buildMyTeams(vm.teams, entities);

    vm.facilities = buildFacilities(championshipCalendar.facilities.concat(facilities), towns);
    vm.myFacilities = buildFacilities(facilities, towns);
    vm.matchDays = buildMatchDays(championshipCalendar.matchDays, vm.teams, vm.facilities, championshipCalendar.sportMatchDay);

    vm.getTeamName = getTeamName;
    vm.getMatchFacilities = getMatchFacilities;
    vm.getFacilityName = getFacilityName;
    vm.saveMatches = saveMatches;

    vm.canEditScore = canEditScore;
    vm.canEditDate = canEditDate;
    vm.canEditTime = canEditTime;
    vm.canEditFacility = canEditFacility;

    function getTeamName(teamId) {
      var team = vm.teams[teamId];
      return angular.isUndefined(team) ? undefined : team.teamInfo.name;
    }

    function getMatchFacilities(match) {
      if (match.facilityId === null) {
        return vm.myFacilities;
      } else {
        var assignedFacility = {};
        assignedFacility[match.facilityId] = vm.facilities[match.facilityId];

        // TODO: Revise if it's necesary precalculate the list
        var myFacilities = _.clone(vm.myFacilities);
        return _.assign(myFacilities, assignedFacility);
      }
    }

    function getFacilityName(facilityId) {
      var facility = vm.facilities[facilityId];
      return angular.isUndefined(facility) ? undefined : facility.name;
    }

    function buildTeams(teams) {
      var newTeams = {};
      angular.forEach(teams, function (team) {
        newTeams[team.teamInfo.id] = team;
      });
      return newTeams;
    }

    function buildMyTeams(teams, entities) {
      var entitiesId = _.map(entities, function (e) {
        return e.id;
      });
      var myTeams = _.filter(teams, function (t) {
        return _.contains(entitiesId, t.publicEntityModel.id);
      });
      return _.map(myTeams, function (t) {
        return t.teamInfo.id;
      });
    }

    function buildFacilities(facilities, towns) {
      var newFacilities = {};
      angular.forEach(facilities, function (facility) {
        newFacilities[facility.id] = facility;
        newFacilities[facility.id].town = findItemById(towns, facility.idTown);
      });
      return newFacilities;
    }

    function buildMatchDays(matchDays, sportMatchDay) {
      angular.forEach(matchDays, function (matchDay) {
        matchDay.matches = buildMatches(matchDay.matches);
        matchDay.sportMatchDay = false;
      });
      matchDays = addSportMatchDay(matchDays, sportMatchDay);
      return matchDays;
    }

    function buildMatches(matches) {
      var newMatches = [];
      angular.forEach(matches, function (match) {
        newMatches.push({
          id: match.id,
          date: moment(match.date).toDate(),
          time: _.isNull(match.time) ? null : moment(match.time, 'HH:mm').toDate(),
          localScore: match.localScore,
          visitorScore: match.visitorScore,
          localTeamId: match.localTeamId,
          visitorTeamId: match.visitorTeamId,
          facilityId: match.facilityId
        });
      });
      return newMatches;
    }

    function addSportMatchDay(matchDays, sportMatchDay) {
      matchDays = _.sortBy(matchDays, 'date');
      if (_.size(matchDays) && sportMatchDay > _.head(matchDays).date && sportMatchDay < _.last(matchDays).date) {
        matchDays.push({
          sportMatchDay: true,
          date: sportMatchDay
        });
      }
      return _.sortBy(matchDays, 'date');
    }

    function saveMatches() {
      var matchesToSave = [];
      angular.forEach(vm.matchDays, function (matchDay) {
        angular.forEach(matchDay.matches, function (match) {
          if (canEditMatch(match)) {
            matchesToSave.push({
              id: match.id,
              date: moment(match.date).format('YYYY-MM-DD'),
              time: _.isNull(match.time) ? null : moment(match.time).format('HH:mm'),
              localScore: match.localScore,
              visitorScore: match.visitorScore,
              localTeamId: match.localTeamId,
              visitorTeamId: match.visitorTeamId,
              facilityId: match.facilityId
            })
          }
        });
      });
      ChampionshipMatches.update({id: vm.championship.id}, matchesToSave, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CHAMPIONSHIPS.MATCHES_SUCCESSFUL_UPDATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
      }, function (err) {
        var message = err.data.message || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }


    function canEditMatch(match) {
      return canEditScore(match) || canEditDate(match) || canEditTime(match) || canEditFacility(match);
    }

    function canEditScore(match) {
      //TODO: Revisar lógica en API
      return !vm.championship.jvp && (AclService.isAdmin() || vm.championship.owner);
    }

    function canEditDate(match) {
      return AclService.isAdmin() || vm.championship.owner;
    }

    function canEditTime(match) {
      return (AclService.isAdmin() || vm.championship.owner || _.contains(vm.myTeamsId, match.localTeamId)) && !_.isNull(match.visitorTeamId) && !_.isNull(match.localTeamId);
    }

    function canEditFacility(match) {
      return (AclService.isAdmin() || vm.championship.owner || _.contains(vm.myTeamsId, match.localTeamId)) && !_.isNull(match.visitorTeamId) && !_.isNull(match.localTeamId);
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name cancellations.postponeCanceledMatches
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.canceledMatches.postponeCanceledMatches', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.cancellations.canceledMatches.postponeCanceledMatches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations.canceledMatches.postponeCanceledMatches', {
        url: '/{matchId}/postpone',
        templateUrl: 'home/postponements/new-postponement/new-postponement.tpl.html',
        controller: 'PostponeCanceledMatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          facilities: ["Facilities", function (Facilities) {
            return Facilities.query().$promise;
          }],
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise;
          }],
          match: ["Matches", "$stateParams", function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cancellations.postponeCanceledMatches.controller:PostponeCanceledMatchesCtrl
   *
   * @description
   *
   */
  PostponeCanceledMatchesCtrl.$inject = ["$state", "$mdToast", "$filter", "Postponements", "LastCancellation", "entities", "facilities", "match"];
  angular
    .module('neo.home.cancellations.canceledMatches.postponeCanceledMatches')
    .controller('PostponeCanceledMatchesCtrl', PostponeCanceledMatchesCtrl);

  function PostponeCanceledMatchesCtrl($state, $mdToast, $filter, Postponements, LastCancellation, entities, facilities, match) {
    var vm = this;
    vm.ctrlName = 'PostponeCanceledMatchesCtrl';
    vm.informationRequired = false;
    vm.facilities = angular.copy(facilities);
    vm.postponement = {
      date: match.date,
      time: _.isUndefined(match.time) ? undefined : moment(match.time, 'HH:mm').toDate(),
      facility: match.facility === null ? undefined : match.facility
    };

    vm.localTeam = match.localTeam;
    vm.localTeam.columnName = 'CHAMPIONSHIPS.LOCAL_TEAM';

    vm.visitorTeam = match.visitorTeam;
    vm.visitorTeam.columnName = 'CHAMPIONSHIPS.VISITOR_TEAM';

    vm.matchDate = moment(match.date, "DD/MM/YYYY").toDate();
    vm.canSetTime = checkCanSetTime();
    vm.canSetFacility = checkCanSetFacility();

    vm.savePostponement = function savePostponement() {
      var postObject = {};
      postObject.date = moment(vm.postponement.date).format('YYYY-MM-DD');
      postObject.time = angular.isUndefined(vm.postponement.time) || !checkCanSetTime() ? null : moment(vm.postponement.time).format('HH:mm');
      postObject.facilityId = !checkCanSetFacility() ? null : vm.postponement.facility;
      postObject.details = vm.postponement.details;

      Postponements.save({id: match.id}, postObject, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('POSTPONEMENTS.SUCCESS_CREATION'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.cancellations.canceledMatches', {}, {reload: true});
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'POSTPONEMENTS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };

    function checkCanSetTime() {
      var item = findItemById(entities, vm.localTeam.entityId);
      return angular.isDefined(item);
    }

    function checkCanSetFacility() {
      return vm.canSetTime;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name ajuntament.informacio
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio', [
    'ui.router',
    'ngMaterial',
    'neo.home.ajuntaments.ajuntament.informacio.image',
    'neo.home.ajuntaments.ajuntament.informacio.people'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments.ajuntament.informacio', {
      url: '/informacio',
      views: {
        '': {
          templateUrl: 'home/ajuntaments/ajuntament/informacio/informacio.tpl.html',
          controller: 'InformacioAjuntamentCtrl',
          controllerAs: 'vm'
        },
        'image@home.ajuntaments.ajuntament.informacio': {
          templateUrl: 'home/ajuntaments/ajuntament/informacio/image/image.tpl.html',
          controller: 'ImageCtrl',
          controllerAS: 'vm'
        },
        'people@home.ajuntaments.ajuntament.informacio': {
          templateUrl: 'home/ajuntaments/ajuntament/informacio/people/people.tpl.html',
          controller: 'AjuntamentPeopleCtrl',
          controllerAs: 'vm',
          resolve: {
            users: ["$stateParams", "OrganisationUsers", "$q", function ($stateParams, OrganisationUsers, $q) {
              var deferred = $q.defer();
              OrganisationUsers.query({id: $stateParams.ajuntamentId},
                function (data) {
                  // returned 200
                  deferred.resolve(data);
                },
                function (response) {
                  deferred.reject(response);
                }
              );

              return deferred.promise;
              //return [{email: "prova@email.com", id: 1}];
            }]
          }
        },
        'text@home.ajuntaments.ajuntament.informacio': {
          templateUrl: 'home/ajuntaments/ajuntament/informacio/text.tpl.html'
        },
        'actions@home.ajuntaments.ajuntament.informacio': {
          templateUrl: 'components/actionButton/action-button.tpl.html',
          controller: 'ActionButtonCtrl',
          controllerAs: 'vm'
        }
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name ajuntament.informacio.controller:InformacioAjuntamentCtrl
   *
   * @description
   *
   */
  InformacioAjuntamentCtrl.$inject = ["$state", "$stateParams", "$mdToast", "$filter", "ajuntament", "towns", "Ajuntaments", "actionButton"];
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio')
  .controller('InformacioAjuntamentCtrl', InformacioAjuntamentCtrl);

  function InformacioAjuntamentCtrl($state, $stateParams, $mdToast, $filter, ajuntament, towns, Ajuntaments, actionButton) {
    var vm = this;
    vm.ctrlName = 'InformacioAjuntamentCtrl';
    vm.ajuntament = ajuntament;
    vm.towns = towns;
    angular.forEach(towns, function (value) {
      if (value.id === ajuntament.idTown) vm.ajuntament.townName = value.name;
    });
    vm.edit = false;

    actionButton.dial = true;
    actionButton.buttonImage = 'images/ic_more_vert_white_48px.svg';

    actionButton.actions = [{
      buttonImage: 'images/ic_edit_black_48px.svg',
      attrClass: '',
      tooltip: 'Edita',
      execute: enableEdit
    },
      {
        buttonImage: 'images/ic_person_add_black_48px.svg',
        attrClass: '',
        tooltip: 'Nova persona',
        execute: function () {
        }
      },
      {
        buttonImage: 'images/ic_visibility_off_white_48px.svg',
        attrClass: 'md-warn',
        tooltip: 'Deshabilita',
        execute: function () {
        }
      }
    ];

    vm.updateAjuntament = updateAjuntament;

    function enableEdit() {
      vm.edit = true;
      actionButton.dial = false;
    }

    function updateAjuntament() {
      Ajuntaments.update({id: $stateParams.ajuntamentId}, vm.ajuntament, function () {
        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')('TOWN_HALL_SUCCESSFUL_MODIFY'))
          .position('bottom left')
          .hideDelay(3000)
        );
        $state.go($state.current, $stateParams, {reload: true});
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name calendar.championship
   * @description
   *
   */
  angular
    .module('neo.public.calendar.championship', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name calendar.championship.controller:ChampionshipCalendarCtrl
   *
   * @description
   *
   */
  ChampionshipCalendarExcelCtrl.$inject = ["$filter", "$timeout", "championshipCalendar", "championship", "categories", "sports", "genders", "towns", "excel", "$scope"];
  angular
    .module('neo.public.calendar.championship')
    .controller('ChampionshipCalendarExcelCtrl', ChampionshipCalendarExcelCtrl);

  function ChampionshipCalendarExcelCtrl($filter, $timeout,championshipCalendar, championship, categories, sports, genders, towns,excel, $scope) {
    var vm = this;
    vm.ctrlName = 'ChampionshipCalendarExcelCtrl';

    vm.championship = championship;

    vm.buttons = {
      dial: true,
      buttonImage: 'images/ic_more_vert_white_48px.svg',
      tooltip: 'Accions',
      actions: [
        {
          changeState: false,
          execute: printReport,
          buttonImage: 'images/ic_print_black_24px.svg',
          tooltip: $filter('translate')('CALENDAR.PRINT')
        }
      ]
    };

    vm.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);
    vm.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);

    vm.teams = buildTeams(championshipCalendar.teams);
    vm.facilities = buildFacilities(championshipCalendar.facilities, towns);

    vm.matchDays = buildMatchDays(championshipCalendar.matchDays, vm.teams, vm.facilities, championshipCalendar.sportMatchDay);

    vm.isEmpty = function (collection) {
      return _.isEmpty(collection);
    };
    
    $scope.exportToExcel=function(tableId){ // ex: '#my-table'
            var exportHref=excel.tableToExcel(tableId,'sheet name');
            $timeout(function(){location.href=exportHref;},100); // trigger download
        };

    function printReport($window) {
      var championshipTpl = '<div flex>' +
        '<h1 class="md-title">' + $filter('translate')("CALENDAR.CHAMPIONSHIP") + '</h1>' +
        '<div layout="row" layout-align="space-around none" layout-padding layout-wrap>' +
        '<span class="md-title">' + $filter('translate')("CHAMPIONSHIPS.NAME") + ': </span>' +
        '<span>' + vm.championship.name + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("CATEGORY") + ': </span>' +
        '<span>' + vm.category + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("SPORT") + ': </span>' +
        '<span>' + vm.sport + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("GENDER") + ': </span>' +
        '<span>' + vm.gender + '</span><br/>' +
        '</div>' +
        '</div>';
      var matchesTpl = (document.getElementById('matches') !== null) ? document.getElementById('matches').innerHTML : '';
      var facilitiesTpl = (document.getElementById('facilities') !== null) ? document.getElementById('facilities').innerHTML : '';
      var teamsTpl = (document.getElementById('teams') !== null) ? document.getElementById('teams').innerHTML : '';
      var template = championshipTpl + matchesTpl + facilitiesTpl + teamsTpl;
     
     // printWin.document..write('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><?xml version="1.0" encoding="utf-8" standalone="yes"?><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head></html><body><style>' + getPrintStyles() + '</style>' + template + '</body></html>');
    //  printWin.document.close();
     
       var exportHref=excel.tableToExcel(table2,'sheet name');
            $timeout(function(){location.href=exportHref;},100); 
		
    }

    function getPrintStyles() {
      return 'body {-webkit-print-color-adjust: exact;}' +
        '@media print { .matchday-container { page-break-inside: avoid; } }' +
        '.match-container, .facility-container, .team-container {display: block;}' +
        '.match-header {padding: 3mm;}' +
        '.match-container span, .facility-container span, .team-container span {padding: 2mm 0;}' +
        '.match-container span:nth-child(1), .facility-container span:nth-child(1), .team-container span:nth-child(1) {padding-left: 2mm;}' +
        '.match-container span, .facility-container span, .team-container span {display: inline-block;}' +
        '.match-container span:nth-child(1) {width: 30mm;}' +
        '.match-container span:nth-child(2), .match-container span:nth-child(n+4) {width: 45mm;}' +
        '.match-container span:nth-child(3) {width: 10mm;}' +
        '.facility-container span:nth-child(1) {display: none;}' +
        '.facility-container span:nth-child(n+2) {width: 50mm;}' +
        '.facility-container span:nth-child(5) {width: 20mm;}' +
        '.team-container span {display: inline-block; width: 25mm;}';
    }


    vm.postponedMatch = postponedMatch;

    function postponedMatch(match) {
      return match.postponed;
    }

    vm.matchHasUnresolvedCancellation = matchHasUnresolvedCancellation;

    function matchHasUnresolvedCancellation(match) {
      if (angular.isDefined(match.lastCancellation) && !_.isNull(match.lastCancellation)) {
        if (match.lastCancellation.resolved === false) return true;
      }
      return false;
    }


    function buildTeams(teams) {
      var newTeams = {};
      angular.forEach(teams, function (team) {
        newTeams[team.teamInfo.id] = team;
      });
      return newTeams;
    }

    function buildFacilities(facilities, towns) {
      var newFacilities = {};
      angular.forEach(facilities, function (facility) {
        newFacilities[facility.id] = facility;
        newFacilities[facility.id].town = findItemById(towns, facility.idTown);
      });
      return newFacilities;
    }

    function buildMatches(matches, teams, facilities) {
      var newMatches = [];
      angular.forEach(matches, function (match) {
        newMatches.push({
          date: moment(match.date).format('L'),
          time: match.time,
          localScore: match.localScore,
          visitorScore: match.visitorScore,
          postponed: match.postponed,
          team1: teams[match.localTeamId],
          team2: teams[match.visitorTeamId],
          facility: facilities[match.facilityId],
          lastPostponement: match.lastPostponement,
          lastCancellation: match.lastCancellation
        });
      });
      return newMatches;
    }

    function buildMatchDays(matchDays, teams, facilities, sportMatchDay) {
      angular.forEach(matchDays, function (matchDay) {
        matchDay.matches = buildMatches(matchDay.matches, teams, facilities);
        matchDay.sportMatchDay = false;
      });
      matchDays = addSportMatchDay(matchDays, sportMatchDay);
      return matchDays;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function addSportMatchDay(matchDays, sportMatchDay) {
      matchDays = _.sortBy(matchDays, 'date');
      if (_.size(matchDays) && sportMatchDay > _.head(matchDays).date && sportMatchDay < _.last(matchDays).date) {
        matchDays.push({
          sportMatchDay: true,
          date: sportMatchDay
        });
      }
      return _.sortBy(matchDays, 'date');
    }
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.public.calendar.championship')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('public.championshipCalendar', {
        url: '/championship/{championshipId}/calendar',
        templateUrl: 'public/calendar/championship/championship.tpl.html',
        controller: 'ChampionshipCalendarCtrl',
        controllerAs: 'vm',
        resolve: {
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          championship: ["$stateParams", "ChampionshipPublic", function ($stateParams, ChampionshipPublic) {
            return ChampionshipPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          championshipCalendar: ["$stateParams", "ChampionshipCalendarPublic", function ($stateParams, ChampionshipCalendarPublic) {
            return ChampionshipCalendarPublic.get({id: $stateParams.championshipId}).$promise;
          }]
        }
      }).state('public.championshipCalendarExcel', {
        url: '/championship/{championshipId}/calendarexcel',
        templateUrl: 'public/calendar/championship/championshipexcel.tpl.html',
        controller: 'ChampionshipCalendarExcelCtrl',
        controllerAs: 'vm',
        resolve: {
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          championship: ["$stateParams", "ChampionshipPublic", function ($stateParams, ChampionshipPublic) {
            return ChampionshipPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          championshipCalendar: ["$stateParams", "ChampionshipCalendarPublic", function ($stateParams, ChampionshipCalendarPublic) {
            return ChampionshipCalendarPublic.get({id: $stateParams.championshipId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name calendar.championship.controller:ChampionshipCalendarCtrl
   *
   * @description
   *
   */
  ChampionshipCalendarCtrl.$inject = ["$filter", "championshipCalendar", "championship", "categories", "sports", "genders", "towns"];
  angular
    .module('neo.public.calendar.championship')
    .controller('ChampionshipCalendarCtrl', ChampionshipCalendarCtrl);

  function ChampionshipCalendarCtrl($filter, championshipCalendar, championship, categories, sports, genders, towns) {
    var vm = this;
    vm.ctrlName = 'ChampionshipCalendarCtrl';

    vm.championship = championship;

    vm.buttons = {
      dial: true,
      buttonImage: 'images/ic_more_vert_white_48px.svg',
      tooltip: 'Accions',
      actions: [
        {
          changeState: false,
          execute: printReport,
          buttonImage: 'images/ic_print_black_24px.svg',
          tooltip: $filter('translate')('CALENDAR.PRINT')
        }
      ]
    };

    vm.category = $filter('translate')('CATEGORIES.' + findItemById(categories, vm.championship.categoryId).name);
    vm.sport = $filter('translate')('SPORTS.' + findItemById(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById(genders, vm.championship.genderId).name);

    vm.teams = buildTeams(championshipCalendar.teams);
    vm.facilities = buildFacilities(championshipCalendar.facilities, towns);

    vm.matchDays = buildMatchDays(championshipCalendar.matchDays, vm.teams, vm.facilities, championshipCalendar.sportMatchDay);

    vm.isEmpty = function (collection) {
      return _.isEmpty(collection);
    };

    function printReport() {
      var championshipTpl = '<div flex>' +
        '<h1 class="md-title">' + $filter('translate')("CALENDAR.CHAMPIONSHIP") + '</h1>' +
        '<div layout="row" layout-align="space-around none" layout-padding layout-wrap>' +
        '<span class="md-title">' + $filter('translate')("CHAMPIONSHIPS.NAME") + ': </span>' +
        '<span>' + vm.championship.name + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("CATEGORY") + ': </span>' +
        '<span>' + vm.category + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("SPORT") + ': </span>' +
        '<span>' + vm.sport + '</span><br/>' +
        '<span class="md-title">' + $filter('translate')("GENDER") + ': </span>' +
        '<span>' + vm.gender + '</span><br/>' +
        '</div>' +
        '</div>';
      var matchesTpl = (document.getElementById('matches') !== null) ? document.getElementById('matches').innerHTML : '';
      var facilitiesTpl = (document.getElementById('facilities') !== null) ? document.getElementById('facilities').innerHTML : '';
      var teamsTpl = (document.getElementById('teams') !== null) ? document.getElementById('teams').innerHTML : '';
      var template = championshipTpl + matchesTpl + facilitiesTpl + teamsTpl;
      var printWin = window.open('', '',
        'left=0, top=0, width=' + screen.availWidth + ', height=' + screen.availHeight
        + ', toolbar=0, scrollbars=0, status=0');
      printWin.document.write('<html><body onload="window.print()"><style>' + getPrintStyles() + '</style>' + template + '</body></html>');
      printWin.document.close();
    }

    function getPrintStyles() {
      return 'body {-webkit-print-color-adjust: exact;}' +
        '@media print { .matchday-container { page-break-inside: avoid; } }' +
        '.match-container, .facility-container, .team-container {display: block;}' +
        '.match-header {padding: 3mm;}' +
        '.match-container span, .facility-container span, .team-container span {padding: 2mm 0;}' +
        '.match-container span:nth-child(1), .facility-container span:nth-child(1), .team-container span:nth-child(1) {padding-left: 2mm;}' +
        '.match-container span, .facility-container span, .team-container span {display: inline-block;}' +
        '.match-container span:nth-child(1) {width: 30mm;}' +
        '.match-container span:nth-child(2), .match-container span:nth-child(n+4) {width: 45mm;}' +
        '.match-container span:nth-child(3) {width: 10mm;}' +
        '.facility-container span:nth-child(1) {display: none;}' +
        '.facility-container span:nth-child(n+2) {width: 50mm;}' +
        '.facility-container span:nth-child(5) {width: 20mm;}' +
        '.team-container span {display: inline-block; width: 25mm;}';
    }


    vm.postponedMatch = postponedMatch;

    function postponedMatch(match) {
      return match.postponed;
    }

    vm.matchHasUnresolvedCancellation = matchHasUnresolvedCancellation;

    function matchHasUnresolvedCancellation(match) {
      if (angular.isDefined(match.lastCancellation) && !_.isNull(match.lastCancellation)) {
        if (match.lastCancellation.resolved === false) return true;
      }
      return false;
    }


    function buildTeams(teams) {
      var newTeams = {};
      angular.forEach(teams, function (team) {
        newTeams[team.teamInfo.id] = team;
      });
      return newTeams;
    }

    function buildFacilities(facilities, towns) {
      var newFacilities = {};
      angular.forEach(facilities, function (facility) {
        newFacilities[facility.id] = facility;
        newFacilities[facility.id].town = findItemById(towns, facility.idTown);
      });
      return newFacilities;
    }

    function buildMatches(matches, teams, facilities) {
      var newMatches = [];
      angular.forEach(matches, function (match) {
        newMatches.push({
          date: moment(match.date).format('L'),
          time: match.time,
          localScore: match.localScore,
          visitorScore: match.visitorScore,
          postponed: match.postponed,
          team1: teams[match.localTeamId],
          team2: teams[match.visitorTeamId],
          facility: facilities[match.facilityId],
          lastPostponement: match.lastPostponement,
          lastCancellation: match.lastCancellation
        });
      });
      return newMatches;
    }

    function buildMatchDays(matchDays, teams, facilities, sportMatchDay) {
      angular.forEach(matchDays, function (matchDay) {
        matchDay.matches = buildMatches(matchDay.matches, teams, facilities);
        matchDay.sportMatchDay = false;
      });
      matchDays = addSportMatchDay(matchDays, sportMatchDay);
      return matchDays;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function addSportMatchDay(matchDays, sportMatchDay) {
      matchDays = _.sortBy(matchDays, 'date');
      if (_.size(matchDays) && sportMatchDay > _.head(matchDays).date && sportMatchDay < _.last(matchDays).date) {
        matchDays.push({
          sportMatchDay: true,
          date: sportMatchDay
        });
      }
      return _.sortBy(matchDays, 'date');
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name user.profile
   * @description
   *
   */
  angular
  .module('neo.home.user.profile', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.user.profile')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.userProfile', {
      url: '/users/:userId/profile',
      views: {
        '': {
          templateUrl: 'home/user/profile/profile.tpl.html',
          controller: 'ProfileCtrl',
          controllerAs: 'vm',
          resolve: {
            profile: ["UserProfile", "$stateParams", function (UserProfile, $stateParams) {
              return UserProfile.get({id: $stateParams.userId}).$promise;
            }]
          }
        },
        'details@home.userProfile': {
          templateUrl: 'home/user/profile/details.tpl.html'
        },
        'actions@home.userProfile': {
          templateUrl: 'components/actionButton/action-button.tpl.html',
          controller: 'ActionButtonCtrl',
          controllerAs: 'vm'
        }
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name user.profile.controller:ProfileCtrl
   *
   * @description
   *
   */
  ProfileCtrl.$inject = ["$stateParams", "$filter", "actionButton", "profile", "ActionResendRegEmail", "$mdToast", "UserProfile", "AclService"];
  angular
    .module('neo.home.user.profile')
    .controller('ProfileCtrl', ProfileCtrl);

  function ProfileCtrl($stateParams, $filter, actionButton, profile, ActionResendRegEmail, $mdToast, UserProfile, AclService) {
    var vm = this;
    vm.ctrlName = 'ProfileCtrl';
    vm.edit = false;
    vm.profile = profile;
    vm.isAdmin = canChangeUsername();

    actionButton.dial = true;

    actionButton.buttonImage = 'images/ic_more_vert_white_48px.svg';
    actionButton.actions = [
      {
        buttonImage: 'images/ic_edit_black_48px.svg',
        attrClass: '',
        tooltip: $filter('translate')('EDIT'),
        execute: enableEdit
      },
      {
        buttonImage: 'images/ic_send_black_48px.svg',
        attrClass: '',
        tooltip: $filter('translate')('RESEND_EMAIL'),
        execute: resendEmail
      }];

    vm.updateEmail = updateEmail;

    function resendEmail() {
      ActionResendRegEmail.save({email: vm.profile.email},
        function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('SUCCESSFUL_EMAIL_RESEND'))
              .position('bottom left')
              .hideDelay(3000)
          );
        }, function (error) {
          var message = null;
          if (error.status === 409) {
            message = 'ALREADY_REGISTERED_USER_AND_NOT_RESEND';
          } else {
            message = 'ERROR_SENDING_MAIL';
          }
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function canChangeUsername() {
      return AclService.isAdmin() || AclService.can('TOWN_HALL', 'R');
    }

    function enableEdit() {
      vm.edit = true;
      actionButton.dial = false;
    }

    function updateEmail() {
      UserProfile.update({id: $stateParams.userId}, vm.profile,
        function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('SUCCESSFUL_EMAIL_CHANGE_SEND'))
              .position('bottom left')
              .hideDelay(3000)
          );
          vm.edit = false;
          actionButton.dial = true;
        }, function (error) {
          var message = 'ERROR_MODIFY_MAIL';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name teams.team
   * @description
   *
   */
  angular
    .module('neo.home.teams.team', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.teams.team')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.teams.team', {
      url: '/{teamId}',
      templateUrl: 'home/teams/team/team.tpl.html',
      controller: 'TeamCtrl',
      controllerAs: 'vm',
      resolve: {
        team: ["Teams", "$stateParams", function (Teams, $stateParams) {
          return Teams.get({id: $stateParams.teamId}).$promise
        }],
        sportProgramme: ["ProgrammeSports", "team", function (ProgrammeSports, team) {
          return ProgrammeSports.query({id: team.programmeId}).$promise
        }],
        licenseTypes: ["LicenseTypes", function (LicenseTypes) {
          return LicenseTypes.query().$promise;
        }],
        licenses: ["LicenseTeamDetails", "$stateParams", function (LicenseTeamDetails, $stateParams) {
          return LicenseTeamDetails.query({teamId: $stateParams.teamId}).$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name teams.team.controller:TeamCtrl
   *
   * @description
   *
   */
  TeamCtrl.$inject = ["AclService", "$filter", "entities", "team", "genders", "programmes", "categories", "$scope", "ProgrammeSports", "Insurances", "Teams", "$mdToast", "$stateParams", "$state", "$mdDialog", "sportProgramme", "licenses", "licenseTypes"];
  angular
    .module('neo.home.teams.team')
    .controller('TeamCtrl', TeamCtrl);

  function TeamCtrl(AclService, $filter, entities, team, genders, programmes, categories, $scope, ProgrammeSports,
                    Insurances, Teams, $mdToast, $stateParams, $state, $mdDialog, sportProgramme, licenses, licenseTypes) {
    var vm = this;
    vm.ctrlName = 'TeamCtrl';

    vm.edit = false;
    vm.can = AclService.can;

    vm.team = angular.copy(team);
    vm.entities = entities;
    vm.genders = genders;
    vm.programs = programmes;
    vm.categories = categories;
    vm.sports = sportProgramme;

    vm.entitySelected = findItemById(vm.entities, vm.team.entityId);
    vm.showInsurance = false;
    vm.price = {};

    vm.printTeam = {
      entityName: vm.entitySelected.name,
      teamName: vm.team.name,
      sportName: 'SPORTS.' + findItemById(vm.sports, vm.team.sportId).name,
      categoryName: 'CATEGORIES.' + findItemById(vm.categories, vm.team.categoryId).name,
      programName: findItemById(vm.programs, vm.team.programmeId).name,
      coachName: team.coachName,
      coachEmail: team.coachEmail,
      coachPhone: team.coachPhone,
      shirtColor: team.shirtColor,
      pantsColor: team.pantsColor,
      persons: buildPersonsInformation(licenses)
    };

    vm.discardChanges = discardChanges;
    vm.updateTeam = updateTeam;


    //Buttons
    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'Accions',
      actions: []
    };

    if (vm.can('TEAM', 'U')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: enableEdit,
          icon: 'edit',
          tooltip: $filter('translate')('EDIT')
        }
      )
    }
    if (vm.can('TEAM', 'R')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: printReport,
          icon: 'print',
          tooltip: $filter('translate')('PRINT')
        }
      )
    }
    if (vm.can('TEAM', 'D')) {
      vm.buttons.actions.push(
        {
          changeState: false,
          execute: deleteTeam,
          icon: 'delete',
          attrClass: 'md-warn',
          tooltip: $filter('translate')('DELETE')
        }
      )
    }

    ///// ---------

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function enableEdit() {
      vm.edit = true;
      vm.buttons.dial = false;
      if (vm.team.inscribedToChampionship) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Equip inscrit a un campionat')
            .textContent($filter('translate')('EDIT_ENROLLED'))
            .ok($filter('translate')('ACCEPT'))
        );
      }
    }

    function deleteTeam() {
      $mdDialog.show({
        controller: ["$scope", "$mdDialog", "$filter", function DialogController($scope, $mdDialog, $filter) {
          $scope.alertText = $filter('translate')('ALERT');
          $scope.textContent = $filter('translate')('TEAMS.CONFIRM_DELETE');
          $scope.cancelText = $filter('translate')('CANCEL');
          $scope.deleteText = $filter('translate')('DELETE');

          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.delete = function () {
            //then
            $mdDialog.hide();
          };
        }],
        templateUrl: 'home/teams/team/delete-confirmation.tmpl.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true
      })
        .then(function () {
          Teams.remove({id: $stateParams.teamId},
            function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')('TEAMS.SUCCESSFUL_DELETE'))
                  .position('bottom left')
                  .hideDelay(3000));
              $state.go('home.teams', {}, {reload: true});
            },
            function (error) {
              var message = 'TOAST_ERROR';
              if (error.status > 0) {
                message = angular.isDefined(error.data.message)? error.data.message : message;
              }
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')(message))
                  .position('bottom left')
                  .hideDelay(3000)
              );
            });
        });
    }


    function buildPersonsInformation(licenses) {
      var persons = [];
      angular.forEach(licenses, function (license) {
        var lic = license.license;
        persons.push({
          licenseCode: license.licenseCode,
          name: lic.person.name,
          surnames: lic.person.surname1+ (lic.person.surname2 !== null ? lic.person.surname2 : ''),
          nif: lic.person.nif,
          licenseType: 'PERSON_TYPES.' + findItemById(licenseTypes, lic.licenceTypeId).name,
          category: 'CATEGORIES.' + lic.category.name,
          bornDate: moment(lic.person.bornDate).format('L')
        });
      });
      return persons;
    }

    function printReport() {
      var template = document.getElementById('teamPrintPreview').innerHTML;
      var printWin = window.open('', '',
        'left=0, top=0, width=' + screen.availWidth + ', height=' + screen.availHeight
        + ', toolbar=0, scrollbars=0, status=0');
      printWin.document.write(template);
      printWin.document.close();
      setTimeout(function () {
        printWin.focus();
        printWin.print();
        printWin.close();
      }, 500);
    }

    function getProgrammeSports(programmeId) {
      ProgrammeSports.query({id: programmeId}, function (sports) {
        vm.sports = sports;
      });
    }

    $scope.$watch('vm.team.programmeId', function (newID, oldID) {
      if (newID !== oldID) {
        if (angular.isDefined(newID)) {
          vm.team.sportId = undefined;
          getProgrammeSports(vm.team.programmeId);
        }
      }
    });

    $scope.$watch('vm.team.sportId', function (newID) {
      getInsurancePrice(vm.team.programmeId, newID, vm.team.categoryId);
    });

    $scope.$watch('vm.team.categoryId', function (newID) {
      getInsurancePrice(vm.team.programmeId, vm.team.sportId, newID);
    });

    function getInsurancePrice(programID, sportID, categoryID) {
      if (angular.isDefined(sportID) && angular.isDefined(categoryID)) {
        Insurances.get({idP: programID, idS: sportID, idC: categoryID}, function (price) {
          vm.showInsurance = true;
          vm.price = price;
        });
      } else {
        vm.showInsurance = false;
        vm.price = undefined;
      }
    }


    function discardChanges() {
      vm.team = angular.copy(team);
      vm.edit = false;
      vm.buttons.dial = true;
    }


    function updateTeam() {
      Teams.update({id: $stateParams.teamId}, vm.team, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('TEAM_SUCCESSFUL_UPDATE'))
              .position('bottom left')
              .hideDelay(3000)
          );
          $state.go('home.teams', {}, {reload: true});
        },
        function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Hi ha hagut algun error')
              .position('bottom left')
              .hideDelay(3000)
          );
        })
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name teams.newTeam
   * @description
   *
   */
  angular
  .module('neo.home.teams.newTeam', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.teams.newTeam')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.teams.newTeam', {
          url: '/new-team',
          templateUrl: 'home/teams/new-team/new-team.tpl.html',
          controller: 'NewTeamCtrl',
          controllerAs: 'vm',
          params: {
            entity: undefined
          },
          resolve: {
            genders: ["Genders", function (Genders) {
              return Genders.query().$promise;
            }],
            programmes: ["Programmes", function (Programmes) {
              return Programmes.query().$promise;
            }],
            entities: ["Entitats", function (Entitats) {
              return Entitats.query().$promise;
            }]
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name teams.newTeam.controller:NewTeamCtrl
   *
   * @description
   *
   */
  NewTeamCtrl.$inject = ["$scope", "$mdToast", "$filter", "$stateParams", "$state", "categories", "genders", "programmes", "entities", "ProgrammeSports", "Insurances", "EntityTeams"];
  angular
    .module('neo.home.teams.newTeam')
    .controller('NewTeamCtrl', NewTeamCtrl);

  function NewTeamCtrl($scope, $mdToast, $filter, $stateParams, $state,
                       categories, genders, programmes, entities,
                       ProgrammeSports, Insurances, EntityTeams) {
    var vm = this;
    vm.ctrlName = 'NewTeamCtrl';
    vm.genders = genders;
    vm.sports = [];
    vm.programs = programmes;
    vm.categories = categories;
    vm.entities = entities;
    vm.lodp = false;
    vm.team = {
      programmeId: vm.programs[0].id
    };
    vm.programmeSelected = false;
    vm.price = {};
    vm.showInsurance = false;

    vm.createTeam = createTeam;
    vm.entitySelected = selectEntity($stateParams.entity);

    $scope.$watch('vm.team.programmeId', function (newID) {
      vm.sports = [];
      if (angular.isDefined(newID)) {
        ProgrammeSports.query({id: newID}, function (sports) {
          vm.sports = sports;
          vm.team.sportId = undefined;
          vm.programmeSelected = true;
        }, function () {
          vm.programmeSelected = false;
        });
      }
    });
    $scope.$watch('vm.team.sportId', function (newID) {
      getInsurancePrice(vm.team.programmeId, newID, vm.team.categoryId);
    });

    $scope.$watch('vm.team.categoryId', function (newID) {
      getInsurancePrice(vm.team.programmeId, vm.team.sportId, newID);
    });

    function getInsurancePrice(programID, sportID, categoryID) {
      if (angular.isDefined(sportID) && angular.isDefined(categoryID)) {
        Insurances.get({idP: programID, idS: sportID, idC: categoryID}, function (price) {
          vm.showInsurance = true;
          vm.price = price;
        });
      } else {
        vm.showInsurance = false;
        vm.price = undefined;
      }
    }

    function selectEntity(entityId) {
      if (vm.entities.length === 1) {
        return vm.entities[0];
      } else {
        return findEntity(entityId)
      }
    }

    function findEntity(entityId) {
      return _.find(entities, function (e) {
        return e.id === entityId;
      });
    }



    function createTeam() {
      EntityTeams.save({entityId: vm.entitySelected.id}, vm.team, function () {
        $state.go('home.teams', {selectedEntity: vm.entitySelected}, {reload: true});
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('TEAM_SUCCESSFUL_CREATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
      }, function (err) {
        var errorMessage;
        if (err.status === 400) {
          errorMessage = 'BAD_REQUEST_TEAM';
        } else if (err.status === 409) {
          errorMessage = 'ERROR_EXISTING_TEAM';
        } else {
          errorMessage = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(errorMessage))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }


  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name statistics.teams
   * @description
   *
   */
  angular
    .module('neo.home.statistics.teams', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.statistics.teams')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.statistics.teams', {
        url: '/teams',
        templateUrl: 'home/statistics/teams/teams.tpl.html',
        controller: 'StatsTeamsCtrl',
        controllerAs: 'vm',
        resolve: {
          teamStats: ["TeamStatistics", "currentSeason", function (TeamStatistics, currentSeason) {
            return TeamStatistics.query({season_id: currentSeason.id}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name statistics.teams.controller:StatsTeamsCtrl
   *
   * @description
   *
   */
  StatsTeamsCtrl.$inject = ["$filter", "$mdToast", "TeamStatistics", "categories", "genders", "seasons", "currentSeason", "teamStats"];
  angular
    .module('neo.home.statistics.teams')
    .controller('StatsTeamsCtrl', StatsTeamsCtrl);

  function StatsTeamsCtrl($filter, $mdToast, TeamStatistics, categories, genders, seasons, currentSeason, teamStats) {
    var vm = this;
    vm.ctrlName = 'StatsTeamsCtrl';

    vm.teamStats = teamStats;

    vm.phases = _.uniq(_.pluck(vm.teamStats, 'phase'));
    vm.programmes = _.uniq(_.pluck(vm.teamStats, 'programme'));
    vm.seasons = seasons;

    vm.selectedPhase = undefined;
    vm.selectedProgramme = undefined;
    vm.selectedSeasonId = currentSeason.id;


    vm.myChartObject = {
      type: 'Table',
      displayed: false,
      data: {
        cols: buildCols(categories, genders),
        rows: buildRows(vm.teamStats, categories, genders)
      },
      options: {
        title: $filter('translate')('STATISTICS.TEAMS'),
        cssClassNames : {'headerCell': 'header-padding'}
      },
      formatters: {}
    };

    vm.changeSeason = function () {
      TeamStatistics.query({'season_id': vm.selectedSeasonId}, function (data) {
        vm.teamStats = data;
        vm.changeFilter();
      }, function (err) {
        var message = err.data.message || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };


    vm.changeFilter = function () {
      var filterParams = {};
      if (!_.isUndefined(vm.selectedPhase)) filterParams['phase'] = vm.selectedPhase;
      if (!_.isUndefined(vm.selectedProgramme)) filterParams['programme'] = vm.selectedProgramme;
      var filteredTeamStats = _.filter(vm.teamStats, filterParams);
      vm.myChartObject.data.rows = buildRows(filteredTeamStats, categories, genders);
    };

    vm.readyHandler = function (chartWrapper) {
      vm.htmlTable = chartWrapper.getChart().getContainer().childNodes[0].childNodes[0].childNodes[0];
    };

    function buildCols(categories, genders) {
      var cols = [];
      cols.push({id: 'sport', label: $filter('translate')('SPORT'), type: 'string'});

      _.forEach(categories, function (c) {
        _.forEach(genders, function (g) {
          var l = $filter('translate')('CATEGORIES.' + c.name) + ' ' + $filter('translate')(g.name);
          cols.push({id: c.name + '_' + g.name, label: l, type: 'number'});
        })
      });

      cols.push({id: 'total', label: $filter('translate')('TOTAL'), type: 'number'});
      return cols;
    }

    function buildRows(data, categories, genders) {
      var rows = [];
      var sports = _.uniq(_.pluck(data, 'sport'));

      _.forEach(sports, function (s) {
        var sportName = $filter('translate')('SPORTS.' + s);
        var row = buildRow(sportName, categories, genders, _.filter(data, 'sport', s));
        rows.push(row);
      });
      var totalName = $filter('translate')('TOTAL');
      var totalRow = buildRow(totalName, categories, genders, data);

      rows.push(totalRow);
      return rows;

    }

    function buildRow(rowName, categories, genders, data) {
      var values = [];
      values.push({v: rowName});
      var total = 0;

      _.forEach(categories, function (c) {
        _.forEach(genders, function (g) {

          var predicate = {'category': c.name, 'gender': g.name};
          var teams = _.filter(data, predicate);
          var numTeamIds = _.size(_.uniq(_.pluck(teams, 'teamId')));

          values.push({v: numTeamIds});
          total = total + numTeamIds;
        })
      });
      values.push({v: total});
      return {c: values};
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name statistics.teams
   * @description
   *
   */
  angular
    .module('neo.home.statistics.neoindi', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.statistics.neoindi')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.statistics.neoindi', {
        url: '/neoindi',
        templateUrl: 'home/statistics/neoindi/neoindi.tpl.html',
        controller: 'NeoindiCtrl',
        controllerAs: 'vm'
        
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name statistics.teams.controller:StatsTeamsCtrl
   *
   * @description
   *
   */
  NeoindiCtrl.$inject = ["$filter", "$mdToast", "$scope"];
  angular
    .module('neo.home.statistics.neoindi')
    .controller('NeoindiCtrl',NeoindiCtrl);

  function NeoindiCtrl($filter, $mdToast,$scope) {
    var vm = this;
    vm.ctrlName = 'NeoindiCtrl';
    vm.us='cebllob';
    vm.pass='cebllob';
   
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name statistics.licenses
   * @description
   *
   */
  angular
    .module('neo.home.statistics.licenses', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.statistics.licenses')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.statistics.licenses', {
        url: '/licenses',
        templateUrl: 'home/statistics/licenses/licenses.tpl.html',   
        data: {
          townHall: undefined
        },
        controller: 'StatsLicensesCtrl',
        controllerAs: 'vm',
        resolve: {
          licenceStats: ["LicenceStatistics", "currentSeason", function (LicenceStatistics, currentSeason) {
            return LicenceStatistics.query({season_id: currentSeason.id}).$promise;
          }], townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name statistics.licenses.controller:StatsLicensesCtrl
   *
   * @description
   *
   */
  StatsLicensesCtrl.$inject = ["AclService", "$state", "$filter", "$mdToast", "LicenceStatistics", "categories", "genders", "seasons", "townHalls", "currentSeason", "licenceStats"];
  angular
    .module('neo.home.statistics.licenses')
    .controller('StatsLicensesCtrl', StatsLicensesCtrl);

  function StatsLicensesCtrl(AclService,$state,$filter, $mdToast, LicenceStatistics, categories, genders, seasons,townHalls, currentSeason, licenceStats) {
    var vm = this;
    vm.ctrlName = 'StatsLicensesCtrl';
     if( AclService.isAdmin()){
        townHalls.unshift({id:9999, name:'Tots', email:'', phoneNumber:0});
    }
    var personGenders = _.filter(genders, 'person', true);
    vm.townhalls = angular.copy(townHalls);
     if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      $state.current.data.townHall = vm.selectedTownHall;
    } else {
      vm.selectedTownHall = ($state.current.data.townHall) ? $state.current.data.townHall : undefined;
    }
    vm.licenceStats = licenceStats;

    vm.phases = _.uniq(_.pluck(vm.licenceStats, 'phase'));
    vm.programmes = _.uniq(_.pluck(vm.licenceStats, 'programme'));
    vm.licenseTypes = _.uniq(_.pluck(vm.licenceStats, 'licenceType'));
    vm.seasons = seasons;

    vm.selectedPhase = undefined;
    vm.selectedProgramme = undefined;
    vm.selectedLicenseType = undefined;
    vm.selectedSeasonId = currentSeason.id;


    vm.myChartObject = {
      type: 'Table',
      displayed: false,
      data: {
        cols: buildCols(categories, personGenders),
        rows: buildRows(vm.licenceStats, categories, personGenders)
      },
      options: {
        title: $filter('translate')('STATISTICS.LICENSES'),
        cssClassNames : {'headerCell': 'header-padding'}
      },
      formatters: {}
    };

    vm.changeSeason = function () {
    //    alert(vm.selectedTownHall.id);
      LicenceStatistics.query({'season_id': vm.selectedSeasonId}, function (data) {
        vm.licenceStats = data;
        vm.changeFilter();
      }, function (err) {
        var message = err.data.message || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };

    vm.changeFilter = function () {
      var filterParams = {};
      if (!_.isUndefined(vm.selectedPhase)) filterParams['phase'] = vm.selectedPhase;
      if (!_.isUndefined(vm.selectedProgramme)) filterParams['programme'] = vm.selectedProgramme;
      if (!_.isUndefined(vm.selectedLicenseType)) filterParams['licenceType'] = vm.selectedLicenseType;
      var filteredLicenceStats = _.filter(vm.licenceStats, filterParams);
      vm.myChartObject.data.rows = buildRows(filteredLicenceStats, categories, personGenders);
    };

    vm.readyHandler = function (chartWrapper) {
      vm.htmlTable = chartWrapper.getChart().getContainer().childNodes[0].childNodes[0].childNodes[0];
    };

    function buildCols(categories, personGenders) {
      var cols = [];

      cols.push({id: 'sport', label: $filter('translate')('SPORT'), type: 'string'});

      _.forEach(categories, function (c) {
        _.forEach(personGenders, function (g) {
          var l = $filter('translate')('CATEGORIES.' + c.name) + ' ' + $filter('translate')(g.name);
          cols.push({id: c.name + '_' + g.name, label: l, type: 'number'});
        })
      });

      cols.push({id: 'total', label: $filter('translate')('TOTAL'), type: 'number'});
      return cols;
    }

    function buildRows(data, categories, personGenders) {

      var rows = [];

      var sports = _.uniq(_.pluck(data, 'sport'));

      _.forEach(sports, function (s) {
        var sportName = $filter('translate')('SPORTS.' + s);
        var row = buildRow(sportName, categories, personGenders, _.filter(data, 'sport', s));
        rows.push(row);
      });
      var totalName = $filter('translate')('TOTAL');
      var totalRow = buildRow(totalName, categories, personGenders, data);

      rows.push(totalRow);
      return rows;

    }

    function buildRow(rowName, categories, personGenders, data) {
      var values = [];
      values.push({v: rowName});

      var total = 0;

      _.forEach(categories, function (c) {
        _.forEach(personGenders, function (g) {

          var predicate = {'category': c.name, 'gender': g.name};
          var licences = _.filter(data, predicate);
          var numLicenceIds = _.size(_.uniq(_.pluck(licences, 'licenceId')));

          values.push({v: numLicenceIds});
          total = total + numLicenceIds;
        })
      });
      values.push({v: total});
      return {c: values};
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.statistics.entities
   * @description
   *
   */
  angular
    .module('neo.home.statistics.entities', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.statistics.entities')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.statistics.entities', {
        url: '/entities',
        templateUrl: 'home/statistics/entities/entities.tpl.html',
        controller: 'StatsEntitiesCtrl',
        controllerAs: 'vm',
        resolve: {
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise;
          }],
          programmes: ["Programmes", function (Programmes) {
            return Programmes.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name statistics.entities.controller:EntitiesCtrl
   *
   * @description
   *
   */
  StatsEntitiesCtrl.$inject = ["$mdToast", "$filter", "categories", "genders", "entities", "seasons", "currentSeason", "LicenceStatistics", "TeamStatistics", "programmes"];
  angular
    .module('neo.home.statistics.entities')
    .controller('StatsEntitiesCtrl', StatsEntitiesCtrl);

  function StatsEntitiesCtrl($mdToast, $filter, categories, genders, entities, seasons, currentSeason, LicenceStatistics, TeamStatistics, programmes) {
    var vm = this;
    vm.ctrlName = 'StatsEntitiesCtrl';

    var personGenders = _.filter(genders, 'person', true);

    vm.licenceStats = undefined;
    vm.teamStats = undefined;

    vm.seasons = seasons;
    vm.entities = entities;
    vm.programmes = programmes;

    vm.selectedSeasonId = currentSeason.id;
    vm.selectedEntityId = undefined;
    vm.selectedProgramme = undefined;

    vm.myChartObjectPlayers = {
      type: 'Table',
      displayed: false,
      data: {
        cols: buildCols(categories, personGenders),
        rows: buildRows([], categories, personGenders)
      },
      options: {
        title: $filter('translate')('STATISTICS.PLAYER_LICENSES'),
        cssClassNames : {'headerCell': 'header-padding'}
      },
      formatters: {}
    };

    vm.myChartObjectNoPlayers = {
      type: 'Table',
      displayed: false,
      data: {
        cols: buildCols(categories, personGenders),
        rows: buildRows([], categories, personGenders)
      },
      options: {
        title: $filter('translate')('STATISTICS.NO_PLAYER_LICENSES'),
        cssClassNames : {'headerCell': 'header-padding'}
      },
      formatters: {}
    };


    vm.myChartObjectTeams = {
      type: 'Table',
      displayed: false,
      data: {
        cols: buildCols(categories, genders),
        rows: buildRows([], categories, genders)
      },
      options: {
        title: $filter('translate')('STATISTICS.ENTITY_TEAMS'),
        cssClassNames : {'headerCell': 'header-padding'}
      },
      formatters: {}
    };

    vm.changeMandatoryFilter = function () {
      if (_.isUndefined(vm.selectedSeasonId)) return;
      if (_.isUndefined(vm.selectedEntityId)) return;
      LicenceStatistics.query({'season_id': vm.selectedSeasonId, 'entity_id': vm.selectedEntityId}, function (data) {
        vm.licenceStats = data;
        TeamStatistics.query({'season_id': vm.selectedSeasonId, 'entity_id': vm.selectedEntityId}, function (data) {
          vm.teamStats = data;
          vm.changeFilter();
        }, function (err) {
          var message = err.data.message || 'ERROR_UPDATE';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
      }, function (err) {
        var message = err.data.message || 'ERROR_UPDATE';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };

    vm.changeFilter = function () {
      var preFilterParams = {};
      if (!_.isUndefined(vm.selectedProgramme)) preFilterParams['programme'] = vm.selectedProgramme;
      var preFilteredLicenceStats = _.filter(vm.licenceStats, preFilterParams);
      var filteredTeamStats = _.filter(vm.teamStats, preFilterParams);

      var filterParams = {};
      filterParams['licenceType'] = 'ATHLETE';
      var filteredLicenceStats = _.filter(preFilteredLicenceStats, filterParams);
      vm.myChartObjectPlayers.data.rows = buildRows(filteredLicenceStats, categories, personGenders);

      filteredLicenceStats = _.cloneDeep(preFilteredLicenceStats);
      _.remove(filteredLicenceStats, filterParams);
      vm.myChartObjectNoPlayers.data.rows = buildRows(filteredLicenceStats, categories, personGenders);

      vm.myChartObjectTeams.data.rows = buildRows(filteredTeamStats, categories, genders);
    };

    function buildRows(data, categories, personGenders) {

      var rows = [];

      var sports = _.uniq(_.pluck(data, 'sport'));

      _.forEach(sports, function (s) {
        var sportName = $filter('translate')('SPORTS.' + s);
        var row = buildRow(sportName, categories, personGenders, _.filter(data, 'sport', s));
        rows.push(row);
      });
      var totalName = $filter('translate')('TOTAL');
      var totalRow = buildRow(totalName, categories, personGenders, data);

      rows.push(totalRow);
      return rows;
    }

    function buildRow(rowName, categories, personGenders, data) {
      var values = [];
      values.push({v: rowName});

      var total = 0;

      _.forEach(categories, function (c) {
        _.forEach(personGenders, function (g) {

          var predicate = {'category': c.name, 'gender': g.name};
          var licences = _.filter(data, predicate);
          var numLicenceIds = _.size(_.uniq(_.pluck(licences, 'licenceId')));

          values.push({v: numLicenceIds});
          total = total + numLicenceIds;
        })
      });
      values.push({v: total});
      return {c: values};
    }

    function buildCols(categories, personGenders) {
      var cols = [];

      cols.push({id: 'sport', label: $filter('translate')('SPORT'), type: 'string'});

      _.forEach(categories, function (c) {
        _.forEach(personGenders, function (g) {
          var l = $filter('translate')('CATEGORIES.' + c.name) + ' ' + $filter('translate')(g.name);
          cols.push({id: c.name + '_' + g.name, label: l, type: 'number'});
        })
      });

      cols.push({id: 'total', label: $filter('translate')('TOTAL'), type: 'number'});
      return cols;
    }

    vm.readyPlayerHandler = function (chartWrapper) {
      vm.htmlPlayerTable = chartWrapper.getChart().getContainer().childNodes[0].childNodes[0].childNodes[0];
    };

    vm.readyNoPlayerHandler = function (chartWrapper) {
      vm.htmlNoPlayerTable = chartWrapper.getChart().getContainer().childNodes[0].childNodes[0].childNodes[0];
    };

    vm.readyTeamHandler = function (chartWrapper) {
      vm.htmlTeamTable = chartWrapper.getChart().getContainer().childNodes[0].childNodes[0].childNodes[0];
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name season
   * @description
   *
   */
  angular
  .module('neo.home.seasons.season', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.seasons.season')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.seasons.season', {
      url: '/season',
      templateUrl: 'home/seasons/season/season.tpl.html',
      controller: 'SeasonCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.seasons.season.controller:SeasonCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.seasons.season')
  .controller('SeasonCtrl', SeasonCtrl);

  function SeasonCtrl() {
    var vm = this;
    vm.ctrlName = 'SeasonCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name competicio.newSeason
   * @description
   *
   */
  angular
  .module('neo.home.seasons.newSeason', []);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.seasons.newSeason')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.seasons.newSeason', {
      url: '/new-temporada',
      templateUrl: 'home/seasons/new-season/new-season.tpl.html',
      controller: 'NewSeasonCtrl',
      controllerAs: 'vm',
      resolve: {
        acl: ["$q", "AclService", function ($q, AclService) {
          if (AclService.can('SEASON', 'C')) {
            // Has proper permissions
            return true;
          } else {
            // Does not have permission
            return $q.reject('Unauthorized');
          }
        }]
      }

    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name seasons.newTemporada.controller:NewTemporadaCtrl
   *
   * @description
   *
   */
  NewSeasonCtrl.$inject = ["$state", "$filter", "Seasons", "$mdToast", "$mdDialog"];
  angular
  .module('neo.home.seasons.newSeason')
  .controller('NewSeasonCtrl', NewSeasonCtrl);


  function NewSeasonCtrl($state, $filter, Seasons, $mdToast, $mdDialog) {
    var vm = this;
    vm.ctrlName = 'NewSeasonCtrl';
    vm.temporada = {};


    vm.confirmAlta = function (ev) {
      var confirm = $mdDialog.confirm()
      .title($filter('translate')('ALERT'))
      .textContent($filter('translate')('NEW_SEASON_ALERT'))
      .targetEvent(ev)
      .ok('Si')
      .cancel('No');

      $mdDialog.show(confirm).then(function () {
        vm.addTemporada(vm.temporada);
      }, function () {
        //S'ha cancel·lat
      });

    };

    vm.addTemporada = function (temporada) {
      if (temporada.data2 <= temporada.data1 || temporada.data2 < moment().format('YYYY-MM-DD')) {
        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')('ERROR_INVALID_DATE'))
          .position('bottom left')
          .hideDelay(3000)
        );
      }
      else {
        var temporadaToSave = {
          name: temporada.name,
          iniDate: moment(temporada.data1).format('YYYY-MM-DD'),
          endDate: moment(temporada.data2).format('YYYY-MM-DD'),
          sportMatchDay: moment(temporada.datajornadaesportiva).format('YYYY-MM-DD')
        };
        Seasons.save(temporadaToSave, function () {
            $mdToast.show(
              $mdToast.simple()
              .textContent($filter('translate')('SUCCESS_NEW_SEASON'))
              .position('bottom left')
              .hideDelay(3000)
            );
            $state.go('home.seasons', {}, {reload: true});
          },
          function (error) {
            var message;
            if (error.status === 409) {
              message = 'ERROR_INVALID_DATE';
            } else {
              message = 'ERROR_BAD_REQUEST_DATE';
            }
            $mdToast.show(
              $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
            );
          });
      }
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.referees.referee', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.referees.referee')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.referees.referee', {
      url: '/{licenseId}',
      views: {
        '': {
          templateUrl: 'home/referees/referee/referee.tpl.html',
          controller: 'RefereeCtrl',
          controllerAs: 'vm'
        }
      },
      resolve:{
        genders: ["Genders", function (Genders) {
          return Genders.query().$promise;
        }],
        entities: ["Entitats", function (Entitats) {
          return Entitats.query().$promise;
        }],
        townHalls: ["Ajuntaments", function (Ajuntaments) {
          return Ajuntaments.query().$promise;
        }],
        refereeLicense: ["RefereeLicence", "$stateParams", function (RefereeLicence,  $stateParams){
          return RefereeLicence.get({licenceId :  $stateParams.licenseId}).$promise;
    }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  RefereeCtrl.$inject = ["$mdToast", "$scope", "$state", "genders", "townHalls", "entities", "AclService", "refereeLicense", "$mdDialog", "$filter", "RefereeLicence"];
  angular
    .module('neo.home.referees.referee')
    .controller('RefereeCtrl', RefereeCtrl);

  function RefereeCtrl($mdToast, $scope, $state, genders, townHalls, entities, AclService, refereeLicense, $mdDialog, $filter, RefereeLicence) {
    var vm = this;
    vm.ctrlName = 'RefereeCtrl';
    vm.today = moment().toDate();

    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    vm.isAdmin = AclService.isAdmin;
    vm.edit = false;
    vm.personGenders = [];
    angular.forEach(genders, function(gender){
      if(gender.person) vm.personGenders.push(gender);
    });
    vm.entities = entities;
    vm.townHalls = townHalls;
    vm.license = angular.copy(refereeLicense);
    vm.person = angular.copy(vm.license.person);


    vm.updateLicense = updateLicense;
    vm.setRefereeToCouncil = setRefereeToCouncil;
    vm.setRefereeToTownhall = setRefereeToTownhall;
    vm.setRefereeToEntity = setRefereeToEntity;
    vm.initialState = {};
    vm.initialState.isTowhallSelectable = vm.isTowhallSelectable = false;
    vm.initialState.isEntitySelectable = vm.isEntitySelectable = false;
    vm.initialState.belongsToCouncil = vm.belongsToCouncil = true;
    vm.initialState.belongsToTownHall = vm.belongsToTownHall = false;
    vm.initialState.belongsToEntity = vm.belongsToEntity = false;


    if (!_.isNull(vm.license.organisationId) && angular.isDefined(vm.license.organisationId)) {
      vm.initialState.belongingTownHall = vm.belongingTownHall = angular.copy(findItemById(vm.townHalls, vm.license.organisationId));
      vm.initialState.belongingEntity = vm.belongingEntity = angular.copy(findItemById(vm.entities, vm.license.organisationId));
      vm.initialState.belongsToCouncil = vm.belongsToCouncil = false;
    }

    if (angular.isDefined(vm.belongingTownHall)) vm.initialState.belongsToTownHall = vm.belongsToTownHall = true;
    if (angular.isDefined(vm.belongingEntity)) vm.initialState.belongsToEntity = vm.belongsToEntity = true;

    function resetState() {
      vm.isTowhallSelectable = vm.initialState.isTowhallSelectable;
      vm.isEntitySelectable = vm.initialState.isEntitySelectable;
      vm.belongsToCouncil = vm.initialState.belongsToCouncil;
      vm.belongsToTownHall = vm.initialState.belongsToTownHall;
      vm.belongsToEntity = vm.initialState.belongsToEntity;
      vm.belongsToTownHall = vm.initialState.belongingTownHall;
      vm.belongingEntity = vm.initialState.belongingEntity
    }

    function setRefereeToCouncil() {
      vm.belongsToCouncil = true;
      vm.belongsToTownHall = false;
      vm.isTowhallSelectable = false;
      vm.selectedTownhall = undefined;
    }

    function setRefereeToTownhall() {
      vm.belongsToTownHall = true;
      vm.belongsToCouncil = false;
      vm.belongsToEntity = false;
      vm.isEntitySelectable = false;
      vm.selectedEntity = undefined;
      vm.isTowhallSelectable = true;
      if (angular.isDefined(vm.belongingTownHall)) {
        vm.selectedTownhall = vm.belongingTownHall;
        if (vm.townHalls.length === 1) {
          vm.isTowhallSelectable = false;
        }
      }
      else if (vm.townHalls.length === 1) {
        vm.selectedTownhall = vm.townHalls[0];
        vm.isTowhallSelectable = false;
      }
    }

    function setRefereeToEntity() {
      vm.belongsToEntity = true;
      vm.belongsToTownHall = false;
      vm.selectedTownhall = undefined;
      vm.isEntitySelectable = true;
      if (angular.isDefined(vm.belongingEntity)) {
        vm.selectedEntity = vm.belongingEntity;
        if (vm.entities.length === 1) {
          vm.isEntitySelectable = false;
        }
      }
      else if (vm.entities.length === 1) {
        vm.selectedEntity = vm.entities[0];
        vm.isEntitySelectable = false;
      }
    }

    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'ACTIONS',
      actions: [{
        icon: 'edit',
        tooltip: 'EDIT',
        execute: enableEdit
      }, {
        icon: 'delete',
        attrClass: 'md-warn',
        tooltip: 'DELETE',
        execute: deleteLicence
      }, {
        icon: 'timer',
       
        tooltip: 'Partits arbitrats',
        execute: partitsarb
      }]
    };
    function partitsarb(){
         $state.go('home.refereeNewInvoice', {licenseId: vm.license.id});
    }
    function enableEdit() {
      if (vm.belongsToCouncil) setRefereeToCouncil();
      else if (vm.belongsToTownHall) setRefereeToTownhall();
      else setRefereeToEntity();
      vm.edit = true;
      vm.buttons.dial = false;
    }

    function deleteLicence() {
      RefereeLicence.remove({licenceId: refereeLicense.id}, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('REFEREES.SUCCESSFUL_DELETE'))
              .position('bottom left')
              .hideDelay(3000));
          $state.go('home.referees');
        },
        function (err) {
          var message = err.data.message || 'PEOPLE.ERROR_DELETE';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    vm.disableEdit = function () {
      resetState();
      vm.edit = false;
      vm.license = angular.copy(refereeLicense);
      vm.person = angular.copy(vm.license.person);
      vm.buttons.dial = true;
      $scope.refereeForm.$setUntouched();
      $scope.refereeForm.$setPristine();
      $scope.refereeForm.$setValidity();
    };

    function getSelectedOrganisationId() {
      if (vm.belongsToCouncil) return null;
      if (vm.belongsToTownHall) return vm.selectedTownhall.id;
      else return vm.selectedEntity.id;
    }

    function updateLicense() {
      var selectedOrganisationId = getSelectedOrganisationId();
      if (selectedOrganisationId !== refereeLicense.organisationId) {

        var confirm = $mdDialog.confirm()
          .title($filter('translate')('ALERT'))
          .textContent($filter('translate')('REFEREES.MODIFY_BELONGING_CONFIRMATION'))
          .ok($filter('translate')('YES'))
          .cancel($filter('translate')('NO'));

        $mdDialog.show(confirm).then(function () {
          callEdit();
        }, function () {
          $mdDialog.cancel();
        })
      }
      else {
        callEdit();
      }
    }

    function callEdit() {
      var newRefereeLicensePutObject = {
        organisationId: getSelectedOrganisationId(),
        iban: vm.license.iban,
        person: {
          id: vm.person.id,
          name: vm.person.name,
          surname: vm.person.surname,
          secondSurname: vm.person.secondSurname,
          genderId: vm.person.genderId,
          bornDate: parseDate(vm.person.bornDate),
          nif: vm.person.nif,
          healthInsuranceCardNumber: vm.person.healthInsuranceCardNumber,
          email: vm.person.email,
          address: vm.person.address,
          town: vm.person.town,
          zipCode: vm.person.zipCode
        }
      };
      RefereeLicence.update({licenceId: refereeLicense.id}, newRefereeLicensePutObject, vm.successfulPersonEdition, vm.errorInPersonAddition);
    }

    vm.successfulPersonEdition = function () {
      $state.go('home.referees', {reload: true});
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('PEOPLE.SUCCESSFUL_UPDATE'))
          .position('bottom left')
          .hideDelay(3000)
      );
    };


    function parseDate(date) {
      return moment(date).format('YYYY-MM-DD');
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.newReferee
   * @description
   *
   */
  angular
    .module('neo.home.referees.newReferee', [
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.referees.newReferee')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.referees.newReferee', {
        url: '/new',
        templateUrl: 'home/referees/new-referee/new-referee.tpl.html',
        controller: 'NewRefereeCtrl',
        controllerAs: 'vm',
        resolve: {
          entities: ["AclService", "Entitats", function(AclService, Entitats){
            if(!AclService.isAdmin()){
              return Entitats.query().$promise;
            }
            else return undefined;
          }],
          licenseTypes: ["LicenseTypes", function (LicenseTypes) {
            return LicenseTypes.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.newReferee.controller:NewRefereeCtrl
   *
   * @description
   *
   */
  NewRefereeCtrl.$inject = ["AclService", "townHalls", "entities", "licenseTypes", "genders", "DuplicatedPerson", "$mdDialog", "$mdToast", "PersonLicense", "RefereeLicence", "$state", "sports", "$filter"];
  angular
  .module('neo.home.referees.newReferee')
  .controller('NewRefereeCtrl', NewRefereeCtrl);

  function NewRefereeCtrl(AclService, townHalls, entities, licenseTypes, genders, DuplicatedPerson, $mdDialog, $mdToast, PersonLicense, RefereeLicence, $state, sports,$filter) {
    var vm = this;
    vm.ctrlName = 'NewRefereeCtrl';
    vm.today = moment().toDate();
    vm.personGenders = _.filter(genders, 'person');
    vm.referee = undefined;
    vm.isAdmin = AclService.isAdmin;
    vm.townHalls = townHalls;
    vm.entities = entities;
    vm.setRefereeToCouncil = setRefereeToCouncil;
    vm.setRefereeToTownhall = setRefereeToTownhall;
    vm.setRefereeToEntity = setRefereeToEntity;
    vm.isTowhallSelectable = false;
    vm.isEntitySelectable = false;
    vm.belongsToCouncil = true;
    vm.belongsToTownHall = false;
    vm.belongsToEntity = false;
    vm.lopd = false;

    if (!vm.isAdmin()) {
      vm.isTowhallSelectable = true;
      if (vm.townHalls.length === 1) {
        vm.selectedTownhall = angular.copy(vm.townHalls[0]);
        vm.isTowhallSelectable = false;
      }
      vm.belongsToTownHall = true;
      vm.belongsToCouncil = false;
    }


    function setRefereeToCouncil() {
      vm.belongsToCouncil = true;
      vm.belongsToTownHall = false;
      vm.isTowhallSelectable = false;
      vm.selectedTownhall = undefined;
    }

    function setRefereeToTownhall() {
      vm.belongsToTownHall = true;
      vm.belongsToCouncil = false;
      vm.belongsToEntity = false;
      vm.isEntitySelectable = false;
      vm.selectedEntity = undefined;
      vm.isTowhallSelectable = true;
      if (angular.isDefined(vm.townHalls)) {
        if (vm.townHalls.length === 1) {
          vm.selectedTownhall = angular.copy(vm.townHalls[0]);
          vm.isTowhallSelectable = false;
        }
      }
    }

    function setRefereeToEntity() {
      vm.belongsToEntity = true;
      vm.belongsToTownHall = false;
      vm.selectedTownhall = undefined;
      vm.isEntitySelectable = true;
      if (angular.isDefined(vm.entities)) {
        if (vm.entities.length === 1) {
          vm.selectedEntity = angular.copy(vm.entities[0]);
          vm.isEntitySelectable = false;
        }
      }
    }


    function parseDate(date) {
      return moment(date).format('YYYY-MM-DD');
    }

    vm.saveReferee = function () {
      DuplicatedPerson.query({
        name: vm.person.name,
        surname: vm.person.surname,
        bornDate: parseDate(vm.person.bornDate)
      }, function (data) {
        if (data.length > 0) {
          $mdDialog.show({
            controller: 'DuplicateDialogCtrl',
            templateUrl: 'home/persons/new-person/duplicate-dialog.tpl.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
              duplicatedPersons: data,
              licenses: licenseTypes,
              sports: sports
            }
          }).then(function (personId) {
            if (angular.isDefined(personId)) {
              assignLicenceToPerson(personId);
            } else {
              vm.createPerson();
            }
          });
        } else {
          vm.createPerson();
        }
      }, function (err) {
      });
    };


    function assignLicenceToPerson(personId) {
      var organisationId = getSelectedOrganisationId();
      PersonLicense.save( {personId: personId, team: false}, {licenceTypeId: 4, organisationId: organisationId, iban: null},
        vm.successfulPersonAddition,
      function (err) {

      });
    }

    function getSelectedOrganisationId() {
      if (vm.belongsToCouncil) return null;
      if (vm.belongsToTownHall) return vm.selectedTownhall.id;
      else return vm.selectedEntity.id;
    }





    vm.createPerson = function () {
      var newRefereeLicensePostObject = {
        licenceTypeId: 4,
        organisationId: getSelectedOrganisationId(),
        iban: vm.person.iban,
        person: {
          name: vm.person.name,
          surname: vm.person.surname,
          secondSurname: vm.person.secondSurname,
          genderId: vm.person.genderId,
          bornDate: parseDate(vm.person.bornDate),
          nif: vm.person.nif,
          healthInsuranceCardNumber: vm.person.healthInsuranceCardNumber,
          email: vm.person.email,
          address: vm.person.address,
          town: vm.person.town,
          zipCode: vm.person.zipCode
        }
      };
      RefereeLicence.save(newRefereeLicensePostObject, vm.successfulPersonAddition, vm.errorInPersonAddition);
    };


    vm.successfulPersonAddition = function(){
      $state.go('home.referees', {reload: true});
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')('REFEREES.SUCCESSFUL_CREATE'))
        .position('bottom left')
        .hideDelay(3000)
      );
    };

    vm.errorInPersonAddition = function(err){
      var errorMessage;
      if (err.status === 400) {
        errorMessage = err.data.message || 'BAD_REQUEST_PERSON';
      } else if (err.status === 409) {
        errorMessage = 'PEOPLE.EXISTING_PERSON';
      } else {
        errorMessage = 'SERVER_ERROR';
      }
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')(errorMessage))
        .position('bottom left')
        .hideDelay(3000)
      );
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.newline',['ui.router']);
}());


(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.newline')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.new-line', {
      url: '/referee-new-invoice/new-line/{licenseId}/inv',
     
          templateUrl: 'home/referee-new-invoice/new-line/new-line.tpl.html',
          controller: 'RefereeNewLine',
          controllerAs: 'vm'
        ,
      resolve:{
       
        refereeLicense: ["RefereeLicence", "$stateParams", function (RefereeLicence,  $stateParams){
          return RefereeLicence.get({licenceId :  $stateParams.licenseId}).$promise;
    }],
    refId:["$stateParams", function ($stateParams){
        return $stateParams.licenseId;
    }],
    Receptores: ["receptores", "$stateParams", function(receptores,$stateParams){
        return receptores.query();
    }]
      }
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  RefereeNewLine.$inject = ["$mdToast", "$scope", "$state", "AclService", "refereeLicense", "$mdDialog", "$filter", "RefereeLicence", "refId", "InvoiceRef", "Receptores"];
  angular
    .module('neo.home.refereeNewInvoice.newline')
    .controller('RefereeNewLine', RefereeNewLine);

  function  RefereeNewLine($mdToast, $scope, $state,  AclService, refereeLicense, $mdDialog, $filter, RefereeLicence, refId, InvoiceRef,Receptores) {
   var vm = this;
    vm.ctrlName = 'RefereeNewLine';
    
    vm.person=refereeLicense.person;
 vm.today=new Date();
 
  $scope.receptores=Receptores;
 $scope.sel=1;
 
  var linea={
       idref: refId,
      fecha:'',
      esport:'',
      numpartits: 0,
      preu:0,sinirpf:false,sintexto:false,idreceptor:1
            };
  
      vm.createLinea = function () {
      var r=vm.linea.preu.replace(",",".");
      vm.linea.esport=vm.linea.esport.substring(0,80);
      var sin='0';
      if (vm.linea.sinirpf){
          sin='1';
      }
       var sint='0';
      if (vm.linea.sintexto){
          sint='1';
      }
      
      linea = {
      idref: refId,
      fecha:parseDate(vm.linea.fecha),
      esport:vm.linea.esport,
      numpartits: vm.linea.numpartits,
      preu:r,
      sinirpf: sin,sintexto:sint,idreceptor:$scope.selectreceptor.idReceptor
      
        };
    
     InvoiceRef.save({Id: refId},linea);
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('Linia creada'))
          .position('bottom left')
          .hideDelay(6000)
      );   
      setTimeout( function() { $state.go('home.refereeNewInvoice', {licenseId: refId}, {reload: true, notify:true});},3000);
     
      };
      
   function parseDate(date) {
      return moment(date).format('YYYY-MM-DD');
    }
  }
}());





(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.line',['ui.router']);
}());


(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.line')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.line', {
      url: '/referee-new-invoice/line/{licenceId}/inv/{lineId}',
     
          templateUrl: 'home/referee-new-invoice/line/line.tpl.html',
          controller: 'RefereeLine',
          controllerAs: 'vm'
        ,
      resolve:{
       
        refereeLicense: ["RefereeLicence", "$stateParams", function (RefereeLicence,  $stateParams){
          return RefereeLicence.get({licenceId :  $stateParams.licenceId}).$promise;
    }],
    refId:["$stateParams", function ($stateParams){
        return $stateParams.licenceId;
    }],
    lineId:["$stateParams", function ($stateParams){
        return $stateParams.lineId;
    }],
    lineread:["InvoiceRefLine", "$stateParams", function (InvoiceRefLine,  $stateParams){
          return InvoiceRefLine.get({lineId :  $stateParams.lineId}).$promise;
      }],
    Receptores: ["receptores", "$stateParams", function(receptores,$stateParams){
        return receptores.query();
    }]
      }});
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  RefereeLine.$inject = ["$mdToast", "$scope", "$state", "AclService", "refereeLicense", "$mdDialog", "$filter", "RefereeLicence", "refId", "lineId", "lineread", "InvoiceRef", "InvoiceRefLine", "Receptores"];
  angular
    .module('neo.home.refereeNewInvoice.line')
    .controller('RefereeLine', RefereeLine);

  function  RefereeLine($mdToast, $scope, $state,  AclService, refereeLicense, $mdDialog, $filter, RefereeLicence, refId,lineId, lineread,InvoiceRef,InvoiceRefLine,Receptores) {
   var vm = this;
    vm.ctrlName = 'RefereeLine';
  
      $scope.receptores=Receptores;
 $scope.sel=1;
    vm.person=refereeLicense.person;

  var linea={
       idref: refId,
      fecha:'' ,
      esport:'',
      numpartits: 0,
      preu:0,sinirpf:0,sintexto:0,idreceptor:1
            };
     $scope.fecha=lineread.fecha;
     $scope.esport=lineread.esport;
     $scope.numpartits=lineread.numpartits;
     $scope.preu=lineread.preu;
     $scope.numinvoice=lineread.numinvoice;
     $scope.selectreceptor=lineread.idreceptor;
     $scope.sel=lineread.idreceptor;
       if (lineread.sinirpf==='1'){
          $scope.sinirpf=true;
       }
       
          if (lineread.sintexto==='1'){
          $scope.sintexto=true;
       }
  
      vm.createLinea = function () {
          var sir=0;
          if($scope.sinirpf){
              sir=1;
          }
           var sirt=0;
          if($scope.sintexto){
              sirt=1;
          }
      linea = {
      id:lineId,
      idref: refId,
      fecha:parseDate( $scope.fecha),
      esport: $scope.esport,
      numpartits:  $scope.numpartits,
      preu:$scope.preu, sinirpf:sir,sintexto:sirt,idreceptor:$scope.selectreceptor.idReceptor
      
        };
    
     InvoiceRef.update({Id: refId},linea);
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('Linia creada'))
          .position('bottom left')
          .hideDelay(6000)
      );   
      
     setTimeout( function() {$state.go('home.refereeNewInvoice', {licenseId: refId}, {reload: true});},4000);
     
      };
      
   function parseDate(date) {
      return moment(date).format('YYYY-MM-DD');
    }
    
     vm.esborrar=function(){
        var ret= confirm("Segur que vol esborrar aquesta linea?");
        if (ret) {InvoiceRefLine.delete({lineId: lineId});  
              $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('Linia esborrada'))
          .position('bottom left')
          .hideDelay(6000)
      );   
      
     setTimeout( function() {$state.go('home.refereeNewInvoice', {licenseId: refId}, {reload: true});},4000);
        }
     };
  }
}());





(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.invoicestrimestral',['ui.router']);
}());


(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.invoicestrimestral')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.invoicestrimestral', {
      url: '/referee-new-invoice/invoicestrimestral',
     
          templateUrl: 'home/referee-new-invoice/invoices-trimestral/invoices-trimestral.tpl.html',
          controller: 'invoicestrimestral',
          controllerAs: 'vm',
        resolve:{
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
       
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  invoicestrimestral.$inject = ["AclService", "Invoicesgrouptrimestral", "townHalls", "$mdToast", "$filter", "$scope", "$state", "excel", "$timeout", "$mdDialog"];
  angular
    .module('neo.home.refereeNewInvoice.invoicestrimestral')
    .controller('invoicestrimestral', invoicestrimestral);

  function invoicestrimestral(AclService,Invoicesgrouptrimestral,townHalls, $mdToast, $filter, $scope, $state,excel, $timeout, $mdDialog) {
    var vm = this;
     var organisationList = angular.copy(townHalls);
    vm.isAdm=AclService.isAdmin();
    vm.applyFilters = applyFilters;
    var indexPersones=[];
    vm.llistatpersones=[];
    vm.llistatpersones1=[];
     var llistatpersones2=[];
     var llistatpersones3=[];
     var llistatpersones4=[];
    
      vm.matches = [];
    vm.selected = [];
    vm.select = undefined;
    vm.dis=true;
    var template;
        
     
    function applyFilters() {
      vm.isFiltered = true;
      
      var a= moment(vm.iniDate).format('YYYY');
      query1( "01/01/"+a, "12/31/"+a);
     
    }
    
 
    
     function query1( iniDate, endDate) {
          var parameters = {
                initDate: moment(iniDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
                isAdmin:AclService.isAdmin(),
                idAjuntament:townHalls[0].id
      };
     
     vm.llistatpersones=Invoicesgrouptrimestral.query(parameters);
   
     }
     
    
     
      
     
     
      $scope.exportToExcel=function(tableId){ // ex: '#my-table'
            var exportHref=excel.tableToExcel(tableId,'name');
            $timeout(function(){location.href=exportHref;},100); // trigger download
        };
    vm.imprimir=function(){
        var trato="";
        var c=0;
        
         angular.forEach(vm.llistatpersones, function (persona) {
          if (persona.selected) {
           trato=trato+"-"+persona.numinvoice+"/"+persona.idreferee;
            c++;
          
                 vm.persona=persona;
            // $scope.$watch(persona, function(e) { vm.persona = persona; });
            
             var url =    $state.href('home.invoiceref', {personId: persona.idreferee,numinvoice:persona.numinvoice},{reload:true});
            // var printWin = window.open(url, '');
   //   printWin.document.write(s);
      
  //  printWin.document.write(template);
  //  printWin.document.close();
            var p=    window.open(url,'');
            
            
                 template = document.getElementById('invoicePrintPreview').innerHTML;
                 
   
       
            
 // var printWin = window.open('', '');
   //   printWin.document.write(s);
      
  //  printWin.document.write(template);
  //  printWin.document.close();
      //printWin.onload = function () {
      
          }
          
        });
        if (c===0) {alert("Si us plau, selecciona al menys una factura per imprimir");vm.dis=true;}
      
    };
    vm.enable=function(){
         vm.dis=false;
    };
  }
}());






(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.invoiceslist',['ui.router']);
}());




(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.invoiceslist')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.invoiceslist', {
      url: '/referee-new-invoice/invoiceslist',
     
          templateUrl: 'home/referee-new-invoice/invoices-list/invoices-list.tpl.html',
          controller: 'invoiceslist',
          controllerAs: 'vm',
        resolve:{
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
       
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  invoiceslist.$inject = ["AclService", "Invoices", "townHalls", "$mdToast", "$filter", "$scope", "$state", "excel", "$timeout", "$mdDialog"];
  angular
    .module('neo.home.refereeNewInvoice.invoiceslist')
    .controller('invoiceslist', invoiceslist);

  function invoiceslist(AclService,Invoices,townHalls, $mdToast, $filter, $scope, $state,excel, $timeout, $mdDialog) {
    var vm = this;
    
      vm.townhalls = angular.copy(townHalls);
    vm.isAdm=AclService.isAdmin();
    vm.applyFilters = applyFilters;
    vm.llistatpersones=[];
      vm.matches = [];
    vm.selected = [];
    vm.select = undefined;
      vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'ACTIONS',
      actions: [{
        icon: 'euro_symbol',
        tooltip: 'Facturar',
        execute: facturar
      }]
    };
     if (vm.townhalls.length === 1) {
       vm.selectedTownHall = vm.townhalls[0];
       vm.isCorn=(vm.selectedTownHall.id===16) || (vm.selectedTownHall.id===20);
    } 
    
   
     function facturar(){
       var idfact="";
       var diferents= vm.llistatpersones[0].idreceptor;
       var diforigin=true;
       var i=0;
         angular.forEach(vm.llistatpersones, function (persona) {
            
          if (persona.selected) {
              if(i===0){
                  diferents=persona.idreceptor;
              }
              i=i+1;
              idfact=idfact+persona.idinvoice+",";
               if(persona.idreceptor!==diferents){
                 diforigin=false;
             }
          }
         
      });
      idfact=idfact.substring(0,idfact.length-1);
  
         if(idfact.length===0){
             alert("Si us plau, has de seleccionar al menys una linea");
         }else{
             if (diforigin){
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Estas segur/a de voler emetre les factures dels Tutors?')
          .textContent('Es generaran les factures dels partits pendents de facturar.')
          .ariaLabel('NEO')
          
          .ok('Si')
          .cancel('No');

    $mdDialog.show(confirm).then(function() {
        $state.go('home.facturar', {fechaini: moment(vm.iniDate).format('YYYY-MM-DD'),fechafin:moment(vm.endDate).format('YYYY-MM-DD'), idAjuntament:vm.selectedTownHall.id,ids:idfact});
    }, function() {
    
    });
         }else{
             alert("No es pot facturar en una mateixa factura 2 receptors diferents.");
         }
         }
  };
     
     
     
    function applyFilters() {
      vm.isFiltered = true;
      query( vm.iniDate, vm.endDate);
    }
    
     function query( iniDate, endDate) {
          var parameters = {
                initDate: moment(iniDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
                isAdmin:AclService.isAdmin(),
                idAjuntament:vm.selectedTownHall.id
      };
      var an1=moment(iniDate).format('YYYY');
      var an2=moment(endDate).format('YYYY');
      if (an1===an2){
     vm.llistatpersones=Invoices.query(parameters);}
     else{
         alert("No es poden consultar dades de diferents anys.")
     }
     
     }
     
      $scope.exportToExcel= ((function() {
          var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
          return function(table, name) {
            table = document.getElementById(table);
            var ctx = {worksheet: name || 'Report', table: table.innerHTML};
            window.location.href = uri + base64(format(template, ctx));
          }
        })())
        
        
 

  

 

  }
}());



(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.invoicesgroup',['ui.router']);
}());




(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.invoicesgroup')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.invoicesgroup', {
      url: '/referee-new-invoice/invoicesgroup',
     
          templateUrl: 'home/referee-new-invoice/invoices-group/invoices-group.tpl.html',
          controller: 'invoicesgroup',
          controllerAs: 'vm',
        resolve:{
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
       
    }).
      state('home.invoiceref',{
          url: '/referee-new-invoice/invoice/{personId}/{numinvoice}/{anyo}',
          templateUrl: 'home/referee-new-invoice/invoices-group/invoice.html',
          controller: 'invoiceprint',
          controllesAs:'vm',
          resolve:{
              personId:["$stateParams", function ( $stateParams){
          return  $stateParams.personId;
    }],
             numinvoice:["$stateParams", function ( $stateParams){
          return $stateParams.numinvoice;
    }],
             anyo:["$stateParams", function ( $stateParams){
          return $stateParams.anyo;
    }],
             personafact:["RefereeLicence", "$stateParams", function (RefereeLicence,$stateParams){
           return RefereeLicence.get({licenceId:$stateParams.personId}).$promise;
    }],
             lineesfact:["InvoiceLines", "$stateParams", function ( InvoiceLines,$stateParams){
           return InvoiceLines.query({Id:$stateParams.personId, invoiceid:$stateParams.numinvoice,anyo:$stateParams.anyo}).$promise;
    }],
    Receptores: ["receptores", "$stateParams", function(receptores,$stateParams){
        return receptores.query();}]
          }
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  invoicesgroup.$inject = ["AclService", "Invoicesgroup", "townHalls", "$mdToast", "$filter", "$scope", "$state", "excel", "$timeout", "$mdDialog"];
  angular
    .module('neo.home.refereeNewInvoice.invoicesgroup')
    .controller('invoicesgroup', invoicesgroup);

  function invoicesgroup(AclService,Invoicesgroup,townHalls, $mdToast, $filter, $scope, $state,excel, $timeout, $mdDialog) {
    var vm = this;
     var organisationList = angular.copy(townHalls);
    vm.isAdm=AclService.isAdmin();
    vm.applyFilters = applyFilters;
    vm.llistatpersones=[];
      vm.matches = [];
    vm.selected = [];
    vm.select = undefined;
    vm.dis=true;
    var template;
        
     
    function applyFilters() {
      vm.isFiltered = true;
      query( vm.iniDate, vm.endDate);
    }
    
     function query( iniDate, endDate) {
          var parameters = {
                initDate: moment(iniDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
                isAdmin:AclService.isAdmin(),
                idAjuntament:townHalls[0].id
      };
       var an1=moment(vm.iniDate).format('YYYY');
       var an2=moment(vm.endDate).format('YYYY');
       if(an1===an2){
     vm.llistatpersones=Invoicesgroup.query(parameters);
 }
 else{
     alert("No es poden consultar dades de diferents anys.")
 }
    
     }
     
      $scope.exportToExcel=function(tableId){ // ex: '#my-table'
            var exportHref=excel.tableToExcel(tableId,'name');
            $timeout(function(){location.href=exportHref;},100); // trigger downloa
        };
    vm.imprimir=function(){
        var trato="";
        var c=0;
        
         angular.forEach(vm.llistatpersones, function (persona) {
          if (persona.selected) {
           trato=trato+"-"+persona.numinvoice+"/"+persona.idreferee;
            c++;
         
                 vm.persona=persona;
            // $scope.$watch(persona, function(e) { vm.persona = persona; });
            var an=moment(vm.iniDate).format('YYYY');
             var url =    $state.href('home.invoiceref', {personId: persona.idreferee,numinvoice:persona.numinvoice,anyo:an},{reload:true});
            // var printWin = window.open(url, '');
   //   printWin.document.write(s);
      
  //  printWin.document.write(template);
  //  printWin.document.close();
  //url='http://localhost:3000/#/home/referee-new-invoice/invoice/19/1/2020';
 
  var windowFeatures = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes";
            var p=    window.open(url,'');
            
            
                 template = document.getElementById('invoicePrintPreview').innerHTML;
                 
   
       
            
 // var printWin = window.open('', '');
   //   printWin.document.write(s);
      
  //  printWin.document.write(template);
  //  printWin.document.close();
      //printWin.onload = function () {
      
          }
          
        });
        if (c===0) {alert("Si us plau, selecciona al menys una factura per imprimir");vm.dis=true;}
      
    };
    vm.enable=function(){
         vm.dis=false;
    };
  }
}());



(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.invoicegroup.invoice',['ui.router']);
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  invoiceprint.$inject = ["AclService", "$scope", "$state", "personafact", "lineesfact", "Receptores"];
  angular
    .module('neo.home.refereeNewInvoice.invoicegroup.invoice')
    .controller('invoiceprint', invoiceprint);

  function invoiceprint( AclService,$scope, $state,  personafact,lineesfact,Receptores) {
     
   var vm = this;
    vm.isAdm=AclService.isAdmin();
    vm.ctrlName = 'invoiceprint';
   vm.lineesfact=lineesfact;
  
    var base;
          var  s="<style>"+
"* {"+
	"border: 0;"+
	"box-sizing: content-box;"+
	"color: inherit;"+
	"font-family: inherit;"+
	"font-size: inherit;"+
	"font-style: inherit;"+
	"font-weight: inherit;"+
	"line-height: inherit;"+
	"list-style: none;"+
	"margin: 0;"+
	"padding: 0;"+
	"text-decoration: none;"+
	"vertical-align: top;"+
"}"+

/* content editable */

"*[contenteditable] { border-radius: 0.25em; min-width: 1em; outline: 0; }"+

"*[contenteditable] { cursor: pointer; }"+

"*[contenteditable]:hover, *[contenteditable]:focus, td:hover *[contenteditable], td:focus *[contenteditable], img.hover { background: #DEF; box-shadow: 0 0 1em 0.5em #DEF; }"+

"span[contenteditable] { display: inline-block; }"+

/* heading */

"h1 { font: bold 100% sans-serif; letter-spacing: 0.5em; text-align: center; text-transform: uppercase; }"+

/* table */

"table { font-size: 75%; table-layout: fixed; width: 100%; }"+
"table { border-collapse: separate; border-spacing: 2px; }"+
"th, td { border-width: 1px; padding: 0.5em; position: relative; text-align: left; }"+
"th, td { border-radius: 0.25em; border-style: solid; }"+
"th { background: #EEE; border-color: #BBB; }"+
"td { border-color: #DDD; }"+

/* page */

"html { font: 16px/1 'Open Sans', sans-serif; overflow: auto; padding: 0.5in; }"+
"html { background: #999; cursor: default; }"+

"body { box-sizing: border-box; height: 11in; margin: 0 auto; overflow: hidden; padding: 0.5in; width: 8.5in; }"+
"body { background: #FFF; border-radius: 1px; box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5); }"+

/* header */

"header { margin: 0 0 3em; }"+
"header:after { clear: both; content: \"\"; display: table; }"+

"header h1 { background: #000; border-radius: 0.25em; color: #FFF; margin: 0 0 1em; padding: 0.5em 0; }"+
"header address { float: left; font-size: 75%; font-style: normal; line-height: 1.25; margin: 0 1em 1em 0; }"+
"header address p { margin: 0 0 0.25em; }"+
"header span, header img { display: block; float: right; }"+
"header span { margin: 0 0 1em 1em; max-height: 25%; max-width: 60%; position: relative; }"+
"header img { max-height: 100%; max-width: 100%; }"+
"header input { cursor: pointer; -ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\"; height: 100%; left: 0; opacity: 0; position: absolute; top: 0; width: 100%; }"+

/* article */

"article, article address, table.meta, table.inventory { margin: 0 0 3em; }"+
"article:after { clear: both; content: \"\"; display: table; }"+
"article h1 { clip: rect(0 0 0 0); position: absolute; }"+

"article address { float: left; font-size: 100%; font-weight: normal; }"+

/* table meta & balance */

"table.meta, table.balance { float: right; width: 36%; }"+
"table.meta:after, table.balance:after { clear: both; content: \"\"; display: table; }"+

/* table meta */

"table.meta th { width: 60%; }"+
"table.meta td { width: 40%; }"+

/* table items */

"table.inventory { clear: both; width: 100%; }"+
/*"table.inventory th { font-weight: bold; text-align: center; }"+*/

"table.inventory th:nth-child(1) { text-align:  center;width: 64%;font-weight: bold;  }"+
"table.inventory th:nth-child(2) { text-align:  center; width: 12%; font-weight: bold; }"+
"table.inventory th:nth-child(3) { text-align:  center; width: 12%;font-weight: bold;  }"+
"table.inventory th:nth-child(4) { text-align:  center; width: 12%;font-weight: bold;  }"+


"table.inventory td:nth-child(1) { width: 64%; }"+
"table.inventory td:nth-child(2) { text-align: right; width: 12%; }"+
"table.inventory td:nth-child(3) { text-align: right; width: 12%; }"+
"table.inventory td:nth-child(4) { text-align: right; width: 12%; }"+

/* table balance */

"table.balance th, table.balance td { width: 50%; }"+
"table.balance td { text-align: right; }"+

/* aside */

"aside h1 { border: none; border-width: 0 0 1px; margin: 0 0 1em; }"+
"aside h1 { border-color: #999; border-bottom-style: solid; }"+

/* javascript */

".add, .cut"+
"{"+
	"border-width: 1px;"+
	"display: block;"+
	"font-size: .8rem;"+
	"padding: 0.25em 0.5em;	"+
	"float: left;"+
	"text-align: center;"+
	"width: 0.6em;"+
"}"+

".add, .cut"+
"{"+
	"background: #9AF;"+
	"box-shadow: 0 1px 2px rgba(0,0,0,0.2);"+
	"background-image: -moz-linear-gradient(#00ADEE 5%, #0078A5 100%);"+
	"background-image: -webkit-linear-gradient(#00ADEE 5%, #0078A5 100%);"+
	"border-radius: 0.5em;"+
	"border-color: #0076A3;"+
	"color: #FFF;"+
	"cursor: pointer;"+
	"font-weight: bold;"+
	"text-shadow: 0 -1px 2px rgba(0,0,0,0.333);"+
"}"+

".add { margin: -2.5em 0 0; }"+

".add:hover { background: #00ADEE; }"+

".cut { opacity: 0; position: absolute; top: 0; left: -1.5em; }"+
".cut { -webkit-transition: opacity 100ms ease-in; }"+

"tr:hover .cut { opacity: 1; }"+

"@media print {"+
	"* { -webkit-print-color-adjust: exact; }"+
	"html { background: none; padding: 0; }"+
	"body { box-shadow: none; margin: 0; }"+
	"span:empty { display: none; }"+
	".add, .cut { display: none; }"+
"}"+

"@page { margin: 0; }"+
"</style>";
 if (personafact.person.name==null){personafact.person.name="";}
  if (personafact.person.surname==null){personafact.person.surname="";}
   if (personafact.person.secondSurname==null){personafact.person.secondSurname="";}
   if (personafact.person.nif==null){personafact.person.nif="";}
     if (personafact.person.address==null){personafact.person.address="";}
      if (personafact.person.town==null){personafact.person.town="";} 
      if (personafact.person.zipCode==null){personafact.person.zipCode="";}
     
     var recept=Receptores;
    $scope.persona2=personafact;
     var r=0;
      for(var j=0;j<recept.length;j++){
       
        if(recept[j].idReceptor===lineesfact[0].idreceptor){
            r=j;
        }
    }
    var renombre=recept[r].nombre;
    var redireccion=recept[r].direccion;
    var redireccion2=recept[r].direccion2;
    var renif=recept[r].nif;
    var retelf=recept[r].telf;
    
    var date=new Date(vm.lineesfact[0].datafact);
    var day = date.getDate();
  var monthIndex = date.getMonth()+1;
  var year = date.getFullYear();
  var fecha=day+"/"+monthIndex+"/"+year;
 
  base=vm.lineesfact[0].total;
   var irpf3=0;
   if (vm.lineesfact[0].sinirpf!=='1'){
           irpf3=irpf3+0.15*base;}
  for(var i=0;i<vm.lineesfact.length-1;i++){
        
        document.querySelector('table.inventory tbody').appendChild(generateTableRow(vm.lineesfact[i+1],personafact));
           base=base+vm.lineesfact[i+1].total;
           if (vm.lineesfact[i+1].sinirpf!=='1'){
           irpf3=irpf3+0.15*vm.lineesfact[i+1].total;}
    }
    var concepte0=vm.lineesfact[0].esport+" competició JJEE de "+personafact.organisationName+" ";
    
    if (vm.lineesfact[0].sintexto==='1'){
           concepte0=vm.lineesfact[0].esport+" ";
    }
       
      // var irpf=0.15*base;
       var irpf=irpf3;
       var t=irpf.toFixed(2);
       var total=base-t;
       
        var template = document.getElementById('divaprint').innerHTML.replace("persona2.name",personafact.person.name.toUpperCase())
               .replace("persona2.surname1",personafact.person.surname.toUpperCase())
               .replace("persona2.surname2",personafact.person.secondSurname.toUpperCase())
               .replace("persona2.dni",personafact.person.nif.toUpperCase())
               .replace("persona2.adress",personafact.person.address)
               .replace("persona2.poblacio",personafact.person.town)
               .replace("persona2.cp",personafact.person.zipCode)
                .replace("rece2.nombre",renombre)
          .replace("rece2.direccion",redireccion).replace("rece2.direccion2",redireccion2).replace("rece2.nif",renif)
             .replace("rece2.telf",retelf)
               .replace("invoice.numinvoice",vm.lineesfact[0].numinvoice)
               .replace("invoice.data",fecha)
               .replace("persona2.iban",personafact.iban)
               .replace("linea.concepte0",concepte0)
               .replace("linea.partits0",vm.lineesfact[0].numpartits)
                .replace("linea.preu0",currency(vm.lineesfact[0].preu,2, ['.', "'", ',']))
                .replace("linea.total0",currency(vm.lineesfact[0].total,2, ['.', "'", ',']))
                .replace("invoice.base",currency(base,2, ['.', "'", ',']))
                 .replace("invoice.irpf",currency(irpf,2, ['.', "'", ',']))
                 .replace("invoice.total",currency(total,2, ['.', "'", ',']))
                  .replace("invoice.total",currency(total,2, ['.', "'", ',']));
       	
        
       
     var printWin = window.open('', '',
          'left=0, top=0, width=' + screen.availWidth + ', height=' + screen.availHeight
          + ', toolbar=0, scrollbars=0, status=0');
   printWin.document.write(s);
         
   printWin.document.write(template);
   setTimeout(function () {
        printWin.focus();
        printWin.print();
        printWin.close();
      }, 1500);
     window.close();
  }
  
  function generateTableRow(linea,personafact) {
	var emptyColumn = document.createElement('tr');
        var concepte=linea.esport+" competició JJEE de "+personafact.organisationName+" ";
        if (linea.sintexto==='1'){
            concepte=linea.esport+" ";
        }
	emptyColumn.innerHTML = '<td><a class="cut">-</a><span contenteditable>'+concepte+'</span></td>' +
		
                '<td><span contenteditable>'+linea.numpartits+'</span></td>' +
		'<td><span contenteditable>'+currency(linea.preu,2,['.', "'", ','])+'</span><span data-prefix> €</span></td>' +
		
		'<td><span>'+currency(linea.total,2,['.', "'", ','])+'</span><span data-prefix> €</span></td>';
     
	return emptyColumn;
}

function currency(value, decimals, separators) {
    decimals = decimals >= 0 ? parseInt(decimals, 0) : 2;
    separators = separators || ['.', "'", ','];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return (parts.length == 3 ? '-' : '') + result;
}
}());



(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice.facturar',['ui.router']);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice.facturar')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.facturar', {
      url: '/facturar/{fechaini}/{fechafin}/{idAjuntament}/{ids}',
     
          templateUrl: 'home/referee-new-invoice/facturar/facturar.tpl.html',
          controller: 'facturar',
          controllerAs: 'vm',
        resolve:{
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }],
        fechaini:["$stateParams", function ($stateParams){
             return $stateParams.fechaini;
           }],
        fechafin:["$stateParams", function ($stateParams){
             return $stateParams.fechafin;
           }],
           
        ajuntament:["$stateParams", function ($stateParams){
             return $stateParams.idAjuntament;
           }],
            ids:["$stateParams", function ($stateParams){
             return $stateParams.ids;
           }]
          
                  
        }
       
    });
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  facturar.$inject = ["AclService", "invoicesgenerate", "townHalls", "$scope", "fechaini", "fechafin", "ajuntament", "ids"];
  angular
    .module('neo.home.refereeNewInvoice.facturar')
    .controller('facturar', facturar);

  function facturar(AclService,invoicesgenerate,townHalls, $scope, fechaini,fechafin,ajuntament,ids) {
    var vm = this;
   
     var parameters = {
                initDate: fechaini,
                endDate: fechafin,
                isAdmin:AclService.isAdmin(),
                idAjuntament:ajuntament,ids:ids
                
      };
      
    invoicesgenerate.query(parameters);
     
    
   
       

  }
}());



(function () {
  'use strict';

  /* @ngdoc object
   * @name postponedMatches
   * @description
   *
   */
  angular
    .module('neo.home.postponements.postponedMatches', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.postponements.postponedMatches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.postponements.postponedMatches', {
        url: '/postponed-matches',
        templateUrl: 'home/postponements/postponed-matches/postponed-matches.tpl.html',
        controller: 'PostponedMatchesCtrl',
        controllerAs: 'vm'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name postponedMatches.controller:PostponedMatchesCtrl
   *
   * @description
   *
   */
  PostponedMatchesCtrl.$inject = ["$q", "$state", "$filter", "$mdToast", "$mdDialog", "AclService", "Matches", "Entitats", "LastPostponement", "townHalls", "currentSeason"];
  angular
    .module('neo.home.postponements.postponedMatches')
    .controller('PostponedMatchesCtrl', PostponedMatchesCtrl);

  function PostponedMatchesCtrl($q, $state, $filter, $mdToast, $mdDialog, AclService, Matches, Entitats, LastPostponement, townHalls, currentSeason) {
    var vm = this;
    vm.ctrlName = 'PostponedMatchesCtrl';

    vm.isFiltered = false;
    vm.showList = false;
    vm.matches = [];
    vm.initDate = moment(currentSeason.iniDate).toDate();
    vm.endDate = moment(currentSeason.endDate).toDate();
    vm.townhalls = _.cloneDeep(townHalls);
    vm.queryOrder = 'date';
    vm.sort = 'date';
    vm.currentPage = 1;

    vm.matchesPerPage = 2550;
    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      applyFilters();
    }

    vm.reorder = reorder;
    vm.applyFilters = applyFilters;
    vm.showEditButton = showEditButton;
    vm.showAcceptAndRejectButton = showAcceptAndRejectButton;
    vm.showCreateButton = showCreateButton;
    vm.showResolveSwitch = showResolveSwitch;
    vm.editPostponement = editPostponement;
    vm.acceptPostponement = acceptPostponement;
    vm.rejectPostponement = rejectPostponement;
    vm.changeResolutionPostponement = changeResolutionPostponement;
    vm.showExpiredPostponement = showExpiredPostponement;

    function reorder(order) {
      vm.sort = order;
      query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
    }

    function reload() {
      $state.reload();
    }

    function showExpiredPostponement(match) {
      return !AclService.isAdmin() && isExpired(match);
    }

    function showResolveSwitch(match) {
      return AclService.isAdmin() && isExpired(match) && match.lastPostponement.state !== 'RESOLVED_BY_COMMITTEE';
    }

    function acceptPostponement(match) {
      patchNewState(match, 'ACCEPTED', 'POSTPONEMENTS.SUCCESSFUL_ACCEPTED', reload);
    }

    function rejectPostponement(match) {
      patchNewState(match, 'REJECTED', 'POSTPONEMENTS.SUCCESSFUL_REJECTED', reload)
    }

    function changeResolutionPostponement(match) {
      var confirm = $mdDialog.confirm({
          onComplete: function afterShowAnimation() {
            // TODO: This is DOM manipulation throw angular, it shouldn't be like this
            var $dialog = angular.element(document.querySelector('md-dialog'));
            var $actionsSection = $dialog.find('md-dialog-actions');
            var $cancelButton = $actionsSection.children()[0];
            var $confirmButton = $actionsSection.children()[1];
            angular.element($confirmButton).removeClass('md-focused');
            angular.element($cancelButton).addClass('md-focused');
            $cancelButton.focus();

            angular.element($confirmButton).addClass('md-warn md-raised');
          }
        }
      )
        .title($filter('translate')('ALERT'))
        .textContent($filter('translate')('POSTPONEMENTS.CONFIRM_RESOLVE'))
        .ok($filter('translate')('CONTINUE'))
        .cancel($filter('translate')('CANCEL'));

      $mdDialog.show(confirm).then(function () {
        patchNewState(match, 'RESOLVED_BY_COMMITTEE', 'POSTPONEMENTS.SUCCESSFUL_CHANGED_RESOLUTION',
          function (match) {
            match.lastPostponement.state = 'RESOLVED_BY_COMMITTEE';
          }, function (match) {
            match.lastPostponement.resolved = false;
          });
      }, function (match) {
        match.lastPostponement.resolved = false;
      });
    }

    function patchNewState(match, newState, successMsg, functionOnSuccess, functionOnError) {
      var postponement = {
        state: newState
      };
      LastPostponement.update({id: match.id}, postponement, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(successMsg))
            .position('bottom left')
            .hideDelay(3000)
        );
        functionOnSuccess(match);
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'POSTPONEMENTS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
        if (angular.isDefined(functionOnError)) {
          functionOnError(match);
        }
      });
    }

    function showEditButton(match) {
      if (!AclService.can('POSTPONEMENT', 'U')) return false;
      if (isExpired(match)) return false;
      if (match.lastPostponement.state !== "PENDING") return false;
      if (teamIsMine(match.localTeam)) return true;
      return !hasValue(match.lastPostponement.time) && !hasValue(match.lastPostponement.facilityId);
    }

    function showAcceptAndRejectButton(match) {
      if (!AclService.can('POSTPONEMENT', 'U')) return false;
      if (match.lastPostponement.state !== "PENDING" || isExpired(match)) return false;
      return teamIsMine(match.visitorTeam) && hasValue(match.lastPostponement.date) && hasValue(match.lastPostponement.time) && hasValue(match.lastPostponement.facilityId);

    }

    function showCreateButton(match) {
      if (!AclService.can('POSTPONEMENT', 'C')) return false;
      if (isExpired(match)) return false;
      return match.lastPostponement.state === 'ACCEPTED' || match.lastPostponement.state === 'REJECTED';
    }

    function isExpired(match) {
      return moment(moment.now()).isAfter(match.lastPostponement.managementDeadline);
    }

    function editPostponement(match) {
      if (!AclService.can('POSTPONEMENT', 'U')) return false;
      $state.go('home.postponements.edit', {matchId: match.id});
    }

    function applyFilters() {
      vm.isFiltered = true;
      query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
    }


    function queryMyEntities() {
      Entitats.query(function (data) {
        vm.myEntities = data;
        if (vm.matches.length !== 0) {
          vm.showList = true;
        }
      })
    }

    function query(townHallId, initDate, endDate, page, sort) {
      var deferredMatches = $q.defer();
      vm.promiseMatches = deferredMatches.promise;
      var parameters = {
        townHall: townHallId,
        initDate: moment(initDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        page: page,
        size: vm.matchesPerPage,
        postponement: true
      };
      //Optional parameters
      if (!_.isUndefined(sort)) {
        parameters.sort = sort;
      }
      Matches.get(parameters, function (data) {
        _.remove(vm.matches);
        angular.forEach(data.matches, function (match) {
          vm.matches.push(parseMatch(data, match));
        });
        queryMyEntities();
        vm.maxMatches = data.page.count;
        deferredMatches.resolve();
      }, function () {
        deferredMatches.resolve();
      });
    }

    function teamIsMine(team) {
      return !_.isUndefined(findItemById(vm.myEntities, team.entityId));
    }

    function parseMatch(data, match) {
      var facility = findItemById(data.facilities, match.facilityId);
      var localTeam = findItemById(data.teams, match.localTeamId);
      var visitorTeam = findItemById(data.teams, match.visitorTeamId);
      return {
        id: match.id,
        canPostpone: !_.isUndefined(localTeam) && !_.isUndefined(visitorTeam),
        localTeam: !_.isUndefined(localTeam) ? localTeam : {name: $filter('translate')('CALENDAR.REST')},
        visitorTeam: !_.isUndefined(visitorTeam) ? visitorTeam : {name: $filter('translate')('CALENDAR.REST')},
        date: moment(match.date).format('L'),
        time: match.time === null ? undefined : match.time,
        facility: !_.isUndefined(facility) ? facility : undefined,
        championship: findItemById(data.championships, match.championshipId).name,
        lastPostponement: parsePostponement(match)
      };
    }

    function parsePostponement(match) {
      return {
        id: match.lastPostponement.id,
        state: match.lastPostponement.state,
        date: moment(match.lastPostponement.date).format('L'),
        time: match.lastPostponement.time === null ? undefined : match.lastPostponement.time,
        facilityId: !_.isUndefined(match.lastPostponement.facilityId) ? match.lastPostponement.facilityId : undefined,
        details: match.lastPostponement.details,
        requesterId: match.lastPostponement.requesterId,
        receiverId: match.lastPostponement.receiverId,
        managementDeadline: match.lastPostponement.managementDeadline,
        resolved: match.lastPostponement.state === "RESOLVED_BY_COMMITTEE"
      }
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function hasValue(field) {
      return !_.isNull(field) && !_.isUndefined(field);
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name postponements.newPostponement
   * @description
   *
   */
  angular
    .module('neo.home.postponements.new', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.postponements.new')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.postponements.new', {
        url: '^/home/matches/{matchId}/postponement/new',
        templateUrl: 'home/postponements/new-postponement/new-postponement.tpl.html',
        controller: 'NewPostponementCtrl',
        controllerAs: 'vm',
        resolve: {
          facilities: ["Facilities", function (Facilities) {
            return Facilities.query().$promise;
          }],
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise;
          }],
          match: ["Matches", "$stateParams", function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }],
          championship: ["Championship", "match", function (Championship, match) {
            return Championship.get({id: match.championship.id}).$promise;
          }],
          recoveryDates: ["PhaseRecoveryMatchDates", "championship", function (PhaseRecoveryMatchDates, championship) {
            return PhaseRecoveryMatchDates.query({id: championship.phaseId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name postponements.newPostponement.controller:NewPostponementCtrl
   *
   * @description
   *
   */
  NewPostponementCtrl.$inject = ["$scope", "$state", "$mdToast", "$filter", "Postponements", "entities", "facilities", "match", "recoveryDates"];
  angular
    .module('neo.home.postponements.new')
    .controller('NewPostponementCtrl', NewPostponementCtrl);

  function NewPostponementCtrl($scope, $state, $mdToast, $filter, Postponements, entities, facilities, match, recoveryDates) {
    var vm = this;
    vm.ctrlName = 'NewPostponementCtrl';

    vm.minDate = moment().toDate();
    vm.suggestedDates = parseRecoveryDates(angular.copy(recoveryDates));

    vm.informationRequired = false;
    vm.facilities = angular.copy(facilities);

    vm.postponement = {
      date: match.date,
      time: _.isUndefined(match.time) ? undefined : moment(match.time, 'HH:mm').toDate(),
      facility: match.facility === null ? undefined : match.facility
    };

    vm.localTeam = match.localTeam;
    vm.localTeam.columnName = 'CHAMPIONSHIPS.LOCAL_TEAM';

    vm.visitorTeam = match.visitorTeam;
    vm.visitorTeam.columnName = 'CHAMPIONSHIPS.VISITOR_TEAM';

    vm.canSetTime = checkCanSetTime();
    vm.canSetFacility = checkCanSetFacility();

    vm.savePostponement = function savePostponement() {
      var postObject = {};
      postObject.date = moment(vm.postponement.date).format('YYYY-MM-DD');
      postObject.time = angular.isUndefined(vm.postponement.time) || !checkCanSetTime() ? null : moment(vm.postponement.time).format('HH:mm');
      postObject.facilityId = !checkCanSetFacility() ? null : vm.postponement.facility;
      postObject.details = vm.postponement.details;

      Postponements.save({id: match.id}, postObject, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('POSTPONEMENTS.SUCCESS_CREATION'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.postponements.postponedMatches');
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'POSTPONEMENTS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    };

    function checkCanSetTime() {
      var item = findItemById(entities, vm.localTeam.entityId);
      return angular.isDefined(item);
    }

    function checkCanSetFacility() {
      return vm.canSetTime;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function parseRecoveryDates(recoveryDates) {
      var dates = [];
      angular.forEach(recoveryDates, function (date) {
        dates.push(moment(date).format('L'));
      });
      return dates;
    }

    $scope.$watch('vm.selectedRecoveryDate',
      function setToCalendar(stringDate) {
        if (angular.isDefined(stringDate)) {
          vm.postponement.date = moment(stringDate, "DD/MM/YYYY").toDate();
        } else {
          vm.postponement.date = match.date;
        }
      }
    );
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name postponements.editPostponement
   * @description
   *
   */
  angular
    .module('neo.home.postponements.edit', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.postponements.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.postponements.edit', {
        url: '^/home/matches/{matchId}/postponement/edit',
        templateUrl: 'home/postponements/edit-postponement/edit-postponement.tpl.html',
        controller: 'EditPostponementCtrl',
        controllerAs: 'vm',
        resolve: {
          facilities: ["Facilities", function (Facilities) {
            return Facilities.query().$promise;
          }],
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise;
          }],
          match: ["Matches", "$stateParams", function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }],
          championship: ["Championship", "match", function (Championship, match) {
            return Championship.get({id: match.championship.id}).$promise;
          }],
          recoveryDates: ["PhaseRecoveryMatchDates", "championship", function (PhaseRecoveryMatchDates, championship) {
            return PhaseRecoveryMatchDates.query({id: championship.phaseId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name postponements.editPostponement.controller:EditPostponementCtrl
   *
   * @description
   *
   */
  EditPostponementCtrl.$inject = ["$scope", "$mdToast", "$state", "$filter", "LastPostponement", "facilities", "entities", "match", "recoveryDates"];
  angular
    .module('neo.home.postponements.edit')
    .controller('EditPostponementCtrl', EditPostponementCtrl);

  function EditPostponementCtrl($scope, $mdToast, $state, $filter, LastPostponement, facilities, entities, match, recoveryDates) {
    var vm = this;
    vm.ctrlName = 'EditPostponementCtrl';

    vm.suggestedDates = parseRecoveryDates(angular.copy(recoveryDates));

    vm.facilities = facilities;
    vm.localTeam = match.localTeam;
    vm.localTeam.columnName = 'CHAMPIONSHIPS.LOCAL_TEAM';

    vm.visitorTeam = match.visitorTeam;
    vm.visitorTeam.columnName = 'CHAMPIONSHIPS.VISITOR_TEAM';

    vm.postponement = _.cloneDeep(match.lastPostponement);
    vm.postponement.time = moment(vm.postponement.time, 'HH:mm').toDate();

    vm.canSetTime = checkCanSetTime();
    vm.canSetFacility = checkCanSetFacility();
    vm.updatePostponement = updatePostponement;
    vm.cancelEdition = cancelEdition;

    function cancelEdition() {
      vm.postponement = _.cloneDeep(match.lastPostponement);
      vm.postponement.time = moment(vm.postponement.time, 'HH:mm').toDate();
    }

    function checkCanSetTime() {
      var item = findItemById(entities, vm.localTeam.entityId);
      return angular.isDefined(item);
    }

    function checkCanSetFacility() {
      return checkCanSetTime();
    }

    function updatePostponement() {
      var postObject = {};
      postObject.date = moment(vm.postponement.date).format('YYYY-MM-DD');
      postObject.time = angular.isUndefined(vm.postponement.time) || !checkCanSetTime() ? null : moment(vm.postponement.time).format('HH:mm');
      postObject.facilityId = !checkCanSetFacility() ? null : vm.postponement.facilityId;
      postObject.details = vm.postponement.details;

      LastPostponement.update({id: match.id}, postObject, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('POSTPONEMENTS.SUCCESS_EDITION'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.postponements.postponedMatches');
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'POSTPONEMENTS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    function parseRecoveryDates(recoveryDates) {
      var dates = [];
      angular.forEach(recoveryDates, function (date) {
        dates.push(moment(date).format('L'));
      });
      return dates;
    }

    $scope.$watch('vm.selectedRecoveryDate',
      function setToCalendar(stringDate) {
        if (angular.isDefined(stringDate)) {
          vm.postponement.date = moment(stringDate, "DD/MM/YYYY").toDate();
        } else {
          vm.postponement.date = match.lastPostponement.date;
        }
      }
    );
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.phases.phase
   * @description
   *
   */
  angular
    .module('neo.home.phases.phase', [
      'ui.router',
      'neo.home.phases.phase.inscribedTeams'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.phases.phase')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.phases.phase', {
          url: '/{phaseId}',
          views: {
            '': {
              templateUrl: 'home/phases/phase/phase.tpl.html',
              controller: 'PhaseCtrl',
              controllerAs: 'vm'
            },
            'actions@home.phases.phase': {
              templateUrl: 'components/actionButton/action-button.tpl.html',
              controller: 'ActionButtonCtrl',
              controllerAs: 'vm'
            }
          },
          resolve: {
            phase: ["$stateParams", "Phase", function ($stateParams, Phase) {
              return Phase.query({
                phaseId: $stateParams.phaseId
              }).$promise;
            }]
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name phases.phase.controller:PhaseCtrl
   *
   * @description
   *
   */
  PhaseCtrl.$inject = ["$state", "actionButton", "$stateParams", "$filter", "$mdToast", "phase", "Phase", "AclService"];
  angular
    .module('neo.home.phases.phase')
    .controller('PhaseCtrl', PhaseCtrl);

  function PhaseCtrl($state, actionButton, $stateParams, $filter, $mdToast, phase, Phase, AclService) {
    var vm = this;
    vm.ctrlName = 'PhaseCtrl';

    vm.phase = phase;
    vm.phase.iniDate = moment(vm.phase.iniDate).toDate();
    vm.phase.endDate = moment(vm.phase.endDate).toDate();

    vm.edit = false;
    vm.can = AclService.can;

    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'ACTIONS',
      actions: []
    };

    if (vm.phase.type === "LOCAL" && vm.can('LOCAL_PHASE', 'U') || (vm.phase.type === "REGIONAL" && vm.can('REGIONAL_PHASE', 'U'))) {
      vm.buttons.actions.push({
        buttonImage: 'images/ic_edit_black_48px.svg',
        attrClass: '',
        tooltip: 'EDIT',
        execute: enableEdit
      });
    }

    vm.buttons.actions.push({
      buttonImage: 'images/ic_assignment_black_48px.svg',
      attrClass: '',
      tooltip: 'PHASES.INSCRIBED_TEAMS_LABEL',
      stateToChange: 'home.phases.phase.inscribedTeams',
      changeState: true
    });
    vm.buttons.actions.push({
      buttonImage: 'images/ic_equalizer_black_48px.svg',
      attrClass: '',
      tooltip: 'PHASES.INSCRIBED_TEAMS_NUMBER_LABEL',
      stateToChange: 'home.phases.phase.inscribedTeamsNumber',
      changeState: true
    });

    function enableEdit() {
      vm.edit = true;
      actionButton.dial = false;
    }

    vm.updatePhase = function () {
      vm.phase.iniDate = moment(vm.phase.iniDate).format('YYYY-MM-DD');
      vm.phase.endDate = moment(vm.phase.endDate).format('YYYY-MM-DD');
      if (vm.iniDate > vm.endDate) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('ERROR_INVALID_DATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
      } else {
        Phase.update({phaseId: $stateParams.phaseId}, vm.phase, function () {
            $mdToast.show(
              $mdToast.simple()
                .textContent($filter('translate')('PHASES.PHASE_SUCCESSFUL_UPDATE'))
                .position('bottom left')
                .hideDelay(3000)
            );
            $state.go($state.current, $stateParams, {reload: true});
          },
          function (error) {
            var errorMessage;
            if (error.status === 409) {
              errorMessage = 'PHASES.ERROR_INVALID_DATE_PHASE';
            } else if (error.status === 403) {
              errorMessage = 'NO_PERMISSIONS';
            } else {
              errorMessage = 'SERVER_ERROR';
            }
            $mdToast.show(
              $mdToast.simple()
                .textContent($filter('translate')(errorMessage))
                .position('bottom left')
                .hideDelay(3000)
            );
          });
      }
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name phases.newPhase
   * @description
   *
   */
  angular
    .module('neo.home.phases.newPhase', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.phases.newPhase')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.phases.newPhase', {
        url: '/new-phase',
        templateUrl: 'home/phases/new-phase/new-phase.tpl.html',
        controller: 'NewPhaseCtrl',
        controllerAs: 'vm',
        resolve: {
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name phases.newPhase.controller:NewPhaseCtrl
   *
   * @description
   *
   */
  NewPhaseCtrl.$inject = ["Phases", "LocalPhases", "$mdToast", "$state", "$filter", "AclService", "townHalls"];
  angular
    .module('neo.home.phases.newPhase')
    .controller('NewPhaseCtrl', NewPhaseCtrl);

  function NewPhaseCtrl(Phases, LocalPhases, $mdToast, $state, $filter, AclService, townHalls) {
    var vm = this;
    vm.ctrlName = 'NewPhaseCtrl';
    vm.can = AclService.can;
    vm.townHalls = townHalls;

    vm.phase = {};

    function successMethod() {
      $state.go('home.phases', {}, {reload: true});
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('PHASES.PHASE_SUCCESSFUL_CREATE'))
          .position('bottom left')
          .hideDelay(3000)
      );
    }

    function errorMethod(error) {
      var errorMessage;
      if (error.status === 409) {
        errorMessage = 'PHASES.ERROR_INVALID_DATE_PHASE';
      } else {
        errorMessage = 'SERVER_ERROR';
      }
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')(errorMessage))
          .position('bottom left')
          .hideDelay(3000)
      );
    }

    // TODO: Change API call to different routes and control acl permissions to call one or another
    vm.savePhase = function () {
      vm.phase.iniDate = moment(vm.iniDate).format('YYYY-MM-DD');
      vm.phase.endDate = moment(vm.endDate).format('YYYY-MM-DD');
      if (vm.iniDate > vm.endDate) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('ERROR_INVALID_DATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
      } else {
        if (vm.phase.type === 'regional') {
          Phases.save(vm.phase, successMethod, errorMethod);
        }
        else {
          var townHallId = angular.isDefined(vm.selectedTownHall) ? vm.selectedTownHall.id : townHalls[0].id;
          LocalPhases.save({id: townHallId}, vm.phase, successMethod, errorMethod);
        }
      }
    };
  }
}());


(function () {
  'use strict';

  /* @ngdoc object
   * @name phases.inscription
   * @description
   *
   */
  angular
    .module('neo.home.phases.inscription', []);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.phases.inscription')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.phases.inscription', {
        url: '/inscription',
        templateUrl: 'home/phases/inscription/inscription.tpl.html',
        controller: 'InscriptionPhaseCtrl',
        controllerAs: 'vm',
        resolve: {
          phases: ["Phases", function (Phases) {
            return Phases.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
            /*return [{id: 1, name: "Pablito"}]*/
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name phases.inscription.controller:InscriptionPhaseCtrl
   *
   * @description
   *
   */
  InscriptionCtrl.$inject = ["phases", "genders", "categories", "sports", "PhasesInscriptions", "townHalls", "$mdToast", "$filter"];
  angular
    .module('neo.home.phases.inscription')
    .controller('InscriptionPhaseCtrl', InscriptionCtrl);

  function InscriptionCtrl(phases, genders, categories, sports, PhasesInscriptions, townHalls, $mdToast, $filter) {
    var vm = this;
    vm.ctrlName = 'InscriptionPhaseCtrl';
    vm.phases = phases;
    vm.inscriptions = [];
    vm.myTownHalls = townHalls;
    vm.townHallSearch = "";
    vm.getInscriptions = getInscriptions;
    vm.categories = categories;
    vm.selectedTownHall = undefined;
    vm.disableButtons = true;

    if (vm.myTownHalls.length === 1) {
      vm.onlyOneTownHall = true;
      vm.selectedTownHall = vm.myTownHalls[0];
      vm.isSelectedTownhallUndefined = false;

      vm.getInscriptions();
    }
    else{
      vm.isSelectedTownhallUndefined = true;
      vm.onlyOneTownHall = false;
    }

    var findCategory = function (categoryId) {
      return _.find(vm.categories, function (c) {
        return c.id === categoryId;
      });
    };

    var findSport = function (sportId) {
      return _.find(sports, function (s) {
        return s.id === sportId;
      });
    };

    var findGender = function (genderId) {
      return _.find(genders, function (g) {
        return g.id === genderId;
      })
    };

    vm.getPhaseIndexOf = function (phase) {
      return _.findIndex(vm.phases, function (p) {
        return p.id === phase.id;
      });
    };

    vm.hasChangedModel = function () {
      vm.disableButtons = false;
    };


    function getInscriptions() {
      vm.isSelectedTownhallUndefined = false;
      vm.inscriptions = [];
      PhasesInscriptions.query({townHallId: vm.selectedTownHall.id}, function (inscriptions) {
        angular.forEach(inscriptions, function (inscription) {
          var myInscription = {};
          myInscription.team = inscription.team;
          myInscription.teamName = inscription.team.name;
          myInscription.teamNameOrder = $filter('lowercase')(inscription.team.name);
          var category = findCategory(inscription.team.categoryId);
          myInscription.teamCategory = 'CATEGORIES.' + category.name;
          myInscription.teamCategoryOrder = category.startYear;
          myInscription.teamSport = $filter('translate')('SPORTS.' + findSport(inscription.team.sportId).name);
          myInscription.teamGender = findGender(inscription.team.genderId).name;
          myInscription.phases = inscription.phases;
          vm.inscriptions.push(myInscription);
        });
        vm.inscriptions = _.sortByOrder(vm.inscriptions, ['teamSport', 'teamCategoryOrder', 'teamGender'], [true, false, true]);
        vm.originalInscriptions = _.cloneDeep(vm.inscriptions);
      });
    }

    vm.discardChanges = function () {
      vm.inscriptions = _.cloneDeep(vm.originalInscriptions);
      vm.disableButtons = true;
    };

    vm.submitInscription = function () {
      var inscriptionsToSave = [];
      angular.forEach(vm.inscriptions, function (inscriptionModel) {
        var inscriptionToSave = {
          team: inscriptionModel.team,
          phases: inscriptionModel.phases
        };
        inscriptionsToSave.push(inscriptionToSave);
      });

      PhasesInscriptions.save(inscriptionsToSave,
        function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('PHASES.COMPLETED_INSCRIPTIONS'))
              .position('bottom left')
              .hideDelay(3000)
          );
        }, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('TOAST_ERROR'))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.person
   * @description
   *
   */
  angular
  .module('neo.home.persons.person', [
    'ui.router',
    'neo.home.persons.person.information'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.persons.person')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.persons.person', {
          url: '?{team}&{license}',
          abstract: true,
          templateUrl: 'home/persons/person/person.tpl.html',
          controller: 'PersonCtrl',
          controllerAs: 'vm',
          resolve: {
            licenseTeamPerson: ["LicenseTeamPerson", "$stateParams", function(LicenseTeamPerson, $stateParams) {
              return LicenseTeamPerson.query({
                licenseId: $stateParams.license,
                teamId: $stateParams.team
              }).$promise;
            }]
          }
        });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.person.controller:PersonCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.persons.person')
  .controller('PersonCtrl', PersonCtrl);

  function PersonCtrl() {
    var vm = this;
    vm.ctrlName = 'PersonCtrl';
    vm.currentNavItem = 'informacio';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.newPerson
   * @description
   *
   */
  angular
  .module('neo.home.persons.newPerson', [
    'ui.router'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.persons.newPerson')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.persons.newPerson', {
      url: '/new-person',
      templateUrl: 'home/persons/new-person/new-person.tpl.html',
      controller: 'NewPersonCtrl',
      controllerAs: 'vm',
      // params: {
      //   entity: undefined,
      //   team: undefined
      // },
      resolve: {
        entities: ["Entitats", function (Entitats) {
          return Entitats.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.newPerson.controller:NewPersonCtrl
   *
   * @description
   *
   */
  NewPersonCtrl.$inject = ["$scope", "$stateParams", "$state", "$mdToast", "$filter", "$mdDialog", "LicenseTeam", "EntityTeams", "entities", "licenseTypes", "genders", "DuplicatedPerson", "PersonLicense", "sports"];
  angular
    .module('neo.home.persons.newPerson')
    .controller('NewPersonCtrl', NewPersonCtrl)
    .directive('fileDropzone', function() {
  return {
    restrict: 'A',
    scope: {
      file: '=',
      fileName: '='
    },
    link: function(scope, element, attrs) {
      var checkSize,
          isTypeValid,
          processDragOverOrEnter,
          validMimeTypes;
      
      processDragOverOrEnter = function (event) {
        if (event !== null) {
          event.preventDefault();
        }
        event.dataTransfer.effectAllowed = 'copy';
        return false;
      };
      
      validMimeTypes = attrs.fileDropzone;
       
      checkSize = function(size) {
        var _ref;
        var maxima=2;
        
        if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < maxima) {
          return true;
        } else {
          alert("El fitxer no pot ser més gran de " + maxima + " MB");
          return false;
        }
      };

      isTypeValid = function(type) {
        if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
          return true;
        } else {
          alert("Tipus de fitxer invàlid. Hauria de ser: " + validMimeTypes);
          return false;
        }
      };
      
      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);

      return element.bind('drop', function(event) {
            
        var file, name, reader, size, type;
        if (event !== null) {
          event.preventDefault();
        }
        reader = new FileReader();
        reader.onload = function(evt) {
          if (checkSize(size) && isTypeValid(type)) {
            return scope.$apply(function() {
              scope.file = evt.target.result;
              if (angular.isString(scope.fileName)) {
                return scope.fileName = name;
              }
            });
          }
        };
        file = event.dataTransfer.files[0];
        name = file.name;
        type = file.type;
        size = file.size;
       
        reader.readAsDataURL(file);
       
        return false;
      });
    }
  };
})
.directive("fileread", [function () {
    return {
        scope: {
            fileread: "="
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        scope.fileread = loadEvent.target.result;
                       
                    });
                }; 
               
                if (((changeEvent.target.files[0].size)/1024/1024) < 2 ){
                    reader.readAsDataURL(changeEvent.target.files[0]);
                return true;
                }
                    else
                    {
                       
                         alert("El fitxer no pot ser més gran de 2 MB");
                         return false;
                    }
            });
        }
    };
}])
;


  function NewPersonCtrl($scope, $stateParams, $state, $mdToast, $filter, $mdDialog,
                         LicenseTeam, EntityTeams, entities, licenseTypes, genders, DuplicatedPerson, PersonLicense, sports) {
    var vm = this;
  $scope.image = null;
  $scope.imageFileName = '';
  
  $scope.uploadme = {};
  $scope.uploadme.src = '';
  
      vm.ctrlName = 'NewPersonCtrl';
    vm.licenseTeamTypes = _.filter(licenseTypes, function (lt) {
      return lt.team
    });
    vm.personGenders = _.filter(genders, function (g) {
      return g.person
    });
    vm.person = {};

    vm.entities = entities;
    vm.lodp = false;

    $scope.$watch('vm.person.entity', function (entity) {
      if (angular.isDefined(entity) && entity !== null) {
        EntityTeams.query({entityId: entity.id}, function (data) {
          vm.entityTeams = data;
        });
      }
    });

    var findItemById = function (collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    };

    if (entities.length === 1) {
      vm.person.entity = entities[0];
    } else if (angular.isDefined($stateParams.selectedEntity.id)) {
      vm.person.entity = findItemById(entities, $stateParams.selectedEntity.id);
    }

    if (angular.isDefined(vm.person.entity) && angular.isDefined($stateParams.selectedTeam.id)) {
      EntityTeams.query({entityId: vm.person.entity.id}, function (data) {
        vm.entityTeams = data;
        vm.person.team = findItemById(vm.entityTeams, $stateParams.selectedTeam.id);
      });
    }

    function parseDate(date) {
      return moment(date).format('YYYY-MM-DD');
    }

    vm.successfulPersonAddition = function(){
       
      $state.go('home.persons', {selectedEntity: vm.person.entity, selectedTeam: vm.person.team}, {reload: true});
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('PEOPLE.SUCCESSFUL_CREATE'))
          .position('bottom left')
          .hideDelay(3000)
      );
    };

    vm.errorInPersonAddition = function(err){
      var errorMessage;
      if (err.status === 400) {
        errorMessage = err.data.message || 'BAD_REQUEST_PERSON';
      } else if (err.status === 409) {
        errorMessage = 'PEOPLE.EXISTING_PERSON';
      } else {
        errorMessage = 'SERVER_ERROR';
      }
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')(errorMessage))
          .position('bottom left')
          .hideDelay(3000)
      );
    };

    vm.createPerson = function () {
      var newLicense = {
        licenceTypeId: vm.person.licenseType,
        person: {
          name: vm.person.name,
          surname: vm.person.surname,
          secondSurname: vm.person.secondSurname,
          genderId: vm.person.genderId,
          bornDate: parseDate(vm.person.birthday),
          nif: vm.person.nif,
          healthInsuranceCardNumber: vm.person.healthInsuranceCard,
          email: vm.person.email,
          address: vm.person.address,
          town: vm.person.town,
          zipCode: vm.person.zipCode
        },foto:$scope.image
      };

   LicenseTeam.save({teamId: vm.person.team.id}, newLicense, vm.successfulPersonAddition, vm.errorInPersonAddition);
    
    };

    vm.assignExistentPerson = function (personId) {
      var data = {licenceTypeId: vm.person.licenseType, teamId: vm.person.team.id};
      PersonLicense.save({personId: personId}, data, vm.successfulPersonAddition, vm.errorInPersonAddition);
    };

    vm.savePerson = function () {
      DuplicatedPerson.query({
        name: vm.person.name,
        surname: vm.person.surname,
        bornDate: parseDate(vm.person.birthday)
      }, function (data) {
        if (data.length > 0) {
          $mdDialog.show({
            controller: 'DuplicateDialogCtrl',
            templateUrl: 'home/persons/new-person/duplicate-dialog.tpl.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
              duplicatedPersons: data,
              licenses: licenseTypes,
              sports: sports
            }
          }).then(function (personId) {
            if (angular.isDefined(personId)) {
              vm.assignExistentPerson(personId);
            } else {
              vm.createPerson();
            }
          });
        } else {
          vm.createPerson();
        }
      }, function (err) {
      });
      
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.controller:DuplicateDialogCtrl
   *
   * @description
   *
   */
  DuplicateDialogCtrl.$inject = ["$scope", "$mdDialog", "duplicatedPersons", "licenses", "sports"];
  angular
  .module('neo.home.persons.newPerson')
  .controller('DuplicateDialogCtrl', DuplicateDialogCtrl);

  function DuplicateDialogCtrl($scope, $mdDialog, duplicatedPersons, licenses, sports) {

    var filteredDuplicates = {};
    angular.forEach(duplicatedPersons, function (duplicated) {
      if (angular.isUndefined(filteredDuplicates[duplicated.person.id])) {

        filteredDuplicates[duplicated.person.id] = {
          name: duplicated.person.name,
          surname1: duplicated.person.surname1,
          surname2: duplicated.person.surname2,
          bornDate: duplicated.person.bornDate,
          licensesList: duplicated.teamLicences,
          noTeamLicencesList: duplicated.noTeamLicences,
          check: false
        };
      }
      /*filteredDuplicates[person.id].licensesList.push({
       licenseTypeId: person.licenceTypeId,
       organisation: person.organisation,
       team: person.team,
       town: person.town,
       sport: person.sport
       });*/
    });

    $scope.duplicatedPersons = filteredDuplicates;
    $scope.sports = sports;

    $scope.someSelected = function () {
      return _.some($scope.duplicatedPersons, function (dp) {
        return dp.check;
      })
    };

    $scope.unselectOthers = function (id) {
      angular.forEach($scope.duplicatedPersons, function (person, idP) {
        if (idP !== id) person.check = false;

      });
    };

    $scope.parseDate = parseDate;

    $scope.getLicenseName = function (licenseId) {
      var license = findItemById(licenses, licenseId);
      return angular.isDefined(license) ? license.name : undefined;
    };

    $scope.getSportName = function (sportId) {
      var sport = findItemById(sports, sportId);
      return angular.isDefined(sport) ? sport.name : undefined;
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.newPerson = function () {
      $mdDialog.hide(undefined);
    };

    $scope.selectedPerson = function () {
      var selectedPerson = _.findKey($scope.duplicatedPersons, function (dp) {
        return dp.check;
      });
      $mdDialog.hide(selectedPerson);
    };

    var findItemById = function (collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    };

    function parseDate(date) {
      var ymd = date.split('-');
      ymd.reverse();
      return ymd.join('-');
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name facilities.newFacility
   * @description
   *
   */
  angular
    .module('neo.home.facilities.newFacility', []);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.facilities.newFacility')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.facilities.newFacility', {
        url: '/new-facility',
        templateUrl: 'home/facilities/new-facility/new-facility.tpl.html',
        controller: 'NewFacilityCtrl',
        controllerAs: 'vm',
        resolve :{
          acl: ["$q", "AclService", function ($q, AclService) {
            if (AclService.can('FACILITY', 'C')) {
              // Has proper permissions
              return true;
            } else {
              // Does not have permission
              return $q.reject('Unauthorized');
            }
          }],
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          townhalls : ["Ajuntaments", function(Ajuntaments){
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name facilities.newFacility.controller:NewFacilityCtrl
   *
   * @description
   *
   */
  NewFacilityCtrl.$inject = ["uiGmapGoogleMapApi", "uiGmapLogger", "towns", "townhalls", "$scope", "Facilities", "$mdToast", "$filter", "$state"];
  angular
    .module('neo.home.facilities.newFacility')
    .controller('NewFacilityCtrl', NewFacilityCtrl);

  function NewFacilityCtrl(uiGmapGoogleMapApi, uiGmapLogger, towns, townhalls, $scope, Facilities, $mdToast, $filter, $state) {
    var vm = this;
    vm.ctrlName = 'NewFacilityCtrl';

    vm.facility = {
      name: undefined,
      townHall: undefined,
      townName: undefined,
      zipCode: undefined,
      address: undefined,
      latitude: undefined,
      longitude: undefined
    };

    vm.towns = towns;
    vm.townHalls = townhalls;
    if (vm.townHalls.length === 1) {
      vm.facility.townHall = vm.townHalls[0];
    }

    vm.submitFacility = function () {
      vm.facility.idTownHall = vm.facility.townHall.id;
      Facilities.save(vm.facility, function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('FACILITIES.SUCCESSFUL_CREATE'))
              .position('bottom left')
              .hideDelay(3000));
          $state.go('home.facilities', {}, {reload: true});

        },
        function (error) {
          var message;
          if (error.status === 404) {
            message = 'ERROR_NON_EXISTING_TOWNHALL';
          } else {
            message = 'ERROR_BAD_REQUEST';
          }
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    };

    vm.markerCoords = {
      latitude: 41.3794631,
      longitude: 2.0568846
    };

    uiGmapGoogleMapApi.then(function (maps) {
      maps.visualRefresh = true;
      uiGmapLogger.log('Map succeed');
      vm.geocoder = new maps.Geocoder();
    });


    vm.map = {
      center: {
        latitude: vm.markerCoords.latitude,
        longitude: vm.markerCoords.longitude
      },
      zoom: 12,
      options: {
        tilt: 45
      },
      events: {
        click: function (mapModel, eventName, eventArgs) {
          setCoordinates(eventArgs[0].latLng.lat(), eventArgs[0].latLng.lng());
        }
      },
      markers: [{
        id: 1,
        latitude: vm.markerCoords.latitude,
        longitude: vm.markerCoords.longitude
      }
      ]
    };

    function centerMap() {
      vm.map.center.latitude = vm.markerCoords.latitude;
      vm.map.center.longitude = vm.markerCoords.longitude;
    }

    vm.searchLocation = function () {
      if (!angular.isUndefined(vm.facility.address) && !angular.isUndefined(vm.facility.townName)) {
        var address = vm.facility.address + ",";
        if (!angular.isUndefined(vm.facility.zipCode)) {
          address = address + vm.facility.zipCode;
        }
        address = address + " " + vm.facility.townName;
        vm.geocoder.geocode({'address': address}, function (results) {
          if (!results.isUndefined || results.size() > 0) {
            setCoordinates(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            centerMap();
          }
        })
      }
    };

    function setCoordinates(latitude, longitude) {
      vm.markerCoords.latitude = vm.facility.latitude = latitude;
      vm.markerCoords.longitude = vm.facility.longitude = longitude;
      vm.map.markers.pop();
      vm.map.markers.push({
        id: 1,
        latitude: vm.markerCoords.latitude,
        longitude: vm.markerCoords.longitude
      });
      $scope.$evalAsync();
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name facilities.facility
   * @description
   *
   */
  angular
    .module('neo.home.facilities.facility', [ ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.facilities.facility')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.facilities.facility', {
        url: '/{facilityId}',
        templateUrl: 'home/facilities/facility/facility.tpl.html',
        controller: 'FacilityCtrl',
        controllerAs: 'vm',
        resolve :{
          towns: ["Poblacions", function (Poblacions) {
            return Poblacions.query().$promise;
          }],
          townhalls : ["Ajuntaments", function(Ajuntaments){
            return Ajuntaments.query().$promise;
          }],
          facility : ["Facilities", "$stateParams", function(Facilities, $stateParams){
            return Facilities.get({id: $stateParams.facilityId}).$promise;
          }]
        }
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name facilities.facility.controller:FacilityCtrl
     *
     * @description
     *
     */
    FacilityCtrl.$inject = ["uiGmapGoogleMapApi", "towns", "townhalls", "$scope", "Facilities", "$mdToast", "$filter", "facility", "$stateParams", "AclService", "$mdDialog", "$state"];
    angular
    .module('neo.home.facilities.facility')
    .controller('FacilityCtrl', FacilityCtrl);

    function FacilityCtrl(uiGmapGoogleMapApi, towns, townhalls, $scope, Facilities, $mdToast, $filter, facility, $stateParams, AclService, $mdDialog, $state) {
      var vm = this;
      vm.ctrlName = 'FacilityCtrl';

      vm.hasPermission = AclService.can("FACILITY", "U");
      vm.can = AclService.can;

      vm.facility = angular.copy(facility);

      vm.edit = false;

      vm.towns = towns;
      vm.townHalls = townhalls;
      if (vm.townHalls.length === 1) {
        vm.facility.townHall = vm.townHalls[0];
      } else if (vm.townHalls.length > 1) {
        vm.facility.townHall = findItemById(vm.townHalls, vm.facility.idTownHall);
      }

      vm.buttons = {
        dial: true,
        buttonImage: 'images/ic_more_vert_white_48px.svg',
        tooltip: 'Accions',
        actions: []
      };

      if (vm.can('FACILITY', 'U')) {
        vm.buttons.actions.push({
          changeState: false,
          execute: enableEdit,
          buttonImage: 'images/ic_edit_black_48px.svg',
          tooltip: $filter('translate')('EDIT')
        })
      }

      if (vm.can('FACILITY', 'D')) {
        vm.buttons.actions.push({
          changeState: false,
          execute: deleteFacility,
          buttonImage: 'images/ic_delete_white_48px.svg',
          attrClass: 'md-warn',
          tooltip: $filter('translate')('DELETE')
        })
      }

      vm.disableEdit = function () {
        vm.facility = angular.copy(facility);
        vm.edit = false;
        actionButton.dial = true;
      };

      function enableEdit() {
        vm.edit = true;
        vm.buttons.dial = false;
      }

      function deleteFacility() {

        $mdDialog.show({
          controller: ["$scope", "$mdDialog", "$filter", function DialogController($scope, $mdDialog, $filter) {
            $scope.alertText = $filter('translate')('ALERT');
            $scope.textContent = $filter('translate')('FACILITIES.CONFIRM_DELETE');
            $scope.cancelText = $filter('translate')('CANCEL');
            $scope.deleteText = $filter('translate')('DELETE');

            $scope.hide = function () {
              $mdDialog.hide();
            };

            $scope.cancel = function () {
              $mdDialog.cancel();
            };

            $scope.delete = function () {
              //then
              $mdDialog.hide();
            };
          }],
          templateUrl: 'home/championships/championship/delete-confirmation.tmpl.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true
        })
        .then(function () {
          Facilities.delete({id: vm.facility.id},
            function () {
              $mdToast.show(
                $mdToast.simple()
                .textContent($filter('translate')('FACILITIES.SUCCESSFUL_DELETE'))
                .position('bottom left')
                .hideDelay(3000));
              $state.go('home.facilities', {}, {reload: true});
            },
            function (error) {
              $mdToast.show(
                $mdToast.simple()
                .textContent($filter('translate')('ERROR_BAD_REQUEST'))
                .position('bottom left')
                .hideDelay(3000));
            }
          )
        });
      }

      vm.submitFacility = function () {
        if (vm.hasPermission) {
          vm.facility.idTownHall = vm.facility.townHall.id;
          Facilities.update({id: $stateParams.facilityId}, vm.facility, function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')('FACILITIES.SUCCESSFUL_UPDATE'))
                .position('bottom left')
                .hideDelay(3000));
              vm.edit = false;
              vm.buttons.dial = true;
            },
            function (error) {
              var message;
              if (error.status === 404) {
                message = 'ERROR_NON_EXISTING_TOWNHALL';
              } else {
                message = 'ERROR_BAD_REQUEST';
              }
              $mdToast.show(
                $mdToast.simple()
                .textContent($filter('translate')(message))
                .position('bottom left')
                .hideDelay(3000)
              );
            });
        }
      };

      vm.markerCoords = {
        latitude: vm.facility.latitude,
        longitude: vm.facility.longitude
      };

      uiGmapGoogleMapApi.then(function (maps) {
        maps.visualRefresh = true;
        vm.geocoder = new maps.Geocoder();
      });


      vm.map = {
        center: {
          latitude: vm.markerCoords.latitude,
          longitude: vm.markerCoords.longitude
        },
        zoom: 12,
        options: {
          tilt: 45
        },
        events: {
          click: function (mapModel, eventName, eventArgs) {
            setCoordenatesWhenEditMode(eventArgs[0].latLng.lat(), eventArgs[0].latLng.lng());
          }
        },
        markers: [{
          id: 1,
          latitude: vm.markerCoords.latitude,
          longitude: vm.markerCoords.longitude
        }
        ]
      };

      vm.searchLocation = function () {
        if (vm.edit === true) {
          if (!angular.isUndefined(vm.facility.address) && !angular.isUndefined(vm.facility.zipCode) && !angular.isUndefined(vm.facility.idTown)) {
            var address = vm.facility.address + "," + vm.facility.zipCode + " " + findItemById(vm.towns, vm.facility.idTown).name;
            vm.geocoder.geocode({'address': address}, function (results, status) {
              if (!results.isUndefined || results.size() > 0) {
                setCoordenatesWhenEditMode(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                vm.map.center.latitude = vm.markerCoords.latitude;
                vm.map.center.longitude = vm.markerCoords.longitude;
              }
            })
          }
        }
      };

      function findItemById(collection, itemId) {
        return _.find(collection, function (i) {
          return i.id === itemId;
        });
      }

      function setCoordenatesWhenEditMode(latitude, longitude) {
        if (vm.edit === true) {
          vm.markerCoords.latitude = vm.facility.latitude = latitude;
          vm.markerCoords.longitude = vm.facility.longitude = longitude;
          vm.map.markers.pop();
          vm.map.markers.push({
            id: 1,
            latitude: vm.markerCoords.latitude,
            longitude: vm.markerCoords.longitude
          });
          $scope.$evalAsync();
        }
      }

    }
  }()
);

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats.newEntitat
   * @description
   *
   */
  angular
  .module('neo.home.entitats.newEntitat', [
    'ui.router',
    'ngMaterial'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.entitats.newEntitat')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.entitats.newEntitat', {
      url: '/new',
      templateUrl: 'home/entitats/new-entitat/new-entitat.tpl.html',
      controller: 'NewEntitatCtrl',
      controllerAs: 'vm',
      resolve: {
        // acl: function ($q, AclService) {
        //   if (AclService.can('ENTITY', 'C')) {
        //     // Has proper permissions
        //     return true;
        //   } else {
        //     // Does not have permission
        //     return $q.reject('Unauthorized');
        //   }
        // },
        towns: ["Poblacions", function (Poblacions) {
          return Poblacions.query().$promise;
        }],
        townhalls : ["Ajuntaments", function(Ajuntaments){
          return Ajuntaments.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.newEntitat.controller:NewEntitatCtrl
   *
   * @description
   *
   */
  NewEntitatCtrl.$inject = ["$state", "$mdToast", "$filter", "TownhallEntities", "townhalls", "towns", "entityTypes"];
  angular
      .module('neo.home.entitats.newEntitat')
      .controller('NewEntitatCtrl', NewEntitatCtrl);

  function NewEntitatCtrl($state, $mdToast, $filter, TownhallEntities, townhalls, towns, entityTypes) {
    var vm = this;
    vm.ctrlName = 'NewEntitatCtrl';
    vm.entitat = {
      townHall: {}
    };

    vm.towns = towns;
    vm.townHalls = townhalls;
    vm.entityTypes = entityTypes;
    if(vm.townHalls.length < 2){
      vm.onyOneTownHall = true;
      if (vm.townHalls.length === 1) {
        vm.entitat.townHall = vm.townHalls[0];
      }
    }

    vm.addEntitat = function () {
      TownhallEntities.save({id: vm.entitat.townHall.id}, vm.entitat, function () {
        $state.go('home.entitats', {}, {reload: true});
        $mdToast.show(
            $mdToast.simple()
                .textContent($filter('translate')('ENTITY_SUCCESSFUL_CREATE'))
                .position('bottom left')
                .hideDelay(3000)
        );
      }, function (error) {
        var errorMessage;
        if (error.status === 409) {
          errorMessage = 'ALREADY_EXISTING_ENTITY';
        } else {
          errorMessage = 'SERVER_ERROR';
        }
        $mdToast.show(
            $mdToast.simple()
                .textContent($filter('translate')(errorMessage))
                .position('bottom left')
                .hideDelay(3000)
        );
      });
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats.entitat
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat', [
    'ui.router',
    'neo.home.entitats.entitat.informacio',
      'neo.home.entitats.entitat.printCards'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.entitats.entitat')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.entitats.entitat', {
          url: '/{entitatId}',
          abstract: true,
          templateUrl: 'home/entitats/entitat/entitat.tpl.html',
          controller: 'EntitatCtrl',
          controllerAs: 'vm',
          resolve: {
            entitat: ["$stateParams", "Entitats", "$q", function ($stateParams, Entitats, $q) {
              var deferred = $q.defer();

              Entitats.get({id: $stateParams.entitatId},
                  function (data) {
                    // returned 204
                    deferred.resolve(data);
                  },
                  function (response) {
                    deferred.reject(response);
                  }
              );
              return deferred.promise;
            }],
            towns: ["Poblacions", "$q", function (Poblacions, $q) {
              var deferred = $q.defer();

              Poblacions.query(function (data) {
                    deferred.resolve(data)
                  },
                  function (response) {
                    deferred.reject(response)
                  }
              );
              return deferred.promise;
            }]
          }
        });
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.entitat.controller:EntitatCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat')
  .controller('EntitatCtrl', EntitatCtrl);

  function EntitatCtrl() {
    var vm = this;
    vm.ctrlName = 'EntitatCtrl';
    vm.currentNavItem = 'informacio';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships.newChampionship
   * @description
   *
   */
  angular
    .module('neo.home.championships.newChampionship', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.championships.newChampionship')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.championships.newChampionship', {
        url: '/new-championship',
        templateUrl: 'home/championships/new-championship/new-championship.tpl.html',
        controller: 'NewChampionshipCtrl',
        controllerAs: 'vm',
        resolve: {
          acl: ["$q", "AclService", function ($q, AclService) {
            return (AclService.can('LOCAL_PHASE', 'C')) ? true : $q.reject('Unauthorized');
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championships.newChampionship.controller:NewChampionshipCtrl
   *
   * @description
   *
   */
  NewChampionshipCtrl.$inject = ["$state", "$mdToast", "$filter", "Championships", "AclService", "genders", "programmes", "categories", "phases", "sports"];
  angular
      .module('neo.home.championships.newChampionship')
      .controller('NewChampionshipCtrl', NewChampionshipCtrl);

  function NewChampionshipCtrl($state, $mdToast, $filter, Championships, AclService,
                               genders, programmes, categories, phases, sports) {
    var vm = this;
    vm.ctrlName = 'NewChampionshipCtrl';

    vm.isAdmin = AclService.isAdmin;

    vm.genders = genders;
    vm.programmes = programmes;
    vm.categories = categories;
    vm.phases = buildPhases(phases);

    vm.sports = sports;
    vm.championshipTypes = buildChampionshipTypes();

    vm.championship = {
      programmeId: 1,
      typeId: 1,
      jvp: false,
      winPoints: 3,
      drawPoints: 2,
      lostPoints: 1,
      editableMatches: true,invisible:false
    };
    vm.saveChampionship = saveChampionship;

    function buildChampionshipTypes() {
      return [
        {
          id: 1,
          name: 'Lliga'
        }
      ];
    }

    function buildPhases(phases) {
      if (vm.isAdmin()) {
        return phases;
      } else {
        return filterLocalPhases(phases);
      }
    }

    function filterLocalPhases(phases) {
      return _.filter(phases, function (phase) {
        return phase.type === 'LOCAL';
      });
    }

    function saveChampionship() {
      Championships.save(vm.championship, function () {
        $state.go('home.championships', {}, {reload: true});
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CHAMPIONSHIPS.SUCCESSFUL_CREATE'))
            .position('bottom left')
            .hideDelay(3000)
        );
      }, function (err) {
        var errorMessage = err.status === 400
          ? err.data.message || 'BAD_REQUEST_CHAMPIONSHIP'
          : 'SERVER_ERROR';
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(errorMessage))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championships.championship
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship', [
      'ui.router',
      'neo.home.championships.championship.assignTeams',
      'neo.home.championships.championship.draw',
      'neo.home.championships.championship.assignMatches',
      'neo.home.championships.championship.editMatches'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
      .module('neo.home.championships.championship')
      .config(config);

  function config($stateProvider) {
    $stateProvider
        .state('home.championships.championship', {
          url: '/{championshipId}',
          templateUrl: 'home/championships/championship/championship.tpl.html',
          controller: 'ChampionshipCtrl',
          controllerAs: 'vm',
          resolve: {
            championship: ["Championship", "$stateParams", function (Championship, $stateParams) {
              return Championship.query({id: $stateParams.championshipId}).$promise;
            }]
          }
        });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name championships.championship.controller:ChampionshipCtrl
     *
     * @description
     *
     */
    ChampionshipCtrl.$inject = ["$mdDialog", "$mdToast", "$filter", "$stateParams", "$state", "AclService", "Championship", "championship", "genders", "sports", "categories", "phases", "programmes"];
    angular
      .module('neo.home.championships.championship')
      .controller('ChampionshipCtrl', ChampionshipCtrl);

    function ChampionshipCtrl($mdDialog, $mdToast, $filter, $stateParams, $state, AclService,
                              Championship, championship, genders, sports, categories, phases, programmes) {
      var vm = this;
      vm.ctrlName = 'ChampionshipCtrl';
      vm.can = AclService.can;
      vm.isAdmin = AclService.isAdmin;

      vm.championship = championship;
      vm.championship.typeId = 1;
      vm.sports = sports;
      vm.categories = categories;
      vm.genders = genders;
      vm.phases = buildPhases(phases);
      vm.programmes = programmes;
      vm.championshipTypes = buildChampionshipTypes();


      vm.updateChampionship = updateChampionship;

      vm.edit = false;

      vm.hasPermissionToModifyMatches = hasPermissionToModifyMatches;
      vm.buttons = {
        dial: true,
        icon: 'more_vert',
        tooltip: 'ACTIONS',
        actions: []
      };

      if (vm.championship.owner) {
        vm.buttons.actions.push({
          icon: 'edit',
          tooltip: 'EDIT',
          execute: enableEdit
        });
        vm.buttons.actions.push({
          icon: 'delete',
          attrClass: 'md-warn',
          tooltip: 'DELETE',
          execute: removeChampionship
        });
        vm.buttons.actions.push({
          icon: 'playlist_add',
          tooltip: 'CHAMPIONSHIPS.ASSIGN_TEAMS',
          execute: assignTeams
        });
        vm.buttons.actions.push({
          buttonImage: 'images/draw.svg',
          tooltip: 'CHAMPIONSHIPS.DRAW.DRAW_CHAMPIONSHIP',
          execute: drawChampionship
        });
      }

      if (isNotJvp(vm.championship) && vm.championship.hasBeenDrawn) {
        vm.buttons.actions.push({
          icon: 'format_list_numbered',
          tooltip: 'CHAMPIONSHIPS.CLASSIFICATION',
          execute: showClassification
        });
      }

      if (vm.championship.hasBeenDrawn && hasPermissionToModifyMatches()) {
        vm.buttons.actions.push({
          icon: 'assignment',
          tooltip: 'CHAMPIONSHIPS.ASSIGN_MATCHES',
          execute: assignMatches
        });
      }

      if (vm.isAdmin() || (vm.championship.owner && vm.championship.editableMatches)) {
        vm.buttons.actions.push({
          icon: 'settings',
          tooltip: 'CHAMPIONSHIPS.EDIT_CALENDAR',
          execute: editMatches
        });
      }

      function buildChampionshipTypes() {
        return [
          {
            id: 1,
            name: 'Lliga'
          }
        ];
      }

      function buildPhases(phases) {
        if (vm.isAdmin()) {
          return phases;
        }
        else if (vm.championship.owner) {
          return filterLocalPhases(phases);
        }
        else {
          return [findItemById(phases, vm.championship.phaseId)];
        }

      }

      function filterLocalPhases(phases) {
        return _.filter(phases, function (phase) {
          return phase.type === 'LOCAL';
        });
      }


      function findItemById(collection, itemId) {
        return _.find(collection, function (i) {
          return i.id === itemId;
        });
      }
      function hasPermissionToModifyMatches() {
        return AclService.isAdmin() || (vm.championship.owner && vm.championship.editableMatches) || vm.championship.editableMatches;
      }

      function isNotJvp(championship) {
        return !championship.jvp;
      }

      function enableEdit() {
        vm.edit = true;
        vm.buttons.dial = false;
      }

      function disableEdit() {
        vm.edit = false;
        vm.buttons.dial = true;
      }

      function updateChampionship() {
        Championship.update({id: $stateParams.championshipId}, vm.championship, function () {
          disableEdit();
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('CHAMPIONSHIPS.SUCCESSFUL_UPDATE'))
              .position('bottom left')
              .hideDelay(3000)
          );
          $state.reload();
        }, function (err) {
          var message = err.data.message || 'ERROR_UPDATE';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
      }

      function removeChampionship() {

        $mdDialog.show({
          controller: ["$scope", "$mdDialog", "$filter", function DialogController($scope, $mdDialog, $filter) {
            $scope.alertText = $filter('translate')('ALERT');
            $scope.textContent = $filter('translate')('CHAMPIONSHIPS.DELETE_ALERT');
            $scope.cancelText = $filter('translate')('CANCEL');
            $scope.deleteText = $filter('translate')('DELETE');

            $scope.hide = function () {
              $mdDialog.hide();
            };

            $scope.cancel = function () {
              $mdDialog.cancel();
            };

            $scope.delete = function () {
              //then
              $mdDialog.hide();
            };
          }],
          templateUrl: 'home/championships/championship/delete-confirmation.tmpl.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true
        })
          .then(function () {
            Championship.delete({id: vm.championship.id}, function () {
              $state.go('home.championships', {}, {reload: true});
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')('CHAMPIONSHIPS.SUCCESSFUL_DELETE'))
                  .position('bottom left')
                  .hideDelay(3000)
              );
            }, function (err) {
              var message = err.data || 'ERROR_DELETE';
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')(message))
                  .position('bottom left')
                  .hideDelay(3000)
              );
            });
          });
      }

      function assignTeams() {
        $state.go('home.championships.championship.assignTeams');
      }

      function drawChampionship() {
        $state.go('home.championships.championship.draw');
      }

      function showClassification() {
        $state.go('public.classification', {championshipId: $stateParams.championshipId});
      }

      function assignMatches() {
        $state.go('home.championships.championship.assignMatches');
      }

      function editMatches() {
        $state.go('home.championships.championship.editMatches');
      }

    }
  }()
);


(function () {
  'use strict';

  /* @ngdoc object
   * @name cancellations.newCancellation
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.new', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.cancellations.new')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations.new', {
        url: '^/home/matches/{matchId}/cancellation/new',
        templateUrl: 'home/cancellations/new-cancellation/new-cancellation.tpl.html',
        controller: 'NewCancellationCtrl',
        controllerAs: 'vm',
        resolve: {
          cancellationTypes: ["CancellationTypesPublic", function (CancellationTypesPublic) {
            return CancellationTypesPublic.query().$promise;
          }],
          match: ["Matches", "$stateParams", function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cancellations.newCancellation.controller:NewCancellationCtrl
   *
   * @description
   *
   */
  NewCancellationCtrl.$inject = ["$state", "$mdToast", "$filter", "Cancellations", "cancellationTypes", "match"];
  angular
    .module('neo.home.cancellations.new')
    .controller('NewCancellationCtrl', NewCancellationCtrl);

  function NewCancellationCtrl($state, $mdToast, $filter, Cancellations, cancellationTypes, match) {
    var vm = this;
    vm.ctrlName = 'NewCancellationCtrl';

    vm.cancellationTypes = cancellationTypes;

    vm.localTeam = match.localTeam;
    vm.localTeam.columnName = 'CHAMPIONSHIPS.LOCAL_TEAM';

    vm.visitorTeam = match.visitorTeam;
    vm.visitorTeam.columnName = 'CHAMPIONSHIPS.VISITOR_TEAM';

    vm.saveCancellation = saveCancellation;

    function saveCancellation() {
      Cancellations.save({id: match.id}, vm.cancellation, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CANCELLATIONS.SUCCESS_CREATION'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.cancellations', {}, {reload: true});
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'CANCELLATIONS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.cancellations.edit
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.edit', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.cancellations.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations.edit', {
        url: '^/home/matches/{matchId}/cancellation/edit',
        templateUrl: 'home/cancellations/edit-cancellation/edit-cancellation.tpl.html',
        controller: 'EditCancellationCtrl',
        controllerAs: 'vm',
        resolve: {
          cancellationTypes: ["CancellationTypesPublic", function (CancellationTypesPublic) {
            return CancellationTypesPublic.query().$promise;
          }],
          match: ["Matches", "$stateParams", function (Matches, $stateParams) {
            return Matches.get({id: $stateParams.matchId}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cancellations.editCancellation.controller:EditCancellationCtrl
   *
   * @description
   *
   */
  EditCancellationCtrl.$inject = ["$mdToast", "$filter", "$state", "LastCancellation", "cancellationTypes", "match"];
  angular
    .module('neo.home.cancellations.edit')
    .controller('EditCancellationCtrl', EditCancellationCtrl);

  function EditCancellationCtrl($mdToast, $filter, $state, LastCancellation, cancellationTypes, match) {
    var vm = this;
    vm.ctrlName = 'EditCancellationCtrl';

    vm.cancellationTypes = cancellationTypes;

    vm.cancellation = _.cloneDeep(match.lastCancellation);

    vm.localTeam = match.localTeam;
    vm.localTeam.columnName = 'CHAMPIONSHIPS.LOCAL_TEAM';

    vm.visitorTeam = match.visitorTeam;
    vm.visitorTeam.columnName = 'CHAMPIONSHIPS.VISITOR_TEAM';

    vm.editCancellation = editCancellation;
    vm.cancelEdition = cancelEdition;

    function cancelEdition() {
      vm.cancellation = _.cloneDeep(match.lastCancellation);
    }

    function editCancellation() {
      var postObject = {};
      postObject.typeId = vm.cancellation.typeId;
      postObject.details = vm.cancellation.details;

      LastCancellation.update({id: match.id}, postObject, function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('CANCELLATIONS.SUCCESS_EDITION'))
            .position('bottom left')
            .hideDelay(3000)
        );
        $state.go('home.cancellations.canceledMatches');
      }, function (error) {
        var message;
        if (error.status === 400) {
          message = 'CANCELLATIONS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.cancellations.canceledMatches
   * @description
   *
   */
  angular
    .module('neo.home.cancellations.canceledMatches', [
      'ui.router',
      'neo.home.cancellations.canceledMatches.postponeCanceledMatches'

    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.cancellations.canceledMatches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations.canceledMatches', {
        url: '/canceled-matches',
        templateUrl: 'home/cancellations/canceled-matches/canceled-matches.tpl.html',
        controller: 'CanceledMatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          cancellationTypes: ["CancellationTypesPublic", function (CancellationTypesPublic) {
            return CancellationTypesPublic.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function (CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cancellations.canceledMatches.controller:CanceledMatchesCtrl
   *
   * @description
   *
   */
  CanceledMatchesCtrl.$inject = ["$state", "$mdToast", "$q", "$filter", "Matches", "LastCancellation", "Entitats", "AclService", "currentSeason", "townHalls", "cancellationTypes"];
  angular
    .module('neo.home.cancellations.canceledMatches')
    .controller('CanceledMatchesCtrl', CanceledMatchesCtrl);

  function CanceledMatchesCtrl($state, $mdToast, $q, $filter, Matches, LastCancellation, Entitats, AclService, currentSeason, townHalls, cancellationTypes) {
    var vm = this;
    vm.ctrlName = 'CanceledMatchesCtrl';

    vm.cancellationTypes = cancellationTypes;

    vm.showList = false;
    vm.matches = [];
    vm.today = moment().toDate();
    vm.endDate = vm.today;
    vm.initDate = moment(currentSeason.iniDate).toDate();
    vm.townhalls = _.cloneDeep(townHalls);

    vm.currentPage = 1;
    vm.matchesPerPage = 25;

    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      applyFilters();
    }


    vm.applyFilters = applyFilters;
    vm.showPostponeButton = showPostponeButton;
    vm.showEditButton = showEditButton;
    vm.showResolveSwitch = showResolveSwitch;
    vm.updateMatchState = updateMatchState;
    vm.editCancellation = editCancellation;
    vm.postponeCancellation = postponeCancellation;

    function showEditButton(match) {
      return !match.lastCancellation.resolved;
    }

    function postponeCancellation(match) {
      $state.go('home.cancellations.canceledMatches.postponeCanceledMatches', {matchId: match.id})
    }

    function editCancellation(match) {
      $state.go('home.cancellations.edit', {matchId: match.id})
    }

    function showPostponeButton(match) {
      return !match.lastCancellation.type.committee && !match.lastCancellation.resolved;
    }

    function showResolveSwitch(match) {
      return match.lastCancellation.type.committee && AclService.isAdmin();
    }

    function updateMatchState(match) {
      var postObject = {};
      postObject.resolved = match.lastCancellation.resolved;

      LastCancellation.update({id: match.id}, postObject, function () {
        if (match.lastCancellation.resolved) {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('CANCELLATIONS.RESOLVED_EDITION'))
              .position('bottom left')
              .hideDelay(3000)
          );
        } else {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('CANCELLATIONS.UNRESOLVED_EDITION'))
              .position('bottom left')
              .hideDelay(3000)
          );
        }
      }, function (error) {
        match.lastCancellation.resolved = !match.lastCancellation.resolved;
        var message;
        if (error.status === 400) {
          message = 'CANCELLATIONS.' + error.data.message;
        } else {
          message = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')(message))
            .position('bottom left')
            .hideDelay(3000)
        );
      });
    }

    function applyFilters() {
      vm.isFiltered = true;
      query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
    }


    function queryMyEntities() {
      Entitats.query(function (data) {
        vm.myEntities = data;
        if (vm.matches.length !== 0) {
          vm.showList = true;
        }
      })
    }

    function query(townHallId, initDate, endDate, page, sort) {
      var deferredMatches = $q.defer();
      vm.promiseMatches = deferredMatches.promise;
      var parameters = {
        townHall: townHallId,
        initDate: moment(initDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        page: page,
        size: vm.matchesPerPage,
        cancellation: true
      };
      //Optional parameters
      if (angular.isDefined(sort)) {
        parameters.sort = sort;
      }
      Matches.get(parameters, function (data) {
        _.remove(vm.matches);
        angular.forEach(data.matches, function (match) {
          vm.matches.push(parseMatch(data, match));
        });
        queryMyEntities();
        vm.maxMatches = data.page.count;
        deferredMatches.resolve();
      }, function () {
        deferredMatches.resolve();
      });
    }

    function parseMatch(data, match) {
      var facility = findItemById(data.facilities, match.facilityId);
      var localTeam = findItemById(data.teams, match.localTeamId);
      var visitorTeam = findItemById(data.teams, match.visitorTeamId);
      return {
        id: match.id,
        localTeam: angular.isDefined(localTeam) ? localTeam : {name: $filter('translate')('CALENDAR.REST')},
        visitorTeam: angular.isDefined(visitorTeam) ? visitorTeam : {name: $filter('translate')('CALENDAR.REST')},
        date: moment(match.date).format('L'),
        time: match.time === null ? undefined : match.time,
        facility: angular.isDefined(facility) ? facility : undefined,
        championship: findItemById(data.championships, match.championshipId).name,
        lastCancellation: parseCancellation(match)
      };
    }

    function parseCancellation(match) {
      return {
        id: match.lastCancellation.id,
        resolved: match.lastCancellation.resolved,
        typeId: match.lastCancellation.typeId,
        type: findItemById(vm.cancellationTypes, match.lastCancellation.typeId),
        details: match.lastCancellation.details
      }
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name ajuntaments.newAjuntament
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.newAjuntament', [
    'ui.router',
    'ngMaterial'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments.newAjuntament')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments.newAjuntament', {
      url: '/new',
      templateUrl: 'home/ajuntaments/new-ajuntament/new-ajuntament.tpl.html',
      controller: 'NewAjuntamentCtrl',
      controllerAs: 'vm',
      resolve: {
        acl: ["$q", "AclService", function ($q, AclService) {
          if (AclService.can('TOWN_HALL', 'C')) {
            // Has proper permissions
            return true;
          } else {
            // Does not have permission
            return $q.reject('Unauthorized');
          }
        }],
        towns: ["Poblacions", function (Poblacions) {
          return Poblacions.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name ajuntaments.newAjuntament.controller:NewAjuntamentCtrl
   *
   * @description
   *
   */
  NewAjuntamentCtrl.$inject = ["Ajuntaments", "towns", "$state", "$mdToast", "$filter"];
  angular
  .module('neo.home.ajuntaments.newAjuntament')
  .controller('NewAjuntamentCtrl', NewAjuntamentCtrl);

  function NewAjuntamentCtrl(Ajuntaments, towns, $state, $mdToast, $filter) {
    var vm = this;
    vm.ctrlName = 'NewAjuntamentCtrl';
    vm.ajuntament = {};

    vm.towns = towns;

    vm.addAjuntament = function () {
      Ajuntaments.save(vm.ajuntament, function () {
        $state.go('home.ajuntaments', {}, {reload: true});

        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')('TOWN_HALL_SUCCESSFUL_CREATE'))
          .position('bottom left')
          .hideDelay(3000)
        );
      }, function (error) {
        var errorMessage;
        if (error.status === 409) {
          errorMessage = 'ALREADY_EXISTING_TOWN_HALL';
        } else if (error.status === 403) {
          errorMessage = 'NO_PERMISSIONS';
        } else {
          errorMessage = 'SERVER_ERROR';
        }
        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')(errorMessage))
          .position('bottom left')
          .hideDelay(3000)
        );
      });
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name ajuntaments.ajuntament
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament', [
    'neo.home.ajuntaments.ajuntament.informacio'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments.ajuntament')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments.ajuntament', {
      url: '/{ajuntamentId}',
      abstract: true,
      templateUrl: 'home/ajuntaments/ajuntament/ajuntament.tpl.html',
      controller: 'AjuntamentCtrl',
      controllerAs: 'vm',
      resolve: {
        ajuntament: ["$stateParams", "Ajuntaments", "$q", function ($stateParams, Ajuntaments, $q) {
          var deferred = $q.defer();
          Ajuntaments.get({id: $stateParams.ajuntamentId},
            function (data) {
              // returned 204
              deferred.resolve(data);
            },
            function (response) {
              deferred.reject(response);
            }
          );
          return deferred.promise;
        }],
        towns: ["Poblacions", "$q", function (Poblacions, $q) {
          var deferred = $q.defer();
          Poblacions.query(function (data) {
              deferred.resolve(data)
            },
            function (response) {
              deferred.reject(response)
            }
          );
          return deferred.promise;
        }]
      }
    })
    ;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name ajuntaments.ajuntament.controller:AjuntamentCtrl
   *
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament')
  .controller('AjuntamentCtrl', AjuntamentCtrl);

  function AjuntamentCtrl() {
    var vm = this;
    vm.ctrlName = 'AjuntamentCtrl';
    vm.currentNavItem = 'informacio';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.services.auth
   * @description
   *
   */
  angular
  .module('neo.services.auth', [
    'ngResource'
  ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.auth.factory:Tokens
   *
   * @description
   *
   */
  Tokens.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services.auth')
  .factory('Tokens', Tokens);

  function Tokens($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/auth/tokens/:token', {token: '@_token'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.auth.factory:ResetPassword
   *
   * @description
   *
   */
  ResetPassword.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services.auth')
  .factory('ResetPassword', ResetPassword);

  function ResetPassword($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/auth/resetPassword');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.auth.factory:PasswordToken
   *
   * @description
   *
   */
  PasswordToken.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services.auth')
  .factory('PasswordToken', PasswordToken);

  function PasswordToken($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/auth/passwordToken/:token', {token: '@_token'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.auth.factory:NewPassword
   *
   * @description
   *
   */
  NewPassword.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services.auth')
  .factory('NewPassword', NewPassword);

  function NewPassword($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/auth/newPassword', null, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc neo.services
   * @name neo.services.auth.factory:Authentication
   *
   * @description
   *
   */
  AuthenticationService.$inject = ["$http", "$q", "EnvironmentConfig"];
  angular
    .module('neo.services.auth')
    .factory('AuthenticationService', AuthenticationService);

  function AuthenticationService($http, $q, EnvironmentConfig) {
    var AuthenticationBase = {};
    AuthenticationBase.login = login;
    AuthenticationBase.logout = logout;
    return AuthenticationBase;


    function login(username, password) {
      var deferred = $q.defer();

      $http.post(EnvironmentConfig.API + '/auth/login',
        {username: username, password: password}, {
          skipAuthorization: true
        })
        .then(function (response) {
          // login successful if there's a token in the response
          var authorization = response.headers('Authorization');
          if (authorization) {
            var token = authorization.replace('Bearer ', '');
            // store username and token in local storage to keep user logged in between page refreshes
            localStorage.setItem('id_token', token);

            // add jwt token to auth header for all requests made by the $http service
            $http.defaults.headers.common.Authorization = authorization;

            // execute callback with true to indicate successful login
            deferred.resolve();
          } else {
            // execute callback with false to indicate failed login
            deferred.reject(response);
          }
        }, function (response) {
          deferred.reject(response);
        });
      return deferred.promise;
    }

    function logout() {
      // remove user from local storage and clear http auth header
      delete localStorage.removeItem('id_token');
      $http.defaults.headers.common.Authorization = '';
    }
  }

}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.public.resultats', [
      'ui.router'
    ]);
}());
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

            config.$inject = ["$stateProvider"];
  angular
  .module('neo.public.resultats')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('public.resultats', {
      url: '/resultats/{idPartit}',
     
          templateUrl: 'public/resultats/resultats.tpl.html',
          controller: 'resultatsCtrl2',
          controllerAs: 'vm'
        ,
      resolve:{
       
        resultat: ["resultats2", "$stateParams", function ( resultats2,$stateParams){
          return resultats2.query({idPartit :  $stateParams.idPartit}).$promise;
    }]
      }
    })
            ; }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  angular
    .module('neo.public.resultats')
    .controller('resultatsCtrl2', resultatsCtrl2);

  function resultatsCtrl2() {
   var vm = this;
   
   
 
  }
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championship.classification
   * @description
   *
   */
  angular
    .module('neo.public.classification', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.public.classification')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('public.classification', {
        url: '/championships/{championshipId}/classification',
        templateUrl: 'public/classification/classification.tpl.html',
        controller: 'ClassificationCtrl',
        controllerAs: 'vm',
        resolve: {
          championship: ["ChampionshipPublic", "$stateParams", function (ChampionshipPublic, $stateParams) {
            return ChampionshipPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          teams: ["ChampionshipTeamsPublic", "$stateParams", function (ChampionshipTeamsPublic, $stateParams) {
            return ChampionshipTeamsPublic.query({id: $stateParams.championshipId}).$promise;
          }],
          classification: ["ChampionshipClassification", "$stateParams", function (ChampionshipClassification, $stateParams) {
            return ChampionshipClassification.query({id: $stateParams.championshipId}).$promise;
          }],
          matchDay: ["ChampionshipMatchesPublic", "$stateParams", function (ChampionshipMatchesPublic, $stateParams) {
            return ChampionshipMatchesPublic.get({id: $stateParams.championshipId}).$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name championship.classification.controller:ClassificationCtrl
   *
   * @description
   *
   */
  ClassificationCtrl.$inject = ["classification", "championship", "matchDay", "teams", "genders", "sports", "categories", "ChampionshipMatchesPublic", "ChampionshipClassification", "$stateParams", "$filter", "$q"];
  angular
      .module('neo.public.classification')
      .controller('ClassificationCtrl', ClassificationCtrl);

  function ClassificationCtrl(classification, championship, matchDay, teams, genders, sports, categories, ChampionshipMatchesPublic, ChampionshipClassification, $stateParams, $filter, $q) {
    var vm = this;
    vm.ctrlName = 'ClassificationCtrl';

    vm.championship = championship;

    vm.category = $filter('translate')('CATEGORIES.' + findItemById2(categories, vm.championship.categoryId).name);
    vm.sport = $filter('translate')('SPORTS.' + findItemById2(sports, vm.championship.sportId).name);
    vm.gender = $filter('translate')(findItemById2(genders, vm.championship.genderId).name);

    vm.paginationLabel = {
      page: $filter('translate')('CHAMPIONSHIPS.MATCH_DAY_LABEL'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };
    vm.maxMatches = (teams.length % 2) ? teams.length * vm.championship.rounds : (teams.length) - 1 * vm.championship.rounds;
    vm.matchesPerPage = 1;
    vm.currentMatch = matchDay.number;

    vm.classification = classification;
    parseClassifications(vm.classification);

    vm.classificationHeaders = [
      'CHAMPIONSHIPS.TEAM',
      'CHAMPIONSHIPS.POINTS',
      'CHAMPIONSHIPS.PLAYED_GAMES',
      'CHAMPIONSHIPS.WINS',
      'CHAMPIONSHIPS.TIES',
      'CHAMPIONSHIPS.LOSES',
      'CHAMPIONSHIPS.SCORE_FOR',
      'CHAMPIONSHIPS.SCORE_AGAINST',
      'CHAMPIONSHIPS.PENALTIES'
    ];

    vm.matchDay = matchDay;
    parseMatches(vm.matchDay);

    vm.matchHeaders = [
      'CHAMPIONSHIPS.LOCAL_TEAM',
      'CHAMPIONSHIPS.LOCAL_SCORE',
      'CHAMPIONSHIPS.VISITOR_SCORE',
      'CHAMPIONSHIPS.VISITOR_TEAM'
    ];

    vm.getNewPage = function (page) {
      var deferredClassification = $q.defer();
      vm.promiseClassification = deferredClassification.promise;
      ChampionshipClassification.query({id: $stateParams.championshipId, matchday: page}, function (data) {
        vm.classification = data;
        parseClassifications(vm.classification);
        deferredClassification.resolve();
      });
      var deferredMatches = $q.defer();
      vm.promiseMatches = deferredMatches.promise;
      ChampionshipMatchesPublic.get({id: $stateParams.championshipId, matchday: page}, function (data) {
        vm.matchDay = data;
        parseMatches(vm.matchDay);
        deferredMatches.resolve();
      });
    };

    function parseClassifications(classification) {
      angular.forEach(classification, function (teamResult) {
        teamResult.teamName = findItemById(teams, 'id', teamResult.teamId).name;
      });
    }

    function parseMatches(matchDay) {
      angular.forEach(matchDay.matches, function (match) {
        match.localTeam = match.localTeamId !== null
          ? findItemById(teams, 'id', match.localTeamId).name
            : $filter('translate')('CALENDAR.REST');
        match.localScore = match.localScore !== null ? match.localScore : '-';
        match.visitorTeam = match.visitorTeamId !== null
          ? findItemById(teams, 'id', match.visitorTeamId).name
            : $filter('translate')('CALENDAR.REST');
        match.visitorScore = match.visitorScore !== null ? match.visitorScore : '-';
      });
    }

    function findItemById(collection, fieldId, itemId) {
      return _.find(collection, function (i) {
        return i[fieldId] === itemId;
      });
    }
function findItemById2(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.public.classificacio', [
      'ui.router'
    ]);
}());


(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.public.classificacio')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('public.classificacio', {
        url: '/classificacio/{idCampionat}',
        templateUrl: 'public/classificacio/classificacio.tpl.html',
       
        controller: 'classificacioCtrl',
        controllerAs: 'vm',
        resolve: {
          classificacions: ["Classificacio", "$stateParams", function (Classificacio,$stateParams) {
            return Classificacio.query({idCampionat :  $stateParams.idCampionat}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  classificacioCtrl.$inject = ["classificacions"];
  angular
    .module('neo.public.classificacio')
    .controller('classificacioCtrl', classificacioCtrl);

  function classificacioCtrl(classificacions) {
   var vm = this;
  
   
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name public.calendar
   * @description
   *
   */
  angular
    .module('neo.public.calendar', [
      'ui.router',
      'neo.public.calendar.championship'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.public.calendar')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('public.calendar', {
        url: '/calendar',
        templateUrl: 'public/calendar/calendar.tpl.html',
        controller: 'CalendarCtrl',
        controllerAs: 'vm',
        resolve: {
          championships: ["ChampionshipsPublic", function (ChampionshipsPublic) {
            return ChampionshipsPublic.query().$promise;
          }],
          phases: ["PhasesPublic", function (PhasesPublic) {
            return PhasesPublic.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name public.calendar.controller:CalendarCtrl
   *
   * @description
   *
   */
  CalendarCtrl.$inject = ["$filter", "championships", "sports", "phases", "categories", "genders"];
  angular
    .module('neo.public.calendar')
    .controller('CalendarCtrl', CalendarCtrl);

  function CalendarCtrl($filter, championships, sports, phases, categories, genders) {
    var vm = this;
    vm.ctrlName = 'CalendarCtrl';

    vm.championships = _.cloneDeep(championships);

    vm.sports = _.map(sports, translateSport);
    vm.categories = _.map(categories, translateCategory);
    vm.genders = genders;
    vm.phases = phases;
 
     

    angular.forEach(vm.championships, function (championship) {
      championship.nameOrder = $filter('lowercase')(championship.name);
      championship.sport = findItemById(vm.sports, championship.sportId).name;
      var category = findItemById(vm.categories, championship.categoryId);
      championship.category = category.name;
      championship.categoryOrder = category.startYear;
      championship.gender = $filter('translate')(findItemById(vm.genders, championship.genderId).name);
      var phase = findItemById(vm.phases, championship.phaseId);
      championship.phase = phase.name;
      championship.phaseOrder = phase.iniDate;
    });

    vm.filteredChampionships = _.cloneDeep(vm.championships);


    vm.filteredChampionshipsRef = vm.filteredChampionships;

    vm.data = {
      title: 'CHAMPIONSHIPS.SELECT',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'CHAMPIONSHIPS.NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'sport', name: 'SPORT', canOrder: true},
        {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
        {id: 'gender', name: 'GENDER', canOrder: true},
        {id: 'phase', name: 'PHASES.PHASE', canOrder: true, orderBy: 'phaseOrder'}
      ],
      state: {
        slink: 'public.championshipCalendar', params: [
          {key: 'championshipId', value: 'id'}
        ]
      },
      filters: [
        {
          label: 'PHASES.SELECT',
          showField: 'name',
          filterParam: 'phaseId',
          filterField: 'id',
          options: vm.phases,
          selectedItem: undefined,
          eventRefreshData: filterChampionships
        },
        {
          label: 'SPORTS.SELECT',
          showField: 'name',
          filterParam: 'sportId',
          filterField: 'id',
          options: vm.sports,
          selectedItem: undefined,
          eventRefreshData: filterChampionships
        },
        {
          label: 'CATEGORIES.SELECT',
          showField: 'name',
          filterParam: 'categoryId',
          filterField: 'id',
          options: vm.categories,
          selectedItem: undefined,
          eventRefreshData: filterChampionships
        }
      ],
      //defaultOrderBy: ['phaseOrder', 'sport', 'categoryOrder', 'gender'],
      //defaultTypeOrderBy: [true, true, false, true],
      defaultOrderBy: ['phaseOrder', 'sport', 'categoryOrder', 'nameOrder'],
      defaultTypeOrderBy: [false, true, false, true],
      values: vm.filteredChampionships
    };

    function filterChampionships() {
      var filterObj = {};
      angular.forEach(vm.data.filters, function (filter) {
        if (hasValue(filter.selectedItem)) {
          filterObj[filter.filterParam] = filter.selectedItem[filter.filterField];
        }
      });

      return _.filter(vm.championships, filterObj);
    }

    function hasValue(field) {
      return angular.isDefined(field) && field !== null;
    }

    function translateSport(sport) {
      sport.name = $filter('translate')('SPORTS.' + sport.name);
      return sport;
    }

    function translateCategory(category) {
      category.name = $filter('translate')('CATEGORIES.' + category.name);
      return category;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.votacio', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
 votaciotutorgradaCtrl.$inject = ["resultat", "perfil", "$state", "$scope", "equip", "valoraciones", "items", "partit", "valoracions"];
  angular
    .module('neo.home.votacio')
    .controller('votaciotutorgradaCtrl', votaciotutorgradaCtrl);

  function votaciotutorgradaCtrl(resultat,perfil, $state,$scope,equip,valoraciones,items,partit, valoracions)
  {
     var vm=this;
    // vm.items=items.slice(0,items.length-1);
    vm.items=items;
    vm.show=false;
     vm.observacions=items[items.length-1].valor;
     if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       puntsVisitant:0,totpunts:0,
       idEquipo:resultat[0].idVisitant,
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
     if (vm.observacions===0){
         vm.observacions="";
     }
     vm.itempos=[];
     vm.valoracions=valoraciones;
    
     vm.perfil=perfil;
    
      $scope.opcions=[];
      $scope.valors=[];
 //     $scope.opcions[0]= [{ id: 1, name: "Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 //     $scope.opcions[1]= [{ id: 1, name: "2Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[2]= [{ id: 1, name: "3Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[3]= [{ id: 1, name: "4Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[4]= [{ id: 1, name: "5Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
////  $scope.opcions[5]= [{ id: 1, name: "6Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[6]= [{ id: 1, name: "7Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 $scope.item1={iditem:0,nom:"",respetoa:""};
 $scope.opcions1=[];
 var valorspos1=[];
 var valorscsv1=[];
 $scope.item2={iditem:0,nom:"",respetoa:""};
 $scope.opcions2=[];
 var valorspos2=[];
 var valorscsv2=[];
 $scope.item3={iditem:0,nom:"",respetoa:""};
 $scope.opcions3=[];
 var valorspos3=[];
 var valorscsv3=[];
 $scope.item13={iditem:0,nom:"",respetoa:""};
 $scope.opcions13=[];
 var valorspos13=[];
 var valorscsv13=[];
 $scope.item14={iditem:0,nom:"",respetoa:""};
 $scope.opcions14=[];
 var valorspos14=[];
 var valorscsv14=[];
 $scope.item15={iditem:0,nom:"",respetoa:""};
 $scope.opcions15=[];
 var valorspos15=[];
 var valorscsv15=[];
 $scope.item16={iditem:0,nom:"",respetoa:""};
 $scope.opcions16=[];
 var valorspos16=[];
 var valorscsv16=[];

    for(var j=0;j<vm.items.length;j++)
     {    
       
         if(vm.items[j].iditem===1){
             $scope.item1.iditem=1;
             $scope.item1.nom=vm.items[j].nom;
             $scope.item1.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions1[i]={id:i,name:a[i],selec:0};
             valorspos1[i]=valors[i];
             valorscsv1[i]=a[i];
         }
         }
         if(vm.items[j].iditem===2){
             $scope.item2.iditem=2;
             $scope.item2.nom=vm.items[j].nom;
             $scope.item2.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions2[i]={id:i,name:a[i],selec:0};
             valorspos2[i]=valors[i];
             valorscsv2[i]=a[i];
         }
         }
         if(vm.items[j].iditem===3){
             $scope.item3.iditem=3;
             $scope.item3.nom=vm.items[j].nom;
             $scope.item3.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions3[i]={id:i,name:a[i],selec:0};
             valorspos3[i]=valors[i];
             valorscsv3[i]=a[i];
         }
         }
        
        
      
       
         
         var a=vm.items[j].valorsCSV.split(";"); 
         var valors=vm.items[j].valoresposbiles.split(";");
         var c=[];
         var valorspos=[];
         var seleccionat=[];
         if ((vm.items[j].iditem===35)||(vm.items[j].iditem===36)||(vm.items[j].iditem===42)||(vm.items[j].iditem===43)){
             for(var i=0;i<100;i++){
             c[i]={id:i,name:i.toString(),selec:0};
             valorspos[i]=i.toString();
         }
         }else{
         for(var i=0;i<a.length;i++){
             c[i]={id:i,name:a[i],selec:0};
             valorspos[i]=valors[i];
         }}
    //$scope.opcions[j]([{ id: 1, name: "Gairebé mai"}, { id: 2, name:"Algunes vegades"}, { id: 3, name:"Sovint"}, { id: 4, name:"Gairebé sempre"}]);
 $scope.opcions[j]=c;
 $scope.valors[j]=valorspos;
 
 
      }
      $scope.seleccionat=[];
      var d=0;
       for (var f=0;f<vm.valoracions.length;f++)
              {
                 // for (var g=0;g<vm.items.length;g++)
                      
        //        if(vm.items[g].iditem===vm.valoracions[f].item) 
         //   {
            if(vm.valoracions[f].item===44){
               // alert(vm.valoracions[f].observacions);
                $scope.observ=vm.valoracions[f].observacions;}
      //      }else{
                   
                     if(vm.valoracions[f].item===1){
                         var i=valorspos1.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init1=$scope.opcions1[i].name;
                    }
                    
                     if(vm.valoracions[f].item===2){
                         var i=valorspos2.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init2=$scope.opcions2[i].name;
                    }
                    
                     if(vm.valoracions[f].item===3){
                         var i=valorspos3.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init3=$scope.opcions3[i].name;
                    }
                      
                  
                  
                  
                      //  { //alert(g.toString()+"- idtiem:"+vm.valoracions[f].item+"-vproc:"+vm.valoracions[f].vporc.toString());
                        //      $scope.seleccionat[g]=$scope.valors[g].indexOf(vm.valoracions[f].vporc.toString());
                        //      d=$scope.opcions[g][$scope.seleccionat[g]].name;
                              //  alert($scope.valors[g][$scope.seleccionat[g]]+"cporc:"+vm.valoracions[f].vporc+"-index:"+ $scope.seleccionat[g]+$scope.opcions[g][$scope.seleccionat[g]].name+"selec:·"+$scope.opcions[g][$scope.seleccionat[g]].selec);
                               //$scope.seleccionat[g]=d;  
                     //          $scope.opcions[g][$scope.seleccionat[g]].selec=1;
                     //    }
                  
              }
       
     var  local=0;
   var visitant=1;
  
   
   
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
   } else{
       local=1;
       visitant=0;
   }
    
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
    vm.ppl=resultat[local].pp;
    vm.ppv=resultat[visitant].pp;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
     vm.pttl=resultat[local].ptt;
    vm.pttv=resultat[visitant].ptt;
     vm.ptel=resultat[local].pte;
    vm.ptev=resultat[visitant].pte;
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
    }
  
  if (perfil==='1') $scope.perfilnom="Tutor/a de grada";
  if (perfil==='2') $scope.perfilnom="Públic";
  if (perfil==='4') $scope.perfilnom="Tècnic/a";
  if (perfil==='5') $scope.perfilnom="Tutor/a de joc";

  if (equip===resultat[0].idLocal.toString()){
      $scope.equipnom=vm.elocal;
  }else{
      $scope.equipnom=vm.evisitant;
  }
 vm.click=function (){
     var r=true;
      
               if(r===true)
        {
  if (vm.valoracions.length>2){
    for(var j=0;j<vm.valoracions.length;j++)
     {    
         var v={idvaloracion:0,idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
    
         if (vm.valoracions[j].idvaloracion !== null){
             v.idvaloracion=vm.valoracions[j].idvaloracion;
            
             v.idpartido=vm.valoracions[j].idPartido;
             v.iditemvalorado=vm.valoracions[j].item;
             v.idperfil=1;
             v.idusuario=0;
             v.idequipo=vm.valoracions[j].idequipo;
             v.idconsell=2;
             
          
             
           
         
          if(vm.valoracions[j].item===1){
                  var i=valorscsv1.indexOf($scope.select1);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                    
                    }
           if(vm.valoracions[j].item===2){
                  var i=valorscsv2.indexOf($scope.select2);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                 
                    }
                    
             if(vm.valoracions[j].item===3){
                  var i=valorscsv3.indexOf($scope.select3);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=34;
              
                    }
          
                
            
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.update({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
            } 
              }
              //alert("voy");
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          else{
              for(var j=0;j<vm.items.length;j++)
     {    
            var v={idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
             
             v.idpartido=resultat[local].idPartido;
             v.iditemvalorado=vm.items[j].iditem;
             v.idperfil=1;
             v.idusuario=0;
             //alert(vm.items[j].iditem);
             v.idconsell=2;
             v.idequipo=equip;
             
            
         
        
           if(vm.items[j].iditem===1){
                  var i=valorscsv1.indexOf($scope.select1);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                      
                 
                    }
                    
             if(vm.items[j].iditem===2){
                  var i=valorscsv2.indexOf($scope.select2);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                     
              
                    }
           if(vm.items[j].iditem===3){
                  var i=valorscsv3.indexOf($scope.select3);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=34;
                
                    }
                    
        
            
            
          
                    
           
          
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.insert({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
             
              } 
              
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          
          
          
          
  }
 };  
 }}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
 votaciotecnicCtrl.$inject = ["resultat", "perfil", "$state", "$scope", "equip", "valoraciones", "items", "partit", "valoracions"];
  angular
    .module('neo.home.votacio')
    .controller('votaciotecnicCtrl', votaciotecnicCtrl);

  function votaciotecnicCtrl(resultat,perfil, $state,$scope,equip,valoraciones,items,partit, valoracions)
  {
     var vm=this;
    // vm.items=items.slice(0,items.length-1);
    vm.items=items;
    vm.show=false;
     vm.observacions=items[items.length-1].valor;
     if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       puntsVisitant:0,totpunts:0,
       idEquipo:resultat[0].idVisitant,
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
     if (vm.observacions===0){
         vm.observacions="";
     }
     vm.itempos=[];
     vm.valoracions=valoraciones;
    
     vm.perfil=perfil;
    
      $scope.opcions=[];
      $scope.valors=[];
 //     $scope.opcions[0]= [{ id: 1, name: "Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 //     $scope.opcions[1]= [{ id: 1, name: "2Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[2]= [{ id: 1, name: "3Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[3]= [{ id: 1, name: "4Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[4]= [{ id: 1, name: "5Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
////  $scope.opcions[5]= [{ id: 1, name: "6Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[6]= [{ id: 1, name: "7Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 $scope.item10={iditem:0,nom:"",respetoa:""};
 $scope.opcions10=[];
 var valorspos10=[];
 var valorscsv10=[];
 $scope.item11={iditem:0,nom:"",respetoa:""};
 $scope.opcions11=[];
 var valorspos11=[];
 var valorscsv11=[];
 $scope.item12={iditem:0,nom:"",respetoa:""};
 $scope.opcions12=[];
 var valorspos12=[];
 var valorscsv12=[];
 $scope.item13={iditem:0,nom:"",respetoa:""};
 $scope.opcions13=[];
 var valorspos13=[];
 var valorscsv13=[];
 $scope.item14={iditem:0,nom:"",respetoa:""};
 $scope.opcions14=[];
 var valorspos14=[];
 var valorscsv14=[];
 $scope.item15={iditem:0,nom:"",respetoa:""};
 $scope.opcions15=[];
 var valorspos15=[];
 var valorscsv15=[];
 $scope.item16={iditem:0,nom:"",respetoa:""};
 $scope.opcions16=[];
 var valorspos16=[];
 var valorscsv16=[];

    for(var j=0;j<vm.items.length;j++)
     {    
       
         if(vm.items[j].iditem===10){
             $scope.item10.iditem=10;
             $scope.item10.nom=vm.items[j].nom;
             $scope.item10.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions10[i]={id:i,name:a[i],selec:0};
             valorspos10[i]=valors[i];
             valorscsv10[i]=a[i];
         }
         }
         if(vm.items[j].iditem===11){
             $scope.item11.iditem=11;
             $scope.item11.nom=vm.items[j].nom;
             $scope.item11.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions11[i]={id:i,name:a[i],selec:0};
             valorspos11[i]=valors[i];
             valorscsv11[i]=a[i];
         }
         }
         if(vm.items[j].iditem===12){
             $scope.item12.iditem=12;
             $scope.item12.nom=vm.items[j].nom;
             $scope.item12.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions12[i]={id:i,name:a[i],selec:0};
             valorspos12[i]=valors[i];
             valorscsv12[i]=a[i];
         }
         }
         if(vm.items[j].iditem===13){
             $scope.item13.iditem=13;
             $scope.item13.nom=vm.items[j].nom;
             $scope.item13.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions13[i]={id:i,name:a[i],selec:0};
             valorspos13[i]=valors[i];
             valorscsv13[i]=a[i];
         }
         }
         if(vm.items[j].iditem===14){
             $scope.item14.iditem=14;
             $scope.item14.nom=vm.items[j].nom;
             $scope.item14.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions14[i]={id:i,name:a[i],selec:0};
             valorspos14[i]=valors[i];
             valorscsv14[i]=a[i];
         }
         }
       
       
         if(vm.items[j].iditem===15){
             $scope.item15.iditem=15;
             $scope.item15.nom=vm.items[j].nom;
             $scope.item15.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
       
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions15[i]={id:i,name:a[i],selec:0};
             valorspos15[i]=valors[i];
             valorscsv15[i]=a[i];
         }
         }
         if(vm.items[j].iditem===16){
             $scope.item16.iditem=16;
             $scope.item16.nom=vm.items[j].nom;
             $scope.item16.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions16[i]={id:i,name:a[i],selec:0};
             valorspos16[i]=valors[i];
             valorscsv16[i]=a[i];
         }
         }
         
       
         
         var a=vm.items[j].valorsCSV.split(";"); 
         var valors=vm.items[j].valoresposbiles.split(";");
         var c=[];
         var valorspos=[];
         var seleccionat=[];
         if ((vm.items[j].iditem===35)||(vm.items[j].iditem===36)||(vm.items[j].iditem===42)||(vm.items[j].iditem===43)){
             for(var i=0;i<100;i++){
             c[i]={id:i,name:i.toString(),selec:0};
             valorspos[i]=i.toString();
         }
         }else{
         for(var i=0;i<a.length;i++){
             c[i]={id:i,name:a[i],selec:0};
             valorspos[i]=valors[i];
         }}
    //$scope.opcions[j]([{ id: 1, name: "Gairebé mai"}, { id: 2, name:"Algunes vegades"}, { id: 3, name:"Sovint"}, { id: 4, name:"Gairebé sempre"}]);
 $scope.opcions[j]=c;
 $scope.valors[j]=valorspos;
 
 
      }
      $scope.seleccionat=[];
      var d=0;
       for (var f=0;f<vm.valoracions.length;f++)
              {
                 // for (var g=0;g<vm.items.length;g++)
                      
        //        if(vm.items[g].iditem===vm.valoracions[f].item) 
         //   {
            if(vm.valoracions[f].item===44){
               // alert(vm.valoracions[f].observacions);
                $scope.observ=vm.valoracions[f].observacions;}
      //      }else{
                   
                     if(vm.valoracions[f].item===10){
                         var i=valorspos10.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init10=$scope.opcions10[i].name;
                    }
                    
                     if(vm.valoracions[f].item===11){
                         var i=valorspos11.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init11=$scope.opcions11[i].name;
                    }
                    
                     if(vm.valoracions[f].item===12){
                         var i=valorspos12.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init12=$scope.opcions12[i].name;
                    }
                      if(vm.valoracions[f].item===13){
                         
                         var i=valorspos13.indexOf(vm.valoracions[f].vporc.toString());
                   
                       
                        vm.init13=$scope.opcions13[i].name;
                    }
                     if(vm.valoracions[f].item===14){
                         var i=valorspos14.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init14=$scope.opcions14[i].name;
                    }
                     if(vm.valoracions[f].item===15){
                         var i=valorspos15.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init15=$scope.opcions15[i].name;
                    }
                     if(vm.valoracions[f].item===16){
                         var i=valorspos16.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init16=$scope.opcions16[i].name;
                    }
                     
                    
                  
                  
                      //  { //alert(g.toString()+"- idtiem:"+vm.valoracions[f].item+"-vproc:"+vm.valoracions[f].vporc.toString());
                        //      $scope.seleccionat[g]=$scope.valors[g].indexOf(vm.valoracions[f].vporc.toString());
                        //      d=$scope.opcions[g][$scope.seleccionat[g]].name;
                              //  alert($scope.valors[g][$scope.seleccionat[g]]+"cporc:"+vm.valoracions[f].vporc+"-index:"+ $scope.seleccionat[g]+$scope.opcions[g][$scope.seleccionat[g]].name+"selec:·"+$scope.opcions[g][$scope.seleccionat[g]].selec);
                               //$scope.seleccionat[g]=d;  
                     //          $scope.opcions[g][$scope.seleccionat[g]].selec=1;
                     //    }
                  
              }
       
     var  local=0;
   var visitant=1;
  
   
   
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
   } else{
       local=1;
       visitant=0;
   }
    
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
    vm.ppl=resultat[local].pp;
    vm.ppv=resultat[visitant].pp;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
     vm.pttl=resultat[local].ptt;
    vm.pttv=resultat[visitant].ptt;
     vm.ptel=resultat[local].pte;
    vm.ptev=resultat[visitant].pte;
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
    }
  
  if (perfil==='1') $scope.perfilnom="Tutor/a de grada";
  if (perfil==='2') $scope.perfilnom="Públic";
  if (perfil==='4') $scope.perfilnom="Tècnic/a";
  if (perfil==='5') $scope.perfilnom="Tutor/a de joc";

  if (equip===resultat[0].idLocal.toString()){
      $scope.equipnom=vm.elocal;
  }else{
      $scope.equipnom=vm.evisitant;
  }
 vm.click=function (){
     var r=true;
      
               if(r===true)
        {
  if (vm.valoracions.length>5){
    for(var j=0;j<vm.valoracions.length;j++)
     {    
         var v={idvaloracion:0,idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
    
         if (vm.valoracions[j].idvaloracion !== null){
             v.idvaloracion=vm.valoracions[j].idvaloracion;
            
             v.idpartido=vm.valoracions[j].idPartido;
             v.iditemvalorado=vm.valoracions[j].item;
             v.idperfil=4;
             v.idusuario=0;
             v.idequipo=vm.valoracions[j].idequipo;
             v.idconsell=2;
             
          
             
           
         
          if(vm.valoracions[j].item===10){
                  var i=valorscsv10.indexOf($scope.select10);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                    
                    }
           if(vm.valoracions[j].item===11){
                  var i=valorscsv11.indexOf($scope.select11);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                 
                    }
                    
             if(vm.valoracions[j].item===12){
                  var i=valorscsv12.indexOf($scope.select12);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=34;
              
                    }
           if(vm.valoracions[j].item===13){
                  var i=valorscsv13.indexOf($scope.select13);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                
                    }
                    
           if(vm.valoracions[j].item===14){
                  var i=valorscsv14.indexOf($scope.select14);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                 
                    }
           if(vm.valoracions[j].item===15){
                  var i=valorscsv15.indexOf($scope.select15);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                   
                    }
                
               if(vm.valoracions[j].item===16){
                  var i=valorscsv16.indexOf($scope.select16);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                   
                    }
           
            
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.update({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
            } 
              }
              //alert("voy");
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          else{
              for(var j=0;j<vm.items.length;j++)
     {    
            var v={idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
             
             v.idpartido=resultat[local].idPartido;
             v.iditemvalorado=vm.items[j].iditem;
             v.idperfil=4;
             v.idusuario=0;
             //alert(vm.items[j].iditem);
             v.idconsell=2;
              v.idequipo=equip;
           
          if(vm.items[j].iditem===10){
                  var i=valorscsv10.indexOf($scope.select10);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                   
                    
                    }
           if(vm.items[j].iditem===11){
                  var i=valorscsv11.indexOf($scope.select11);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=33;
                     
                    }
                    
             if(vm.items[j].iditem===12){
                  var i=valorscsv12.indexOf($scope.select12);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*8.25;
                     v.observaciones="";
                     v.vmaximo=34;
                     
              
                    }
           if(vm.items[j].iditem===13){
                  var i=valorscsv13.indexOf($scope.select13);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                 
                    }
                    
           if(vm.items[j].iditem===14){
                  var i=valorscsv14.indexOf($scope.select14);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                    }
           if(vm.items[j].iditem===15){
                  var i=valorscsv15.indexOf($scope.select15);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                    }
                
               if(vm.items[j].iditem===16){
                  var i=valorscsv16.indexOf($scope.select16);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                    }
         
                    
              
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.insert({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
             
              } 
              
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          
          
          
          
  }
 };  
 }}());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
 votaciopublicCtrl.$inject = ["resultat", "perfil", "$state", "$scope", "equip", "valoraciones", "items", "partit", "valoracions"];
  angular
    .module('neo.home.votacio')
    .controller('votaciopublicCtrl', votaciopublicCtrl);

  function votaciopublicCtrl(resultat,perfil, $state,$scope,equip,valoraciones,items,partit, valoracions)
  {
     var vm=this;
    // vm.items=items.slice(0,items.length-1);
    vm.items=items;
    vm.show=false;
    if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       puntsVisitant:0,totpunts:0,
       idEquipo:resultat[0].idVisitant,
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
     vm.observacions=items[items.length-1].valor;
     if (vm.observacions===0){
         vm.observacions="";
     }
     vm.itempos=[];
     vm.valoracions=valoraciones;
    
     vm.perfil=perfil;
    
      $scope.opcions=[];
      $scope.valors=[];
 //     $scope.opcions[0]= [{ id: 1, name: "Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 //     $scope.opcions[1]= [{ id: 1, name: "2Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[2]= [{ id: 1, name: "3Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[3]= [{ id: 1, name: "4Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[4]= [{ id: 1, name: "5Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
////  $scope.opcions[5]= [{ id: 1, name: "6Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[6]= [{ id: 1, name: "7Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 $scope.item4={iditem:0,nom:"",respetoa:""};
 $scope.opcions4=[];
 var valorspos4=[];
 var valorscsv4=[];
 $scope.item5={iditem:0,nom:"",respetoa:""};
 $scope.opcions5=[];
 var valorspos5=[];
 var valorscsv5=[];
 $scope.item6={iditem:0,nom:"",respetoa:""};
 $scope.opcions6=[];
 var valorspos6=[];
 var valorscsv6=[];
 $scope.item7={iditem:0,nom:"",respetoa:""};
 $scope.opcions7=[];
 var valorspos7=[];
 var valorscsv7=[];
 $scope.item14={iditem:0,nom:"",respetoa:""};
 $scope.opcions14=[];
 var valorspos14=[];
 var valorscsv14=[];
 $scope.item15={iditem:0,nom:"",respetoa:""};
 $scope.opcions15=[];
 var valorspos15=[];
 var valorscsv15=[];
 $scope.item16={iditem:0,nom:"",respetoa:""};
 $scope.opcions16=[];
 var valorspos16=[];
 var valorscsv16=[];

    for(var j=0;j<vm.items.length;j++)
     {    
       
         if(vm.items[j].iditem===4){
             $scope.item4.iditem=4;
             $scope.item4.nom=vm.items[j].nom;
             $scope.item4.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions4[i]={id:i,name:a[i],selec:0};
             valorspos4[i]=valors[i];
             valorscsv4[i]=a[i];
         }
         }
         if(vm.items[j].iditem===5){
             $scope.item5.iditem=5;
             $scope.item5.nom=vm.items[j].nom;
             $scope.item5.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions5[i]={id:i,name:a[i],selec:0};
             valorspos5[i]=valors[i];
             valorscsv5[i]=a[i];
         }
         }
         if(vm.items[j].iditem===6){
             $scope.item6.iditem=6;
             $scope.item6.nom=vm.items[j].nom;
             $scope.item6.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions6[i]={id:i,name:a[i],selec:0};
             valorspos6[i]=valors[i];
             valorscsv6[i]=a[i];
         }
         }
        if(vm.items[j].iditem===7){
             $scope.item7.iditem=7;
             $scope.item7.nom=vm.items[j].nom;
             $scope.item7.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions7[i]={id:i,name:a[i],selec:0};
             valorspos7[i]=valors[i];
             valorscsv7[i]=a[i];
         }
         }
        
      
       
         
         var a=vm.items[j].valorsCSV.split(";"); 
         var valors=vm.items[j].valoresposbiles.split(";");
         var c=[];
         var valorspos=[];
         var seleccionat=[];
         if ((vm.items[j].iditem===35)||(vm.items[j].iditem===36)||(vm.items[j].iditem===42)||(vm.items[j].iditem===43)){
             for(var i=0;i<100;i++){
             c[i]={id:i,name:i.toString(),selec:0};
             valorspos[i]=i.toString();
         }
         }else{
         for(var i=0;i<a.length;i++){
             c[i]={id:i,name:a[i],selec:0};
             valorspos[i]=valors[i];
         }}
    //$scope.opcions[j]([{ id: 1, name: "Gairebé mai"}, { id: 2, name:"Algunes vegades"}, { id: 3, name:"Sovint"}, { id: 4, name:"Gairebé sempre"}]);
 $scope.opcions[j]=c;
 $scope.valors[j]=valorspos;
 
 
      }
      $scope.seleccionat=[];
      var d=0;
      
     var  local=0;
   var visitant=1;
  
   
   
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
   } else{
       local=1;
       visitant=0;
   }
    
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
    vm.ppl=resultat[local].pp;
    vm.ppv=resultat[visitant].pp;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
     vm.pttl=resultat[local].ptt;
    vm.pttv=resultat[visitant].ptt;
     vm.ptel=resultat[local].pte;
    vm.ptev=resultat[visitant].pte;
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
    }
  
  if (perfil==='1') $scope.perfilnom="Tutor/a de grada";
  if (perfil==='2') $scope.perfilnom="Públic";
  if (perfil==='4') $scope.perfilnom="Tècnic/a";
  if (perfil==='5') $scope.perfilnom="Tutor/a de joc";

  if (equip===resultat[0].idLocal.toString()){
      $scope.equipnom=vm.evisitant;
  }else{
      $scope.equipnom=vm.elocal;
  }
 vm.click=function (){
     var r=true;
      
               if(r===true)
        {
  
              for(var j=0;j<vm.items.length;j++)
     {    
            var v={idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
             
             v.idpartido=resultat[local].idPartido;
             v.iditemvalorado=vm.items[j].iditem;
             v.idperfil=2;
             v.idusuario=0;
             //alert(vm.items[j].iditem);
             v.idconsell=2;
             v.idequipo=equip;
            
            
         
        
           if(vm.items[j].iditem===4){
                  var i=valorscsv4.indexOf($scope.select4);
                
                     v.vporc=i*100; 
                     v.vvalor=(i+1)*12.5;
                     v.observaciones="";
                     v.vmaximo=25;
                      
                 
                    }
                    
             if(vm.items[j].iditem===5){
                  var i=valorscsv5.indexOf($scope.select5);
                     v.vporc=i*100; 
                     v.vvalor=(i+1)*12.5;
                     v.observaciones="";
                     v.vmaximo=25;
                     
              
                    }
           if(vm.items[j].iditem===6){
                  var i=valorscsv6.indexOf($scope.select6);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                
                    }
                    
          if(vm.items[j].iditem===7){
                  var i=valorscsv7.indexOf($scope.select7);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*6.25;
                     v.observaciones="";
                     v.vmaximo=25;
                
                    }
            
            
          
                    
           
          
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.insert({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
             
              } 
              
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          
          
          
          
  
 };  
 }}());
(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.votacio')
  .config(config);

  function config($stateProvider) {
    $stateProvider.state('home.votacio', {
      url: '/votacio/{idPartit}/{idPerfil}/{idEquip}/{idEquip2}',
     
          templateUrl: 'home/votacio/votacio.tpl.html',
          controller: 'votacioCtrl',
          controllerAs: 'vm',
      resolve:{
       
        resultat: ["resultats", "$stateParams", function ( resultats,$stateParams){
          return resultats.query({idPartit :  $stateParams.idPartit}).$promise;
    }], items:["items", "$stateParams", function ( items,$stateParams){
          return items.query({idPerfil :  $stateParams.idPerfil}).$promise;
    }],
    perfil: ["$stateParams", function($stateParams){
        return $stateParams.idPerfil;
    }],
    equip: ["$stateParams", function($stateParams){
        return $stateParams.idEquip;
    }],
    valoraciones: ["valoracions", "$stateParams", function(valoracions,$stateParams){
        return valoracions.query({idpartit:$stateParams.idPartit,idequip:$stateParams.idEquip,idperfil:$stateParams.idPerfil}).$promise;
    }],
    valoraciones2: ["valoracions", "$stateParams", function(valoracions,$stateParams){
        return valoracions.query({idpartit:$stateParams.idPartit,idequip:$stateParams.idEquip2,idperfil:$stateParams.idPerfil}).$promise;
    }],
    partit: ["$stateParams", function($stateParams){
        return $stateParams.idPartit;
    }]
      }
       
    }).state('home.votaciotecnic', {
      url: '/votaciotecnic/{idPartit}/{idPerfil}/{idEquip}',
     
          templateUrl: 'home/votacio/votaciotecnic.tpl.html',
          controller: 'votaciotecnicCtrl',
          controllerAs: 'vm',
      resolve:{
       
        resultat: ["resultats", "$stateParams", function ( resultats,$stateParams){
          return resultats.query({idPartit :  $stateParams.idPartit}).$promise;
    }], items:["items", "$stateParams", function ( items,$stateParams){
          return items.query({idPerfil :  $stateParams.idPerfil}).$promise;
    }],
    perfil: ["$stateParams", function($stateParams){
        return $stateParams.idPerfil;
    }],
    equip: ["$stateParams", function($stateParams){
        return $stateParams.idEquip;
    }],
    valoraciones: ["valoracions", "$stateParams", function(valoracions,$stateParams){
        return valoracions.query({idpartit:$stateParams.idPartit,idequip:$stateParams.idEquip,idperfil:$stateParams.idPerfil}).$promise;
    }],
    
    partit: ["$stateParams", function($stateParams){
        return $stateParams.idPartit;
    }]
      }
       
    }).state('home.votaciotutorgrada', {
      url: '/votaciotutorgrada/{idPartit}/{idPerfil}/{idEquip}',
     
          templateUrl: 'home/votacio/votaciotutorgrada.tpl.html',
          controller: 'votaciotutorgradaCtrl',
          controllerAs: 'vm',
      resolve:{
       
        resultat: ["resultats", "$stateParams", function ( resultats,$stateParams){
          return resultats.query({idPartit :  $stateParams.idPartit}).$promise;
    }], items:["items", "$stateParams", function ( items,$stateParams){
          return items.query({idPerfil :  $stateParams.idPerfil}).$promise;
    }],
    perfil: ["$stateParams", function($stateParams){
        return $stateParams.idPerfil;
    }],
    equip: ["$stateParams", function($stateParams){
        return $stateParams.idEquip;
    }],
    valoraciones: ["valoracions", "$stateParams", function(valoracions,$stateParams){
        return valoracions.query({idpartit:$stateParams.idPartit,idequip:$stateParams.idEquip,idperfil:$stateParams.idPerfil}).$promise;
    }],
    
    partit: ["$stateParams", function($stateParams){
        return $stateParams.idPartit;
    }]
      }
       
    }).state('home.votaciopublic', {
      url: '/votaciopublic/{idPartit}/{idPerfil}/{idEquip}',
     
          templateUrl: 'home/votacio/votaciopublic.tpl.html',
          controller: 'votaciopublicCtrl',
          controllerAs: 'vm',
      resolve:{
       
        resultat: ["resultats", "$stateParams", function ( resultats,$stateParams){
          return resultats.query({idPartit :  $stateParams.idPartit}).$promise;
    }], items:["items", "$stateParams", function ( items,$stateParams){
          return items.query({idPerfil :  $stateParams.idPerfil}).$promise;
    }],
    perfil: ["$stateParams", function($stateParams){
        return $stateParams.idPerfil;
    }],
    equip: ["$stateParams", function($stateParams){
        return $stateParams.idEquip;
    }],
    valoraciones: ["valoracions", "$stateParams", function(valoracions,$stateParams){
        return valoracions.query({idpartit:$stateParams.idPartit,idequip:$stateParams.idEquip,idperfil:$stateParams.idPerfil}).$promise;
    }],
    
    partit: ["$stateParams", function($stateParams){
        return $stateParams.idPartit;
    }]
      }
       
    });
  }
  }());
(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
 votacioCtrl.$inject = ["resultat", "perfil", "$state", "$scope", "equip", "valoraciones", "valoraciones2", "items", "partit", "valoracions"];
  angular
    .module('neo.home.votacio')
    .controller('votacioCtrl', votacioCtrl);

  function votacioCtrl(resultat,perfil, $state,$scope,equip,valoraciones,valoraciones2,items,partit, valoracions)
  {
     var vm=this;
    // vm.items=items.slice(0,items.length-1);
    vm.items=items;
    vm.show=false;
     vm.observacions=items[items.length-1].valor;
     if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       puntsVisitant:0,totpunts:0,
       idEquipo:resultat[0].idVisitant,
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
     if (vm.observacions===0){
         vm.observacions="";
     }
     vm.itempos=[];
     vm.valoracions=valoraciones;
     vm.valoracions2=valoraciones2;
     vm.perfil=perfil;
     if(vm.perfil==="5"){
     
   var v2=vm.valoracions.concat(vm.valoracions2);
 // alert(vm.valoracions2.length.toString()+"-"+vm.valoracions.length.toString()+"-"+v2.length.toString());
  vm.valoracions=v2;
   }
      $scope.opcions=[];
      $scope.valors=[];
 //     $scope.opcions[0]= [{ id: 1, name: "Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 //     $scope.opcions[1]= [{ id: 1, name: "2Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[2]= [{ id: 1, name: "3Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//      $scope.opcions[3]= [{ id: 1, name: "4Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[4]= [{ id: 1, name: "5Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
////  $scope.opcions[5]= [{ id: 1, name: "6Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
//  $scope.opcions[6]= [{ id: 1, name: "7Gairebé mai"},{ id: 2, name: "Gairebé mai"},{ id: 3, name: "Gairebé mai"},{ id: 4, name: "Gairebé mai"}];
 $scope.item35={iditem:0,nom:"",respetoa:""};
 $scope.opcions35=[];
 var valorspos35=[];
 $scope.item36={iditem:0,nom:"",respetoa:""};
 $scope.opcions36=[];
 var valorspos36=[];
 $scope.item8={iditem:0,nom:"",respetoa:""};
 $scope.opcions8=[];
 var valorspos8=[];
 var valorscsv8=[];
 $scope.item9={iditem:0,nom:"",respetoa:""};
 $scope.opcions9=[];
 var valorspos9=[];
 var valorscsv9=[];
 $scope.item17={iditem:0,nom:"",respetoa:""};
 $scope.opcions17=[];
 var valorspos17=[];
 var valorscsv17=[];
 $scope.item18={iditem:0,nom:"",respetoa:""};
 $scope.opcions18=[];
 var valorspos18=[];
 var valorscsv18=[];
 $scope.item19={iditem:0,nom:"",respetoa:""};
 $scope.opcions19=[];
 var valorspos19=[];
 var valorscsv19=[];
 $scope.item20={iditem:0,nom:"",respetoa:""};
 $scope.opcions20=[];
 var valorspos20=[];
 var valorscsv20=[];
 $scope.item21={iditem:0,nom:"",respetoa:""};
 $scope.opcions21=[];
 var valorspos21=[];
 var valorscsv21=[];
 $scope.item22={iditem:0,nom:"",respetoa:""};
 $scope.opcions22=[];
 var valorspos22=[];
 var valorscsv22=[];
 $scope.item23={iditem:0,nom:"",respetoa:""};
 $scope.opcions23=[];
 var valorspos23=[];
 var valorscsv23=[];
 $scope.item24={iditem:0,nom:"",respetoa:""};
 $scope.opcions24=[];
 var valorspos24=[];
 var valorscsv24=[];
 $scope.item25={iditem:0,nom:"",respetoa:""};
 $scope.opcions25=[];
 var valorspos25=[];
 var valorscsv25=[];
 $scope.item26={iditem:0,nom:"",respetoa:""};
 $scope.opcions26=[];
 var valorspos26=[];
 var valorscsv26=[];
 $scope.item27={iditem:0,nom:"",respetoa:""};
 $scope.opcions27=[];
 var valorspos27=[];
 var valorscsv27=[];
 $scope.item28={iditem:0,nom:"",respetoa:""};
 $scope.opcions28=[];
 var valorspos28=[];
 var valorscsv28=[];
 $scope.item29={iditem:0,nom:"",respetoa:""};
 $scope.opcions29=[];
 var valorspos29=[];
 var valorscsv29=[];
 $scope.item30={iditem:0,nom:"",respetoa:""};
 $scope.opcions30=[];
 var valorspos30=[];
 var valorscsv30=[];
 $scope.item31={iditem:0,nom:"",respetoa:""};
 $scope.opcions31=[];
 var valorspos31=[];
 var valorscsv31=[];
 $scope.item35={iditem:0,nom:"",respetoa:""};
 $scope.opcions35=[];
 var valorspos35=[];
 $scope.item36={iditem:0,nom:"",respetoa:""};
 $scope.opcions36=[];
 var valorspos36=[];
 $scope.item37={iditem:0,nom:"",respetoa:""};
 $scope.opcions37=[];
 var valorspos37=[];
 var valorscsv37=[];
 $scope.item38={iditem:0,nom:"",respetoa:""};
 $scope.opcions38=[];
 var valorspos38=[];
 var valorscsv38=[];
 $scope.item39={iditem:0,nom:"",respetoa:""};
 $scope.opcions39=[];
 var valorspos39=[];
 var valorscsv39=[];
 $scope.item40={iditem:0,nom:"",respetoa:""};
 $scope.opcions40=[];
 var valorspos40=[];
 var valorscsv40=[];
 $scope.item41={iditem:0,nom:"",respetoa:""};
 $scope.opcions41=[];
 var valorspos41=[];
 var valorscsv41=[];
 $scope.item42={iditem:0,nom:"",respetoa:""};
 $scope.opcions42=[];
 var valorspos42=[];
 $scope.item43={iditem:0,nom:"",respetoa:""};
 $scope.opcions43=[];
 $scope.opcions60=[];
 $scope.opcions61=[];
 var valorspos43=[];
    for(var j=0;j<vm.items.length;j++)
     {    
         if(vm.items[j].iditem===43){
             $scope.item43.iditem=43;
             $scope.item43.nom=vm.items[j].nom;
             $scope.item43.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
                 for(var i=0;i<100;i++){
             $scope.opcions43[i]={id:i,name:i.toString(),selec:0};
             valorspos43[i]=i.toString();
         }
         }
         if(vm.items[j].iditem===42){
             $scope.item42.iditem=42;
             $scope.item42.nom=vm.items[j].nom;
             $scope.item42.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<100;i++){
             $scope.opcions42[i]={id:i,name:i.toString(),selec:0};
             valorspos42[i]=i.toString();
         }
         }
         if(vm.items[j].iditem===41){
             $scope.item41.iditem=41;
             $scope.item41.nom=vm.items[j].nom;
             $scope.item41.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions41[i]={id:i,name:a[i],selec:0};
             valorspos41[i]=valors[i];
             valorscsv41[i]=a[i];
         }
       
         }
         if(vm.items[j].iditem===40){
             $scope.item40.iditem=40;
             $scope.item40.nom=vm.items[j].nom;
             $scope.item40.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions40[i]={id:i,name:a[i],selec:0};
             valorspos40[i]=valors[i];
             valorscsv40[i]=a[i];
         }
         }
         if(vm.items[j].iditem===39){
             $scope.item39.iditem=39;
             $scope.item39.nom=vm.items[j].nom;
             $scope.item39.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions39[i]={id:i,name:a[i],selec:0};
             valorspos39[i]=valors[i];
             valorscsv39[i]=a[i];
         }
         }
         if(vm.items[j].iditem===38){
             $scope.item38.iditem=38;
             $scope.item38.nom=vm.items[j].nom;
             $scope.item38.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions38[i]={id:i,name:a[i],selec:0};
             valorspos38[i]=valors[i];
             valorscsv38[i]=a[i];
         }
         }
         if(vm.items[j].iditem===37){
             $scope.item37.iditem=37;
             $scope.item37.nom=vm.items[j].nom;
             $scope.item37.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions37[i]={id:i,name:a[i],selec:0};
             valorspos37[i]=valors[i];
             valorscsv37[i]=a[i];
         }
         }
       
       
         if(vm.items[j].iditem===31){
             $scope.item31.iditem=31;
             $scope.item31.nom=vm.items[j].nom;
             $scope.item31.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
       
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions31[i]={id:i,name:a[i],selec:0};
             valorspos31[i]=valors[i];
             valorscsv31[i]=a[i];
         }
         }
         if(vm.items[j].iditem===30){
             $scope.item30.iditem=30;
             $scope.item30.nom=vm.items[j].nom;
             $scope.item30.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions30[i]={id:i,name:a[i],selec:0};
             valorspos30[i]=valors[i];
             valorscsv30[i]=a[i];
         }
         }
           if(vm.items[j].iditem===29){
             $scope.item29.iditem=29;
             $scope.item29.nom=vm.items[j].nom;
             $scope.item29.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions29[i]={id:i,name:a[i],selec:0};
             valorspos29[i]=valors[i];
             valorscsv29[i]=a[i];
         }
         }
           if(vm.items[j].iditem===28){
             $scope.item28.iditem=28;
             $scope.item28.nom=vm.items[j].nom;
             $scope.item28.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions28[i]={id:i,name:a[i],selec:0};
             valorspos28[i]=valors[i];
             valorscsv28[i]=a[i];
         }
         }
           if(vm.items[j].iditem===27){
             $scope.item27.iditem=27;
             $scope.item27.nom=vm.items[j].nom;
             $scope.item27.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions27[i]={id:i,name:a[i],selec:0};
             valorspos27[i]=valors[i];
             valorscsv27[i]=a[i];
         }
         }
          if(vm.items[j].iditem===26){
             $scope.item26.iditem=26;
             $scope.item26.nom=vm.items[j].nom;
             $scope.item26.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions26[i]={id:i,name:a[i],selec:0};
             valorspos26[i]=valors[i];
             valorscsv26[i]=a[i];
         }
         }
          if(vm.items[j].iditem===25){
             $scope.item25.iditem=25;
             $scope.item25.nom=vm.items[j].nom;
             $scope.item25.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions25[i]={id:i,name:a[i],selec:0};
             valorspos25[i]=valors[i];
             valorscsv25[i]=a[i];
         }
         }
          if(vm.items[j].iditem===24){
             $scope.item24.iditem=24;
             $scope.item24.nom=vm.items[j].nom;
             $scope.item24.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions24[i]={id:i,name:a[i],selec:0};
             valorspos24[i]=valors[i];
             valorscsv24[i]=a[i];
         }
         }
          if(vm.items[j].iditem===23){
             $scope.item23.iditem=23;
             $scope.item23.nom=vm.items[j].nom;
             $scope.item23.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions23[i]={id:i,name:a[i],selec:0};
             valorspos23[i]=valors[i];
             valorscsv23[i]=a[i];
         }
         }
          if(vm.items[j].iditem===22){
             $scope.item22.iditem=22;
             $scope.item22.nom=vm.items[j].nom;
             $scope.item22.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions22[i]={id:i,name:a[i],selec:0};
             valorspos22[i]=valors[i];
             valorscsv22[i]=a[i];
         }
         }
         if(vm.items[j].iditem===21){
             $scope.item21.iditem=21;
             $scope.item21.nom=vm.items[j].nom;
             $scope.item21.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions21[i]={id:i,name:a[i],selec:0};
             valorspos21[i]=valors[i];
             valorscsv21[i]=a[i];
         }
         }
           if(vm.items[j].iditem===20){
             $scope.item20.iditem=20;
             $scope.item20.nom=vm.items[j].nom;
             $scope.item20.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
                  
             $scope.opcions20[i]={id:i,name:a[i],selec:0};
             valorspos20[i]=valors[i];
             valorscsv20[i]=a[i];
         }
         }
           if(vm.items[j].iditem===19){
             $scope.item19.iditem=19;
             $scope.item19.nom=vm.items[j].nom;
             $scope.item19.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions19[i]={id:i,name:a[i],selec:0};
             valorspos19[i]=valors[i];
             valorscsv19[i]=a[i];
             
         }
         }
          if(vm.items[j].iditem===18){
             $scope.item18.iditem=18;
             $scope.item18.nom=vm.items[j].nom;
             $scope.item18.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions18[i]={id:i,name:a[i],selec:0};
             valorspos18[i]=valors[i];
             valorscsv18[i]=a[i];
         }
         }
         if(vm.items[j].iditem===17){
             $scope.item17.iditem=17;
             $scope.item17.nom=vm.items[j].nom;
             $scope.item17.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions17[i]={id:i,name:a[i],selec:0};
             valorspos17[i]=valors[i];
             valorscsv17[i]=a[i];
         }
         }
           if(vm.items[j].iditem===9){
             $scope.item9.iditem=9;
             $scope.item9.nom=vm.items[j].nom;
             $scope.item9.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions9[i]={id:i,name:a[i],selec:0};
             valorspos9[i]=valors[i];
               valorscsv9[i]=a[i];
         }
         }
         if(vm.items[j].iditem===8){
             $scope.item8.iditem=8;
             $scope.item8.nom=vm.items[j].nom;
             $scope.item8.respetoa=vm.items[j].respestoa;
            var a=vm.items[j].valorsCSV.split(";"); 
            var valors=vm.items[j].valoresposbiles.split(";");
               for(var i=0;i<a.length;i++){
             $scope.opcions8[i]={id:i,name:a[i],selec:0};
             valorspos8[i]=valors[i];
             valorscsv8[i]=a[i];
         }
         }
         if(vm.items[j].iditem===35){
             $scope.item35.iditem=35;
             $scope.item35.nom=vm.items[j].nom;
             $scope.item35.respetoa=vm.items[j].respestoa;
           
               for(var i=0;i<100;i++){
            $scope.opcions60[i]={id:i,name:i.toString(),selec:0};
        }
            
           $scope.opcions35[0]={id:0,name:"Guanya",selec:0};
           $scope.opcions35[1]={id:1,name:"Empata",selec:0};
           $scope.opcions35[2]={id:2,name:"Perd",selec:0};
             valorspos35[0]=100;
             valorspos35[1]=66;
             valorspos35[2]=33;
         
         }
         
         if(vm.items[j].iditem===36){
             $scope.item36.iditem=36;
             $scope.item36.nom=vm.items[j].nom;
             $scope.item36.respetoa=vm.items[j].respestoa;
             for(var i=0;i<100;i++){
            $scope.opcions61[i]={id:i,name:i.toString(),selec:0};
        }
         //      for(var i=0;i<100;i++){
              $scope.opcions36[0]={id:0,name:"Guanya",selec:0};
           $scope.opcions36[1]={id:1,name:"Empata",selec:0};
           $scope.opcions36[2]={id:2,name:"Perd",selec:0};
             valorspos36[0]=100;
             valorspos36[1]=66;
             valorspos36[2]=33;
      //   }
         }
         
         var a=vm.items[j].valorsCSV.split(";"); 
         var valors=vm.items[j].valoresposbiles.split(";");
         var c=[];
         var valorspos=[];
         var seleccionat=[];
         if ((vm.items[j].iditem===35)||(vm.items[j].iditem===36)){
             a=['Guanya','Empata','Perd'];
             valors=[100,66,33];
              for(var i=0;i<a.length;i++){
             c[i]={id:i,name:a[i],selec:0};
             valorspos[i]=valors[i];
             
         }
         }else{
         if ((vm.items[j].iditem===42)||(vm.items[j].iditem===43)){
             for(var i=0;i<100;i++){
             c[i]={id:i,name:i.toString(),selec:0};
             valorspos[i]=i.toString();
         }
         }else{
         for(var i=0;i<a.length;i++){
             c[i]={id:i,name:a[i],selec:0};
             valorspos[i]=valors[i];
         }}}
    //$scope.opcions[j]([{ id: 1, name: "Gairebé mai"}, { id: 2, name:"Algunes vegades"}, { id: 3, name:"Sovint"}, { id: 4, name:"Gairebé sempre"}]);
 $scope.opcions[j]=c;
 $scope.valors[j]=valorspos;
 
 
      }
      $scope.seleccionat=[];
      var d=0;
       for (var f=0;f<vm.valoracions.length;f++)
              {
                 // for (var g=0;g<vm.items.length;g++)
                      
        //        if(vm.items[g].iditem===vm.valoracions[f].item) 
         //   {
            if(vm.valoracions[f].item===44){
               // alert(vm.valoracions[f].observacions);
                $scope.observ=vm.valoracions[f].observacions;}
      //      }else{
                    if(vm.valoracions[f].item===35){
                         var i=valorspos35.indexOf(vm.valoracions[f].vporc.toString());
                        if(vm.valoracions[f].vporc===33){
                            vm.init35='Perd';
                        }
                         if(vm.valoracions[f].vporc===66){
                            vm.init35='Empata';
                        }
                         if(vm.valoracions[f].vporc===100){
                            vm.init35='Guanya';
                        }
                       
            vm.init60= vm.valoracions[f].observacions;
                       //  vm.init35=i.toString();
                      // vm.init35=$scope.opcions35[i].name;
                    }
                     if(vm.valoracions[f].item===36){
                         var i=valorspos36.indexOf(vm.valoracions[f].vporc.toString());
                        // vm.init36=i.toString();
                        
                         if(vm.valoracions[f].vporc===33){
                            vm.init36='Perd';
                        }
                         if(vm.valoracions[f].vporc===66){
                            vm.init36='Empata';
                        }
                         if(vm.valoracions[f].vporc===100){
                            vm.init36='Guanya';
                        }
                       vm.init61= vm.valoracions[f].observacions;
                    }
                     if(vm.valoracions[f].item===8){
                         var i=valorspos8.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init8=$scope.opcions8[i].name;
                    }
                     if(vm.valoracions[f].item===9){
                         var i=valorspos9.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init9=$scope.opcions9[i].name;
                    }
                     if(vm.valoracions[f].item===17){
                         var i=valorspos17.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init17=$scope.opcions17[i].name;
                    }
                    
                     if(vm.valoracions[f].item===18){
                         var i=valorspos18.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init18=$scope.opcions18[i].name;
                    }
                    
                     if(vm.valoracions[f].item===19){
                         var i=valorspos19.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init19=$scope.opcions19[i].name;
                    }
                      if(vm.valoracions[f].item===20){
                         
                         var i=valorspos20.indexOf(vm.valoracions[f].vporc.toString());
                   
                       
                        vm.init20=$scope.opcions20[i].name;
                    }
                     if(vm.valoracions[f].item===21){
                         var i=valorspos21.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init21=$scope.opcions21[i].name;
                    }
                     if(vm.valoracions[f].item===22){
                         var i=valorspos22.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init22=$scope.opcions22[i].name;
                    }
                     if(vm.valoracions[f].item===23){
                         var i=valorspos23.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init23=$scope.opcions23[i].name;
                    }
                     if(vm.valoracions[f].item===24){
                         var i=valorspos24.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init24=$scope.opcions24[i].name;
                    }
                     if(vm.valoracions[f].item===25){
                         var i=valorspos25.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init25=$scope.opcions25[i].name;
                    }
                    
                     if(vm.valoracions[f].item===26){
                         var i=valorspos26.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init26=$scope.opcions26[i].name;
                    }
                     if(vm.valoracions[f].item===27){
                         var i=valorspos27.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init27=$scope.opcions27[i].name;
                    }
                     if(vm.valoracions[f].item===28){
                         var i=valorspos28.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init28=$scope.opcions28[i].name;
                    }
                     if(vm.valoracions[f].item===29){
                         var i=valorspos29.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init29=$scope.opcions29[i].name;
                    }
                     if(vm.valoracions[f].item===30){
                         var i=valorspos30.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init30=$scope.opcions30[i].name;
                    }
                     if(vm.valoracions[f].item===31){
                         var i=valorspos31.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init31=$scope.opcions31[i].name;
                    }
                      if(vm.valoracions[f].item===37){
                         var i=valorspos37.indexOf(vm.valoracions[f].vporc.toString());
                       
                         vm.init37=$scope.opcions37[i].name;
                    }
                      if(vm.valoracions[f].item===38){
                         var i=valorspos38.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init38=$scope.opcions38[i].name;
                    }
                      if(vm.valoracions[f].item===39){
                         var i=valorspos39.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init39=$scope.opcions39[i].name;
                    }
                      if(vm.valoracions[f].item===40){
                         var i=valorspos40.indexOf(vm.valoracions[f].vporc.toString());
                         
                         vm.init40=$scope.opcions40[i].name;
                    }
                    if(vm.valoracions[f].item===41){
                         var i=valorspos41.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init41=$scope.opcions41[i].name;
                    }
                    if(vm.valoracions[f].item===42){
                         var i=valorspos42.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init42=$scope.opcions42[i].name;
                    }
                    if(vm.valoracions[f].item===43){
                         var i=valorspos43.indexOf(vm.valoracions[f].vporc.toString());
                         vm.init43=$scope.opcions43[i].name;
                    }
                      //  { //alert(g.toString()+"- idtiem:"+vm.valoracions[f].item+"-vproc:"+vm.valoracions[f].vporc.toString());
                        //      $scope.seleccionat[g]=$scope.valors[g].indexOf(vm.valoracions[f].vporc.toString());
                        //      d=$scope.opcions[g][$scope.seleccionat[g]].name;
                              //  alert($scope.valors[g][$scope.seleccionat[g]]+"cporc:"+vm.valoracions[f].vporc+"-index:"+ $scope.seleccionat[g]+$scope.opcions[g][$scope.seleccionat[g]].name+"selec:·"+$scope.opcions[g][$scope.seleccionat[g]].selec);
                               //$scope.seleccionat[g]=d;  
                     //          $scope.opcions[g][$scope.seleccionat[g]].selec=1;
                     //    }
                  
              }
       
     var  local=0;
   var visitant=1;
  
   
   
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
   } else{
       local=1;
       visitant=0;
   }
    
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
    vm.ppl=resultat[local].pp;
    vm.ppv=resultat[visitant].pp;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
     vm.pttl=resultat[local].ptt;
    vm.pttv=resultat[visitant].ptt;
     vm.ptel=resultat[local].pte;
    vm.ptev=resultat[visitant].pte;
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
    }
  
  if (perfil==='1') $scope.perfilnom="Tutor/a de grada";
  if (perfil==='2') $scope.perfilnom="Públic";
  if (perfil==='4') $scope.perfilnom="Tècnic/a";
  if (perfil==='5') $scope.perfilnom="Tutor/a de joc";

  if (equip===resultat[0].idLocal.toString()){
      $scope.equipnom=vm.elocal;
  }else{
      $scope.equipnom=vm.evisitant;
  }
 vm.click=function (){
     var r=true;
        if(parseInt($scope.select60)+parseInt($scope.select61)!==16){
            r=confirm("La suma del marcador es diferent de 16");
           
       
        
     }
       if ( $scope.select41.length>2 || $scope.select41.length===0 || $scope.select37.length>2 || $scope.select37.length===0){
             alert('Si us plau, indica si els equips han rebut Targetes Verdes');
             r=false;
         };
               if(r===true)
        {
  if (vm.valoracions.length>7){
    for(var j=0;j<vm.valoracions.length;j++)
     {    
         var v={idvaloracion:0,idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
    
         if (vm.valoracions[j].idvaloracion !== null){
             v.idvaloracion=vm.valoracions[j].idvaloracion;
            
             v.idpartido=vm.valoracions[j].idPartido;
             v.iditemvalorado=vm.valoracions[j].item;
             v.idperfil=5;
             v.idusuario=0;
             v.idequipo=vm.valoracions[j].idequipo;
             v.idconsell=2;
             
   //          if(vm.valoracions[j].item===35){
     //            v.vporc=parseInt($scope.select35);
       //          v.vmaximo=0;
        //         v.vvalor=0.00;
         //        v.observaciones=$scope.select60.toString();
     //        }
       //      if(vm.valoracions[j].item===36){
         //        v.vporc=parseInt($scope.select36);
        //         v.vmaximo=0;
          //       v.vvalor=0.00;
       //          v.observaciones=$scope.select61.toString();
         //    }
              if(vm.valoracions[j].item===35){
                 // var i=valorscsv35.indexOf($scope.select8);
                     //$scope.opcions8[i].id  
                  if(parseInt($scope.select60)>parseInt($scope.select61)) v.vporc=100;
                  if(parseInt($scope.select60)<parseInt($scope.select61)) v.vporc=33.4;
                   if(parseInt($scope.select60)===parseInt($scope.select61)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor= v.vporc*5;
                 v.observaciones=$scope.select60.toString();
             }
              if(vm.valoracions[j].item===36){
                 // var i=valorscsv9.indexOf($scope.select9);
                     //$scope.opcions8[i].id  
                  if(parseInt($scope.select61)>parseInt($scope.select60)) v.vporc=100;
                  if(parseInt($scope.select61)<parseInt($scope.select60)) v.vporc=33.4;
                   if(parseInt($scope.select61)===parseInt($scope.select60)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor= v.vporc*5;
                 v.observaciones=$scope.select61.toString();
                
             }
            
         
          if(vm.valoracions[j].item===17){
                  var i=valorscsv17.indexOf($scope.select17);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    
                    }
           if(vm.valoracions[j].item===20){
                  var i=valorscsv20.indexOf($scope.select20);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                 
                    }
                    
             if(vm.valoracions[j].item===18){
                  var i=valorscsv18.indexOf($scope.select18);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
              
                    }
           if(vm.valoracions[j].item===21){
                  var i=valorscsv21.indexOf($scope.select21);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                
                    }
                    
           if(vm.valoracions[j].item===19){
                  var i=valorscsv19.indexOf($scope.select19);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                 
                    }
           if(vm.valoracions[j].item===22){
                  var i=valorscsv22.indexOf($scope.select22);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                   
                    }
                
               if(vm.valoracions[j].item===23){
                  var i=valorscsv23.indexOf($scope.select23);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                   
                    }
           if(vm.valoracions[j].item===26){
                  var i=valorscsv26.indexOf($scope.select26);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    
                    }
                    
                     if(vm.valoracions[j].item===24){
                  var i=valorscsv24.indexOf($scope.select24);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.5;
                     v.observaciones="";
                     v.vmaximo=50;
                   
                    }
           if(vm.valoracions[j].item===27){
                  var i=valorscsv27.indexOf($scope.select27);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.5;
                     v.observaciones="";
                     v.vmaximo=50;
                    
                    }
               if(vm.valoracions[j].item===25){
                  var i=valorscsv25.indexOf($scope.select25);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                   
                    }
           if(vm.valoracions[j].item===28){
                  var i=valorscsv28.indexOf($scope.select28);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                 
                    }  
                    
               if(vm.valoracions[j].item===29){
                  var i=valorscsv29.indexOf($scope.select29);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                  
                    }
           if(vm.valoracions[j].item===38){
                  var i=valorscsv38.indexOf($scope.select38);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                   
                    }  
                    
               if(vm.valoracions[j].item===30){
                  var i=valorscsv30.indexOf($scope.select30);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                  
                    }
           if(vm.valoracions[j].item===39){
                  var i=valorscsv39.indexOf($scope.select39);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                  
                    }  
                    
            if(vm.valoracions[j].item===31){
             
                  var i=valorscsv31.indexOf($scope.select31);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                    
                    }
           if(vm.valoracions[j].item===40){
                  var i=valorscsv40.indexOf($scope.select40);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                   
                    }
                    
             if(vm.valoracions[j].item===37){
               
                  var i=valorscsv37.indexOf($scope.select37);
                     v.vporc=i*100; 
                     v.vvalor=i*100;
                     v.observaciones="";
                     v.vmaximo=100;
                   
                    }
           if(vm.valoracions[j].item===41){
                  var i=valorscsv41.indexOf($scope.select41);
                     v.vporc=i*100; 
                     v.vvalor=i*100;
                     v.observaciones="";
                     v.vmaximo=100;
                    
                    }          
             if(vm.valoracions[j].item===42){
                 v.vporc=parseInt($scope.select42);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
             }
             if(vm.valoracions[j].item===43){
                 v.vporc=parseInt($scope.select43);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
             }   
             
              if(vm.valoracions[j].item===44){
                 v.vporc=0;
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones=$scope.observ;
                 //alert($scope.observ);
             }   
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.update({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
            } 
              }
              //alert("voy");
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          else{
              for(var j=0;j<vm.items.length;j++)
     {    
            var v={idpartido:0,iditemvalorado:0,vporc:0,vmaximo:0,vvalor:0.00,idperfil:0,idusuario:0,idequipo:0,observaciones:'',idconsell:2};
             
             v.idpartido=resultat[local].idPartido;
             v.iditemvalorado=vm.items[j].iditem;
             v.idperfil=5;
             v.idusuario=0;
             //alert(vm.items[j].iditem);
             v.idconsell=2;
             
             if(vm.items[j].iditem===35){
                 v.vporc=parseInt($scope.select35);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
                 v.idequipo=resultat[local].idLocal;
                  if(parseInt($scope.select60)>parseInt($scope.select61)) v.vporc=100;
                  if(parseInt($scope.select60)<parseInt($scope.select61)) v.vporc=33.4;
                   if(parseInt($scope.select60)===parseInt($scope.select61)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor= v.vporc*5;
                 v.observaciones=$scope.select60.toString();
             }
             if(vm.items[j].iditem===36){
                 v.vporc=parseInt($scope.select36);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
                  v.idequipo=resultat[local].idVisitant;
                   if(parseInt($scope.select61)>parseInt($scope.select60)) v.vporc=100;
                  if(parseInt($scope.select61)<parseInt($scope.select60)) v.vporc=33.4;
                   if(parseInt($scope.select61)===parseInt($scope.select60)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor= v.vporc*5;
                 v.observaciones=$scope.select61.toString();
             }
              if(vm.items[j].iditem===8){
                  var i=valorscsv8.indexOf($scope.select8);
                     //$scope.opcions8[i].id  
                  if(parseInt($scope.select35)>parseInt($scope.select36)) v.vporc=100;
                  if(parseInt($scope.select35)<parseInt($scope.select36)) v.vporc=33.4;
                   if(parseInt($scope.select35)===parseInt($scope.select36)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor=v.vporc*5;
                 v.observaciones="";
                  v.idequipo=resultat[local].idLocal;
             }
              if(vm.items[j].iditem===9){
                  var i=valorscsv9.indexOf($scope.select9);
                     //$scope.opcions8[i].id  
                  if(parseInt($scope.select36)>parseInt($scope.select35)) v.vporc=100;
                  if(parseInt($scope.select36)<parseInt($scope.select35)) v.vporc=33.4;
                   if(parseInt($scope.select36)===parseInt($scope.select35)) v.vporc=66.6;
                   
                 v.vmaximo=500;
                 v.vvalor=v.vporc*5;
                 v.observaciones="";
                  v.idequipo=resultat[local].idVisitant;
             }
            
         
          if(vm.items[j].iditem===17){
                  var i=valorscsv17.indexOf($scope.select17);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.5;
                     v.observaciones="";
                     v.vmaximo=50;
                      v.idequipo=resultat[local].idLocal;
                    
                    }
           if(vm.items[j].iditem===20){
                  var i=valorscsv20.indexOf($scope.select20);
                 
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                      v.idequipo=resultat[local].idVisitant;
                 
                    }
                    
             if(vm.items[j].iditem===18){
                  var i=valorscsv18.indexOf($scope.select18);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                      v.idequipo=resultat[local].idLocal;
              
                    }
           if(vm.items[j].iditem===21){
                  var i=valorscsv21.indexOf($scope.select21);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                 v.idequipo=resultat[local].idVisitant;
                    }
                    
           if(vm.items[j].iditem===19){
                  var i=valorscsv19.indexOf($scope.select19);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                     v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===22){
                  var i=valorscsv22.indexOf($scope.select22);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    v.idequipo=resultat[local].idVisitant;
                    }
                
               if(vm.items[j].iditem===23){
                  var i=valorscsv23.indexOf($scope.select23);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===26){
                  var i=valorscsv26.indexOf($scope.select26);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                     v.idequipo=resultat[local].idVisitant;
                    }
                    
                     if(vm.items[j].iditem===24){
                  var i=valorscsv24.indexOf($scope.select24);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===27){
                  var i=valorscsv27.indexOf($scope.select27);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                     v.idequipo=resultat[local].idVisitant;
                    }
               if(vm.items[j].iditem===25){
                  var i=valorscsv25.indexOf($scope.select25);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                    v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===28){
                  var i=valorscsv28.indexOf($scope.select28);
                     v.vporc=(i+1)*25; 
                     v.vvalor=(i+1)*12.50;
                     v.observaciones="";
                     v.vmaximo=50;
                  v.idequipo=resultat[local].idVisitant;
                    }  
                    
               if(vm.items[j].iditem===29){
                  var i=valorscsv29.indexOf($scope.select29);
                 
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                   v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===38){
                  var i=valorscsv38.indexOf($scope.select38);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                    v.idequipo=resultat[local].idVisitant;
                    }  
                    
               if(vm.items[j].iditem===30){
                  var i=valorscsv30.indexOf($scope.select30);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                   v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===39){
                  var i=valorscsv39.indexOf($scope.select39);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                   v.idequipo=resultat[local].idVisitant;
                    }  
                    
            if(vm.items[j].iditem===31){
             
                  var i=valorscsv31.indexOf($scope.select31);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                     v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===40){
                  var i=valorscsv40.indexOf($scope.select40);
                     v.vporc=i*100; 
                     v.vvalor=i*25;
                     v.observaciones="";
                     v.vmaximo=25;
                    v.idequipo=resultat[local].idVisitant;
                    }
                    
             if(vm.items[j].iditem===37){
               
                  var i=valorscsv37.indexOf($scope.select37);
                     v.vporc=i*100; 
                     v.vvalor=i*100;
                     v.observaciones="";
                     v.vmaximo=100;
                    v.idequipo=resultat[local].idLocal;
                    }
           if(vm.items[j].iditem===41){
                  var i=valorscsv41.indexOf($scope.select41);
                     v.vporc=i*100; 
                     v.vvalor=i*100;
                     v.observaciones="";
                     v.vmaximo=100;
                     v.idequipo=resultat[local].idVisitant;
                    }          
             if(vm.items[j].iditem===42){
                 v.vporc=parseInt($scope.select42);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
                  v.idequipo=resultat[local].idVisitant;
             }
             if(vm.items[j].iditem===43){
                 v.vporc=parseInt($scope.select43);
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones="";
                  v.idequipo=resultat[local].idLocal;
             }   
             
              if(vm.items[j].iditem===44){
                 
                 v.vporc=0;
                 v.vmaximo=0;
                 v.vvalor=0.00;
                 v.observaciones=$scope.observ;
                  v.idequipo=resultat[local].idLocal;
             }   
           var  fecha=new Date();
        //   v.fecha_hora=fecha.getFullYear()+"-"+(fecha.getMonth() + 1) + "-" + fecha.getDate() + " " + fecha.getHours() + ":" + fecha.getMinutes() + ":" + fecha.getSeconds();
        
             valoracions.insert({idpartit: v.idpartido,idequip:v.idequipo,idperfil:v.idperfil}, v);
             
              } 
              
          var url = $state.href("home.resultats",{idPartit: v.idpartido});
           window.open(url,'_self');
          }
          
          
          
          
  }
 };  
 }}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name user
   * @description
   *
   */
  angular
  .module('neo.home.user', [
    'ui.router',
    'ngMaterial',
    'neo.home.user.profile'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.user')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.changePassword', {
      url: '^/change-password',
      templateUrl: 'home/user/change-password.tpl.html',
      controller: 'ChangePasswordCtrl',
      controllerAs: 'vm'
    })
    .state('home.changeUsername', {
      url: '^/change-username',
      templateUrl: 'home/user/change-username.tpl.html',
      controller: 'ChangeUsernameCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.user.controller:ChangeUsernameCtrl
   *
   * @description
   *
   */
  ChangeUsernameCtrl.$inject = ["$state", "$mdToast", "$filter", "Username", "AuthenticationService", "$scope"];
  angular
  .module('neo.home.user')
  .controller('ChangeUsernameCtrl', ChangeUsernameCtrl);

  function ChangeUsernameCtrl($state, $mdToast, $filter, Username, AuthenticationService,$scope) {
    var vm = this;
    vm.ctrlName = 'ChangeUsernameCtrl';
    vm.changeUsernameModel = {};
    vm.username2 = undefined;



    vm.changeUsername = function () {
      Username.update({}, vm.changeUsernameModel,
        function () {
          AuthenticationService.logout();
          $state.go('authentication.login', {}, {reload: true});
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')('SUCCESSFUL_EMAIL_CHANGE'))
            .position('bottom left')
            .hideDelay(5000)
          );
        }, function (error) {
          var errorMessage;
          if (error.status === 400) {
            errorMessage = 'INVALID_EMAIL';
          }
          else if (error.status === 409) {
            errorMessage = 'INVALID_PASSWORD';
          } else {
            errorMessage = 'SERVER_ERROR'
          }
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')(errorMessage))
            .position('bottom left')
            .hideDelay(5000)
          );
        });
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.user.controller:ChangePasswordCtrl
   *
   * @description
   *
   */
  ChangePasswordCtrl.$inject = ["ChangePassword", "$state", "$mdToast", "$filter"];
  angular
  .module('neo.home.user')
  .controller('ChangePasswordCtrl', ChangePasswordCtrl);

  function ChangePasswordCtrl(ChangePassword, $state, $mdToast, $filter) {
    var vm = this;
    vm.ctrlName = 'ChangePasswordCtrl';
    vm.changePasswordModel = {};

    vm.changePassword = function () {
      ChangePassword.save(vm.changePasswordModel,
        function () {
          $state.go('home', {}, {reload: true});
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('SUCCESSFUL_PASSWORD_CHANGE'))
            .position('bottom left')
            .hideDelay(5000)
          );
        }, function (error) {
          var errorMessage;
          if (error.status === 409) {
            errorMessage = 'INVALID_OLD_PASSWORD';
          } else {
            errorMessage = 'SERVER_ERROR';
          }
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')(errorMessage))
            .position('bottom left')
            .hideDelay(5000)
          );
        });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name teams
   * @description
   *
   */
  angular
  .module('neo.home.teams', [
    'ui.router',
    'neo.home.teams.newTeam',
    'neo.home.teams.team'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.teams')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.teams', {
        url: '/teams',
        templateUrl: 'home/teams/teams.tpl.html',
        controller: 'TeamsCtrl',
        controllerAs: 'vm',
        params: {
          selectedEntity: undefined
        },
        resolve: {
          entities: ["Entitats", function (Entitats) {
            return Entitats.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          genders: ["Genders", function(Genders){
            return Genders.query().$promise;
          }],
          programmes: ["Programmes", function(Programmes){
            return Programmes.query().$promise;
          }]
        }
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name teams.controller:TeamsCtrl
     *
     * @description
     *
     */
    TeamsCtrl.$inject = ["$filter", "$stateParams", "EntityTeams", "entities", "categories", "sports", "genders", "programmes"];
    angular
      .module('neo.home.teams')
      .controller('TeamsCtrl', TeamsCtrl);

    function TeamsCtrl($filter, $stateParams, EntityTeams, entities, categories, sports, genders, programmes) {
      var vm = this;
      vm.ctrlName = 'TeamsCtrl';

      vm.data = {
        title: 'TEAM_LIST',
        notFoundMessage: 'RESULT_NOT_FOUND',
        headers: [
          {id: 'name', name: 'NAME', canOrder: true, orderBy: 'nameOrder'},
          {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
          {id: 'sport', name: 'SPORT', canOrder: true},
          {id: 'gender', name: 'GENDER', canOrder: true},
          {id: 'programType', name: 'PROGRAM_TYPE', canOrder: true}
        ],
        areRowsClickable: true,
        state: {
          slink: 'home.teams.team', params: [
            {key: 'teamId', value: 'id'}
          ]
        },
        defaultOrderBy: 'nameOrder',
        filters: [
          {
            label: 'ENTITIES.SELECT',
            showField: 'name',
            filterParam: 'entityId',
            filterField: 'id',
            required: true,
            options: entities
          }
        ],
        filterValues: {
          ENTITIES: $stateParams.selectedEntity
        },
        filterPromise: function (params) {
          return EntityTeams.query({entityId: params.entityId}).$promise;
        },
        filterFunction: function (data) {
          angular.forEach(data, function (team) {
            var category = findCategory(team.categoryId);
            team.nameOrder = $filter('lowercase')(team.name);
            team.category = $filter('translate')('CATEGORIES.' + category.name);
            team.categoryOrder = category.startYear;
            team.sport = $filter('translate')('SPORTS.' + findSport(team.sportId).name);
            team.gender = $filter('translate')(findGender(team.genderId).name);
            team.programType = $filter('translate')(findProgramme(team.programmeId).name);
          });
          return data;
        }
      };

      var hasSelectedItem = function (filter) {
        return angular.isDefined(filter.selectedItem) && filter.selectedItem !== null;
      };

      vm.getEntity = function () {
        if (hasSelectedItem(vm.data.filters[0])) {
          return vm.data.filters[0].selectedItem.id;
        } else {
          return undefined;
        }
      };

      var findCategory = function (categoryId) {
        return _.find(categories, function (c) {
          return c.id === categoryId;
        });
      };

      var findSport = function (sportId) {
        return _.find(sports, function (s) {
          return s.id === sportId;
        });
      };

      var findGender = function (genderId) {
        return _.find(genders, function (g) {
          return g.id === genderId;
        })
      };

      var findProgramme = function (programmeId) {
        return _.find(programmes, function (p) {
          return p.id === programmeId;
        });
      };

    }
  }()
);

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.statistics
   * @description
   *
   */
  angular
    .module('neo.home.statistics', [
      'ui.router',
      'neo.home.statistics.licenses',
      'neo.home.statistics.teams',
      'neo.home.statistics.entities'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.statistics')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.statistics', {
        abstract: true,
        url: '/statistics',
        templateUrl: 'home/statistics/statistics.tpl.html',
        controller: 'StatisticsCtrl',
        controllerAs: 'vm',
        resolve: {
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          seasons: ["Seasons", function (Seasons) {
            return Seasons.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function (CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.statistics.controller:StatisticsCtrl
   *
   * @description
   *
   */
  angular
    .module('neo.home.statistics')
    .controller('StatisticsCtrl', StatisticsCtrl);

  function StatisticsCtrl() {
    var vm = this;
    vm.ctrlName = 'StatisticsCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name home.statistics.factory:HTMLToCSVParser
   *
   * @description
   *
   */
  angular
    .module('neo.home.statistics')
    .factory('HTMLToCSVParser', HTMLToCSVParser);

  function HTMLToCSVParser() {
    return {
      parse: function (table) {
        var csvString = '';
        for (var i = 0; i < table.rows.length; i++) {
          var rowData = table.rows[i].cells;
          for (var j = 0; j < rowData.length; j++) {
            csvString = csvString + rowData[j].innerText + ",";
          }
          csvString = csvString.substring(0, csvString.length - 1);
          csvString = csvString + "\n";
        }
        csvString = csvString.substring(0, csvString.length - 1);
        return csvString;
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.competicio
   * @description
   *
   */
  angular
  .module('neo.home.seasons', [
    'neo.home.seasons.newSeason',
    'neo.home.seasons.season'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.seasons')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.seasons', {
      url: '/seasons',
      templateUrl: 'home/seasons/seasons.tpl.html',
      controller: 'SeasonsCtrl',
      controllerAs: 'vm',
      resolve: {
        seasons: ["Seasons", function (Seasons) {
          return Seasons.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.competicio.controller:CompeticioCtrl
   *
   * @description
   *
   */
  SeasonsCtrl.$inject = ["seasons"];
  angular
  .module('neo.home.seasons')
  .controller('SeasonsCtrl', SeasonsCtrl);

  function SeasonsCtrl(seasons) {
    var vm = this;
    vm.ctrlName = 'SeasonsCtrl';

    angular.forEach(seasons, function (season) {
      season.iniDate = moment(season.iniDate).format('L');
      season.endDate = moment(season.endDate).format('L');
    });
    vm.listSeasons = seasons;
    vm.query = {
      order: 'name'
    };
    vm.selected = [];
    vm.select = undefined;

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.sancions', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.sancions')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.sancions', {
        url: '/sancionscomite/{dataini}/{datafi}',
        templateUrl: 'home/sancions/sancions.tpl.html',
        
        controller: 'sancionsCtrl',
        controllerAs: 'vm',
        resolve: {
          sancionscomite: ["sancionscomite", "$stateParams", function (sancionscomite,$stateParams) {
            return sancionscomite.query({dataini :  $stateParams.dataini,datafi:$stateParams.datafi}).$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  sancionsCtrl.$inject = ["AclService", "sancionscomite", "$mdToast", "$filter", "$scope", "$state"];
  angular
    .module('neo.home.sancions')
    .controller('sancionsCtrl', sancionsCtrl);

  function sancionsCtrl(AclService,sancionscomite, $mdToast, $filter, $scope, $state) {
    var vm = this;
   vm.sancions=sancionscomite;
  for(var j=0;j<vm.sancions.length;j++){
    //  vm.sancions[j].sancion=vm.sancions[j].sancion.replace("dinamitzador","Tut@r de joc");
  }
  
$scope.exportToExcel= ((function() {
          var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
          return function(table, name) {
            table = document.getElementById(table);
            
            var ctx = {worksheet: name || 'Report', table: table.innerHTML};
            window.location.href = uri + base64(format(template, ctx));
          }
        })());
  }
  
  
  
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.resultats', [
      'ui.router','neo.home.votacio'
    ]);
}());
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

            config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.resultats')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.resultats', {
      url: '/resultats/{idPartit}',
     
          templateUrl: 'home/resultats/resultats.tpl.html',
          controller: 'resultatsCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
       
        resultat: ["resultats", "$stateParams", function ( resultats,$stateParams){
          return resultats.query({idPartit :  $stateParams.idPartit}).$promise;
    }],
    valoracionstecnicspartitslocal:["valoracionstecnicslocal", "$stateParams", function ( valoracionstecnicslocal,$stateParams){
          return valoracionstecnicslocal.query({idPartit :  $stateParams.idPartit}).$promise;
    }],
    valoracionstecnicspartitsvisitant:["valoracionstecnicsvisitant", "$stateParams", function ( valoracionstecnicsvisitant,$stateParams){
          return valoracionstecnicsvisitant.query({idPartit :  $stateParams.idPartit}).$promise;
    }],
    
    sancions:["sancions", "$stateParams", function ( sancions,$stateParams){
          return sancions.query().$promise;
    }]
      }
    })
            ; }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  resultatsCtrl.$inject = ["userResolve", "AclService", "sancions", "$window", "$scope", "EnvironmentConfig", "recalcul", "$http", "resultat", "valoracions", "valoracionstecnicspartitslocal", "valoracionstecnicspartitsvisitant", "$state", "$mdDialog", "items"];
  angular
    .module('neo.home.resultats')
    .controller('resultatsCtrl', resultatsCtrl);

  function resultatsCtrl(userResolve,AclService,sancions, $window,$scope,EnvironmentConfig,recalcul, $http, resultat, valoracions,valoracionstecnicspartitslocal,valoracionstecnicspartitsvisitant,$state,$mdDialog,items) {
   var vm = this;
   
   $scope.sancions=sancions;
   vm.isAdmin = AclService.isAdmin; 
   
   $scope.title1="";$scope.title2="";$scope.title3="";$scope.title4="";$scope.title5="";$scope.title6="";$scope.title7="";$scope.title8="";$scope.title9="";$scope.title10="";
   $scope.tooltip1="";$scope.tooltip2="";$scope.tooltip3="";$scope.tooltip4="";$scope.tooltip5="";$scope.tooltip6="";$scope.tooltip7="";$scope.tooltip8="";$scope.tooltip9="";$scope.tooltip10="";
   var  local=0;
   var visitant=1;
   $scope.sancionaplicada=resultat[0].idsancion;
   vm.treure=(resultat[0].idsancion>0);
   vm.poteliminar=false;
   vm.espotVotar=true;
   if(resultat.length===1){
       var r={
       fecha:resultat[0].fecha,
       campionat:resultat[0].campionat,
        elocal:resultat[0].elocal,
    evisitant:resultat[0].evisitant,
    cc:[0].cc,
       pp:0,
       ptg:0,
       ptt:0,
       pte:0,
       pdt:0,
       pdp:0,
       marcador:0,
       verdplay:0,
       tv:0,
       idCampionat:resultat[0].idCampionat,
       puntsVisitant:0,totpunts:0,
       
       idPartido:resultat[0].idPartido,
       idLocal:resultat[0].idLocal,
       idVisitant:resultat[0].idVisitant
          };
       
       resultat.push(r);
   }
   if(resultat[0].idEquipo===0){
       alert("0");
       resultat[0].idEquipo=resultat[0].idLocal;
       resultat[1].idEquipo=resultat[0].idVisitant;
   }else
   {
   if (resultat[0].idEquipo===resultat[0].idLocal){
       local=0;
       visitant=1;
       resultat[1].idEquipo=resultat[0].idVisitant;
   } else{
       local=1;
       visitant=0;
       resultat[1].idEquipo=resultat[0].idLocal;
   }}
   $scope.sancionLocalBool=resultat[local].infractor; 
   $scope.sancionVisitBool=resultat[visitant].infractor; 
    vm.isDescalificatLocal=!resultat[local].isDescalificat; 
     vm.isDescalificatVisitant=!resultat[visitant].isDescalificat; 
     
    
   $scope.ccchange=function(){
       $http.get(EnvironmentConfig.API + '/acc/'+resultat[0].idPartido+'/'+!vm.cc).then(function(response){
           alert("Partit actualitzat");
       });
   };
   
   $scope.ccchangesuspes=function(){
       $http.get(EnvironmentConfig.API + '/asuspendre/'+resultat[0].idPartido).then(function(response){
           alert("Partit actualitzat. Aquesta actualitzacio nomes afecta a la APP. Haruia de suspendre/treure suspensio a PLAYOFF");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
   $window.location.reload();    
       });
   };
   $scope.truredescalificaciolocal=function(){
      var r=confirm('L\'Equip recuperarà totes les puntiacions. Es correcte?');
                   if (r){
                    $http.get(EnvironmentConfig.API + '/retirarsancioretirada/'+resultat[0].idCampionat+'/'+resultat[local].idEquipo).then(function(response){
                
           alert("Sancio retirada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
                   };
  
  $scope.truredescalificaciovisitant=function(){
      var r=confirm('L\'Equip recuperarà totes les puntiacions. Es correcte?');
                   if (r){
                    $http.get(EnvironmentConfig.API + '/retirarsancioretirada/'+resultat[0].idCampionat+'/'+resultat[visitant].idEquipo).then(function(response){
                
           alert("Sancio retirada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
                   };
  
   $scope.aplicarsancio=function(){
      
       if($scope.sancionaplicada===0){
           alert("Si us plau, seleccioneu una sanció a aplicar");
       } else{
           if(vm.sancionLocal===vm.sancionVisit){
                alert("Si us plau, seleccioneu UN equip sancionat");
           }else{
               if($scope.sancions[$scope.sancionaplicada-1].retirada){
                   var equipretirat="";
                   var equipretiratnom="";
                   if (vm.sancionVisit===2) {
                       equipretiratnom=resultat[visitant].evisitant;
                       equipretirat=resultat[visitant].idEquipo;}
                   else{
                       equipretirat=resultat[local].idEquipo;
                       equipretiratnom=resultat[local].elocal;
                   }
                   var r=confirm('La sanció implica la retirada de tots els punts de '+equipretiratnom+"-"+equipretirat);
                   if (r){
                          $http.get(EnvironmentConfig.API + '/aplicarsancioretirada/'+resultat[0].idCampionat+'/'+equipretirat+'/'+$scope.sancionaplicada).then(function(response){
                
           alert("Partit sancionat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });  
                   }
               }
               else{
                 $http.get(EnvironmentConfig.API + '/aplicarsancio/'+resultat[0].idPartido+'/'+resultat[visitant].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionVisit+'/'+resultat[visitant].idClasificacion);
                 $http.get(EnvironmentConfig.API + '/aplicarsancio/'+resultat[0].idPartido+'/'+resultat[local].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionLocal+'/'+resultat[local].idClasificacion).then(function(response){
                
           alert("Partit sancionat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });}
           }
       }
   };
   
    $scope.treuresancio=function(){
      var r=confirm("Segur que vol treure la sanció?");
       if(r){
          
                 $http.get(EnvironmentConfig.API + '/treuresancio/'+resultat[0].idPartido+'/'+resultat[visitant].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionVisit+'/'+resultat[visitant].idClasificacion);
                 $http.get(EnvironmentConfig.API + '/treuresancio/'+resultat[0].idPartido+'/'+resultat[local].idEquipo+'/'+$scope.sancionaplicada+'/'+vm.sancionLocal+'/'+resultat[local].idClasificacion).then(function(response){
                     
           alert("Sanció eliminiada.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });
           }
       
   };
   
    vm.changesancio=function (idsancio){
        $scope.sancionaplicada=idsancio;
  
    };
   $scope.votar2=function(){
            
               recalcul.insert({idPartido:resultat[local].idPartido},resultat[0]);
               recalcul.insert({idPartido:resultat[local].idPartido},resultat[1]);
                  alert('Recalculat');
                 var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
   $window.location.reload();    
   };
     
   $scope.mesures=function(){
       if(resultat[0].idsancion>0){
          alert("Aquest partit està sancionat. No es poden aplicar mesures correctores.") 
       }else{
      $http.get(EnvironmentConfig.API + '/mesures/'+resultat[0].idPartido).then(function(response){
           alert("Partit actualitzat.");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                 window.open(url,'_self');
   $window.location.reload();    
       });
   }};   
  
    vm.ctrlName = 'resultatsCtrl';
    vm.campionat=resultat[local].campionat;
    vm.data=resultat[local].fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');;
    vm.elocal=resultat[local].elocal;
    vm.evisitant=resultat[local].evisitant;  
    vm.cc=resultat[local].cc;
 //   vm.ppl=resultat[local].pp;
 //   vm.ppv=resultat[visitant].pp;
    vm.ppl=0;
    vm.ppv=0;
     vm.ptgl=resultat[local].ptg;
    vm.ptgv=resultat[visitant].ptg;
 //    vm.pttl=resultat[local].ptt;
//    vm.pttv=resultat[visitant].ptt;

  vm.pttl=0;
  vm.pttv=0;
    // vm.ptel=resultat[local].pte;
   // vm.ptev=resultat[visitant].pte;
    
     vm.ptel=0;
    vm.ptev=0;
    
      vm.pdtl=resultat[local].pdt;
    vm.pdtv=resultat[visitant].pdt;
      vm.pdpl=resultat[local].pdp;
    vm.pdpv=resultat[visitant].pdp;
     vm.marcadorl=resultat[local].marcador;
    vm.marcadorv=resultat[visitant].marcador;
    vm.pvpl=resultat[local].verdplay;
    vm.pvpv=resultat[visitant].verdplay;
     vm.tvl=resultat[local].tv;
    vm.tvv=resultat[visitant].tv;
    vm.pl=resultat[local].puntsLocal;
     vm.pv=resultat[visitant].puntsVisitant;
    if (resultat[local].suspendido){
        vm.suspes="PARTIT SUSPES!!";
        vm.suspeschk=true;
    }else{
         vm.suspes=resultat[local].totpunts+ " - "+resultat[visitant].totpunts;
         vm.suspeschk=false;
    }
    //$scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:5});
    
       //$scope.valoracionstecnics=valoracionstecnicspartitsvisitant;
  //var j= valoracionstecnicspartitsvisitant.length;
    $scope.valoracionstecnics=valoracionstecnicspartitslocal;
   // $scope.valoracionstecnics2=valoracionstecnics.query({idpartit:resultat[local].idPartido,idequip:resultat[visitant].idEquipo,idcampeonato:resultat[local].idCampionat});
 var j= valoracionstecnicspartitslocal.length;
   
   switch (j){
       case 1: if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title1=$scope.title1+"C";}
                 $scope.tooltip1=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[0].idPartido;
              break;
      case 2:  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title2=$scope.title2+"C";}
                 $scope.tooltip1=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                 $scope.tooltip2=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[1].idPartido;
                 vm.partido2=$scope.valoracionstecnics[0].idPartido;
              break;
        case 3:  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto3={"background-color": "greenyellow"};
                 } else{  $scope.stboto3={"background-color": "red"};}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title2=$scope.title2+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title3="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title3=$scope.title3+"C";}
                   $scope.tooltip1=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip2=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip3=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[2].idPartido;
                 vm.partido2=$scope.valoracionstecnics[1].idPartido;
                  vm.partido3=$scope.valoracionstecnics[0].idPartido;
                    break;
       case 4:  if ($scope.valoracionstecnics[3].isVotat){
                    $scope.stboto1={"background-color": "greenyellow"};
                 } else{  $scope.stboto1={"background-color": "red"};}
                  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto2={"background-color": "greenyellow"};
                 } else{  $scope.stboto2={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto3={"background-color": "greenyellow"};
                 } else{  $scope.stboto3={"background-color": "red"};}
                 if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto4={"background-color": "greenyellow"};
                 } else{  $scope.stboto4={"background-color": "red"};}
                
                if ($scope.valoracionstecnics[3].isSuspes){$scope.title1="S";}
                if ($scope.valoracionstecnics[3].isCC){$scope.title1=$scope.title1+"C";}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title2="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title2=$scope.title2+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title3="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title3=$scope.title3+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title4="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title4=$scope.title4+"C";}
                  $scope.tooltip1=$scope.valoracionstecnics[3].idPartido+"-"+$scope.valoracionstecnics[3].fecha[2]+"/"+$scope.valoracionstecnics[3].fecha[1]+"/"+$scope.valoracionstecnics[3].fecha[0]+"-"+$scope.valoracionstecnics[3].equiplocal+"-"+$scope.valoracionstecnics[3].equipVisitant;
                  $scope.tooltip2=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                  $scope.tooltip3=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                  $scope.tooltip4=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido1=$scope.valoracionstecnics[3].idPartido;
                 vm.partido2=$scope.valoracionstecnics[2].idPartido;
                  vm.partido3=$scope.valoracionstecnics[1].idPartido;
                   vm.partido4=$scope.valoracionstecnics[0].idPartido;
                    break;
                          
                
    default:break;
  }
    
    $scope.valoracionstecnics=valoracionstecnicspartitsvisitant;
   // $scope.valoracionstecnics2=valoracionstecnics.query({idpartit:resultat[local].idPartido,idequip:resultat[visitant].idEquipo,idcampeonato:resultat[local].idCampionat});
   var j= valoracionstecnicspartitsvisitant.length;
  
   switch (j){
       case 1: 
                 if ($scope.valoracionstecnics[0].isVotat){
                     $scope.stboto6={"background-color": "greenyellow"};
                      if ($scope.valoracionstecnics[0].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title6=$scope.title6+"C";}
                    } else{  $scope.stboto6={"background-color": "red"};};
                    
                    $scope.tooltip6=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                    vm.partido6=$scope.valoracionstecnics[0].idPartido;
              break;
      case 2:  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                   if ($scope.valoracionstecnics[1].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title7=$scope.title7+"C";}
                 $scope.tooltip6=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                 $scope.tooltip7=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                 vm.partido6=$scope.valoracionstecnics[1].idPartido;
                 vm.partido7=$scope.valoracionstecnics[0].idPartido;
                    break;
        case 3:  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                  if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto8={"background-color": "greenyellow"};
                 } else{  $scope.stboto8={"background-color": "red"};}
                    if ($scope.valoracionstecnics[2].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title7=$scope.title7+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title8="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title8=$scope.title8+"C";}
                   $scope.tooltip6=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip7=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip8=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                   vm.partido6=$scope.valoracionstecnics[2].idPartido;
                 vm.partido7=$scope.valoracionstecnics[1].idPartido;
                  vm.partido8=$scope.valoracionstecnics[0].idPartido;
                    break;
       case 4:  if ($scope.valoracionstecnics[3].isVotat){
                    $scope.stboto6={"background-color": "greenyellow"};
                 } else{  $scope.stboto6={"background-color": "red"};}
                  if ($scope.valoracionstecnics[2].isVotat){
                    $scope.stboto7={"background-color": "greenyellow"};
                 } else{  $scope.stboto7={"background-color": "red"};}
                  if ($scope.valoracionstecnics[1].isVotat){
                    $scope.stboto8={"background-color": "greenyellow"};
                 } else{  $scope.stboto8={"background-color": "red"};}
                 if ($scope.valoracionstecnics[0].isVotat){
                    $scope.stboto9={"background-color": "greenyellow"};
                 } else{  $scope.stboto9={"background-color": "red"};}
                  if ($scope.valoracionstecnics[3].isSuspes){$scope.title6="S";}
                if ($scope.valoracionstecnics[3].isCC){$scope.title6=$scope.title6+"C";}
                if ($scope.valoracionstecnics[2].isSuspes){$scope.title7="S";}
                if ($scope.valoracionstecnics[2].isCC){$scope.title7=$scope.title7+"C";}
                if ($scope.valoracionstecnics[1].isSuspes){$scope.title8="S";}
                if ($scope.valoracionstecnics[1].isCC){$scope.title8=$scope.title8+"C";}
                if ($scope.valoracionstecnics[0].isSuspes){$scope.title9="S";}
                if ($scope.valoracionstecnics[0].isCC){$scope.title9=$scope.title9+"C";}
                   $scope.tooltip6=$scope.valoracionstecnics[3].idPartido+"-"+$scope.valoracionstecnics[3].fecha[2]+"/"+$scope.valoracionstecnics[3].fecha[1]+"/"+$scope.valoracionstecnics[3].fecha[0]+"-"+$scope.valoracionstecnics[3].equiplocal+"-"+$scope.valoracionstecnics[3].equipVisitant;
                   $scope.tooltip7=$scope.valoracionstecnics[2].idPartido+"-"+$scope.valoracionstecnics[2].fecha[2]+"/"+$scope.valoracionstecnics[2].fecha[1]+"/"+$scope.valoracionstecnics[2].fecha[0]+"-"+$scope.valoracionstecnics[2].equiplocal+"-"+$scope.valoracionstecnics[2].equipVisitant;
                   $scope.tooltip8=$scope.valoracionstecnics[1].idPartido+"-"+$scope.valoracionstecnics[1].fecha[2]+"/"+$scope.valoracionstecnics[1].fecha[1]+"/"+$scope.valoracionstecnics[1].fecha[0]+"-"+$scope.valoracionstecnics[1].equiplocal+"-"+$scope.valoracionstecnics[1].equipVisitant;
                   $scope.tooltip9=$scope.valoracionstecnics[0].idPartido+"-"+$scope.valoracionstecnics[0].fecha[2]+"/"+$scope.valoracionstecnics[0].fecha[1]+"/"+$scope.valoracionstecnics[0].fecha[0]+"-"+$scope.valoracionstecnics[0].equiplocal+"-"+$scope.valoracionstecnics[0].equipVisitant;
                   vm.partido6=$scope.valoracionstecnics[3].idPartido;
                   vm.partido7=$scope.valoracionstecnics[2].idPartido;
                   vm.partido8=$scope.valoracionstecnics[1].idPartido;
                   vm.partido9=$scope.valoracionstecnics[0].idPartido;
                    break;
                          
                
    default:break;
  }
   
      
   if(( vm.isAdmin())||(userResolve.email==='esportescolar@esplugues.cat')){
      $scope.users =  $scope.users  || [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' },
 //       { id: 3, name: 'Tècnic/a local' },
 //       { id: 4, name: 'Tècnic/a visitant' },
 //       { id: 5, name: 'Públic local' },
 //       { id: 6, name: 'Públic visitant' },
        { id: 7, name: 'Tutor/a grada local' },
        { id: 8, name: 'Tutor/a grada visitant' }
      ];
  }
  else{
      var today = new Date();
var dd = today.getDate();
var mm = today.getMonth()+1; //January is 0!
var yyyy = today.getFullYear();

if(dd<10) {
    dd = '0'+dd;
} 

if(mm<10) {
    mm = '0'+mm;
} 

today = dd + '/' + mm + '/' + yyyy;
     
      var di=datediff(parseDate(vm.data), parseDate(today));
     
      if (di<3){
          vm.espotVotar=true;
     $scope.users =   [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' }
        
      ]; }
  else{
       $scope.users =   [
        { id: 1, name: 'Tutor/a de joc a Equip local'},
        { id: 2, name: 'Tutor/a de joc a Equip visitant' }
        
      ]; 
       vm.espotVotar=false;
  }
  
  }
       $scope.diagidperfil=0;$scope.diagidpartit=0;$scope.diagidquip=0;
       
       vm.change=function (id){
              $scope.id=id;
          if (id===1){
             // $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:5});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+5)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
               $scope.diagidperfil=5;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
             
          };
           if (id===2){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:5});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+5)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=5;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
          if (id===3){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:4});
               $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+4)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=4;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
            if (id===4){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:4});
            $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+4)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=4;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
            if (id===5){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:2});
            $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+2)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               
               $scope.diagidperfil=2;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
           if (id===6){
           //   $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:2});
                $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+2)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=2;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
             if (id===7){
           //   $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idLocal,idperfil:1});
             $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idLocal+'/'+1)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=1;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idLocal;
          };
             if (id===8){
            //  $scope.valoracions=valoracions.query({idpartit:resultat[local].idPartido,idequip:resultat[local].idVisitant,idperfil:1});
                $http.get(EnvironmentConfig.API + '/valoracions/'+resultat[local].idPartido+'/'+resultat[local].idVisitant+'/'+1)
                            .then(function(response){vm.poteliminar=(response.data.length>1);$scope.valoracions=response.data;vm.canvi();});
            
               $scope.diagidperfil=1;$scope.diagidpartit=resultat[local].idPartido;$scope.diagidquip=resultat[local].idVisitant;
          };
          
         
          vm.canvi=function() {
          
          for(var k=0;k<$scope.valoracions.length;k++){
             var val= $scope.valoracions[k].valorCSV.split(";");
             var i=val.indexOf($scope.valoracions[k].vporc.toString());
             
             var valstring=$scope.valoracions[k].stringsCSV.split(";");
             
             if (valstring.length===1) {$scope.valoracions[k].vporc=val[i];}
             else
             {$scope.valoracions[k].vporc=valstring[i];}  
         }
          $scope.$applyAsync(); 
          };
       };
       $scope.verpartido=function(partido){
           var url = $state.href("home.resultats",{idPartit:partido});
           window.open(url,'_blank');
       };
       
         $scope.votar=function(partido){
             if(  ($scope.id===1)||($scope.id===2)){
           var url = $state.href("home.votacio",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal,idEquip2:resultat[local].idVisitant});
             }
               if  ($scope.id===3){
           var url = $state.href("home.votaciotecnic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
              if  ($scope.id===4){
           var url = $state.href("home.votaciotecnic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
               if  ($scope.id===7){
           var url = $state.href("home.votaciotutorgrada",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
             if  ($scope.id===8){
           var url = $state.href("home.votaciotutorgrada",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
             if  ($scope.id===5){
           var url = $state.href("home.votaciopublic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idVisitant});
             }
               if  ($scope.id===6){
           var url = $state.href("home.votaciopublic",{idPerfil: $scope.diagidperfil, idPartit:$scope.diagidpartit,idEquip:resultat[local].idLocal});
             }
                 window.open(url,'_self');
       };
       
       $scope.eliminarvotacio=function(perfil){
           var r2=confirm("Segur que vol eliminar les votacions del perfil "+perfil+" ?");
           
           if(r2){
               $http.get(EnvironmentConfig.API + '/eliminarvotacio/'+resultat[0].idPartido+'/'+$scope.diagidquip+'/'+$scope.diagidperfil).then(function(response){
                     
           alert("Votacions eliminades");  var url = $state.href("home.resultats",{idPartit: +resultat[local].idPartido});
                  window.open(url,'_self');
                     $window.location.reload();    
       });
           }
       };
       function parseDate(str) {
    var mdy = str.split('/');
    return new Date(mdy[2], mdy[1], mdy[0]-1);
}
function datediff(first, second) {
   return Math.round((second-first)/(1000*60*60*24));
}

$scope.clicatlocal=function(a) {
    if(vm.isAdmin()){
    var idnotificacio=0;
    var nomequip="";
    if(a===1)  {idnotificacio=resultat[local].idEquipo;
    nomequip=resultat[0].elocal;}
    if(a===2)  {idnotificacio=resultat[visitant].idEquipo;nomequip=resultat[0].evisitant;}
     var r=confirm("Vols enviar un email d\'advertència de sanció?");
     if (r){
         var pobla="";
            $http.get(EnvironmentConfig.API + '/poblacio/'+idnotificacio).then(function(response){
                pobla=response.data;
                
          
            
          $http.get(EnvironmentConfig.API + '/teams/email/'+idnotificacio).then(function(response){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                } 
                if (mm < 10) {
                    mm = '0' + mm;
                    } 
                var today = dd + '/' + mm + '/' + yyyy;
              var mailHtml='<div lang="CA"><div class="m_-4911676397197326094WordSection1"><p class="MsoNormal">Hola,<u></u><u></u></p><p class="MsoNormal">Els'
+' tècnics dels següents equips de la vostra entitat, acumulen dues o més '
+'setmanes consecutives sense realitzar les seves valoracions a través de '
+'l\'aplicació del Juga Verd Play: <u></u><u></u></p><table class="m_-4911676397197326094MsoNormalTable" style="width: 816.0pt; border-collapse: collapse" width="1088" cellspacing="0" cellpadding="0" border="0"><tbody><tr style="height: 19.5pt"><td style="width: 161.0pt; border: solid windowtext 1.0pt; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="215" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">MUNICIPI<u></u><u></u></span></b></p></td><td style="width: 264.0pt; border: solid windowtext 1.0pt; border-left: none; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="352" valign="bottom"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">CAMPIONAT<u></u><u></u></span></b></p></td><td style="width: 391.0pt; border: solid windowtext 1.0pt; border-left: none; background: #8db4e2; padding: 0cm 3.5pt 0cm 3.5pt; height: 19.5pt" width="521" valign="bottom"><p class="MsoNormal" style="text-align: center" align="center"><b><span style="font-size: 14.0pt">EQUIP<u></u><u></u></span></b></p></td></tr><tr style="height: 18.75pt"><td style="width: 161.0pt; border: solid windowtext 1.0pt; border-top: none; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="215" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+pobla+'<u></u><u></u></span></p></td><td style="width: 264.0pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="352" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+resultat[0].campionat+'<u></u><u></u></span></p></td><td style="width: 391.0pt; border-top: none; border-left: none; border-bottom: solid windowtext 1.0pt; border-right: solid windowtext 1.0pt; padding: 0cm 3.5pt 0cm 3.5pt; height: 18.75pt" width="521" nowrap="nowrap"><p class="MsoNormal" style="text-align: center" align="center"><span style="font-size: 14.0pt; font-family: &quot;Arial&quot;,&quot;sans-serif&quot;">'+nomequip+'<u></u><u></u></span></p></td></tr></tbody></table><p class="MsoNormal">Us recordem que, <b><u><span style="background: yellow">si'
+' un tècnic no valora durant &nbsp;tres setmanes consecutives, l\'equip '
+'perdrà els punts de classificació de manera temporal fins que es valori el següent partit. En cas d\'acumular 4 '
+'jornades consecutives sense valorar, els punts es perdran de manera '
+'permanent*</span>.</u></b><span style="color: black"><u></u><u></u></span></p><p class="MsoNormal">*El Comitè Organitzador actuarà en casos on un tècnic no participa del programa JVP de forma deliberada.<u></u><u></u></p><p class="MsoNormal">'
+'Recordeu que, els codis per valorar tant el tècnic com el tutor de grada de cada equip, els trobareu a la pestanya “EQUIPS” del vostre Playoff. '
+'<u></u><u></u></p><p class="MsoNormal">Preguem'
+' que informeu a tots els tècnics dels següents equips de la vostra '
+'entitat que, &nbsp;en finalitzar el partit han de realitzar les '
+'valoracions a través de l\'aplicació Juga Verd Play. Un cop el tut@r de '
+'joc envií les seves puntuacions, la resta d\'agents: públic, tutor de '
+'grada i tècnics, disposaran dels 15 minuts següents per enviar les seves'
+' valoracions, tal i com hem informat anteriorment a través de circulars '
+'informatives, i com marca la normativa. El partit també es pot valorar '
+'abans que ho faci el tut@r de joc.<u></u><u></u></p><p class="MsoNormal">Salutacions.<u></u><u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><b><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Rocío Toré Luna<u></u><u></u></span></b></p><p class="MsoNormal"><b><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Tècnica <u></u><u></u></span></b></p><p class="MsoNormal"><b><i><span style="font-size: 10.0pt; color: #1f497d" lang="ES">Consell Esportiu del Baix Llobregat<u></u><u></u></span></i></b></p><p class="MsoNormal"><span style="font-size: 7.0pt; font-family: Wingdings; color: navy" lang="ES">(</span><span style="font-size: 7.0pt; font-family: MINITypeRegular; color: navy" lang="PT-BR">:</span><span style="font-size: 10.0pt; color: #1f497d" lang="EN-GB">93 685 20 39 (Ext. 5)&nbsp;&nbsp; </span><b><span style="font-size: 8.0pt; color: #1f497d" lang="EN-GB"><u></u><u></u></span></b></p><p class="MsoNormal"><b><u><span style="font-size: 10.0pt; color: #0070c0" lang="ES"><a href="http://www.cebllob.cat/" target="_blank" rel="noreferrer"><span lang="EN-GB">www.cebllob.cat</span></a><u></u><u></u></span></u></b></p><p class="MsoNormal"><b><u><span style="font-size: 10.0pt; color: #0070c0" lang="ES"><u></u><span style="text-decoration: none">&nbsp;</span><u></u></span></u></b></p><p class="MsoNormal"><span style="font-size: 8.0pt; color: #1f497d" lang="EN-GB">Segueix-nos a<u></u><u></u></span></p><p class="MsoNormal"><a href="http://www.facebook.com/cebllob" target="_blank" rel="noreferrer"><span style="font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none"><img id="m_-4911676397197326094Imagen_x0020_1" src="Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a_002.png" alt="Troba\'ns a Facebook" width="22" height="22" border="0"></span></a><span style=\"color: #1f497d\">&nbsp;</span><a href=\"http://www.twitter.com/cebllob\" target=\"_blank\" rel=\"noreferrer\"><span style=\"font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_2\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a.png\" alt=\"http://www.cebllob.com/cebllob06/Imagenes/iconos/twitter.png\" width=\"22\" height=\"22\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\">&nbsp;</span><a href=\"http://www.youtube.com/cebllob\" target=\"_blank\" rel=\"noreferrer\"><span style=\"font-size: 8.5pt; font-family: &quot;Verdana&quot;,&quot;sans-serif&quot;; color: #49709c; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_3\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a_003.png\" alt=\"http://www.cebllob.com/cebllob06/Imagenes/iconos/youtube.jpg\" width=\"23\" height=\"23\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\">&nbsp;</span><a href=\"https://www.instagram.com/CEBLLOB/\" target=\"_blank\" rel=\"noreferrer\"><span style=\"color: #1f497d; text-decoration: none\"><img id=\"m_-4911676397197326094Imagen_x0020_4\" src=\"Webmail%20%20%20Fwd%20%20Av%C3%ADs%20sanci%C3%B3%20equips%20Jornada%2019_01_19%20(sense%20valoraci%C3%B3%20del%20t%C3%A8cnic)_files/a.jpeg\" alt=\"cid:image005.jpg@01D1E96F.F0412D60\" width=\"22\" height=\"22\" border=\"0\"></span></a><span style=\"color: #1f497d\" lang=\"ES\"><u></u><u></u></span></p><p class=\"MsoNormal\"><span style=\"color: #1f497d\" lang=\"ES\"><u></u>&nbsp;<u></u></span></p><p class=\"MsoNormal\"><b><span style=\"font-size: 8.0pt; color: #666666\">CONFIDENCIALITAT</span></b><span style=\"font-size: 8.0pt; color: #1f497d\" lang=\"ES\"><u></u><u></u></span></p><p class=\"MsoNormal\" style=\"text-align: justify; background: white\"><b><i><u><span style=\"font-size: 8.0pt; color: #1f497d\">Nota legal</span></u></i></b><i><span style=\"font-size: 8.0pt; color: #1f497d\">:'
+' Aquest missatge i qualsevol arxiu adjunt està destinat únicament a la '
+'persona a qui es dirigeix i és confidencial. Si vostè ha rebut aquest '
+'missatge per error, si us plau comuniqui-ho al remitent i esborri '
+'immediatament. La utilització, revelació i / o reproducció del missatge '
+'pot constituir un delicte.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify; background: white"><b><i><u><span style="font-size: 8.0pt; color: #1f497d">Protecció de Dades</span></u></i></b><i><span style="font-size: 8.0pt; color: #1f497d">:'
+' L\'informem que les seves dades de contacte electrònic estan sent '
+'tractades d\'acord amb la Llei Orgànica 3/2018, LOPD-GDD i Normativa '
+'Europea 2016/679, RGPD de Protecció de Dades de Caràcter Personal, '
+'trobant-se incorporats a la base de dades de Consell Esportiu del Baix '
+'Llobregat a fi de enviament d\'informació, resposta a consultes, i '
+'contactes genèrics. Igualment l\'informem que podrà exercir els seus '
+'drets d\'accés, rectificació, oposició, supressió de les seves dades i '
+'les de limitació i portabilitat al seu tractament a través d\'una '
+'comunicació a la següent adreça de correu electrònic: <a href="mailto:cebllob@cebllob.cat" onclick="return rcmail.command(\'compose\',\'cebllob@cebllob.cat\',this)" rel="noreferrer">cebllob@cebllob.cat</a>.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify"><b><i><u><span style="font-size: 8.0pt; color: #1f497d">Baixa</span></u></i></b><i><span style="font-size: 8.0pt; color: #1f497d">:'
+' Amb motiu de la Llei 34/2002 de 11 de Juliol, de Serveis de la Societat'
+' de la Informació i de Comerç Electrònic e Internet, LSSICE, l´informem '
+'que pot revocar en qualsevol moment, el consentiment per a la recepció '
+'d\'aquest servei, enviant un correu a la direcció abans esmentada '
+'indicant la paraula BAIXA.<u></u><u></u></span></i></p><p class="MsoNormal" style="text-align: justify"><i><span style="font-size: 8.0pt; color: #1f497d">Gràcies per la seva col·laboració<u></u><u></u></span></i></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p><p class="MsoNormal"><u></u>&nbsp;<u></u></p></div></div></div></div></div></div>'
+'</div>'

+'</div>';
              var emailTo=response.data;
              var emailsubject="Avís sanció equips Jornada "+today+" (sense valoració del tècnic)";
               
              var emlCont="To:"+emailTo+'\n';
              emlCont+='Subject:'+emailsubject+'\n';
              emlCont+='X-Unsent: 1'+'\n';
              emlCont+='Content-Type: text/html;charset=UTF-8\n';
              emlCont+='\n';
              emlCont+="<DOCTYPE html><html><head>"+mailHtml+"</head></html>";
              var textFile=null;
              var data =new Blob([emlCont],{type:'text/plain'});
              textFile=window.URL.createObjectURL(data);
              var a=document.createElement('a');
              var linkText=document.createTextNode('fileLink');
              a.appendChild(linkText);
              a.href=textFile;
              a.id='fileLink';
              a.download=emailsubject+'.eml';
              a.style.visibility='hidden';
              document.body.appendChild(a);
              document.getElementById('fileLink').click();
              
              
              
            });     
       });  
     }
  };};
  }
  
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /* @ngdoc object
   * @name home.referees
   * @description
   *
   */
  angular
    .module('neo.home.referees', [
      'neo.home.referees.newReferee',
      'neo.home.referees.referee'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.referees')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.referees', {
        url: '/referees',
        templateUrl: 'home/referees/referees.tpl.html',
        controller: 'RefereesCtrl',
        controllerAs: 'vm',
        resolve:{
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.referees.controller:RefereesCtrl
   *
   * @description
   *
   */
  RefereesCtrl.$inject = ["townHalls", "$filter", "AclService", "RefereeList", "$state"];
  angular
    .module('neo.home.referees')
    .controller('RefereesCtrl', RefereesCtrl);

  function RefereesCtrl(townHalls, $filter, AclService, RefereeList, $state) {
    var vm = this;
    vm.ctrlName = 'RefereesCtrl';
    var organisationList = angular.copy(townHalls);
    if(AclService.isAdmin()) organisationList.push({name: $filter('translate')('COUNCIL'), id: undefined});
     vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'ACTIONS',
      actions: [{
        icon: 'add',
        tooltip: 'Afegir',
        execute: add
      }, {
        icon: 'timer',
      
        tooltip: 'Partits arbitrats',
        execute: partits
      }, {
        icon: 'local_atm',
      
        tooltip: 'Veure factures',
        execute: veurefactures
      },{
        icon: 'filter_3',
      
        tooltip: 'Resum trimestral',
        execute: resumtrimestral
      }]
    };
    
     function veurefactures(){
        $state.go('home.invoicesgroup');
    }
    
     function resumtrimestral(){
        $state.go('home.invoicestrimestral');
    }
    
    function add(){
        $state.go('home.referees.newReferee');
    }
    function partits(){
        $state.go('home.invoiceslist');
    }
    vm.data = {
      title: 'REFEREES.LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'surname', name: 'SURNAME', canOrder: true, orderBy: 'surnameOrder', orderDesc: true},
        {id: 'organisation', name: 'RESPONSIBLE_ORGANISATION', canOrder: true}
      ],
      areRowsClickable: true,
      state: {
        slink: 'home.referees.referee', params: [
          {key: 'licenseId', value: 'id'}
        ]
      },
      defaultOrderBy: 'nameOrder',
      filters: [
        {
          label: 'REFEREES.SELECT_TOWNHALL_OR_COUNCIL',
          showField: 'name',
          filterParam: 'organisationId',
          filterField: 'id',
          required: true,
          options: organisationList
        }
      ],
      filterPromise: function (params) {
        var queryObject = {council: false, organisationId: params.organisationId};
        if(angular.isUndefined(params.organisationId) || _.isNull(params.organisationId)){
          queryObject = {council: true, organisationId: null}
        }
        return RefereeList.query(queryObject).$promise;
      },
      filterFunction: function (data) {
        var persons = [];
        angular.forEach(data, function (licence) {
          var newPerson = {
            id: licence.id,
            organisation: _.isNull(licence.organisationName) ?  $filter('translate')('COUNCIL') : licence.organisationName ,
            name: licence.person.name,
            nameOrder: $filter('lowercase')(licence.person.name),
            surname: licence.person.surname,
            surnameOrder: $filter('lowercase')(licence.person.surname)
          };
          persons.push(newPerson);
        });
        return persons;
      }
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name referees.referee
   * @description
   *
   */
  angular
    .module('neo.home.refereeNewInvoice',['ui.router','neo.home.refereeNewInvoice.newline','neo.home.refereeNewInvoice.line','neo.home.refereeNewInvoice.invoiceslist',
    'neo.home.refereeNewInvoice.facturar','neo.home.refereeNewInvoice.invoicesgroup','neo.home.refereeNewInvoice.invoicegroup.invoice']);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.refereeNewInvoice')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.refereeNewInvoice', {
      url: '/referee-new-invoice/{licenseId}/inv',
     
          templateUrl: 'home/referee-new-invoice/referee-new-invoice.tpl.html',
          controller: 'RefereeNewInvoiceCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
       
        refereeLicense: ["RefereeLicence", "$stateParams", function (RefereeLicence,  $stateParams){
          return RefereeLicence.get({licenceId :  $stateParams.licenseId}).$promise;
    }],
      InvoiceRef: ["InvoiceRef", "$stateParams", function (InvoiceRef,  $stateParams){
          return InvoiceRef.query({Id :  $stateParams.licenseId}).$promise;
    }],
    refId:["$stateParams", function ($stateParams){
        return $stateParams.licenseId;
    }]
      }
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  RefereeNewInvoiceCtrl.$inject = ["$mdToast", "$scope", "$state", "AclService", "refereeLicense", "$mdDialog", "$filter", "RefereeLicence", "InvoiceRef", "refId"];
  angular
    .module('neo.home.refereeNewInvoice')
    .controller('RefereeNewInvoiceCtrl', RefereeNewInvoiceCtrl);

  function RefereeNewInvoiceCtrl($mdToast, $scope, $state,  AclService, refereeLicense, $mdDialog, $filter, RefereeLicence,InvoiceRef, refId) {
   var vm = this;
    vm.ctrlName = 'RefereeNewInvoiceCtrl';
     vm.refId=refId;
      
      
      vm.showList = true;
        vm.selected = [];

        vm.select = undefined;
    vm.person=refereeLicense.person;
    vm.title='PARTITS ARBITRATS';
  vm.headers= [
        {id: 'fecha', name: 'Data', canOrder: true},
         {id: 'idreceptor', name: 'Receptor', canOrder: true},
        {id: 'numinvoice', name: 'Num. Factura', canOrder: true},
         {id: 'esport', name: 'Concepte', canOrder: true},
          {id: 'numpartits', name: 'Num. partits', canOrder: true},
        {id: 'preu', name: 'Preu brut', canOrder: true},
        {id: 'total', name: 'Total', canOrder: true}
      ];
      
 vm.values=InvoiceRef;
  vm.buttons = {
        dial: true,
        icon: 'more_vert',
        tooltip: 'ACTIONS',
        actions: []
      };
        vm.buttons.actions.push({
          icon: 'playlist_add',
          tooltip: 'Afegir línia',
          execute: afegirLinia
        });
        
   function afegirLinia() {
        $state.go('home.new-line', {licenseId: refId},{reload:true});
      
      }
      
     
  }
}());



(function () {
  'use strict';

  /* @ngdoc object
   * @name home.postponements
   * @description
   *
   */
  angular
    .module('neo.home.postponements', [
      'ui.router',
      'neo.home.postponements.new',
      'neo.home.postponements.edit',
      'neo.home.postponements.postponedMatches'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.postponements')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.postponements', {
        url: '/postponements',
        templateUrl: 'home/postponements/postponements.tpl.html',
        controller: 'PostponementsCtrl',
        controllerAs: 'vm',
        resolve: {
          acl: ["$q", "AclService", function ($q, AclService) {
            // TODO: Fix security by url, this is't works because the user is requested after of the verification
            /*if (AclService.can('POSTPONEMENT', 'C')) {
             // Has proper permissions
             return true;
             } else {
             // Does not have permission
             return $q.reject('Unauthorized');
             }*/
          }],
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function (CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name home.postponements.controller:PostponementsCtrl
     *
     * @description
     *
     */
    PostponementsCtrl.$inject = ["$state", "$filter", "$q", "Matches", "townHalls", "currentSeason"];
    angular
      .module('neo.home.postponements')
      .controller('PostponementsCtrl', PostponementsCtrl);

    function PostponementsCtrl($state, $filter, $q, Matches, townHalls, currentSeason) {
      var vm = this;
      vm.showList = false;
      vm.matches = [];
      vm.today = moment().toDate();
      vm.initDate = vm.today;
      vm.endDate = moment(currentSeason.endDate).toDate();
      vm.townhalls = angular.copy(townHalls);
      vm.queryOrder = 'date';
      vm.sort = 'date';

      vm.currentPage = 1;
      vm.matchesPerPage = 25;
      vm.paginationLabel = {
        page: $filter('translate')('PAGE'),
        rowsPerPage: '',
        of: $filter('translate')('OF')
      };

      if (vm.townhalls.length === 1) {
        vm.selectedTownHall = vm.townhalls[0];
        applyFilters();
      }

      vm.applyFilters = applyFilters;
      vm.reorder = reorder;
      vm.getNewPage = getNewPage;
      vm.postponeMatch = postponeMatch;

      function postponeMatch(match) {
        $state.go('home.postponements.new', {matchId: match.id});
      }


      function applyFilters() {
        vm.isFiltered = true;
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
      }

      function reorder(order) {
        vm.sort = order;
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
      }

      function parseMatch(data, match) {
        var facility = findItemById(data.facilities, match.facilityId);
        var localTeam = findItemById(data.teams, match.localTeamId);
        var visitorTeam = findItemById(data.teams, match.visitorTeamId);
        return {
          id: match.id,
          canPostpone: angular.isDefined(localTeam) && angular.isDefined(visitorTeam),
          localTeam: angular.isDefined(localTeam) ? localTeam : {name: $filter('translate')('CALENDAR.REST')},
          visitorTeam: angular.isDefined(visitorTeam) ? visitorTeam : {name: $filter('translate')('CALENDAR.REST')},
          date: moment(match.date).format('L'),
          time: _.isNull(match.time) ? undefined : match.time,
          facility: angular.isDefined(facility) ? facility : undefined,
          championship: findItemById(data.championships, match.championshipId).name
        };
      }

      function query(townHallId, initDate, endDate, page, sort) {
        var deferredMatches = $q.defer();
        vm.promiseMatches = deferredMatches.promise;
        var parameters = {
          townHall: townHallId,
          initDate: moment(initDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          page: page,
          size: vm.matchesPerPage,
          pendingPostponement: false
        };
        //Optional parameters
        if (angular.isDefined(sort)) {
          parameters.sort = sort;
        }
        Matches.get(parameters, function (data) {
          _.remove(vm.matches);
          angular.forEach(data.matches, function (match) {
            vm.matches.push(parseMatch(data, match));
          });
          vm.showList = vm.matches.length > 0;
          vm.maxMatches = data.page.count;
          deferredMatches.resolve();
        }, function () {
          deferredMatches.resolve();
        });
      }


      function getNewPage(page) {
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, page, vm.sort);
      }

      function findItemById(collection, itemId) {
        return _.find(collection, function (i) {
          return i.id === itemId;
        });
      }
    }
  }()
);

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.phases
   * @description
   *
   */
  angular
    .module('neo.home.phases', [
      'ui.router',
      'neo.home.phases.newPhase',
      'neo.home.phases.inscription',
      'neo.home.phases.phase'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.phases')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.phases', {
        url: '/phases',
        templateUrl: 'home/phases/phases.tpl.html',
        controller: 'PhasesCtrl',
        controllerAs: 'vm',
        resolve: {
          phases: ["Phases", function (Phases) {
            return Phases.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.phases.controller:PhasesCtrl
   *
   * @description
   *
   */
  PhasesCtrl.$inject = ["$filter", "phases"];
  angular
      .module('neo.home.phases')
      .controller('PhasesCtrl', PhasesCtrl);

  function PhasesCtrl($filter, phases) {
    var vm = this;
    // TODO: refactor when we have date general formatting
    angular.forEach(phases, function (phase) {
      phase.nameOrder = $filter('lowercase')(phase.name);
      phase.iniDateOrder = phase.iniDate;
      phase.iniDate = moment(phase.iniDate).format('L');
      phase.endDateOrder = phase.endDate;
      phase.endDate = moment(phase.endDate).format('L');
      phase.type = $filter('translate')('PHASES.PHASES_TYPES.' + phase.type);
    });

    vm.ctrlName = 'PhasesCtrl';
    vm.data = {
      title: 'PHASES.PHASE_LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'iniDate', name: 'INI_DATE', canOrder: true, orderBy: 'iniDateOrder'},
        {id: 'endDate', name: 'END_DATE', canOrder: true, orderBy: 'endDateOrder'},
        {id: 'type', name: 'PHASES.PHASE_TYPE', canOrder: true}
      ],
      state: {slink: 'home.phases.phase', params: [{key: 'phaseId', value: 'id'}]},
      defaultOrderBy: 'nameOrder',
      filters: undefined,
      values: phases
    };
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons
   * @description
   *
   */
  angular
  .module('neo.home.persons', [
    'ui.router',
    'neo.home.persons.person',
    'neo.home.persons.newPerson'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.persons')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.persons', {
      url: '/persons',
      templateUrl: 'home/persons/persons.tpl.html',
      controller: 'PersonsCtrl',
      controllerAs: 'vm',
      params: {
        selectedEntity: undefined,
        selectedTeam: undefined
      },
      resolve: {
        entities: ["Entitats", function (Entitats) {
          return Entitats.query().$promise;
        }],
        categories: ["Categories", function (Categories) {
          return Categories.query().$promise;
        }],
        sports: ["Sports", function (Sports) {
          return Sports.query().$promise;
        }],
        licenseTypes: ["LicenseTypes", function (LicenseTypes) {
          return LicenseTypes.query().$promise;
        }],
        genders: ["Genders", function (Genders) {
          return Genders.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name persons.controller:PersonsCtrl
   *
   * @description
   *
   */
  PersonsCtrl.$inject = ["$state", "$filter", "$stateParams", "entities", "categories", "genders", "sports", "licenseTypes", "EntityTeams", "LicenseTeam", "$mdToast", "$mdDialog", "ImportPlayers"];
  angular
  .module('neo.home.persons')
  .controller('PersonsCtrl', PersonsCtrl);

  function PersonsCtrl($state, $filter, $stateParams, entities, categories, genders, sports, licenseTypes, EntityTeams, LicenseTeam, $mdToast, $mdDialog, ImportPlayers) {
    var vm = this;
    vm.ctrlName = 'PersonsCtrl';
    vm.hasPermission = true;
    vm.selectedEntity = $stateParams.selectedEntity;
    vm.selectedTeam = $stateParams.selectedTeam;

    vm.data = {
      title: 'PERSONS_LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'surname', name: 'SURNAME', canOrder: true, orderBy: 'surnameOrder'},
         {id: 'secondSurname', name: 'SECOND_SURNAME', canOrder: true},
          {id: 'bornDate', name: 'BIRTH_DATE', canOrder: true,orderBy: 'bornDateOrder'},
        {id: 'personType', name: 'PEOPLE.TYPE', canOrder: true},
        {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
        {id: 'sport', name: 'SPORT', canOrder: true}
      ],
      state: {
        slink: 'home.persons.person.information', params: [
          {key: 'team', value: 'teamId'},
          {key: 'license', value: 'id'}
        ]
      },
      defaultOrderBy: ['nameOrder', 'surnameOrder'],
      filters: [
        {
          label: 'ENTITIES.SELECT',
          showField: 'name',
          filterParam: 'entityId',
          filterField: 'id',
          required: true,
          options: entities,
          selectedItem: undefined,
          eventTrigger: function (params) {
            EntityTeams.query({entityId: params.entityId}, function (data) {
                angular.forEach(data, function (item) {
                  var categoryName = $filter('translate')('CATEGORIES.' + findItemById(categories, item.categoryId).name);
                  var genderName = $filter('translate')(findItemById(genders, item.genderId).name);
                  item.name += ' - ' + categoryName + ' - ' + genderName;
                });
                vm.data.filters[1].options = data;
                if (!_.some(data, function (person) {
                    return vm.data.filters[1].selectedItem && person.id === vm.data.filters[1].selectedItem.id
                  })) {
                  vm.data.filters[1].selectedItem = null;
                }
              }
            );
          }
        },
        {
          label: 'TEAMS',
          showField: 'name',
          filterParam: 'teamId',
          filterField: 'id',
          required: true,
          selectedItem: undefined,
          dependsOn: 0
        }
      ],
      filterValues: {
        ENTITIES: vm.selectedEntity,
        TEAMS: vm.selectedTeam
      },
      filterFunction: function (data) {
        var persons = [];
        angular.forEach(data, function (license) {
          var category = findItemById(categories, license.categoryId);
          var newPerson = {
            id: license.id,
            teamId: license.teamId,
            name: license.person.name,
            nameOrder: $filter('lowercase')(license.person.name),
            surname: license.person.surname,
              surnameOrder: $filter('lowercase')(license.person.surname),
            secondSurname: license.person.secondSurname,
               bornDate:  ('0'+license.person.bornDate[2]).slice(-2)+'/'+('0'+license.person.bornDate[1]).slice(-2)+'/'+ license.person.bornDate[0],
                 bornDateOrder: license.person.bornDate,
            category: $filter('translate')('CATEGORIES.' + category.name),
          
            categoryOrder: category.startYear,
            sport: $filter('translate')('SPORTS.' + findItemById(sports, vm.data.filters[1].selectedItem.sportId).name),
            personType: $filter('translate')('PERSON_TYPES.' + findItemById(licenseTypes, license.licenceTypeId).name)
          };
          persons.push(newPerson);
        });
        return persons;
      },
      filterPromise: function (params) {
        return LicenseTeam.query({teamId: params.teamId}).$promise;
      }
    };


    var hasSelectedItem = function (filter) {
      return angular.isDefined(filter.selectedItem) && filter.selectedItem !== null;
    };

    vm.getEntity = function () {
      if (hasSelectedItem(vm.data.filters[0])) {
        return vm.data.filters[0].selectedItem;
      } else {
        return undefined;
      }
    };

    vm.getTeam = function () {
      if (hasSelectedItem(vm.data.filters[1])) {
        return vm.data.filters[1].selectedItem;
      } else {
        return undefined;
      }
    };

    vm.importAthletes = function () {
      var entityId = vm.getEntity();
      if (angular.isUndefined(entityId)) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('SELECT_ENTITY'))
          .position('bottom left')
          .hideDelay(3000)
        );
        return;
      }
      var teamId = vm.getTeam();
      if (angular.isUndefined(teamId)) {
        $mdToast.show(
          $mdToast.simple()
            .textContent($filter('translate')('SELECT_TEAM'))
          .position('bottom left')
          .hideDelay(3000)
        );
        return;
      }

      ImportPlayers.query({teamId: vm.getTeam()}, function (athletesToImport) {
        $mdDialog.show({
          controller: 'ImportAthletesDialogControllerCtrl',
          templateUrl: 'home/persons/importAthletesDialog.tmpl.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            athletesToImport: athletesToImport
          }
        })
        .then(function (importList) {
          if(importList.length > 0){
            ImportPlayers.save({teamId: vm.getTeam()}, importList,
            function () {
              $mdToast.show(
                $mdToast.simple()
                  .textContent($filter('translate')('PEOPLE.CORRECTLY_IMPORTED'))
                .position('bottom left')
                  .hideDelay(3000)
              );
              $state.go('home.persons', {}, {reload: true});
            },
            function (error) {
              var message = '';
              if(error.status===404){
                message = "TEAM_NOT_FOUND";
              }
              else if (error.status===400){
                message = "NOT_VALID_MODEL";
              }
              $mdToast.show(
                $mdToast.simple()
                .textContent($filter('translate')(message))
                .position('bottom left')
                .hideDelay(3000))
            })
          }
        });
      })

    };

    vm.buttons = {
      dial: true,
      icon: 'more_vert',
      tooltip: 'Accions',
      actions: []
    };

    vm.buttons.actions.push({
      changeState: true,
      stateToChange: "home.persons.newPerson",
      paramsToChange: {
        selectedEntity: vm.getEntity,
        selectedTeam: vm.getTeam
      },
      buttonImage: "images/ic_person_add_black_48px.svg",
      tooltip: $filter('translate')('PEOPLE.NEW_PERSON')
    });

    vm.buttons.actions.push({
      changeState: false,
      execute: vm.importAthletes,
      buttonImage: "images/ic_import_export_black_48px.svg",
      tooltip: $filter('translate')('PEOPLE.IMPORT_ATHLETES')
    });

    var findItemById = function (collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.persons.controller:ImportAthletesDialogControllerCtrl
   *
   * @description
   *
   */
  ImportAthletesDialogControllerCtrl.$inject = ["$scope", "$mdDialog", "athletesToImport", "$filter"];
  angular
  .module('neo.home.persons')
  .controller('ImportAthletesDialogControllerCtrl', ImportAthletesDialogControllerCtrl);

  function ImportAthletesDialogControllerCtrl($scope, $mdDialog, athletesToImport, $filter) {
    $scope.importList = [];
    $scope.notFoundMessage = $filter('translate')('PEOPLE.NO_ATHLETES_TO_IMPORT');
    angular.forEach(athletesToImport,function (athlete) {
      athlete.bornDate = moment(athlete.bornDate).format('DD/MM/YYYY')
    });
    $scope.athletesToImport = athletesToImport;
    $scope.listToImport = function (item, list) {
      var idx = list.indexOf(item.id);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item.id);
      }
    };

    $scope.cancel = function () {
      $mdDialog.cancel()
    };

    $scope.importPeople = function(){
      $mdDialog.hide($scope.importList)
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.matches', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.matches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.matches', {
        url: '/matches',
        templateUrl: 'home/matches/matches.tpl.html',
        data: {
          townHall: undefined,
          initDate: undefined,
          endDate: undefined
        },
        controller: 'MatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function(CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  MatchesCtrl.$inject = ["AclService", "Matches", "townHalls", "currentSeason", "$mdToast", "$filter", "$scope", "$state"];
  angular
    .module('neo.home.matches')
    .controller('MatchesCtrl', MatchesCtrl);

  function MatchesCtrl(AclService,Matches, townHalls, currentSeason, $mdToast, $filter, $scope, $state) {
    var vm = this;
    vm.currentSeason = angular.copy(currentSeason);
    
    if( AclService.isAdmin()){
        townHalls.unshift({id:9999, name:'Tots', email:'', phoneNumber:0});
    }
    vm.townhalls = angular.copy(townHalls);
    vm.currentSeason.iniDate = moment(vm.currentSeason.iniDate).toDate();
    vm.currentSeason.endDate = moment(vm.currentSeason.endDate).toDate();

    //vm.iniDate = (angular.isUndefined($state.current.data.initDate)) ? vm.currentSeason.iniDate : $state.current.data.initDate;
    //vm.endDate = (angular.isUndefined($state.current.data.endDate)) ? vm.currentSeason.endDate : $state.current.data.endDate;
    var d = new Date();
    //d.setDate(d.getDate() - 7);
    vm.iniDate=d;
     var d2 = new Date();
    d2.setDate(d.getDate() + 7);
    vm.endDate=d2;
    
    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    vm.matches = [];
    vm.selected = [];
    vm.select = undefined;

    vm.openMenu = function ($mdMenu, event) {
      $mdMenu.open(event);
    };

    if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      $state.current.data.townHall = vm.selectedTownHall;
    } else {
      vm.selectedTownHall = ($state.current.data.townHall) ? $state.current.data.townHall : undefined;
    }
    vm.currentPage = 1;
    vm.matchesPerPage = 1500;
    vm.queryOrder = 'championship';
    vm.sort = 'championship';

    vm.applyFilters = applyFilters;
    vm.reorder = reorder;
    vm.getNewPage = getNewPage;

    function applyFilters() {
      vm.isFiltered = true;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function reorder(order) {
      vm.sort = order;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function getNewPage(page, limit) {
      vm.currentPage = page;
      vm.matchesPerPage = limit;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function query(townHallId, iniDate, endDate, page, size, sort) {
      var parameters = {
        townHall: townHallId,
        initDate: moment(iniDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        page: page,
        size: size
      };
      //Optional parameters
      if (angular.isDefined(sort)) {
        parameters.sort = sort;
      }
      Matches.get(parameters, function (data) {
          _.remove(vm.matches);
          angular.forEach(data.matches, function (match) {
            var localTeam = findItemById(data.teams, match.localTeamId);
            var visitorTeam = findItemById(data.teams, match.visitorTeamId);
            var facility = findItemById(data.facilities, match.facilityId);
            var championship = findItemById(data.championships, match.championshipId);
            vm.matches.push({
              town: angular.isDefined(facility) ? facility.town : '-',
              matchDay: match.matchDay,
              localTeam: localTeam,
              visitorTeam: visitorTeam,
              date: moment(match.date).format('L'),
              time: match.time === null ? '--:--' : match.time,
              facility: facility,
              championship: championship
            });
          });
          vm.maxMatches = data.page.count;
        },
        function (error) {
          var message = angular.isDefined(error.data.message) ? error.data.message : 'TOAST_ERROR';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    $scope.$watch('vm.iniDate', function (newDate) {
      $state.current.data.initDate = newDate;
    });

    $scope.$watch('vm.endDate', function (newDate) {
      $state.current.data.endDate = newDate;
    });

    $scope.$watch('vm.selectedTownHall', function (selectedTownHall) {
      $state.current.data.townHall = selectedTownHall;
    });
 $scope.exportToExcel= ((function() {
          var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
          return function(table, name) {
            table = document.getElementById(table);
            
            var ctx = {worksheet: name || 'Report', table: table.innerHTML};
            window.location.href = uri + base64(format(template, ctx));
          }
        })())
        


  }
  
  
  
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.licenseSearch
   * @description
   *
   */
  angular
    .module('neo.home.licenseSearch', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.licenseSearch')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.licenseSearch', {
        url: '/license-search',
        templateUrl: 'home/license-search/license-search.tpl.html',
        controller: 'LicenseSearchCtrl',
        controllerAs: 'vm',
        resolve:{
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          licenseTypes: ["LicenseTypes", function (LicenseTypes) {
            return LicenseTypes.query().$promise;
          }],
          programmes: ["Programmes", function (Programmes) {
            return Programmes.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.licenseSearch.controller:LicenseSearchCtrl
   *
   * @description
   *
   */
  LicenseSearchCtrl.$inject = ["sports", "programmes", "categories", "licenseTypes", "$filter", "SearchLicense"];
  angular
    .module('neo.home.licenseSearch')
    .controller('LicenseSearchCtrl', LicenseSearchCtrl);

  function LicenseSearchCtrl(sports, programmes, categories, licenseTypes, $filter, SearchLicense) {
    var vm = this;
    vm.ctrlName = 'LicenseSearchCtrl';
    vm.currentPage = 1;
    vm.licencesPerPage = 10;

    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    vm.hasSearched = false;
    vm.searchName = "";
    vm.searchSurname = "";
    vm.searchSecondSurname = "";
    vm.searchLicenses = searchLicenses;
    vm.getNewPage = getNewPage;

    function searchLicenses() {
      vm.hasSearched = true;
      vm.nameToSearch = vm.searchName;
      vm.surnameToSearch = vm.searchSurname;
      vm.secondSurnameToSearch = vm.searchSecondSurname;
      vm.currentPage = 1;

      query(vm.currentPage, vm.licencesPerPage, vm.nameToSearch, vm.surnameToSearch, vm.secondSurnameToSearch)
    }

    function getNewPage(page) {
      query(page, vm.licencesPerPage, vm.nameToSearch, vm.surnameToSearch, vm.secondSurnameToSearch)
    }

    function query(page, size, name, surname1, surname2) {
      var parameters = {
        page: page,
        size: size,
        name: name,
        surname1: surname1,
        surname2: surname2
      };
      SearchLicense.get(parameters, function (data) {
        vm.licences = [];
        angular.forEach(data.licences, function (responseLicence) {
          var licence = {
            name: responseLicence.name,
            surname1: responseLicence.surname,
            surname2: responseLicence.secondSurname,
            licenseType: _.isNull(responseLicence.licenseTypeId) ? "-" : $filter('translate')("PERSON_TYPES." + findItemById(licenseTypes, responseLicence.licenseTypeId).name),
            sport: _.isNull(responseLicence.sportId) ? "-" : $filter('translate')("SPORTS." + findItemById(sports, responseLicence.sportId).name),
            program: _.isNull(responseLicence.programmeId) ? "-" : $filter('translate')(findItemById(programmes, responseLicence.programmeId).name),
            category: _.isNull(responseLicence.categoryId) ? "-" : $filter('translate')("CATEGORIES." + findItemById(categories, responseLicence.categoryId).name),
            organisationName: _.isNull(responseLicence.organisationName) ? $filter('translate')("COUNCIL") : responseLicence.organisationName,
            teamName: _.isNull(responseLicence.teamName) ? "-" : responseLicence.teamName
          };
          vm.licences.push(licence);
        });
        vm.maxLicences = data.page.count;
      }, function (error) {
        showError(error);
      });
    }


    vm.showError = showError;

    function showError(error) {
      console.log(error);
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

  }


}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.informestg', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

    config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.informestg')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.informestg', {
      url: '/informestg/{dia}/{mes}/{any}/{dia2}/{mes2}/{any2}/{idperfil}',
     
          templateUrl: 'home/informestg/informestg.tpl.html',
          controller: 'informestgCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
          partits: ["partits", "$stateParams", function ( partits,$stateParams){
          return partits.query({dia :  $stateParams.dia,mes :  $stateParams.mes,any :  $stateParams.any
          ,dia2 :  $stateParams.dia2,mes2 :  $stateParams.mes2,any2 :  $stateParams.any2,idperfil :  $stateParams.idperfil}).$promise;
    }]
    
      }
    }); }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  informestgCtrl.$inject = ["resultats", "partits", "$scope", "$state", "$mdDialog", "$http", "EnvironmentConfig"];
  angular
    .module('neo.home.informestg')
    .controller('informestgCtrl', informestgCtrl);

  function informestgCtrl(resultats, partits,$scope,$state,$mdDialog, $http,EnvironmentConfig) {
   var vm = this;
  
   $scope.partidos=[[]];
   var b=[[]];
   
   partits.forEach(function(p,i){
      //a[i]= resultats.query({idPartit: p.idPartido},function(){
        // b[i].elocal=a[i].elocal;
      // });
      $http({
                            url: EnvironmentConfig.API+"/resultatapp/"+p.idPartido,
                            method: "GET"
                        }).success(function (data, status, headers, config) {
                            
                            //copy the data we get to our items array. we need to use angular.copy so that
                            //angular can track the object and bind it automatically.
                            //angular.copy(data, $scope.partidos);
                            var b1=[];
                           ;
                            b1.apellido=p.apellido;
                          
                            if (p.email===null){
                                 b1.nombre="tècnic/a Ajuntament";
                                 b1.email=p.poblacion;
                            }else{
                                 b1.nombre=p.nombre;
                                 b1.email=p.email;
                               }
                           
                            b1.poblacion=p.poblacion;
                             var  local=0;
                             var visitant=1;
                             if (data[0].idEquipo===data[0].idLocal){
                                    local=0;
                                    visitant=1;
                                        } else{
                                             local=1;
                                             visitant=0;
                                }
                            b1.gradaL=data[local].ptg;
                            b1.campionat=data[local].campionat;
                            b1.elocal=data[local].elocal;
                            b1.evisitant=data[local].evisitant;
                            b1.tecnicL=data[visitant].ptt;
                            b1.equipV=data[local].pte;
                            b1.gradaV=data[visitant].ptg;
                           
                            b1.id=data[local].idPartido;
                            b1.fecha=data[local].fecha;
                               $scope.partidos.push(b1);
                               
                        }).error(function (data, status, headers, config) {
                            //something went wrong
                          
                        });
                        
     
   });
   // angular.copy(a, $scope.partidos);
   
  }
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.informestecnic', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

    config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.informestecnic')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.informestecnic', {
      url: '/informestecnic/{dia}/{mes}/{any}/{dia2}/{mes2}/{any2}/{idperfil}',
     
          templateUrl: 'home/informestecnic/informestecnic.tpl.html',
          controller: 'informestecnicCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
          partits: ["partits", "$stateParams", function ( partits,$stateParams){
          return partits.query({dia :  $stateParams.dia,mes :  $stateParams.mes,any :  $stateParams.any
          ,dia2 :  $stateParams.dia2,mes2 :  $stateParams.mes2,any2 :  $stateParams.any2,idperfil :  $stateParams.idperfil}).$promise;
    }]
    
      }
    }); }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  informestecnicCtrl.$inject = ["resultats", "partits", "$scope", "$state", "$mdDialog", "$http", "EnvironmentConfig"];
  angular
    .module('neo.home.informestecnic')
    .controller('informestecnicCtrl', informestecnicCtrl);

  function informestecnicCtrl(resultats, partits,$scope,$state,$mdDialog, $http,EnvironmentConfig) {
   var vm = this;
  
   $scope.partidos=[[]];
   var b=[[]];
   
   partits.forEach(function(p,i){
      //a[i]= resultats.query({idPartit: p.idPartido},function(){
        // b[i].elocal=a[i].elocal;
      // });
      $http({
                            url: EnvironmentConfig.API+"/resultatapp/"+p.idPartido,
                            method: "GET"
                        }).success(function (data, status, headers, config) {
                            
                            //copy the data we get to our items array. we need to use angular.copy so that
                            //angular can track the object and bind it automatically.
                            //angular.copy(data, $scope.partidos);
                            var b1=[];
                           ;
                            b1.apellido=p.apellido;
                          
                            if (p.email===null){
                                 b1.nombre="tècnic/a Ajuntament";
                                 b1.email=p.poblacion;
                            }else{
                                 b1.nombre=p.nombre;
                                 b1.email=p.email;
                               }
                           
                            b1.poblacion=p.poblacion;
                             var  local=0;
                             var visitant=1;
                             if (data[0].idEquipo===data[0].idLocal){
                                    local=0;
                                    visitant=1;
                                        } else{
                                             local=1;
                                             visitant=0;
                                }
                            b1.tecnicV=data[local].ptt;
                            b1.campionat=data[local].campionat;
                            b1.elocal=data[local].elocal;
                            b1.evisitant=data[local].evisitant;
                            b1.tecnicL=data[visitant].ptt;
                            b1.equipV=data[local].pte;
                            b1.equipL=data[visitant].pte;
                           
                            b1.id=data[local].idPartido;
                            b1.fecha=data[local].fecha;
                               $scope.partidos.push(b1);
                               
                        }).error(function (data, status, headers, config) {
                            //something went wrong
                          
                        });
                        
     
   });
   // angular.copy(a, $scope.partidos);
   
  }
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.informespublic', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

    config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.informespublic')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.informespublic', {
      url: '/informespublic/{dia}/{mes}/{any}/{dia2}/{mes2}/{any2}/{idperfil}',
     
          templateUrl: 'home/informespublic/informespublic.tpl.html',
          controller: 'informespublicCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
          partits: ["partits", "$stateParams", function ( partits,$stateParams){
          return partits.query({dia :  $stateParams.dia,mes :  $stateParams.mes,any :  $stateParams.any
          ,dia2 :  $stateParams.dia2,mes2 :  $stateParams.mes2,any2 :  $stateParams.any2,idperfil :  $stateParams.idperfil}).$promise;
    }]
    
      }
    }); }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  informespublicCtrl.$inject = ["resultats", "partits", "$scope", "$state", "$mdDialog", "$http", "EnvironmentConfig"];
  angular
    .module('neo.home.informespublic')
    .controller('informespublicCtrl', informespublicCtrl);

  function informespublicCtrl(resultats, partits,$scope,$state,$mdDialog, $http,EnvironmentConfig) {
   var vm = this;
  
   $scope.partidos=[[]];
   var b=[[]];
   
   partits.forEach(function(p,i){
      //a[i]= resultats.query({idPartit: p.idPartido},function(){
        // b[i].elocal=a[i].elocal;
      // });
      $http({
                            url: EnvironmentConfig.API+"/valoracions/"+p.idPartido+"/2",
                            method: "GET"
                        }).success(function (data, status, headers, config) {
                            
                            //copy the data we get to our items array. we need to use angular.copy so that
                            //angular can track the object and bind it automatically.
                            //angular.copy(data, $scope.partidos);
                            for(var i=0;i<data.length;i++){
                               
                            
                            var b1=[];
                           ;
                            b1.apellido=p.apellido;
                          
                            if (p.email===null){
                                 b1.nombre="tècnic/a Ajuntament";
                                 b1.email=p.poblacion;
                            }else{
                                 b1.nombre=p.nombre;
                                 b1.email=p.email;
                               }
                           
                            b1.poblacion=p.poblacion;
                             
                           
                            
                            b1.elocal=data[i].elocal;
                            b1.evisitant=data[i].evisitante;
                           
                            b1.item_Valorado=data[i].item_Valorado;
                            b1.vporc=data[i].vporc;
                           
                            b1.id=data[i].idPartido;
                            b1.fecha=data[i].fecha;
                               $scope.partidos.push(b1);
                           }
                        }).error(function (data, status, headers, config) {
                            //something went wrong
                         
                        });
                        
     
   });
   // angular.copy(a, $scope.partidos);
   
  }
}());


(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.informes', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

    config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.informes')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.informes', {
      url: '/informes/{dia}/{mes}/{any}/{dia2}/{mes2}/{any2}/{idperfil}',
     
          templateUrl: 'home/informes/informes.tpl.html',
          controller: 'informesCtrl',
          controllerAs: 'vm'
        ,
      resolve:{
          partits: ["partits", "$stateParams", function ( partits,$stateParams){
          return partits.query({dia :  $stateParams.dia,mes :  $stateParams.mes,any :  $stateParams.any
          ,dia2 :  $stateParams.dia2,mes2 :  $stateParams.mes2,any2 :  $stateParams.any2,idperfil :  $stateParams.idperfil}).$promise;
    }]
    
      }
    }); }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name referees.referee.controller:RefereeCtrl
   *
   * @description
   *
   */
  informesCtrl.$inject = ["resultats", "partits", "$scope", "$state", "$mdDialog", "$http", "EnvironmentConfig"];
  angular
    .module('neo.home.informes')
    .controller('informesCtrl', informesCtrl);

  function informesCtrl(resultats, partits,$scope,$state,$mdDialog, $http,EnvironmentConfig) {
   var vm = this;
  
   $scope.partidos=[[]];
   var b=[[]];
   
   partits.forEach(function(p,i){
      //a[i]= resultats.query({idPartit: p.idPartido},function(){
        // b[i].elocal=a[i].elocal;
      // });
      $http({
                            url: EnvironmentConfig.API+"/resultatapp/"+p.idPartido,
                            method: "GET"
                        }).success(function (data, status, headers, config) {
                            
                            //copy the data we get to our items array. we need to use angular.copy so that
                            //angular can track the object and bind it automatically.
                            //angular.copy(data, $scope.partidos);
                            var b1=[];
                           ;
                            b1.apellido=p.apellido;
                          
                            if (p.email===null){
                                 b1.nombre="tècnic/a Ajuntament";
                                 b1.email=p.poblacion;
                            }else{
                                 b1.nombre=p.nombre;
                                 b1.email=p.email;
                               }
                           
                            b1.poblacion=p.poblacion;
                             var  local=0;
                             var visitant=1;
                             if (data[0].idEquipo===data[0].idLocal){
                                    local=0;
                                    visitant=1;
                                        } else{
                                             local=1;
                                             visitant=0;
                                }
                            b1.tecnicL=data[local].pdt;
                            b1.idPartido=data[local].idPartido;
                            b1.campionat=data[local].campionat;
                            b1.elocal=data[local].elocal;
                            b1.evisitant=data[local].evisitant;
                            b1.tecnicV=data[visitant].pdt;
                            b1.publicL=data[local].pdp;
                            b1.publicV=data[visitant].pdp;
                            b1.puntsvpL=data[local].verdplay;
                            b1.puntsvpV=data[visitant].verdplay;
                            b1.tvL=data[local].tv;
                            b1.tvV=data[visitant].tv;
                            b1.fecha=data[local].fecha;
                               $scope.partidos.push(b1);
                               
                        }).error(function (data, status, headers, config) {
                            //something went wrong
                           
                        });
                        
     
   });
   // angular.copy(a, $scope.partidos);
   
  }
}());


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /* @ngdoc object
   * @name home.facilities
   * @description
   *
   */
  angular
    .module('neo.home.facilities', [
      'ui.router',
      'neo.home.facilities.newFacility',
      'neo.home.facilities.facility'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.facilities')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.facilities', {
        url: '/facilities',
        templateUrl: 'home/facilities/facilities.tpl.html',
        controller: 'FacilitiesCtrl',
        controllerAs: 'vm',
        resolve: {
          facilities : ["Facilities", function (Facilities) {
            return Facilities.query().$promise
          }],
          townhalls : ["Ajuntaments", function(Ajuntaments){
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.facilities.controller:FacilitiesCtrl
   *
   * @description
   *
   */
  FacilitiesCtrl.$inject = ["facilities", "townhalls", "AclService"];
  angular
  .module('neo.home.facilities')
  .controller('FacilitiesCtrl', FacilitiesCtrl);

  function FacilitiesCtrl(facilities, townhalls, AclService) {
    var vm = this;
    vm.ctrlName = 'FacilitiesCtrl';

    vm.hasPermission = AclService.can("FACILITY", "C");

    vm.facilities = [];
    angular.forEach(facilities, function (facility) {
      facility.nameOrder = facility.name;
      facility.addressOrder = facility.address;
      facility.town = facility.townName;
      facility.townOrder = facility.townName;
      facility.townHall = findItemById(townhalls, facility.idTownHall).name;
      facility.townHallOrder = findItemById(townhalls, facility.idTownHall).name;
      vm.facilities.push(facility);
    });

    vm.data = {
      title: 'FACILITIES.LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'address', name: 'ADDRESS', canOrder: true, orderBy: 'addressOrder'},
        {id: 'town', name: 'TOWN', canOrder: true, orderBy: 'townOrder'},
        {id: 'townHall', name: 'TOWN_HALL', canOrder: true, orderBy: 'townHallOrder'}
      ],
      state: {
        slink: 'home.facilities.facility', params: [
          {key: 'facilityId', value: 'id'}
        ]
      },
      defaultOrderBy: 'nameOrder',
      values: vm.facilities
    };


    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats
   * @description
   *
   */
  angular
      .module('neo.home.entitats', [
        'ui.router',
        'neo.home.entitats.entitat',
        'neo.home.entitats.newEntitat'
      ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.entitats')
  .config(config);

  function config($stateProvider) {
    $stateProvider.state('home.entitats', {
      url: '/entitats',
      templateUrl: 'home/entitats/entitats.tpl.html',
      controller: 'EntitatsCtrl',
      controllerAs: 'vm',
      resolve: {
        entitats: ["Entitats", "$q", function (Entitats, $q) {
          var deferred = $q.defer();

          Entitats.query(
            function (data) {
              deferred.resolve(data);
            },
            function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        }],
        towns: ["Poblacions", "$q", function (Poblacions, $q) {
          var deferred = $q.defer();

          Poblacions.query(
            function (data) {
              deferred.resolve(data);
            },
            function (response) {
              deferred.reject(response);
            }
          );
          return deferred.promise;
        }],
        entityTypes: ["EntityTypesPublic", function (EntityTypesPublic) {
          return EntityTypesPublic.query().$promise;
        }]
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.controller:EntitatsCtrl
   *
   * @description
   *
   */
  EntitatsCtrl.$inject = ["AclService", "entitats", "towns"];
  angular
  .module('neo.home.entitats')
  .controller('EntitatsCtrl', EntitatsCtrl);

  function EntitatsCtrl(AclService, entitats, towns) {
    var vm = this;
    vm.ctrlName = 'EntitatsCtrl';
    vm.llistaEntitats = entitats;
    vm.can = AclService.can;

    angular.forEach(vm.llistaEntitats, function (entitat) {
      angular.forEach(towns, function (town) {
        if (town.id === entitat.town) {
          entitat.townName = town.name;
        }
      });
    });

    vm.query = {
      order: 'name'
    };

    vm.selected = [];
    vm.select = undefined;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.comite', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.comite')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.comite', {
        url: '/comite',
        templateUrl: 'home/comite/comite.tpl.html',
        data: {
          townHall: undefined,
          initDate: undefined,
          endDate: undefined
        },
        controller: 'comiteCtrl',
        controllerAs: 'vm',
        resolve: {
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }],
          currentSeason: ["CurrentSeason", function(CurrentSeason) {
            return CurrentSeason.get().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  comiteCtrl.$inject = ["AclService", "Comite", "townHalls", "currentSeason", "$mdToast", "$filter", "$scope", "$state"];
  angular
    .module('neo.home.comite')
    .controller('comiteCtrl', comiteCtrl);

  function comiteCtrl(AclService,Comite, townHalls, currentSeason, $mdToast, $filter, $scope, $state) {
    var vm = this;
    vm.currentSeason = angular.copy(currentSeason);
     vm.sancionsshow=false;
    if( AclService.isAdmin()){
        townHalls.unshift({id:9999, name:'Tots', email:'', phoneNumber:0});
        vm.sancionsshow=true;
    }
    vm.townhalls = angular.copy(townHalls);
    vm.currentSeason.iniDate = moment(vm.currentSeason.iniDate).toDate();
    vm.currentSeason.endDate = moment(vm.currentSeason.endDate).toDate();

    //vm.iniDate = (angular.isUndefined($state.current.data.initDate)) ? vm.currentSeason.iniDate : $state.current.data.initDate;
    //vm.endDate = (angular.isUndefined($state.current.data.endDate)) ? vm.currentSeason.endDate : $state.current.data.endDate;
    var d = new Date();
    //d.setDate(d.getDate() - 7);
    vm.iniDate=d;
     var d2 = new Date();
    d2.setDate(d.getDate() + 7);
    vm.endDate=d2;
    
    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    vm.matches = [];
    vm.selected = [];
    vm.select = undefined;

    vm.openMenu = function ($mdMenu, event) {
      $mdMenu.open(event);
    };

    if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      $state.current.data.townHall = vm.selectedTownHall;
    } else {
      vm.selectedTownHall = ($state.current.data.townHall) ? $state.current.data.townHall : undefined;
    }
    vm.currentPage = 1;
    vm.matchesPerPage = 1500;
    vm.queryOrder = 'championship';
    vm.sort = 'championship';

    vm.applyFilters = applyFilters;
    vm.reorder = reorder;
    vm.getNewPage = getNewPage;

    function applyFilters() {
      vm.isFiltered = true;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function reorder(order) {
      vm.sort = order;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function getNewPage(page, limit) {
      vm.currentPage = page;
      vm.matchesPerPage = limit;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function query(townHallId, iniDate, endDate, page, size, sort) {
      var parameters = {
        townHall: townHallId,
        initDate: moment(iniDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        page: page,
        size: size
      };
      //Optional parameters
      if (angular.isDefined(sort)) {
        parameters.sort = sort;
      }
      $scope.verpartido=function(ident,equip1,equip2){
         
          if((typeof equip1!=="undefined")&&(typeof equip2!=="undefined"))
          {
          var url = $state.href("home.resultats",{idPartit: ident});
                  window.open(url,'_blank');
     
          }
      };
      
      Comite.get(parameters, function (data) {
          _.remove(vm.matches);
          var isCC="";
          var isvT="";
          var resultat="";
          var isSus="";
          var isTJ="";
          var isObs="";
          
          angular.forEach(data.matches, function (match) {
            var localTeam = findItemById(data.teams, match.localTeamId);
            var visitorTeam = findItemById(data.teams, match.visitorTeamId);
            var facility = findItemById(data.facilities, match.facilityId);
            var championship = findItemById(data.championships, match.championshipId);
            if (match.isCC){
                isCC="C";
            }else{
                isCC="";
            }
            if(match.isVotat){
                isvT="";
            }else{
                isvT="N";
            }
            if (match.isSuspes){
                isSus="S";
            }
            else{
                isSus="";
            }
              if (match.isVotatTJ){
                isTJ="";
            }
            else{
                isTJ="N";
            }
             if (match.isObservacions){
                isObs="S";
            }
            else{
                isObs="";
            }
            resultat=match.resultat;
            vm.matches.push({
              town: angular.isDefined(facility) ? facility.town : '-',
              matchDay: match.matchDay,
              localTeam: localTeam,
              visitorTeam: visitorTeam,
              date: moment(match.date).format('L'),
              time: match.time === null ? '--:--' : match.time,
              facility: facility,
              championship: championship,
              isCC:isCC,
              isVotatTecnic:isvT,
              idPartit:match.id,
              resultat:resultat,
              isSuspes:isSus,
              isVotatTJ:isTJ,
              isObservacions:isObs
            });
          });
          vm.maxMatches = data.page.count;
        },
        function (error) {
          var message = angular.isDefined(error.data.message) ? error.data.message : 'TOAST_ERROR';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    $scope.$watch('vm.iniDate', function (newDate) {
      $state.current.data.initDate = newDate;
    });

    $scope.$watch('vm.endDate', function (newDate) {
      $state.current.data.endDate = newDate;
    });

    $scope.$watch('vm.selectedTownHall', function (selectedTownHall) {
      $state.current.data.townHall = selectedTownHall;
    });
 $scope.exportToExcel= ((function() {
          var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
          return function(table, name) {
            table = document.getElementById(table);
            
            var ctx = {worksheet: name || 'Report', table: table.innerHTML};
            window.location.href = uri + base64(format(template, ctx));
          }
        })());
  $scope.sancions=((function(){
        var iniDate1=moment(vm.iniDate).format('YYYY-MM-DD');
        var endDate1= moment(vm.endDate).format('YYYY-MM-DD');
        var url = $state.href("home.sancions",{dataini: iniDate1,datafi:endDate1});
                  window.open(url,'_blank');
  })) ;     


  }
  
  
  
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships
   * @description
   *
   */
  angular
    .module('neo.home.championships', [
      'ui.router',
      'neo.home.championships.newChampionship',
      'neo.home.championships.championship'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.championships')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.championships', {
        url: '/championships',
        templateUrl: 'home/championships/championships.tpl.html',
        controller: 'ChampionshipsCtrl',
        controllerAs: 'vm',
        resolve: {
          championships: ["Championships", function (Championships) {
            return Championships.query().$promise;
          }],
          genders: ["Genders", function (Genders) {
            return Genders.query().$promise;
          }],
          programmes: ["Programmes", function (Programmes) {
            return Programmes.query().$promise;
          }],
          sports: ["Sports", function (Sports) {
            return Sports.query().$promise;
          }],
          categories: ["Categories", function (Categories) {
            return Categories.query().$promise;
          }],
          phases: ["Phases", function (Phases) {
            return Phases.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.championships.controller:ChampionshipsCtrl
   *
   * @description
   *
   */
  ChampionshipsCtrl.$inject = ["$filter", "AclService", "championships", "genders", "sports", "categories", "phases"];
  angular
    .module('neo.home.championships')
    .controller('ChampionshipsCtrl', ChampionshipsCtrl);

  function ChampionshipsCtrl($filter, AclService, championships, genders, sports, categories, phases) {
    var vm = this;
    vm.ctrlName = 'ChampionshipsCtrl';
    vm.can = AclService.can;

    vm.sports = sports;
    vm.categories = categories;
    vm.genders = genders;
    vm.phases = phases;

    var championshipList = buildChampionshipModelList(championships);

    vm.data = {
      cardWidth: 80,
      title: 'CHAMPIONSHIPS.LIST',
      notFoundMessage: 'RESULT_NOT_FOUND',
      headers: [
        {id: 'name', name: 'CHAMPIONSHIPS.NAME', canOrder: true, orderBy: 'nameOrder'},
        {id: 'sport', name: 'SPORT', canOrder: true},
        {id: 'category', name: 'CATEGORY', canOrder: true, orderBy: 'categoryOrder', orderDesc: true},
        {id: 'gender', name: 'GENDER', canOrder: true},
        {id: 'phase', name: 'PHASES.PHASE', canOrder: true, orderBy: 'phaseOrder'},
        {id: 'phaseType', name: 'PHASES.PHASE_TYPE', canOrder: true}
      ],
      state: {
        slink: 'home.championships.championship', params: [
          {key: 'championshipId', value: 'id'}
        ]
      },
      defaultOrderBy: ['phaseOrder', 'sport', 'categoryOrder', 'gender'],
      defaultTypeOrderBy: [true, true, false, true],
      values: championshipList
    };

    function buildChampionshipModelList(championships) {
      var championshipList = [];
      angular.forEach(championships, function (championship) {
        var category = findItemById(vm.categories, championship.categoryId);
        var phase = findItemById(vm.phases, championship.phaseId);
        var championshipModel = {
          id: championship.id,
          name: championship.name,
          nameOrder: $filter('lowercase')(championship.name),
          sport: $filter('translate')('SPORTS.' + findItemById(vm.sports, championship.sportId).name),
          category: $filter('translate')('CATEGORIES.' + category.name),
          categoryOrder: category.startYear,
          gender: $filter('translate')(findItemById(vm.genders, championship.genderId).name),
          phase: phase.name,
          phaseOrder: $filter('lowercase')(championship.phase),
          phaseType: $filter('translate')('PHASES.PHASES_TYPES.' + phase.type)
        };
        championshipList.push(championshipModel);
      });
      return championshipList;
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.cancellations
   * @description
   *
   */
  angular
    .module('neo.home.cancellations', [
      'ui.router',
      'neo.home.cancellations.new',
      'neo.home.cancellations.edit',
      'neo.home.cancellations.canceledMatches'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home.cancellations')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cancellations', {
        url: '/cancellations',
        templateUrl: 'home/cancellations/cancellations.tpl.html',
        controller: 'CancellationsCtrl',
        controllerAs: 'vm',
        resolve: {
          townHalls: ["Ajuntaments", function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name cancellations.controller:CancellationsCtrl
   *
   * @description
   *
   */
    CancellationsCtrl.$inject = ["$q", "$filter", "$state", "Matches", "townHalls"];
  angular
    .module('neo.home.cancellations')
    .controller('CancellationsCtrl', CancellationsCtrl);

    function CancellationsCtrl($q, $filter, $state, Matches, townHalls) {
    var vm = this;
    vm.ctrlName = 'CancellationsCtrl';

      vm.showList = false;
      vm.matches = [];
      vm.today = moment().toDate();
      vm.fifteenDaysAgo = moment(vm.today).subtract(15, 'days').toDate();
      vm.endDate = vm.today;
      vm.initDate = vm.fifteenDaysAgo;
      vm.townhalls = _.cloneDeep(townHalls);
      vm.queryOrder = 'date';
      vm.sort = 'date';

      vm.openMenu = function ($mdMenu, event) {
        $mdMenu.open(event);
      };
      vm.currentPage = 1;

      vm.matchesPerPage = 25;
      vm.paginationLabel = {
        page: $filter('translate')('PAGE'),
        rowsPerPage: '',
        of: $filter('translate')('OF')
      };

      if (vm.townhalls.length === 1) {
        vm.selectedTownHall = vm.townhalls[0];
        applyFilters();
      }

      vm.applyFilters = applyFilters;
      vm.reorder = reorder;
      vm.getNewPage = getNewPage;
      vm.cancelMatch = cancelMatch;

      function cancelMatch(match) {
        $state.go('home.cancellations.new', {matchId: match.id});
      }

      function applyFilters() {
        vm.isFiltered = true;
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
      }

      function reorder(order) {
        vm.sort = order;
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, vm.currentPage, vm.sort);
      }

      function hasValue(field) {
        return !_.isNull(field) && !_.isUndefined(field)
      }

      function canCancel(match) {
        if (!hasValue(match.localTeamId)) return false;
        if (!hasValue(match.visitorTeamId)) return false;
        if (hasValue(match.lastCancellation) && !match.lastCancellation.resolved) return false;
        return moment(vm.fifteenDaysAgo).diff(moment(moment(match.date)), 'days') <= 15;
      }

      function parseMatch(data, match) {
        var facility = findItemById(data.facilities, match.facilityId);
        var localTeam = findItemById(data.teams, match.localTeamId);
        var visitorTeam = findItemById(data.teams, match.visitorTeamId);
        return {
          id: match.id,
          canCancel: canCancel(match),
          localTeam: angular.isDefined(localTeam) ? localTeam : {name: $filter('translate')('CALENDAR.REST')},
          visitorTeam: angular.isDefined(visitorTeam) ? visitorTeam : {name: $filter('translate')('CALENDAR.REST')},
          date: moment(match.date).format('L'),
          time: _.isNull(match.time) ? undefined : match.time,
          facility: angular.isDefined(facility) ? facility : undefined,
          championship: findItemById(data.championships, match.championshipId).name
        };
      }

      function query(townHallId, initDate, endDate, page, sort) {
        var deferredMatches = $q.defer();
        vm.promiseMatches = deferredMatches.promise;
        var parameters = {
          townHall: townHallId,
          initDate: moment(initDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          page: page,
          size: vm.matchesPerPage
        };
        //Optional parameters
        if (angular.isDefined(sort)) {
          parameters.sort = sort;
        }
        Matches.get(parameters, function (data) {
          _.remove(vm.matches);
          angular.forEach(data.matches, function (match) {
            vm.matches.push(parseMatch(data, match));
          });
          if (vm.matches.length !== 0) {
            vm.showList = true;
          }
          vm.maxMatches = data.page.count;
          deferredMatches.resolve();
        }, function () {
          deferredMatches.resolve();
        });
      }

      function getNewPage(page) {
        query(vm.selectedTownHall.id, vm.initDate, vm.endDate, page, vm.sort);
      }

      function findItemById(collection, itemId) {
        return _.find(collection, function (i) {
          return i.id === itemId;
        });
      }
    }
  }()
);

(function () {
  'use strict';

  /* @ngdoc object
   * @name home.ajuntaments
   * @description
   *
   */
  angular
  .module('neo.home.jvp2', [
    'ui.router'
  ]);
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.ajuntaments.controller:AjuntamentsCtrl
   *
   * @description
   *
   */
  Jvp2.$inject = ["AclService", "townHalls", "Ajuntaments", "$http", "EnvironmentConfig", "$state"];
  angular
  .module('neo.home.jvp2')
  .controller('Jvp2', Jvp2);

  function Jvp2(AclService,townHalls, Ajuntaments,$http, EnvironmentConfig,$state) {
  var aj;
   
   $http.get(EnvironmentConfig.API + '/ajuntaments/'+townHalls[0].id).then(function(response) {
            aj= response.data;
         
       
  
 
   
   if (AclService.isAdmin()){
   calculaEnlace(68,'co2');
   }else
   {
          calculaEnlace(62,'2,'+ aj.idTown);
   }
   
      }); 
      function calculaEnlace(action, data){
            
            	var f = new Date();
    		var fecha = moment(f).format('YYYY-MM-DD');
    
		var basepath = 'http://baixesport.europeinyourlife.com/eiyl/?forcemobile=S&action=';

		var param ='data1'; //para la nueva versión el parametro se llama data1

		//alert(fecha);
            	var url=basepath+action+'&'+param+'='+data+'&hash='+md5(data+','+fecha+',neopass2013einsmer');
            
            	window.open(url,'_blank');
          //self.frames['thatframe2'].location.href  =url;
             $state.go('home');
            
            }            
            
        function md5(string) {

   function RotateLeft(lValue, iShiftBits) {
           return (lValue<<iShiftBits) | (lValue>>>(32-iShiftBits));
   }

   function AddUnsigned(lX,lY) {
           var lX4,lY4,lX8,lY8,lResult;
           lX8 = (lX & 0x80000000);
           lY8 = (lY & 0x80000000);
           lX4 = (lX & 0x40000000);
           lY4 = (lY & 0x40000000);
           lResult = (lX & 0x3FFFFFFF)+(lY & 0x3FFFFFFF);
           if (lX4 & lY4) {
                   return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
           }
           if (lX4 | lY4) {
                   if (lResult & 0x40000000) {
                           return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                   } else {
                           return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                   }
           } else {
                   return (lResult ^ lX8 ^ lY8);
           }
   }

   function F(x,y,z) { return (x & y) | ((~x) & z); }
   function G(x,y,z) { return (x & z) | (y & (~z)); }
   function H(x,y,z) { return (x ^ y ^ z); }
   function I(x,y,z) { return (y ^ (x | (~z))); }

   function FF(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function GG(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function HH(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function II(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function ConvertToWordArray(string) {
           var lWordCount;
           var lMessageLength = string.length;
           var lNumberOfWords_temp1=lMessageLength + 8;
           var lNumberOfWords_temp2=(lNumberOfWords_temp1-(lNumberOfWords_temp1 % 64))/64;
           var lNumberOfWords = (lNumberOfWords_temp2+1)*16;
           var lWordArray=Array(lNumberOfWords-1);
           var lBytePosition = 0;
           var lByteCount = 0;
           while ( lByteCount < lMessageLength ) {
                   lWordCount = (lByteCount-(lByteCount % 4))/4;
                   lBytePosition = (lByteCount % 4)*8;
                   lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount)<<lBytePosition));
                   lByteCount++;
           }
           lWordCount = (lByteCount-(lByteCount % 4))/4;
           lBytePosition = (lByteCount % 4)*8;
           lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80<<lBytePosition);
           lWordArray[lNumberOfWords-2] = lMessageLength<<3;
           lWordArray[lNumberOfWords-1] = lMessageLength>>>29;
           return lWordArray;
   };

   function WordToHex(lValue) {
           var WordToHexValue="",WordToHexValue_temp="",lByte,lCount;
           for (lCount = 0;lCount<=3;lCount++) {
                   lByte = (lValue>>>(lCount*8)) & 255;
                   WordToHexValue_temp = "0" + lByte.toString(16);
                   WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length-2,2);
           }
           return WordToHexValue;
   };

   function Utf8Encode(string) {
           string = string.replace(/\r\n/g,"\n");
           var utftext = "";

           for (var n = 0; n < string.length; n++) {

                   var c = string.charCodeAt(n);

                   if (c < 128) {
                           utftext += String.fromCharCode(c);
                   }
                   else if((c > 127) && (c < 2048)) {
                           utftext += String.fromCharCode((c >> 6) | 192);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }
                   else {
                           utftext += String.fromCharCode((c >> 12) | 224);
                           utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }

           }

           return utftext;
   };

   var x=Array();
   var k,AA,BB,CC,DD,a,b,c,d;
   var S11=7, S12=12, S13=17, S14=22;
   var S21=5, S22=9 , S23=14, S24=20;
   var S31=4, S32=11, S33=16, S34=23;
   var S41=6, S42=10, S43=15, S44=21;

   string = Utf8Encode(string);

   x = ConvertToWordArray(string);

   a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;

   for (k=0;k<x.length;k+=16) {
           AA=a; BB=b; CC=c; DD=d;
           a=FF(a,b,c,d,x[k+0], S11,0xD76AA478);
           d=FF(d,a,b,c,x[k+1], S12,0xE8C7B756);
           c=FF(c,d,a,b,x[k+2], S13,0x242070DB);
           b=FF(b,c,d,a,x[k+3], S14,0xC1BDCEEE);
           a=FF(a,b,c,d,x[k+4], S11,0xF57C0FAF);
           d=FF(d,a,b,c,x[k+5], S12,0x4787C62A);
           c=FF(c,d,a,b,x[k+6], S13,0xA8304613);
           b=FF(b,c,d,a,x[k+7], S14,0xFD469501);
           a=FF(a,b,c,d,x[k+8], S11,0x698098D8);
           d=FF(d,a,b,c,x[k+9], S12,0x8B44F7AF);
           c=FF(c,d,a,b,x[k+10],S13,0xFFFF5BB1);
           b=FF(b,c,d,a,x[k+11],S14,0x895CD7BE);
           a=FF(a,b,c,d,x[k+12],S11,0x6B901122);
           d=FF(d,a,b,c,x[k+13],S12,0xFD987193);
           c=FF(c,d,a,b,x[k+14],S13,0xA679438E);
           b=FF(b,c,d,a,x[k+15],S14,0x49B40821);
           a=GG(a,b,c,d,x[k+1], S21,0xF61E2562);
           d=GG(d,a,b,c,x[k+6], S22,0xC040B340);
           c=GG(c,d,a,b,x[k+11],S23,0x265E5A51);
           b=GG(b,c,d,a,x[k+0], S24,0xE9B6C7AA);
           a=GG(a,b,c,d,x[k+5], S21,0xD62F105D);
           d=GG(d,a,b,c,x[k+10],S22,0x2441453);
           c=GG(c,d,a,b,x[k+15],S23,0xD8A1E681);
           b=GG(b,c,d,a,x[k+4], S24,0xE7D3FBC8);
           a=GG(a,b,c,d,x[k+9], S21,0x21E1CDE6);
           d=GG(d,a,b,c,x[k+14],S22,0xC33707D6);
           c=GG(c,d,a,b,x[k+3], S23,0xF4D50D87);
           b=GG(b,c,d,a,x[k+8], S24,0x455A14ED);
           a=GG(a,b,c,d,x[k+13],S21,0xA9E3E905);
           d=GG(d,a,b,c,x[k+2], S22,0xFCEFA3F8);
           c=GG(c,d,a,b,x[k+7], S23,0x676F02D9);
           b=GG(b,c,d,a,x[k+12],S24,0x8D2A4C8A);
           a=HH(a,b,c,d,x[k+5], S31,0xFFFA3942);
           d=HH(d,a,b,c,x[k+8], S32,0x8771F681);
           c=HH(c,d,a,b,x[k+11],S33,0x6D9D6122);
           b=HH(b,c,d,a,x[k+14],S34,0xFDE5380C);
           a=HH(a,b,c,d,x[k+1], S31,0xA4BEEA44);
           d=HH(d,a,b,c,x[k+4], S32,0x4BDECFA9);
           c=HH(c,d,a,b,x[k+7], S33,0xF6BB4B60);
           b=HH(b,c,d,a,x[k+10],S34,0xBEBFBC70);
           a=HH(a,b,c,d,x[k+13],S31,0x289B7EC6);
           d=HH(d,a,b,c,x[k+0], S32,0xEAA127FA);
           c=HH(c,d,a,b,x[k+3], S33,0xD4EF3085);
           b=HH(b,c,d,a,x[k+6], S34,0x4881D05);
           a=HH(a,b,c,d,x[k+9], S31,0xD9D4D039);
           d=HH(d,a,b,c,x[k+12],S32,0xE6DB99E5);
           c=HH(c,d,a,b,x[k+15],S33,0x1FA27CF8);
           b=HH(b,c,d,a,x[k+2], S34,0xC4AC5665);
           a=II(a,b,c,d,x[k+0], S41,0xF4292244);
           d=II(d,a,b,c,x[k+7], S42,0x432AFF97);
           c=II(c,d,a,b,x[k+14],S43,0xAB9423A7);
           b=II(b,c,d,a,x[k+5], S44,0xFC93A039);
           a=II(a,b,c,d,x[k+12],S41,0x655B59C3);
           d=II(d,a,b,c,x[k+3], S42,0x8F0CCC92);
           c=II(c,d,a,b,x[k+10],S43,0xFFEFF47D);
           b=II(b,c,d,a,x[k+1], S44,0x85845DD1);
           a=II(a,b,c,d,x[k+8], S41,0x6FA87E4F);
           d=II(d,a,b,c,x[k+15],S42,0xFE2CE6E0);
           c=II(c,d,a,b,x[k+6], S43,0xA3014314);
           b=II(b,c,d,a,x[k+13],S44,0x4E0811A1);
           a=II(a,b,c,d,x[k+4], S41,0xF7537E82);
           d=II(d,a,b,c,x[k+11],S42,0xBD3AF235);
           c=II(c,d,a,b,x[k+2], S43,0x2AD7D2BB);
           b=II(b,c,d,a,x[k+9], S44,0xEB86D391);
           a=AddUnsigned(a,AA);
           b=AddUnsigned(b,BB);
           c=AddUnsigned(c,CC);
           d=AddUnsigned(d,DD);
   		}

   	var temp = WordToHex(a)+WordToHex(b)+WordToHex(c)+WordToHex(d);

   	return temp.toLowerCase();
}
  }
}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name home.ajuntaments
   * @description
   *
   */
  angular
  .module('neo.home.jvp', [
    'ui.router'
  ]);
}());


(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.ajuntaments.controller:AjuntamentsCtrl
   *
   * @description
   *
   */
  Jvp.$inject = ["AclService", "townHalls", "$http", "EnvironmentConfig", "$state"];
  angular
  .module('neo.home.jvp')
  .controller('Jvp', Jvp);

  function Jvp(AclService,townHalls, $http,EnvironmentConfig, $state) {
   var aj;
   
   $http.get(EnvironmentConfig.API + '/ajuntaments/'+townHalls[0].id).then(function(response) {
            aj= response.data;
         
   
   
   if (AclService.isAdmin()){
   calculaEnlace(70,'co2');
   }else
   {
          calculaEnlace(70,'2,'+aj.idTown);
   }
   
     });   
      function calculaEnlace(action, data){
            
            	var f = new Date();
    		var fecha = moment(f).format('YYYY-MM-DD');
    
		var basepath = 'http://baixesport.europeinyourlife.com/eiyl/?forcemobile=S&action=';

		var param ='data1'; //para la nueva versión el parametro se llama data1

		//alert(fecha);
            	var url=basepath+action+'&'+param+'='+data+'&hash='+md5(data+','+fecha+',neopass2013einsmer');
            
          	window.open(url,'_blank');
         // self.frames['thatframe'].location.href  =url;
             $state.go('home');
            
            }            
            
        function md5(string) {

   function RotateLeft(lValue, iShiftBits) {
           return (lValue<<iShiftBits) | (lValue>>>(32-iShiftBits));
   }

   function AddUnsigned(lX,lY) {
           var lX4,lY4,lX8,lY8,lResult;
           lX8 = (lX & 0x80000000);
           lY8 = (lY & 0x80000000);
           lX4 = (lX & 0x40000000);
           lY4 = (lY & 0x40000000);
           lResult = (lX & 0x3FFFFFFF)+(lY & 0x3FFFFFFF);
           if (lX4 & lY4) {
                   return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
           }
           if (lX4 | lY4) {
                   if (lResult & 0x40000000) {
                           return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                   } else {
                           return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                   }
           } else {
                   return (lResult ^ lX8 ^ lY8);
           }
   }

   function F(x,y,z) { return (x & y) | ((~x) & z); }
   function G(x,y,z) { return (x & z) | (y & (~z)); }
   function H(x,y,z) { return (x ^ y ^ z); }
   function I(x,y,z) { return (y ^ (x | (~z))); }

   function FF(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function GG(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function HH(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function II(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function ConvertToWordArray(string) {
           var lWordCount;
           var lMessageLength = string.length;
           var lNumberOfWords_temp1=lMessageLength + 8;
           var lNumberOfWords_temp2=(lNumberOfWords_temp1-(lNumberOfWords_temp1 % 64))/64;
           var lNumberOfWords = (lNumberOfWords_temp2+1)*16;
           var lWordArray=Array(lNumberOfWords-1);
           var lBytePosition = 0;
           var lByteCount = 0;
           while ( lByteCount < lMessageLength ) {
                   lWordCount = (lByteCount-(lByteCount % 4))/4;
                   lBytePosition = (lByteCount % 4)*8;
                   lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount)<<lBytePosition));
                   lByteCount++;
           }
           lWordCount = (lByteCount-(lByteCount % 4))/4;
           lBytePosition = (lByteCount % 4)*8;
           lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80<<lBytePosition);
           lWordArray[lNumberOfWords-2] = lMessageLength<<3;
           lWordArray[lNumberOfWords-1] = lMessageLength>>>29;
           return lWordArray;
   };

   function WordToHex(lValue) {
           var WordToHexValue="",WordToHexValue_temp="",lByte,lCount;
           for (lCount = 0;lCount<=3;lCount++) {
                   lByte = (lValue>>>(lCount*8)) & 255;
                   WordToHexValue_temp = "0" + lByte.toString(16);
                   WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length-2,2);
           }
           return WordToHexValue;
   };

   function Utf8Encode(string) {
           string = string.replace(/\r\n/g,"\n");
           var utftext = "";

           for (var n = 0; n < string.length; n++) {

                   var c = string.charCodeAt(n);

                   if (c < 128) {
                           utftext += String.fromCharCode(c);
                   }
                   else if((c > 127) && (c < 2048)) {
                           utftext += String.fromCharCode((c >> 6) | 192);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }
                   else {
                           utftext += String.fromCharCode((c >> 12) | 224);
                           utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }

           }

           return utftext;
   };

   var x=Array();
   var k,AA,BB,CC,DD,a,b,c,d;
   var S11=7, S12=12, S13=17, S14=22;
   var S21=5, S22=9 , S23=14, S24=20;
   var S31=4, S32=11, S33=16, S34=23;
   var S41=6, S42=10, S43=15, S44=21;

   string = Utf8Encode(string);

   x = ConvertToWordArray(string);

   a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;

   for (k=0;k<x.length;k+=16) {
           AA=a; BB=b; CC=c; DD=d;
           a=FF(a,b,c,d,x[k+0], S11,0xD76AA478);
           d=FF(d,a,b,c,x[k+1], S12,0xE8C7B756);
           c=FF(c,d,a,b,x[k+2], S13,0x242070DB);
           b=FF(b,c,d,a,x[k+3], S14,0xC1BDCEEE);
           a=FF(a,b,c,d,x[k+4], S11,0xF57C0FAF);
           d=FF(d,a,b,c,x[k+5], S12,0x4787C62A);
           c=FF(c,d,a,b,x[k+6], S13,0xA8304613);
           b=FF(b,c,d,a,x[k+7], S14,0xFD469501);
           a=FF(a,b,c,d,x[k+8], S11,0x698098D8);
           d=FF(d,a,b,c,x[k+9], S12,0x8B44F7AF);
           c=FF(c,d,a,b,x[k+10],S13,0xFFFF5BB1);
           b=FF(b,c,d,a,x[k+11],S14,0x895CD7BE);
           a=FF(a,b,c,d,x[k+12],S11,0x6B901122);
           d=FF(d,a,b,c,x[k+13],S12,0xFD987193);
           c=FF(c,d,a,b,x[k+14],S13,0xA679438E);
           b=FF(b,c,d,a,x[k+15],S14,0x49B40821);
           a=GG(a,b,c,d,x[k+1], S21,0xF61E2562);
           d=GG(d,a,b,c,x[k+6], S22,0xC040B340);
           c=GG(c,d,a,b,x[k+11],S23,0x265E5A51);
           b=GG(b,c,d,a,x[k+0], S24,0xE9B6C7AA);
           a=GG(a,b,c,d,x[k+5], S21,0xD62F105D);
           d=GG(d,a,b,c,x[k+10],S22,0x2441453);
           c=GG(c,d,a,b,x[k+15],S23,0xD8A1E681);
           b=GG(b,c,d,a,x[k+4], S24,0xE7D3FBC8);
           a=GG(a,b,c,d,x[k+9], S21,0x21E1CDE6);
           d=GG(d,a,b,c,x[k+14],S22,0xC33707D6);
           c=GG(c,d,a,b,x[k+3], S23,0xF4D50D87);
           b=GG(b,c,d,a,x[k+8], S24,0x455A14ED);
           a=GG(a,b,c,d,x[k+13],S21,0xA9E3E905);
           d=GG(d,a,b,c,x[k+2], S22,0xFCEFA3F8);
           c=GG(c,d,a,b,x[k+7], S23,0x676F02D9);
           b=GG(b,c,d,a,x[k+12],S24,0x8D2A4C8A);
           a=HH(a,b,c,d,x[k+5], S31,0xFFFA3942);
           d=HH(d,a,b,c,x[k+8], S32,0x8771F681);
           c=HH(c,d,a,b,x[k+11],S33,0x6D9D6122);
           b=HH(b,c,d,a,x[k+14],S34,0xFDE5380C);
           a=HH(a,b,c,d,x[k+1], S31,0xA4BEEA44);
           d=HH(d,a,b,c,x[k+4], S32,0x4BDECFA9);
           c=HH(c,d,a,b,x[k+7], S33,0xF6BB4B60);
           b=HH(b,c,d,a,x[k+10],S34,0xBEBFBC70);
           a=HH(a,b,c,d,x[k+13],S31,0x289B7EC6);
           d=HH(d,a,b,c,x[k+0], S32,0xEAA127FA);
           c=HH(c,d,a,b,x[k+3], S33,0xD4EF3085);
           b=HH(b,c,d,a,x[k+6], S34,0x4881D05);
           a=HH(a,b,c,d,x[k+9], S31,0xD9D4D039);
           d=HH(d,a,b,c,x[k+12],S32,0xE6DB99E5);
           c=HH(c,d,a,b,x[k+15],S33,0x1FA27CF8);
           b=HH(b,c,d,a,x[k+2], S34,0xC4AC5665);
           a=II(a,b,c,d,x[k+0], S41,0xF4292244);
           d=II(d,a,b,c,x[k+7], S42,0x432AFF97);
           c=II(c,d,a,b,x[k+14],S43,0xAB9423A7);
           b=II(b,c,d,a,x[k+5], S44,0xFC93A039);
           a=II(a,b,c,d,x[k+12],S41,0x655B59C3);
           d=II(d,a,b,c,x[k+3], S42,0x8F0CCC92);
           c=II(c,d,a,b,x[k+10],S43,0xFFEFF47D);
           b=II(b,c,d,a,x[k+1], S44,0x85845DD1);
           a=II(a,b,c,d,x[k+8], S41,0x6FA87E4F);
           d=II(d,a,b,c,x[k+15],S42,0xFE2CE6E0);
           c=II(c,d,a,b,x[k+6], S43,0xA3014314);
           b=II(b,c,d,a,x[k+13],S44,0x4E0811A1);
           a=II(a,b,c,d,x[k+4], S41,0xF7537E82);
           d=II(d,a,b,c,x[k+11],S42,0xBD3AF235);
           c=II(c,d,a,b,x[k+2], S43,0x2AD7D2BB);
           b=II(b,c,d,a,x[k+9], S44,0xEB86D391);
           a=AddUnsigned(a,AA);
           b=AddUnsigned(b,BB);
           c=AddUnsigned(c,CC);
           d=AddUnsigned(d,DD);
   		}

   	var temp = WordToHex(a)+WordToHex(b)+WordToHex(c)+WordToHex(d);

   	return temp.toLowerCase();
}
  }
}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name home.ajuntaments
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments', [
    'ui.router',
    'neo.home.ajuntaments.ajuntament',
    'neo.home.ajuntaments.newAjuntament'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.home.ajuntaments')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments', {
      url: '/ajuntaments',
      templateUrl: 'home/ajuntaments/ajuntaments.tpl.html',
      controller: 'AjuntamentsCtrl',
      controllerAs: 'vm',
      resolve: {
        ajuntaments: ["Ajuntaments", "$q", function (Ajuntaments, $q) {
          var deferred = $q.defer();

          Ajuntaments.query(
            function (data) {
              deferred.resolve(data);
            },
            function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        }],
         ajuntamentsread: ["Ajuntamentsread", "$q", function (Ajuntamentsread, $q) {
          var deferred = $q.defer();

          Ajuntamentsread.query(
            function (data) {
              deferred.resolve(data);
            },
            function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        }]
      }
    })
            .state('home.jvp',{
                url:'/jvp',
                templateUrl: 'home/ajuntaments/jvp.tpl.html',
                controller: 'Jvp',
                controllerAs: 'vm',
                resolve:{
                 townHalls: ["Ajuntaments", function (Ajuntaments) {
                    return Ajuntaments.query().$promise;
          }]}
    }).state('home.jvp2',{
                url:'/jvp2',
                templateUrl: 'home/ajuntaments/jvp2.tpl.html',
                controller: 'Jvp2',
                controllerAs: 'vm',
                resolve:{  
             
                 townHalls: ["Ajuntaments", function (Ajuntaments) {
                    return Ajuntaments.query().$promise;
          }]}
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.ajuntaments.controller:AjuntamentsCtrl
   *
   * @description
   *
   */
  AjuntamentsCtrl.$inject = ["AclService", "ajuntaments", "ajuntamentsread"];
  angular
  .module('neo.home.ajuntaments')
  .controller('AjuntamentsCtrl', AjuntamentsCtrl);

  function AjuntamentsCtrl(AclService, ajuntaments,ajuntamentsread) {
    var vm = this;
    vm.isAdmin = AclService.isAdmin();
    
    vm.visibletab=vm.isAdmin;
    vm.ctrlName = 'AjuntamentsCtrl';
    vm.llistaAjuntaments = ajuntaments;
    vm.llistaAjuntamentsread = ajuntamentsread;
    vm.query = {
      order: 'name'
    };
    vm.selected = [];
    vm.select = undefined;

    vm.can = AclService.can;
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name neo.directive:toolbar
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="neo">
   <neo-toolbar></neo-toolbar>
   </example>
   *
   */
  angular
  .module('neo')
  .directive('neoToolbar', neoToolbar);

  function neoToolbar() {
    return {
      restrict: 'E',
      scope: {
        logout: "&",
        userName: "="
      },
      templateUrl: 'directives/toolbar/toolbar-directive.tpl.html',
      replace: false,
      controller: 'ToolbarCtrl',
      controllerAs: 'vm'
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name components.controller:ToolbarCtrl
   *
   * @description
   *
   */
  ToolbarCtrl.$inject = ["authManager", "$state"];
  angular
  .module('neo')
  .controller('ToolbarCtrl', ToolbarCtrl);

  function ToolbarCtrl(authManager, $state) {
    var vm = this;
    vm.ctrlName = 'ToolbarCtrl';
    vm.authManager = authManager;
    vm.$state = $state;

    vm.openMenu = function ($mdMenu, ev) {
      $mdMenu.open(ev);
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:neoPrintCardTemplate
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-print-team-template></neo-print-team-template>
   </file>
   </example>
   *
   */
  angular
      .module('neo')
      .directive('neoPrintTeamTemplate', neoPrintTeamTemplate);

  function neoPrintTeamTemplate() {
    return {
      restrict: 'E',
      scope: {
        team: '='
      },
      templateUrl: 'directives/neo-print-team-template/neo-print-team-template-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", function ($scope) {
        var vm = this;

        vm.headers = ['LICENSE_CODE', 'NAME', 'SURNAMES', 'NIF/NIE', 'LICENSE_TYPE', 'CATEGORY', 'BIRTH_DATE'];
        vm.team = $scope.team;
        vm.currentDate = moment(new Date()).format('L')
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:neoPrintCardTemplate
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-print-card-template></neo-print-card-template>
   </file>
   </example>
   *
   */
  angular
      .module('neo')
      .directive('neoPrintInvoiceTemplate', neoPrintInvoiceTemplate);

  function neoPrintInvoiceTemplate() {
    return {
      restrict: 'E',
      scope: {
        persona2: '='
      },
      templateUrl: 'directives/neo-print-invoice-template/neo-print-invoice-template-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", "scope", function ($scope,scope) {
        var vm = this;
        vm.name = 'neoPrintInvoiceTemplate';
    // $scope.persona2=scope.persona2;
      
      }],
      link: function (scope, element, attrs) {
           
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:neoPrintCardTemplate
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-print-card-template></neo-print-card-template>
   </file>
   </example>
   *
   */
  angular
      .module('neo')
      .directive('neoPrintCardTemplate', neoPrintCardTemplate);

  function neoPrintCardTemplate() {
    return {
      restrict: 'E',
      scope: {
        cards: '='
      },
      templateUrl: 'directives/neo-print-card-template/neo-print-card-template-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", function ($scope) {
        var vm = this;
        vm.name = 'neoPrintCardTemplate';
        vm.cards = $scope.cards;
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name components.constant:navigationBar
   *
   * @description
   *
   */
  angular
    .module('neo')
    .value('neoNavigationBarItems', [
     {
      text: 'NAV_TOWN_HALL',
      slink: 'home.ajuntaments',
       selected: false,
      permission: {
         name: 'TOWN_HALL',
         acl: 'R'
       }
     },
     {
       text: 'NAV_ENTITIES',
       selected: false,
       slink: 'home.entitats',
       permission: {
         name: 'ENTITY',
         acl: 'R'
       }
     },
      {
        text: 'NAV_COMPETITION',
        selected: false,
        children: [
         {
           text: 'NAV_SEASONS',
           slink: 'home.seasons',
           permission: {
             name: 'SEASON',
            acl: 'R'
           }
        },
        {
            text: 'PHASES.NAV_PHASES',
           slink: 'home.phases',
           permission: {
            name: 'LOCAL_PHASE',
            acl: 'R'
          }
        },
        {
          text: 'PHASES.INSCRIPTION',
           slink: 'home.phases.inscription',
           permission: {
             name: 'LOCAL_PHASE',
             acl: 'R'
           }
          },
          {
            text: 'CHAMPIONSHIPS.NAV',
            slink: 'home.championships',
            permission: {
              name: 'LOCAL_PHASE',
              acl: 'R'
            }
          },
          {
            text: 'FACILITIES.NAV',
            slink: 'home.facilities',
            permission: {
              name: 'FACILITY',
              acl: 'R'
            }
          },
         
                 {
                         text: 'Control de votacions per tècnics',
                         slink: 'home.jvp',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                     },
                     {text: 'Introduïr resultats JVP',
                         slink: 'home.jvp2',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                         },
                     {text: 'Introduïr resultats JVP V2',
                         slink: 'home.comite',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                         }
                        
         ]},
      {
        text: 'NAV_TEAMS',
        selected: false,
        children: [
          {
            text: 'NAV_TEAMS_LIST',
            slink: 'home.teams',
            permission: {
              name: 'TEAM',
              acl: 'R'
            }
          },
          {
            text: 'PEOPLE.LIST',
            slink: 'home.persons'
          }
        ]
      },
      {
        text: 'MATCHES.NAV',
        selected: false,
        children: [
          {
            text: 'MATCHES.NAV',
            slink: 'home.matches'
          },
          {
            text: 'POSTPONEMENTS.NAV',
            slink: 'home.postponements',
            permission: {
              name: 'POSTPONEMENT',
              acl: 'C'
            }
          },
          {
            text: 'POSTPONEMENTS.POSTPONED_NAV',
            slink: 'home.postponements.postponedMatches',
            permission: {
              name: 'POSTPONEMENT',
              acl: 'R'
            }
          },
          {
            text: 'CANCELLATIONS.NAV',
            slink: 'home.cancellations',
            permission: {
              name: 'CANCELLATION',
              acl: 'R'
            }
          },
          {
            text: 'CANCELLATIONS.CANCELLED_NAV',
            slink: 'home.cancellations.canceledMatches',
            permission: {
              name: 'CANCELLATION',
              acl: 'R'
            }
          }
        ]
      },
      {
        text: 'REFEREES.NAV_REFEREES',
        slink: 'home.referees',
        selected: false,
        permission: {
          name: 'REFEREES',
          acl: 'R'
        }
      },
      {
        text: 'SEARCH',
        selected: false,
        children: [
          {
            text: 'LICENSES.SEARCH',
            slink: 'home.licenseSearch',
            permission: {
              name: 'SEARCH_PEOPLE',
              acl: 'R'
            }
          },
          {
            text: 'STATISTICS.LICENSES',
            slink: 'home.statistics.licenses',
            permission: {
              name: 'STATISTICS',
              acl: 'R'
            }
          },
          {
            text: 'STATISTICS.TEAMS',
            slink: 'home.statistics.teams',
            permission: {
              name: 'STATISTICS',
              acl: 'R'
            }
          },
          {
            text: 'STATISTICS.ENTITIES',
            slink: 'home.statistics.entities',
            permission: {
              name: 'STATISTICS',
              acl: 'R'
            }
          }
        ]
      },
      {
        text: 'DOCUMENTATION.NAV',
        selected: false,
        children: [
          {
            text: 'DOCUMENTATION.COUNCIL',
            url: 'http://cebllob.org/documents/consell'
          },
          {
            text: 'DOCUMENTATION.TOWN_HALLS',
            url: 'http://cebllob.org/documents/ajuntaments'
          },
          {
            text: 'DOCUMENTATION.ENTITIES',
            url: 'http://cebllob.org/documents/entitats'
          }
        ]
      },{
            text: 'NEO INDI',
            url: 'http://neoprograma.cebllob.com/neoindi',
        permission: {
          name: 'ENTITY',
          acl: 'R'
        }
          }
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name components.constant:navigationBar
   *
   * @description
   *
   */
  angular
    .module('neo')
    .value('neoNavigationBarItems', [
    // {
    //  text: 'NAV_TOWN_HALL',
    //  slink: 'home.ajuntaments',
   //    selected: false,
   //   permission: {
     //    name: 'TOWN_HALL',
      //   acl: 'R'
   //    }
   //  },
     //{
    //   text: 'NAV_ENTITIES',
     //  selected: false,
     //  slink: 'home.entitats',
     //  permission: {
      //   name: 'ENTITY',
      //   acl: 'R'
     //  }
    // },
      {
        text: 'NAV_COMPETITION',
        selected: false,
        children: [
       //  {
      //     text: 'NAV_SEASONS',
       //    slink: 'home.seasons',
       //    permission: {
       //      name: 'SEASON',
       //     acl: 'R'
       //    }
       // },
       // {
       //     text: 'PHASES.NAV_PHASES',
       //    slink: 'home.phases',
       //    permission: {
       //     name: 'LOCAL_PHASE',
         //   acl: 'R'
        //  }
      //  },
       // {
        //  text: 'PHASES.INSCRIPTION',
          // slink: 'home.phases.inscription',
       //    permission: {
       //      name: 'LOCAL_PHASE',
       //      acl: 'R'
        //   }
        //  },
        //  {
        //    text: 'CHAMPIONSHIPS.NAV',
        //    slink: 'home.championships',
        //    permission: {
        //      name: 'LOCAL_PHASE',
         //     acl: 'R'
         //   }
       //   },
        //  {
         //   text: 'FACILITIES.NAV',
        //    slink: 'home.facilities',
        //    permission: {
        //      name: 'FACILITY',
        //      acl: 'R'
        //    }
       //   },
         
                 {
                         text: 'Control de votacions per tècnics',
                         slink: 'home.jvp',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                     },
             //        {text: 'Introduïr resultats JVP',
               //          slink: 'home.jvp2',
              //           permission: {
                //          name: 'FACILITY',
                //              acl: 'R'
                  //           }
                 //        },
                     {text: 'Introduïr resultats JVP',
                         slink: 'home.comite',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                         }
                        
         ]},
   //   {
     //   text: 'NAV_TEAMS',
       // selected: false,
    //    children: [
      //    {
       //     text: 'NAV_TEAMS_LIST',
         //   slink: 'home.teams',
      //      permission: {
       //       name: 'TEAM',
     //         acl: 'R'
       //     }
     //     },
       //   {
     //       text: 'PEOPLE.LIST',
       ///     slink: 'home.persons'
       //   }
     //   ]
    //  },
     // {
    //    text: 'MATCHES.NAV',
    //    selected: false,
    //    children: [
      //    {
        //    text: 'MATCHES.NAV',
     //       slink: 'home.matches'
       //   },
      //    {
        //    text: 'POSTPONEMENTS.NAV',
      //      slink: 'home.postponements',
        //    permission: {
      //        name: 'POSTPONEMENT',
        //      acl: 'C'
        //    }
      //    },
     //     {
     //       text: 'POSTPONEMENTS.POSTPONED_NAV',
    //        slink: 'home.postponements.postponedMatches',
      //      permission: {
    //          name: 'POSTPONEMENT',
      //        acl: 'R'
     //       }
       //   },
      //    {
        ///    text: 'CANCELLATIONS.NAV',
       ///     slink: 'home.cancellations',
  //          permission: {
    //          name: 'CANCELLATION',
      //        acl: 'R'
 //           }
   //       },
     //     {
       //     text: 'CANCELLATIONS.CANCELLED_NAV',
         //   slink: 'home.cancellations.canceledMatches',
           // permission: {
 //             name: 'CANCELLATION',
   //           acl: 'R'
     //       }
       //   }
   //     ]
  //    },
      {
        text: 'REFEREES.NAV_REFEREES',
        slink: 'home.referees',
        selected: false,
        permission: {
          name: 'REFEREES',
          acl: 'R'
        }
      }//,
    //  {
    //    text: 'SEARCH',
    //    selected: false,
    //    children: [
    //      {
    //        text: 'LICENSES.SEARCH',
     //       slink: 'home.licenseSearch',
    //        permission: {
    //          name: 'SEARCH_PEOPLE',
  //            acl: 'R'
    //        }
   //       },
    //      {
    //        text: 'STATISTICS.LICENSES',
       //     slink: 'home.statistics.licenses',
       //     permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
    //        }
  //        },
    //      {
    //        text: 'STATISTICS.TEAMS',
   //         slink: 'home.statistics.teams',
    //        permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
   //         }
   //       },
    //      {
    //        text: 'STATISTICS.ENTITIES',
   //         slink: 'home.statistics.entities',
   //         permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
       //     }
     //     }
  //      ]
    //  },
    //  {
    //    text: 'DOCUMENTATION.NAV',
    ///    selected: false,
    //    children: [
   //       {
   //         text: 'DOCUMENTATION.COUNCIL',
    //        url: 'http://cebllob.org/documents/consell'
   //       },
   //       {
   //         text: 'DOCUMENTATION.TOWN_HALLS',
  //          url: 'http://cebllob.org/documents/ajuntaments'
   //       },
    //      {
    //        text: 'DOCUMENTATION.ENTITIES',
    //        url: 'http://cebllob.org/documents/entitats'
    //      }
   //     ]
  //    },{
  //          text: 'NEO INDI',
   //         url: 'http://neoprograma.cebllob.com/neoindi',
    //    permission: {
    //      name: 'ENTITY',
   //       acl: 'R'
  //      }
   //       }
    ]);
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name components.constant:navigationBar
   *
   * @description
   *
   */
  angular
    .module('neo')
    .value('neoNavigationBarItems', [
    // {
    //  text: 'NAV_TOWN_HALL',
    //  slink: 'home.ajuntaments',
   //    selected: false,
   //   permission: {
     //    name: 'TOWN_HALL',
      //   acl: 'R'
   //    }
   //  },
     //{
    //   text: 'NAV_ENTITIES',
     //  selected: false,
     //  slink: 'home.entitats',
     //  permission: {
      //   name: 'ENTITY',
      //   acl: 'R'
     //  }
    // },
      {
        text: 'NAV_COMPETITION',
        selected: false,
        children: [
       //  {
      //     text: 'NAV_SEASONS',
       //    slink: 'home.seasons',
       //    permission: {
       //      name: 'SEASON',
       //     acl: 'R'
       //    }
       // },
       // {
       //     text: 'PHASES.NAV_PHASES',
       //    slink: 'home.phases',
       //    permission: {
       //     name: 'LOCAL_PHASE',
         //   acl: 'R'
        //  }
      //  },
       // {
        //  text: 'PHASES.INSCRIPTION',
          // slink: 'home.phases.inscription',
       //    permission: {
       //      name: 'LOCAL_PHASE',
       //      acl: 'R'
        //   }
        //  },
        //  {
        //    text: 'CHAMPIONSHIPS.NAV',
        //    slink: 'home.championships',
        //    permission: {
        //      name: 'LOCAL_PHASE',
         //     acl: 'R'
         //   }
       //   },
        //  {
         //   text: 'FACILITIES.NAV',
        //    slink: 'home.facilities',
        //    permission: {
        //      name: 'FACILITY',
        //      acl: 'R'
        //    }
       //   },
         
                 {
                         text: 'Control de votacions per tècnics',
                         slink: 'home.jvp',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                     },
             //        {text: 'Introduïr resultats JVP',
               //          slink: 'home.jvp2',
              //           permission: {
                //          name: 'FACILITY',
                //              acl: 'R'
                  //           }
                 //        },
                     {text: 'Introduïr resultats JVP',
                         slink: 'home.comite',
                         permission: {
                          name: 'FACILITY',
                              acl: 'R'
                             }
                         }
                        
         ]},
   //   {
     //   text: 'NAV_TEAMS',
       // selected: false,
    //    children: [
      //    {
       //     text: 'NAV_TEAMS_LIST',
         //   slink: 'home.teams',
      //      permission: {
       //       name: 'TEAM',
     //         acl: 'R'
       //     }
     //     },
       //   {
     //       text: 'PEOPLE.LIST',
       ///     slink: 'home.persons'
       //   }
     //   ]
    //  },
     // {
    //    text: 'MATCHES.NAV',
    //    selected: false,
    //    children: [
      //    {
        //    text: 'MATCHES.NAV',
     //       slink: 'home.matches'
       //   },
      //    {
        //    text: 'POSTPONEMENTS.NAV',
      //      slink: 'home.postponements',
        //    permission: {
      //        name: 'POSTPONEMENT',
        //      acl: 'C'
        //    }
      //    },
     //     {
     //       text: 'POSTPONEMENTS.POSTPONED_NAV',
    //        slink: 'home.postponements.postponedMatches',
      //      permission: {
    //          name: 'POSTPONEMENT',
      //        acl: 'R'
     //       }
       //   },
      //    {
        ///    text: 'CANCELLATIONS.NAV',
       ///     slink: 'home.cancellations',
  //          permission: {
    //          name: 'CANCELLATION',
      //        acl: 'R'
 //           }
   //       },
     //     {
       //     text: 'CANCELLATIONS.CANCELLED_NAV',
         //   slink: 'home.cancellations.canceledMatches',
           // permission: {
 //             name: 'CANCELLATION',
   //           acl: 'R'
     //       }
       //   }
   //     ]
  //    },
      {
        text: 'REFEREES.NAV_REFEREES',
        slink: 'home.referees',
        selected: false,
        permission: {
          name: 'REFEREES',
          acl: 'R'
        }
      }//,
    //  {
    //    text: 'SEARCH',
    //    selected: false,
    //    children: [
    //      {
    //        text: 'LICENSES.SEARCH',
     //       slink: 'home.licenseSearch',
    //        permission: {
    //          name: 'SEARCH_PEOPLE',
  //            acl: 'R'
    //        }
   //       },
    //      {
    //        text: 'STATISTICS.LICENSES',
       //     slink: 'home.statistics.licenses',
       //     permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
    //        }
  //        },
    //      {
    //        text: 'STATISTICS.TEAMS',
   //         slink: 'home.statistics.teams',
    //        permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
   //         }
   //       },
    //      {
    //        text: 'STATISTICS.ENTITIES',
   //         slink: 'home.statistics.entities',
   //         permission: {
   //           name: 'STATISTICS',
   //           acl: 'R'
       //     }
     //     }
  //      ]
    //  },
    //  {
    //    text: 'DOCUMENTATION.NAV',
    ///    selected: false,
    //    children: [
   //       {
   //         text: 'DOCUMENTATION.COUNCIL',
    //        url: 'http://cebllob.org/documents/consell'
   //       },
   //       {
   //         text: 'DOCUMENTATION.TOWN_HALLS',
  //          url: 'http://cebllob.org/documents/ajuntaments'
   //       },
    //      {
    //        text: 'DOCUMENTATION.ENTITIES',
    //        url: 'http://cebllob.org/documents/entitats'
    //      }
   //     ]
  //    },{
  //          text: 'NEO INDI',
   //         url: 'http://neoprograma.cebllob.com/neoindi',
    //    permission: {
    //      name: 'ENTITY',
   //       acl: 'R'
  //      }
   //       }
    ]);
}());
(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:navigationBar
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-navigation-bar></neo-navigation-bar>
   </file>
   </example>
   *
   */
  angular
  .module('neo')
  .directive('neoNavigationBar', neoNavigationBar);

  function neoNavigationBar() {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'directives/neo-navigation-bar/neo-navigation-bar-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$window", "$state", "neoNavigationBarItems", "AclService", function ($window, $state, neoNavigationBarItems, AclService) {
        var vm = this;
        vm.name = 'navigationBar';
        vm.items = neoNavigationBarItems;

        vm.performAction = function (item, menuEvent) {
          if (angular.isDefined(item.children)) {
            menuEvent.open();
          } else {
            vm.markAsSelected(item);
            if (!_.isUndefined(item.slink)) $state.go(item.slink);
            else if (!_.isUndefined(item.url)) $window.open(item.url);
          }
        };

        vm.markAsSelected = function (itemSelected) {
          angular.forEach(vm.items, function (item) {
            item.selected = false;
          });
          itemSelected.selected = true;
        };

        vm.hasPermissionMenu = function (item) {
          if (angular.isUndefined(item.permission)) {
            return _.some(item.children, vm.hasPermission);
          } else return vm.hasPermission(item);
        };

        vm.hasPermission = function (item) {
          if (angular.isUndefined(item.permission)) {
            return true;
          }
          return AclService.can(item.permission.name, item.permission.acl);
        };
      }],

      link: function (scope, element, attrs) {

      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name neo.directive:neoMatch
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="neo">
       <file name="index.html">
        <neo-match></neo-match>
       </file>
     </example>
   *
   */
  neoMatch.$inject = ["$parse"];
  angular
    .module('neo')
    .directive('neoMatch', neoMatch);

  function neoMatch($parse) {
    return {
      restrict: 'A',
      require: '^ngModel',
      link: function (scope, element, attrs, ngModel) {
        var firstWordGetter = $parse(attrs.neoMatch);

        function getFirstWord() {
          return firstWordGetter(scope);
        }

        scope.$watch(getFirstWord, function(){
          ngModel.$$parseAndValidate();
        });

        ngModel.$validators.neoMatch = function(modelValue) {
          var firstWord = getFirstWord();
          return (!modelValue && !firstWord) || (modelValue === firstWord);
        };

      }
    };
  }
}());


(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name components.directive:neoInput
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="components">
   <file name="index.html">
   <neo-input></neo-input>
   </file>
   </example>
   *
   */
  angular
    .module('neo')
    .directive('neoInput', neoInput);

  function neoInput() {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        icon: '@',
        neoIcon: '@',
        error: '@',
        pattern: '@',
        noMargin: '=',
        isRequired: '=',
        isDisabled: '=',
        isReadonly: '=',
        ngModel: '='
      },
      require: '?^form',
      templateUrl: 'directives/neo-input/neo-input-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", function ($scope) {
        var vm = this;
        vm.name = 'neoInput';
        vm.pattern = new RegExp($scope.pattern);
      }],
      link: function (scope, element, attrs, formCtrl) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
        scope.name = attrs.name;
        scope.form = formCtrl;
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name neo.directive:neoList
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="neo">
   <file name="index.html">
   <neo-list></neo-list>
   </file>
   </example>
   *
   */
  angular
  .module('neo')
  .directive('neoList', neoList);

  function neoList() {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      templateUrl: 'directives/neo-list/neo-list-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", function ($scope) {
        var vm = this;
        vm.name = 'neoList';

        $scope.data = $scope.data || {};

        vm.title = $scope.data.title;
        vm.cardWidth = $scope.data.cardWidth || 70;
        vm.notFoundMessage = $scope.data.notFoundMessage;
        vm.headers = $scope.data.headers;
        vm.values = sortValues($scope.data.values, $scope.data.defaultOrderBy, $scope.data.defaultTypeOrderBy);
        vm.state = $scope.data.state;
        vm.defaultOrderBy = undefined;
        vm.filters = $scope.data.filters;

        angular.forEach(vm.filters, function (filter) {
          if (!angular.isUndefined(filter.options)) {
            filter.options.sort(function (a, b) {
              return a[filter.showField].toLowerCase().localeCompare(b[filter.showField].toLowerCase());
            });
          }
        });

        vm.filterPromise = $scope.data.filterPromise;
        vm.filterFunction = $scope.data.filterFunction;
        vm.filterValues = $scope.data.filterValues;
        if (angular.isUndefined($scope.data.areRowsClickable) || $scope.data.areRowsClickable === null || $scope.data.areRowsClickable === true) {
          vm.cursor = "pointer"
        } else {
          vm.cursor = "default"
        }

        vm.showList = true;
        vm.selected = [];

        vm.select = undefined;
        vm.getStateLink = getStateLink;

        vm.applyFilters = applyFilters;
        vm.filteredListHasSomeItem = filteredListHasSomeItem;
        vm.isDisabledFilter = isDisabledFilter;
        vm.isDisabledFilterButton = false;


        if (angular.isDefined(vm.filterValues)) {
          var instantSearch = true;
          vm.showList = false;
          angular.forEach(vm.filters, function (filter) {
            filter.selectedItem = vm.filterValues[filter.label];
            if (angular.isUndefined(vm.filterValues[filter.label])) {

              instantSearch = false;
            }
          });
          if (instantSearch) {
            applyFilters();
          }
        }
        angular.forEach(vm.filters, function (filter) {
          if (angular.isDefined(filter.eventTrigger)) {
            $scope.$watch(
              function () {
                return filter.selectedItem;
              },
              function () {
                if (existsValue(filter.selectedItem)) {
                  var params = {};
                  params[filter.filterParam] = filter.selectedItem[filter.filterField];
                  filter.eventTrigger(params);
                }
              });
          }
          if (angular.isDefined(filter.eventRefreshData)) {
            $scope.$watch(
              function () {
                return filter.selectedItem;
              },
              function () {
                vm.values = sortValues(filter.eventRefreshData(), $scope.data.defaultOrderBy, $scope.data.defaultTypeOrderBy);
              });
          }

          $scope.$watch(
            function () {
              return filter.options;
            },
            function () {
              if (angular.isDefined(filter.options) && (filter.options.length === 1)) {
                filter.selectedItem = filter.options[0];
              }
              if (areAllFilterSelected()) {
                vm.isDisabledFilterButton = isDisabledFilterButton();
                applyFilters();
              }
            });
        });

        function isDisabledFilterButton() {
          return _.every(vm.filters, function (filter) {
            return (angular.isDefined(filter.options) && filter.options.length === 1);
          });
        }

        function areAllFilterSelected() {
          return _.every(vm.filters, function (filter) {
            return (angular.isDefined(filter.selectedItem) && filter.selectedItem !== null);
          });
        }

        function existsValue(value) {
          return angular.isDefined(value) && value !== null;
        }

        function filteredListHasSomeItem() {
          return !angular.isUndefined(vm.filteredValues) && vm.filteredValues.length;
        }

        function sortValues(values, defaultOrderBy, defaultTypeOrderBy) {
          if (angular.isUndefined(defaultTypeOrderBy)) {
            return _.sortByAll(values, defaultOrderBy);
          } else {
            return _.sortByOrder(values, defaultOrderBy, defaultTypeOrderBy);
          }
        }

        function isDisabledFilter(dependency) {
          if (angular.isDefined(dependency)) {
            return vm.filters[dependency].selectedItem === null;
          }
          return false;
        }

        function getStateLink(value) {
          if (angular.isDefined(vm.state)) {
            var params = {};
            angular.forEach(vm.state.params, function (param) {
              params[param.key] = value[param.value];
            });
            return vm.state.slink + '(' + JSON.stringify(params) + ')';
          }
        }

        function applyFilters() {
          vm.showList = true;
          var params = {};
          angular.forEach(vm.filters, function (filter) {
            params[filter.filterParam] = filter.selectedItem[filter.filterField];
          });
          vm.filterPromise(params).then(function (data) {
            vm.values = sortValues(vm.filterFunction(data), $scope.data.defaultOrderBy, $scope.data.defaultTypeOrderBy);

          });
        }
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };


  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name neo.directive:neoDownloadCsvTable
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="neo">
   <file name="index.html">
   <neo-download-csv-table></neo-download-csv-table>
   </file>
   </example>
   *
   */
  angular
    .module('neo')
    .directive('neoDownloadCsvTable', neoDownloadCsvTable);

  function neoDownloadCsvTable() {
    return {
      restrict: 'E',
      scope: {
        htmlTable: '=',
        filename: '@'
      },
      templateUrl: 'directives/neo-download-csv-table/neo-download-csv-table-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", "$filter", "HTMLToCSVParser", function ($scope, $filter, HTMLToCSVParser) {
        var vm = this;
        vm.name = 'neoDownloadCsvTable';

        vm.exportToCsv = function () {
          var csvString = HTMLToCSVParser.parse($scope.htmlTable);
          var completeFilename = $filter('translate')($scope.filename) + '.csv';
          if (window.navigator.msSaveBlob) { // IE
            var blob = new Blob(["\ufeff" + csvString], {type: "text/csv;charset=utf-8;"});
            window.navigator.msSaveOrOpenBlob(blob, completeFilename)
          } else { // Chrome and Firefox
            var anchor = angular.element('<a/>');
            anchor.css({display: 'none'});
            angular.element(document.body).append(anchor);
            anchor.attr({
              href: 'data:application/octet-stream;base64,' + btoa(csvString),
              target: '_blank',
              download: completeFilename
            })[0].click();
            anchor.remove();
          }
        };
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name home.directive:neoActionButton
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="home">
       <file name="index.html">
        <neo-action-button></neo-action-button>
       </file>
     </example>
   *
   */
  angular
    .module('neo')
    .directive('neoActionButton', neoActionButton);

  function neoActionButton() {
    return {
      restrict: 'E',
      scope: {
        buttons: '='
      },
      templateUrl: 'directives/neo-action-button/neo-action-button-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", "$state", function ($scope, $state) {
        var vm = this;
        vm.name = 'neoActionButton';
        vm.buttons = $scope.buttons;

        vm.goToNewState = function (action) {
          if (!_.isUndefined(action.paramsToChange)) {
            var params = {};
            _.forEach(action.paramsToChange, function (value, key) {
              params[key] = _.isFunction(value) ? value() : value;
            });
            $state.go(action.stateToChange, params);
          } else {
            $state.go(action.stateToChange);
          }
        }
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name neo.directive:errorToast
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="neo">
   <file name="index.html">
   <error-toast></error-toast>
   </file>
   </example>
   *
   */
  angular
  .module('neo')
  .directive('errorToast', errorToast);

  function errorToast() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'directives/error-toast/error-toast-directive.tpl.html',
      replace: false,
      controllerAs: 'errorToast',
      controller: 'ErrorToastCtrl'
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.controller:ErrorToastCtrl
   *
   * @description
   *
   */
  ErrorToastCtrl.$inject = ["$rootScope", "$mdToast", "$filter", "$state"];
  angular
  .module('neo')
  .controller('ErrorToastCtrl', ErrorToastCtrl);

  function ErrorToastCtrl($rootScope, $mdToast, $filter, $state) {
    var vm = this;
    vm.ctrlName = 'ErrorToastCtrl';
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')('STATE_CHANGE_ERROR'))
        .position('bottom left')
        .hideDelay(3000)
      );
      //$state.go(fromState.name,{}, {reload:true});
    });

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name components
   * @description
   *
   */
  angular
  .module('neo.components', []);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name entitat.informacio.constant:actionButton
   *
   * @description
   *
   */
  angular
  .module('neo.components')
  .value('actionButton', {
    dial: true,
    buttonImage: 'images/ic_more_vert_white_48px.svg',
    tooltip: 'Opcions',
    execute: function () {
    },
    actions: []
  });
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name components.controller:ActionButtonCtrl
   *
   * @description
   *
   */
  ActionButtonCtrl.$inject = ["actionButton"];
  angular
  .module('neo.components')
  .controller('ActionButtonCtrl', ActionButtonCtrl);

  function ActionButtonCtrl(actionButton) {
    var vm = this;
    vm.ctrlName = 'ActionButtonCtrl';
    vm.buttons = actionButton;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.authentication
   * @description
   *
   */
  angular
  .module('neo.authentication', [
    'neo.authentication.login',
    'neo.authentication.registration',
    'ngMaterial'
  ]);
}());

(function () {
    'use strict';

    config.$inject = ["$stateProvider"];
    passwordTokenConfirmation.$inject = ["PasswordToken", "$stateParams", "$q"];
    angular
      .module('neo.authentication')
      .config(config);

    function config($stateProvider) {
      $stateProvider
        .state('authentication.reset', {
          url: '/reset-password',
          templateUrl: 'authentication/reset-password/reset-password.tpl.html',
          controller: 'ResetPasswordCtrl',
          controllerAs: 'vm',
          params: {
            token: null
          }
        })
        .state('authentication.passwordConfirmation', {
            url: '^/reset?token',
            controller: 'PasswordTokenCtrl',
            controllerAs: 'vm',
            resolve: {
              passwordTokenConfirmation: passwordTokenConfirmation
            }
          }
        )
        .state('authentication.newPassword', {
          url: '^/set-password',
          templateUrl: 'authentication/reset-password/new-password.tpl.html',
          controller: 'NewPasswordCtrl',
          controllerAs: 'vm',
          params: {
            token: null
          }
        });
    }

    function passwordTokenConfirmation(PasswordToken, $stateParams, $q) {
      var deferred = $q.defer();

      PasswordToken.get({token: $stateParams.token},
        function () {
          deferred.resolve('valid');
        },
        function (response) {
          if (response.status === 401) {
            deferred.resolve('invalid');
          } else {
            deferred.reject(response);
          }
        });

      return deferred.promise;
    }
  }()
);

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.user.controller:ResetPasswordCtrl
   *
   * @description
   *
   */
  ResetPasswordCtrl.$inject = ["$filter", "$state", "$mdToast", "ResetPassword"];
  angular
  .module('neo.authentication')
  .controller('ResetPasswordCtrl', ResetPasswordCtrl);

  function ResetPasswordCtrl($filter, $state, $mdToast, ResetPassword) {
    var vm = this;
    vm.ctrlName = 'ResetPasswordCtrl';
    vm.cardTitle = 'RECOVER_PASSWORD';
    vm.email = null;

    vm.sendRestoreEmail = function () {
      ResetPassword.save({email: vm.email}, function () {
        $state.go('authentication.login', {}, {reload: true});
        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')('SUCCESSFUL_PASSWORD_RESET'))
          .position('bottom left')
          .hideDelay(5000)
        );
      }, function () {
        $mdToast.show(
          $mdToast.simple()
          .textContent($filter('translate')('TOAST_ERROR_EMAIL'))
          .position('bottom left')
          .hideDelay(5000)
        );
      });
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name user.controller:ConfirmationCtrl
   *
   * @description
   *
   */
  PasswordTokenCtrl.$inject = ["$state", "$stateParams", "$mdToast", "$filter", "passwordTokenConfirmation"];
  angular
  .module('neo.authentication')
  .controller('PasswordTokenCtrl', PasswordTokenCtrl);

  function PasswordTokenCtrl($state, $stateParams, $mdToast, $filter, passwordTokenConfirmation) {
    var vm = this;
    vm.ctrlName = 'PasswordTokenCtrl';

    if (passwordTokenConfirmation === 'valid') {
      $state.go('authentication.newPassword', {token: $stateParams.token});
    } else if (passwordTokenConfirmation === 'invalid') {
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')('TOKEN_NOT_FOUND'))
        .position('bottom left')
        .hideDelay(3000)
      );
      $state.go('authentication.login');
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.user.controller:ResetPasswordCtrl
   *
   * @description
   *
   */
  NewPasswordCtrl.$inject = ["$filter", "$state", "$stateParams", "$mdToast", "NewPassword"];
  angular
  .module('neo.authentication')
  .controller('NewPasswordCtrl', NewPasswordCtrl);

  function NewPasswordCtrl($filter, $state, $stateParams, $mdToast, NewPassword) {
    var vm = this;

    if ($stateParams.token === null || angular.isUndefined($stateParams.token)) {
      $state.go('authentication.login');
    }

    vm.ctrlName = 'NewPasswordCtrl';
    vm.cardTitle = 'CREATE_NEW_PASSWORD';

    vm.sendPassword = function () {
      vm.newUser = {newPassword: vm.pwd, resetToken: $stateParams.token};
      NewPassword.update(vm.newUser,
        function () {
          $state.go('authentication.login');
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')('SUCCESSFUL_PASSWORD_CHANGE'))
            .position('bottom left')
            .hideDelay(3000)
          );
        },
        function () {
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')('TOAST_ERROR'))
            .position('bottom left')
            .hideDelay(3000)
          );
        });
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name user.registration
   * @description
   *
   */
  angular
  .module('neo.authentication.registration', [
    'ui.router',
    'ngMaterial'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.authentication.registration')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('authentication.registration', {
      params: {
        token: null
      },
      templateUrl: 'authentication/registration/registration.tpl.html',
      controller: 'RegistrationCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.authentication.registration.controller:RegistrationCtrl
   *
   * @description
   *
   */
  RegistrationCtrl.$inject = ["$filter", "$state", "$stateParams", "$mdToast", "Registration"];
  angular
  .module('neo.authentication.registration')
  .controller('RegistrationCtrl', RegistrationCtrl);

  function RegistrationCtrl($filter, $state, $stateParams, $mdToast, Registration) {
    var vm = this;
    vm.ctrlName = 'RegistrationCtrl';

    vm.cardTitle = 'REGISTER_PASSWORD';
    vm.pwd = undefined;
    vm.pwd2 = undefined;

    vm.sendPassword = function () {
      vm.newUser = {password: vm.pwd, token: $stateParams.token};
      Registration.save(vm.newUser,
        function () {
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')('SUCCESSFUL_USER'))
            .position('bottom left')
            .hideDelay(3000)
          );
          $state.go('authentication.login');
        },
        function () {
          $mdToast.show(
            $mdToast.simple()
            .textContent($filter('translate')('TOAST_ERROR'))
            .position('bottom left')
            .hideDelay(3000)
          );
        });
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name authentication.login
   * @description
   *
   */
  angular
  .module('neo.authentication.login', [
    'ui.router',
    'ngMaterial'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.authentication.login')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('authentication.login', {
      templateUrl: 'authentication/login/login.tpl.html',
      controller: 'LoginCtrl',
      controllerAs: 'vm'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.authentication.login.controller:LoginCtrl
   *
   * @description
   *
   */
  LoginCtrl.$inject = ["$state", "$filter", "$mdToast", "AuthenticationService"];
  angular
  .module('neo.authentication.login')
  .controller('LoginCtrl', LoginCtrl);

  function LoginCtrl($state, $filter, $mdToast, AuthenticationService) {
    var vm = this;
    vm.ctrlName = 'LoginCtrl';

    vm.email = undefined;
    vm.password = undefined;
    vm.login = login;

    function login() {
      AuthenticationService.login(vm.email, vm.password)
        .then(function () {
          $state.go('home');
        })
        .catch(function () {
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')('EMAIL_PASSWORD_INVALID'))
              .position('bottom left')
              .hideDelay(5000));
        });
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name services
   * @description
   *
   */
  angular
  .module('neo.services', [
    'ngResource',
    'neo.config',
    'neo.services.auth'
  ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  valoracionstecnicsvisitant.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('valoracionstecnicsvisitant', valoracionstecnicsvisitant);

  function valoracionstecnicsvisitant($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/valoracionstecnicvisitant/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  valoracionstecnicslocal.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('valoracionstecnicslocal', valoracionstecnicslocal);

  function valoracionstecnicslocal($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/valoracionstecniclocal/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  valoracions.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('valoracions', valoracions);

  function valoracions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/valoracions/:idpartit/:idequip/:idperfil', {idpartit: '@_idpartit',idequip: '@_idequip',idperfil: '@_idperfil'}, {
      update: {
        method: 'PUT'
      }, insert: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.factory:Username
   *
   * @description
   *
   */
  Username.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Username', Username);

  function Username($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/user/username', {}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:UserProfile
   *
   * @description
   *
   */
  UserProfile.$inject = ["EnvironmentConfig", "$resource"];
  angular
  .module('neo.services')
  .factory('UserProfile', UserProfile);

  function UserProfile(EnvironmentConfig, $resource) {
    return $resource(EnvironmentConfig.API + '/users/:id/profile', {id: '@_id'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc neo.service
   * @name neo.services.factory:User
   *
   * @description
   *
   */
  User.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('User', User);

  function User($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/user');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:TownhallEntities
   *
   * @description
   *
   */
  TownhallEntities.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('TownhallEntities', TownhallEntities);

  function TownhallEntities($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/ajuntaments/:id/entitats', {id: '@_id'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:TownHallAssociated
   *
   * @description
   *
   */
  TownHallAssociated.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('TownHallAssociated', TownHallAssociated);

  function TownHallAssociated($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/entities/:id/townHall', {id: '@_id'}, {
          query: {
            method: 'GET',
            isArray: false
          }
        }
    );
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Teams
   *
   * @description
   *
   */
  Teams.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Teams', Teams);

  function Teams($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/teams/:id', {id: '@_id'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:TeamStatistics
   *
   * @description
   *
   */
  TeamStatistics.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('TeamStatistics', TeamStatistics);

  function TeamStatistics($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/statistics/teams');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  statsvots.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('statsvots', statsvots);

  function statsvots($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/statsvots/:id', {id: '@_id'},{
      update: {
        method: 'PUT'
      }, insert: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Sports
   *
   * @description
   *
   */
  Sports.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Sports', Sports);

  function Sports($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/sports');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Season
   *
   * @description
   *
   */
  Seasons.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Seasons', Seasons);

  function Seasons($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/competition/seasons');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:SearchLicense
   *
   * @description
   *
   */
  SearchLicense.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('SearchLicense', SearchLicense);

  function SearchLicense($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/persons/licences');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  sancionscomite.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('sancionscomite', sancionscomite);

  function sancionscomite($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/sancionscomite/:dataini/:datafi', {dataini: '@_dataini',datafi:'@_datafi'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  sancions.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('sancions', sancions);

  function sancions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/sancions', {}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  resultats2.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('resultats2', resultats2);

  function resultats2($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/resultatapp2/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  resultats.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('resultats', resultats);

  function resultats($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/resultatapp/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Registration
   *
   * @description
   *
   */
  Registration.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Registration', Registration);

  function Registration($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/auth/register');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  RefereeList.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('RefereeList', RefereeList);

  function RefereeList($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/licences');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeLicence
   *
   * @description
   *
   */
  RefereeLicence.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('RefereeLicence', RefereeLicence);

  function RefereeLicence($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/licences/:licenceId', {licenceId: '@_licenceId'},{
      update:{
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Poblacions
   *
   * @description
   *
   */
  receptores.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('receptores', receptores);

  function receptores($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/receptores');
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  recalcul.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('recalcul', recalcul);

  function recalcul($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/recalcul/:idPartido', {idPartido: '@_idPartido'}, {
      update: {
        method: 'PUT'
      }, insert: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ProgrammeSports
   *
   * @description
   *
   */
  ProgrammeSports.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('ProgrammeSports', ProgrammeSports);

  function ProgrammeSports($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/programmes/:id/sports', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Programme
   *
   * @description
   *
   */
  Programmes.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Programmes', Programmes);

  function Programmes($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/programmes');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Postponements
   *
   * @description
   *
   */
  Postponements.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Postponements', Postponements);

  function Postponements($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/matches/:id/postponements', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Poblacions
   *
   * @description
   *
   */
  Poblacions.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Poblacions', Poblacions);

  function Poblacions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/towns');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PhasesPublic
   *
   * @description
   *
   */
  PhasesPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('PhasesPublic', PhasesPublic);

  function PhasesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/phases');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PhasesInscriptions
   *
   * @description
   *
   */
  PhasesInscriptions.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('PhasesInscriptions', PhasesInscriptions);

  function PhasesInscriptions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phasesInscriptions');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phases
   *
   * @description
   *
   */
  Phases.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Phases', Phases);

  function Phases($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PhaseRecoveryMatchDates
   *
   * @description
   *
   */
  PhaseRecoveryMatchDates.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('PhaseRecoveryMatchDates', PhaseRecoveryMatchDates);

  function PhaseRecoveryMatchDates($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:id/recoveryMatchDates', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PhaseMatchDates
   *
   * @description
   *
   */
  PhaseMatchDates.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('PhaseMatchDates', PhaseMatchDates);

  function PhaseMatchDates($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:phaseId/matchDates', {phaseId: '@_phaseId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  Phase.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('Phase', Phase);

  function Phase($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:phaseId', {phaseId: '@_phaseId'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: false
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PersonLicense
   *
   * @description
   *
   */
  PersonLicense.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('PersonLicense', PersonLicense);

  function PersonLicense($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/persons/:personId/licences', {personId: '@_personId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Person
   *
   * @description
   *
   */
  Person.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Person', Person);

  function Person($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/persons/:personId', {personId: '@_personId'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  partitstutor.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('partitstutor', partitstutor);

  function partitstutor($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/partitstutor/:dia/:mes/:any/:dia2/:mes2/:any2', 
    {dia: '@_dia',mes: '@_mes',any: '@_any',dia2: '@_dia2',mes2: '@_mes2',any2: '@_any2'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  partits.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('partits', partits);

  function partits($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/partits/:dia/:mes/:any/:dia2/:mes2/:any2/:idperfil', 
    {dia: '@_dia',mes: '@_mes',any: '@_any',dia2: '@_dia2',mes2: '@_mes2',any2: '@_any2',idperfil: '@_idperfil'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:OrganisationUsers
   *
   * @description
   *
   */
  OrganisationUsers.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('OrganisationUsers', OrganisationUsers);

  function OrganisationUsers($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/organisation/:id/users', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  Matches.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Matches', Matches);

  function Matches($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/matches/:id', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LocalPhases
   *
   * @description
   *
   */
  LocalPhases.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('LocalPhases', LocalPhases);

  function LocalPhases($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/ajuntaments/:id/phases', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LicenseTypes
   *
   * @description
   *
   */
  LicenseTypes.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('LicenseTypes', LicenseTypes);

  function LicenseTypes($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/licensetypes');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LicenseTeamPerson
   *
   * @description
   *
   */
  LicenseTeamPerson.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('LicenseTeamPerson', LicenseTeamPerson);

  function LicenseTeamPerson($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/teams/:teamId/licences/:licenseId', {
      personId: '@_teamId',
      licenseId: '@_licenseId'
    }, {
      query: {
        method: 'GET',
        isArray: false
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Person
   *
   * @description
   *
   */
  LicenseTeam.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('LicenseTeam', LicenseTeam);

  function LicenseTeam($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/teams/:teamId/licences', {teamId: '@_teamId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LicenseTeamDetails
   *
   * @description
   *
   */
  LicenseTeamDetails.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('LicenseTeamDetails', LicenseTeamDetails);

  function LicenseTeamDetails($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/teams/:teamId/licences/details', {teamId: '@_teamId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:License
   *
   * @description
   *
   */
  License.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('License', License);

  function License($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/persons/:personId/licences', {personId: '@_personId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LicenceStatistics
   *
   * @description
   *
   */
  LicenceStatistics.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('LicenceStatistics', LicenceStatistics);

  function LicenceStatistics($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/statistics/licences');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LastPostponement
   *
   * @description
   *
   */
  LastPostponement.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('LastPostponement', LastPostponement);

  function LastPostponement($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/matches/:id/lastPostponement', {id: '@_id'}, {
      update: {method: 'PATCH'}
    })
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LastCancellation
   *
   * @description
   *
   */
  LastCancellation.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('LastCancellation', LastCancellation);

  function LastCancellation($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/matches/:id/lastCancellation', {id: '@_id'}, {
      update: {method: 'PATCH'}
    })
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  items.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('items', items);

  function items($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/items/:idPerfil', {idPerfil: '@_idPerfil'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
Invoicesgrouptrimestral.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Invoicesgrouptrimestral', Invoicesgrouptrimestral);

  function Invoicesgrouptrimestral($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgrouptrimestral/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
Invoicesgroup.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Invoicesgroup', Invoicesgroup);

  function Invoicesgroup($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgroup/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
invoicesgenerate.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('invoicesgenerate', invoicesgenerate);

  function invoicesgenerate($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgenerate/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
Invoices.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Invoices', Invoices);

  function Invoices($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoices/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  InvoiceRefLine.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('InvoiceRefLine', InvoiceRefLine);

  function InvoiceRefLine($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicerefline/:lineId', {lineId: '@_lineId'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      },
       delete: {
        method: 'DELETE',
        isArray:true
       }
    });
  }
}());





(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  InvoiceRef.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('InvoiceRef', InvoiceRef);

  function InvoiceRef($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoiceref/:Id', {id: '@_Id'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  InvoiceLines.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('InvoiceLines', InvoiceLines);

  function InvoiceLines($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoiceref/:Id/:invoiceid/:anyo', {id: '@_Id',invoiceid:'@_invoiceid',anyo:'@_anyo'}, {
     
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Insurances
   *
   * @description
   *
   */
  Insurances.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Insurances', Insurances);

  function Insurances($resource, EnvironmentConfig) {
    // return $resource(EnvironmentConfig.API + '/programmes/:idP/sports/:idS/categories/:idC/athleteinsurance', {
    return $resource(EnvironmentConfig.API + '/athleteinsurance?programme=:idP&sport=:idS&category=:idC', {
      idP: '@idP',
      idS: '@idS',
      idC: '@idC'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:InscribedTeamsNumber
   *
   * @description
   *
   */
  InscribedTeamsNumber.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('InscribedTeamsNumber', InscribedTeamsNumber);

  function InscribedTeamsNumber($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:phaseId/numberOfInscriptions', {phaseId: '@_phaseId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:InscribedTeams
   *
   * @description
   *
   */
  InscribedTeams.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('InscribedTeams', InscribedTeams);

  function InscribedTeams($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/phases/:phaseId/inscriptions', {phaseId: '@_phaseId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ImportPlayers
   *
   * @description
   *
   */
  ImportPlayers.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ImportPlayers', ImportPlayers);

  function ImportPlayers($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/teams/:teamId/importPlayers', {teamId: '@_teamId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:HttpInterceptorSpinner
   *
   * @description
   *
   */
  HttpInterceptorSpinner.$inject = ["$rootScope", "$timeout", "$q"];
  angular
    .module('neo.services')
    .factory('HttpInterceptorSpinner', HttpInterceptorSpinner);

  function HttpInterceptorSpinner($rootScope, $timeout, $q) {
    return {
      'request': function(config) {
        var promise = $timeout(function(){
          $rootScope.httpCallWaiting = true;
        }, 1000);
        $rootScope.timeoutPromises.push(promise);
        return config;
      },

      'response': function(response) {
        var promise = $rootScope.timeoutPromises.pop();
        $timeout.cancel(promise);
        if($rootScope.timeoutPromises.length === 0){
          $rootScope.httpCallWaiting = false;
        }
        return response;
      },

      'responseError': function (rejection) {
        var promise = $rootScope.timeoutPromises.pop();
        $timeout.cancel(promise);
        if ($rootScope.timeoutPromises.length === 0) {
          $rootScope.httpCallWaiting = false;
        }
        return $q.reject(rejection);
      }
    };
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:HttpInterceptorNoServerFound
   *
   * @description
   *
   */
  HttpInterceptorNoServerFound.$inject = ["$q", "$injector"];
  angular
    .module('neo.services')
    .factory('HttpInterceptorNoServerFound', HttpInterceptorNoServerFound);

  function HttpInterceptorNoServerFound($q, $injector) {
    return {
     /* // optional method
      'request': function (config) {
        // do something on success
        return config;
      },

      // optional method
      'requestError': function (rejection) {
        // do something on error
        if (canRecover(rejection)) {
          return responseOrNewPromise
        }
        return $q.reject(rejection);
      },
*/

     /* // optional method
      'response': function (response) {
        // do something on success
        return response;
      },
*/
      // optional method
      'responseError': function (rejection) {
        if(rejection.status === -1){
          var stateService = $injector.get('$state');
          stateService.go('serverNotFound');
        }
        return $q.reject(rejection);
      }
    }
  }}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Genders
   *
   * @description
   *
   */
  Genders.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Genders', Genders);

  function Genders($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/genders');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:PersonLicense
   *
   * @description
   *
   */
  Foto.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Foto', Foto);

  function Foto($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/foto/:personId', {personId: '@_personId'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
  }
}());



(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Facilities
   *
   * @description
   *
   */
  Facilities.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Facilities', Facilities);

  function Facilities($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/facilities/:id', {id: '@_idFacility'}, {
        update: {
          method: 'PUT'
        }
      }
    );
  }
})();


(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Ajuntaments
   *
   * @description
   *
   */
	excel.$inject = ["$window"];
  angular
    .module('neo.services')
    .factory('excel', excel);

  function excel($window) {

   var uri='data:application/vnd.ms-excel;base64; charset=utf-8,',
			template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><?xml version="1.0" encoding="utf-8" standalone="yes"?><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
    ,base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
			format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];});};
		return {
    tableToExcel:function(tableId,worksheetName){
        var table=document.querySelector(tableId),
            ctx={worksheet:worksheetName,table:table.innerHTML},
            href=uri+base64(format(template,ctx));
        return href;
    }
		};
	}
  
}());





(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:EntityTeams
   *
   * @description
   *
   */
  EntityTeams.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('EntityTeams', EntityTeams);

  function EntityTeams($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/entities/:entityId/teams', {entityId: '@_entityId'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:EntityTypesPublic
   *
   * @description
   *
   */
  EntityTypesPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('EntityTypesPublic', EntityTypesPublic);

  function EntityTypesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/entityTypes');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:EntityLicenses
   *
   * @description
   *
   */
  EntityLicenses.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('EntityLicenses', EntityLicenses);

  function EntityLicenses($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/entities/:id/licenses', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Entitats
   *
   * @description
   *
   */
  Entitats.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Entitats', Entitats);

  function Entitats($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/entities/:id', {id: '@_id'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:DuplicatedPerson
   *
   * @description
   *
   */
  DuplicatedPerson.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('DuplicatedPerson', DuplicatedPerson);

  function DuplicatedPerson($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/duplicatedPersons?name=:name&surname=:surname&bornDate=:bornDate', {
      name: '@_name',
      surname: '@_surname',
      bornDate: '@_bornDate'
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Season
   *
   * @description
   *
   */
  CurrentSeason.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('CurrentSeason', CurrentSeason);

  function CurrentSeason($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/season');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  Comite.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Comite', Comite);

  function Comite($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/comite/:id', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChangePassword
   *
   * @description
   *
   */
  ChangePassword.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('ChangePassword', ChangePassword);

  function ChangePassword($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/user/password');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipsPublic
   *
   * @description
   *
   */
  ChampionshipsPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipsPublic', ChampionshipsPublic);

  function ChampionshipsPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Championships
   *
   * @description
   *
   */
  Championships.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('Championships', Championships);

  function Championships($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.service:ChampionshipTeamsPublic
   *
   * @description
   *
   */
  ChampionshipTeamsPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .service('ChampionshipTeamsPublic', ChampionshipTeamsPublic);

  function ChampionshipTeamsPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/teams', {id: '@id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipPublic
   *
   * @description
   *
   */
  ChampionshipPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipPublic', ChampionshipPublic);

  function ChampionshipPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipMatchesPublic
   *
   * @description
   *
   */
  ChampionshipMatchesPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipMatchesPublic', ChampionshipMatchesPublic);

  function ChampionshipMatchesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/matches', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipMatches
   *
   * @description
   *
   */
  ChampionshipMatches.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('ChampionshipMatches', ChampionshipMatches);

  function ChampionshipMatches($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships/:id/matches', {id: '@_id'}, {
      update: {method: 'PATCH'},
      replace: {method: 'PUT'}
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Championship
   *
   * @description
   *
   */
  Championship.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Championship', Championship);

  function Championship($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships/:id', {id: '@_id'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: false
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChampionshipClassification
   *
   * @description
   *
   */
  ChampionshipClassification.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipClassification', ChampionshipClassification);

  function ChampionshipClassification($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/classification', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.factory:ChampionshipCalendarPublic
   *
   * @description
   *
   */
  ChampionshipCalendarPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipCalendarPublic', ChampionshipCalendarPublic);

  function ChampionshipCalendarPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/calendar', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.factory:ChampionshipCalendar
   *
   * @description
   *
   */
  ChampionshipCalendar.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ChampionshipCalendar', ChampionshipCalendar);

  function ChampionshipCalendar($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships/:championshipId/calendar', {championshipId: '@_championshipId'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Categories
   *
   * @description
   *
   */
  Categories.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Categories', Categories);

  function Categories($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/categories');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Cancellations
   *
   * @description
   *
   */
  Cancellations.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Cancellations', Cancellations);

  function Cancellations($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/matches/:id/cancellations', {id: '@_id'});
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:CancellationTypesPublic
   *
   * @description
   *
   */
  CancellationTypesPublic.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('CancellationTypesPublic', CancellationTypesPublic);

  function CancellationTypesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/cancellationTypes');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:AssignTeams
   *
   * @description
   *
   */
  AssignTeams.$inject = ["$resource", "EnvironmentConfig"];
  angular
      .module('neo.services')
      .factory('AssignTeams', AssignTeams);

  function AssignTeams($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships/:championshipId/teams', {championshipId: '@_championshipId'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Genders
   *
   * @description
   *
   */
  Ajuntamentsread.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Ajuntamentsread', Ajuntamentsread);

  function Ajuntamentsread($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/ajuntamentsread');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Ajuntaments
   *
   * @description
   *
   */
  Ajuntaments.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('Ajuntaments', Ajuntaments);

  function Ajuntaments($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/ajuntaments/:id', {id: '@_id'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Teams
   *
   * @description
   *
   */
  ActionSendEmailEes.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('ActionSendEmailEes', ActionSendEmailEes);

  function ActionSendEmailEes($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/sendemail/:id/:ido', {id: '@_id',ido: '@_ido'});
  }
}());



(function () {
  'use strict';

  ActionResendRegEmail.$inject = ["$resource", "EnvironmentConfig"];
  angular
  .module('neo.services')
  .factory('ActionResendRegEmail', ActionResendRegEmail);

  function ActionResendRegEmail($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/users/resendemail');
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  Classificacio.$inject = ["$resource", "EnvironmentConfig"];
  angular
    .module('neo.services')
    .factory('Classificacio', Classificacio);

  function Classificacio($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/classificacions/:idCampionat', {idCampionat: '@_idCampionat'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name serverNotFound
   * @description
   *
   */
  angular
    .module('neo.serverNotFound', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.serverNotFound')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('serverNotFound', {
        templateUrl: 'server-not-found/server-not-found.tpl.html',
        controller: 'ServerNotFoundCtrl',
        controllerAs: 'vm'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name serverNotFound.controller:ServerNotFoundCtrl
   *
   * @description
   *
   */
  angular
    .module('neo.serverNotFound')
    .controller('ServerNotFoundCtrl', ServerNotFoundCtrl);

  function ServerNotFoundCtrl() {
    var vm = this;
    vm.ctrlName = 'ServerNotFoundCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.security
   * @description
   *
   */
  angular
  .module('neo.security', []);
}());

(function () {
  /* global _ */
  'use strict';

  /**
   * @ngdoc service
   * @name neo.security.factory:Acl
   *
   * @description
   *
   */
  angular
  .module('neo.security')
  .factory('AclService', AclService);

  function AclService() {
    var AclBase = {};
    AclBase.can = can;
    AclBase.setFeatureAcls = setFeatureAcls;
    AclBase.setRoles = setRoles;
    AclBase.isAdmin = isAdmin;

    // ------------------------

    function can(name, acl) {
      return _.some(AclBase.featureAcls, function (featureAcl) {
        return featureAcl.name === name && _.includes(featureAcl.permissions, acl);
      });
    }

    function setFeatureAcls(featureAcl) {
      AclBase.featureAcls = featureAcl;
    }

    function setRoles(roles) {
      AclBase.roles = roles;
    }

    function hasRole(role) {
      return _.contains(AclBase.roles, role);
    }

    function isAdmin() {
      return hasRole('ADMIN');
    }

    return AclBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name public
   * @description
   *
   */
  angular
    .module('neo.public', [
      'ui.router',
      'neo.public.calendar',
      'neo.public.classification','neo.public.classificacio'
      ,'neo.public.resultats'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.public')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('public', {
        abstract: true,
        url: '/public',
        templateUrl: 'authentication/authentication.tpl.html'
      });
  }
}());

(function () {
  'use strict';

  /*
   * @ngdoc object
   * @name home
   * @description
   *
   */
  angular
  .module('neo.home', [
    'neo.home.entitats',
    'neo.home.ajuntaments',
    'neo.home.user',
    'neo.home.seasons',
    'neo.home.teams',
    'neo.home.persons',
    'neo.home.phases',
    'neo.home.championships',
    'neo.home.facilities',
    'neo.home.postponements',
    'neo.home.matches',
    'neo.home.cancellations',
    'neo.home.referees',
    'neo.home.licenseSearch',
    'neo.home.statistics', 'neo.home.statistics.neoindi','neo.home.refereeNewInvoice',
    'neo.home.refereeNewInvoice.newline','neo.home.refereeNewInvoice.line','neo.home.jvp','neo.home.jvp2','neo.home.refereeNewInvoice.invoicegroup.invoice'
    ,'neo.home.refereeNewInvoice.invoicestrimestral','neo.home.informes','neo.home.informestecnic','neo.home.informestg','neo.home.informespublic','neo.home.comite','neo.home.sancions','neo.public.classificacio','neo.public.resultats'
  ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('neo.home')
    .config(config);

  function config($stateProvider) {
    userResolveFunction.$inject = ["$q", "User", "AclService"];
    $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'home/home.tpl.html',
        controller: 'HomeCtrl',
        controllerAs: 'vm',
        resolve: {
          userResolve: userResolveFunction
        }
      });

    function userResolveFunction($q, User, AclService) {
      var deferred = $q.defer();
      User.get().$promise
        .then(function (data) {
          AclService.setFeatureAcls(data.featureAcls);
          AclService.setRoles(data.roles);
          deferred.resolve(data);
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.controller:HomeCtrl
   *
   * @description
   *
   */
  HomeCtrl.$inject = ["$state", "$rootScope", "authManager", "AuthenticationService", "userResolve", "User"];
  angular
      .module('neo.home')
      .controller('HomeCtrl', HomeCtrl);

  function HomeCtrl($state, $rootScope, authManager, AuthenticationService, userResolve, User) {
    var vm = this;
    vm.ctrlName = 'HomeCtrl';
    // TODO: Not works
    vm.authManager = authManager;
    vm.logout = logout;
    vm.userEmail = userResolve.email;

    // TODO: Revisar
    $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (!_.isUndefined(toState.url) && toState.url.startsWith('/home')) {
        User.get({}, {}, function (data) {
          vm.userEmail = data.email;
        }, function () {
          $state.go('authentication.login');
        });
      }
    });


    function logout() {
      AuthenticationService.logout();
      $state.go('authentication.login');
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc filter
   * @name components.filter:filterAccents
   *
   * @description
   *
   * @param {Array} input The array to filter
   * @returns {Array} The filtered array
   *
   */
  angular
    .module('neo.components')
    .filter('filterAccents', filterAccents);

  function filterAccents() {
    return function (array, expression, comparator, anyPropertyKey) {
      if (!angular.isArray(array)) {
        if (array == null) {
          return array;
        } else {
          throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
        }
      }

      anyPropertyKey = anyPropertyKey || '$';
      var expressionType = getTypeForFilter(expression);
      var predicateFn;
      var matchAgainstAnyProp;

      switch (expressionType) {
        case 'function':
          predicateFn = expression;
          break;
        case 'boolean':
        case 'null':
        case 'number':
        case 'string':
          matchAgainstAnyProp = true;
        // falls through
        case 'object':
          predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
          break;
        default:
          return array;
      }

      return Array.prototype.filter.call(array, predicateFn);
    };
  }

  // Helper functions for `filterFilter`
  function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
    var shouldMatchPrimitives = angular.isObject(expression) && (anyPropertyKey in expression);
    var predicateFn;

    if (comparator === true) {
      comparator = equals;
    } else if (!angular.isFunction(comparator)) {
      comparator = function (actual, expected) {
        if (angular.isUndefined(actual)) {
          // No substring matching against `undefined`
          return false;
        }
        if ((actual === null) || (expected === null)) {
          // No substring matching against `null`; only match against `null`
          return actual === expected;
        }
        if (angular.isObject(expected) || (angular.isObject(actual) && !hasCustomToString(actual))) {
          // Should not compare primitives against objects, unless they have custom `toString` method
          return false;
        }

        actual = removeAccents(lowercase('' + actual));
        expected = removeAccents(lowercase('' + expected));
        return actual.indexOf(expected) !== -1;
      };
    }

    function removeAccents(source) {
      if (!angular.isString(source)) return surce;
      var accent = [
          /[\300-\306]/g, /[\340-\346]/g, // A, a
          /[\310-\313]/g, /[\350-\353]/g, // E, e
          /[\314-\317]/g, /[\354-\357]/g, // I, i
          /[\322-\330]/g, /[\362-\370]/g, // O, o
          /[\331-\334]/g, /[\371-\374]/g, // U, u
          /[\321]/g, /[\361]/g, // N, n
          /[\307]/g, /[\347]/g, // C, c
        ],
        noAccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

      for (var i = 0; i < accent.length; i++) {
        source = source.replace(accent[i], noAccent[i]);
      }
      return source;
    }

    predicateFn = function (item) {
      if (shouldMatchPrimitives && !isObject(item)) {
        return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
      }
      return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
    };

    return predicateFn;
  }

  function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
    var actualType = getTypeForFilter(actual);
    var expectedType = getTypeForFilter(expected);

    if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
      return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
    } else if (angular.isArray(actual)) {
      // In case `actual` is an array, consider it a match
      // if ANY of it's items matches `expected`
      return actual.some(function (item) {
        return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
      });
    }

    switch (actualType) {
      case 'object':
        var key;
        if (matchAgainstAnyProp) {
          for (var key in actual) {
            // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
            // See: https://github.com/angular/angular.js/issues/15644
            if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
              return true;
            }
          }
          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
        } else if (expectedType === 'object') {
          for (key in expected) {
            var expectedVal = expected[key];
            if (angular.isFunction(expectedVal) || angular.isUndefined(expectedVal)) {
              continue;
            }

            var matchAnyProperty = key === anyPropertyKey;
            var actualVal = matchAnyProperty ? actual : actual[key];
            if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
              return false;
            }
          }
          return true;
        } else {
          return comparator(actual, expected);
        }
      case 'function':
        return false;
      default:
        return comparator(actual, expected);
    }
  }

  // Used for easily differentiating between `null` and actual `object`
  function getTypeForFilter(val) {
    return (val === null) ? 'null' : typeof val;
  }

  function hasCustomToString(obj) {
    return angular.isFunction(obj.toString) && obj.toString !== toString;
  }

  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };


}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name user.controller:ConfirmationCtrl
   *
   * @description
   *
   */
  ConfirmationCtrl.$inject = ["tokenConfirmation", "$state", "$stateParams", "$mdToast", "$filter"];
  angular
  .module('neo.authentication')
  .controller('ConfirmationCtrl', ConfirmationCtrl);

  function ConfirmationCtrl(tokenConfirmation, $state, $stateParams, $mdToast, $filter) {
    var vm = this;
    vm.ctrlName = 'ConfirmationCtrl';
    if (tokenConfirmation === 'valid') {
      $state.go('authentication.registration', {token: $stateParams.token});
    } else if (tokenConfirmation === 'invalid') {
      $mdToast.show(
        $mdToast.simple()
        .textContent($filter('translate')('TOKEN_NOT_FOUND'))
        .position('bottom left')
        .hideDelay(3000));
      $state.go('authentication.login');
    }
  }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
  .module('neo.authentication')
  .config(config);

  function config($stateProvider) {
    tokenConfirmation.$inject = ["Tokens", "$stateParams", "$q"];
    $stateProvider
    .state('authentication', {
      abstract: true,
      templateUrl: 'authentication/authentication.tpl.html'
    })
    .state('authentication.userConfirmation', {
      url: '^/confirm?token',
      controller: 'ConfirmationCtrl',
      controllerAs: 'vm',
      resolve: {
        tokenConfirmation: tokenConfirmation
      }
    });

    function tokenConfirmation(Tokens, $stateParams, $q) {
      var deferred = $q.defer();

      Tokens.get({token: $stateParams.token},
        function () {
          // returned 204
          deferred.resolve('valid');
        },
        function (response) {
          // returned 404
          if (response.status === 404) {
            deferred.resolve('invalid');
          } else {
            deferred.reject(response);
          }
        });

      return deferred.promise;
    }
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo
   * @description
   *
   */
  config.$inject = ["$mdThemingProvider"];
  angular
    .module('neo')
    .config(config);
  /* @ngInject */
  function config($mdThemingProvider) {
    $mdThemingProvider.definePalette('blueNeoPalette', {
      50: 'e3e9f1',
      100: 'b9c8dd',
      200: '8aa4c6',
      300: '5b7faf',
      400: '37639d',
      500: '14488c',
      600: '124184',
      700: '0e3879',
      800: '0b306f',
      900: '06215c',
      A100: '8eaaff',
      A200: '5b84ff',
      A400: '285eff',
      A700: '0f4bff',
      contrastDefaultColor: 'light',
      contrastDarkColors: [
        '50',
        '100',
        '200',
        'A100',
        'A200'
      ],
      contrastLightColors: [
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A400',
        'A700'
      ]
    });

    $mdThemingProvider.definePalette('greenNeoPalette', {
      50: 'f2f8ed',
      100: 'dfefd3',
      200: 'c9e4b6',
      300: 'b3d998',
      400: 'a3d082',
      500: '93c86c',
      600: '8bc264',
      700: '80bb59',
      800: '76b44f',
      900: '64a73d',
      A100: 'fafff7',
      A200: 'd9ffc4',
      A400: 'b8ff91',
      A700: 'a7ff78',
      contrastDefaultColor: 'light',
      contrastDarkColors: [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      contrastLightColors: [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('default')
      .primaryPalette('blueNeoPalette', {
        default: '500',
        'hue-1': '300',
        'hue-2': '800',
        'hue-3': 'A100'
      })
      .accentPalette('greenNeoPalette', {
        default: '500',
        'hue-1': '300',
        'hue-2': '800',
        'hue-3': 'A100'
      })
      .warnPalette('red')
      .backgroundPalette('grey');
  }
}());

(function () {
  /* global localstorage */
  'use strict';

  config.$inject = ["$urlRouterProvider", "$httpProvider", "jwtOptionsProvider", "EnvironmentConfig"];
  run.$inject = ["authManager", "$rootScope", "AuthenticationService", "$log", "$mdToast", "$filter"];
  angular
    .module('neo')
    .config(config)
    .run(run);

  function config($urlRouterProvider, $httpProvider, jwtOptionsProvider, EnvironmentConfig) {
    $urlRouterProvider.otherwise('/home');

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('HttpInterceptorNoServerFound');
    $httpProvider.interceptors.push('HttpInterceptorSpinner');

    // Security
    jwtOptionsProvider.config({
      tokenGetter: ['options', function (options) {
        // Skip authentication for any requests ending in .html
        if (options && options.url.substr(options.url.length - 5) === '.html') {
          return null;
        }
        return localStorage.getItem('id_token');
      }],
      whiteListedDomains: EnvironmentConfig.whiteListedDomains,
      unauthenticatedRedirector: ['$state', function ($state) {
        $state.go('authentication.login');
      }]
    });
  }


  function run(authManager, $rootScope, AuthenticationService, $log, $mdToast, $filter) {
    authManager.checkAuthOnRefresh();
    authManager.redirectWhenUnauthenticated();

    //inicialization of http timeouts for the spinner;
    $rootScope.timeoutPromises = [];

    $rootScope.$on('$stateChangeStart', function (event, toState) {
      $rootScope.changingState = true;
    });

    $rootScope.$on('tokenHasExpired', function () {
      $log.log('Your session has expired!');
      AuthenticationService.logout();
    });

    $rootScope.$on('$stateChangeSuccess',
      function(event, toState, toParams, fromState, fromParams){
        $rootScope.changingState = false;
      });

    $rootScope.$on('$stateNotFound', function(){
      $rootScope.changingState = false;
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      $rootScope.changingState = false;
      $mdToast.show(
        $mdToast.simple()
          .textContent($filter('translate')('STATE_CHANGE_ERROR'))
          .position('bottom left')
          .hideDelay(3000)
      );
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.locale:Locales
   *
   * @description
   *
   */
  config.$inject = ["$translateProvider", "$mdDateLocaleProvider", "uiGmapGoogleMapApiProvider"];
  angular
    .module('neo')
    .config(config);

  function config($translateProvider, $mdDateLocaleProvider, uiGmapGoogleMapApiProvider) {
    var language = 'ca_ES';
    // Change moment's locale so the 'L'-format is adjusted.
    // For example the 'L'-format is DD.MM.YYYY for German
    moment.locale('ca');

    // Set month and week names for the general $mdDateLocale service
    var localeData = moment.localeData();

    $translateProvider.useStaticFilesLoader({
      prefix: 'locales/locale-',
      suffix: '.json'
    });

    $translateProvider.preferredLanguage(language);
    $translateProvider.useSanitizeValueStrategy(null);

    $mdDateLocaleProvider.months = localeData.months();
    $mdDateLocaleProvider.shortMonths = localeData.monthsShort();
    $mdDateLocaleProvider.days = localeData.weekdays();
    $mdDateLocaleProvider.shortDays = localeData.weekdaysMin();
    // Optionaly let the week start on the day as defined by moment's locale data
    $mdDateLocaleProvider.firstDayOfWeek = localeData.firstDayOfWeek();

    // Format and parse dates based on moment's 'L'-format
    // 'L'-format may later be changed
    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'L', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format('L') : '';
    };

    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyBgzZNxB7Kz6NrLVFLYVsOMRoGBgxS7h10',
      // v: '3.26', // defaults to latest 3.X anyhow
      libraries: 'weather,geometry,visualization',
      language: 'en'
    });
  }
}());

(function () {
  'use strict';
  angular.module('neo.config', [])
.constant('EnvironmentConfig', {'API':'https://neo.cebllob.com/api/','whiteListedDomains':['neo.cebllob.com','localhost','neo.cebllob.com:8080','neo.cebllob.com:443']});
 
})();